webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/J1fQv1/%3F1705692044699&title=Journal%20of%20Sir%20Walter%20Scott%2C%20Canongate%20Classics&summary=This%20edition%20of%20the%20great%20Scottish%20author%26rsquo%3Bs%20personal%20journal%20is%20%26ldquo%3Btruly%20a%20classic%20.%20.%20.%20compelling%20right%20to%20the%20very%20last%20unfinished%20sentence%26rdquo%3B%20%28Scotland%20on%20Sunday%2C%20UK%29.%20%26%23160%3B%20The%20celebrated%2018th%20and%2019th%20century&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/J1fQv1/%3F1705692044699",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=This%20edition%20of%20the%20great%20Scottish%20author%26rsquo%3Bs%20personal%20journal%20is%20%26ldquo%3Btruly%20a%20classic%20.%20.%20.%20compelling%20right%20to%20the%20very%20last%20unfinish%0Dhttps://textcafe.co/books/J1fQv1/%3F1705692044699&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/J1fQv1/%3F1705692044699&posttype=link&caption=This%20edition%20of%20the%20great%20Scottish%20author%26rsquo%3Bs%20personal%20journal%20is%20%26ldquo%3Btruly%20a%20classic%20.%20.%20.%20compelling%20right%20to%20the%20very%20last%20unfinished%20sentence%26rdquo%3B%20%28Scotland%20on%20Sunday%2C%20UK%29.%20%26%23160%3B%20The%20celebrated%2018th%20and%2019th%20century",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/J1fQv1/%3F1705692044699&description=This%20edition%20of%20the%20great%20Scottish%20author%26rsquo%3Bs%20personal%20journal%20is%20%26ldquo%3Btruly%20a%20classic%20.%20.%20.%20compelling%20right%20to%20the%20very%20last%20unfinished%20sentence%26rdquo%3B%20%28Scotland%20on%20Sunday%2C%20UK%29.%20%26%23160%3B%20The%20celebrated%2018th%20and%2019th%20century&media=https://textcafe.co/books/J1fQv1/tc-custom/9781847674951.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9781847674951&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781847674951').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/J1fQv1/tc-custom/9781847674951.jpg?1705692044699',
        alt: 'Journal of Sir Walter Scott, Canongate Classics'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "9781847674951_tableofcontents", "9781847674951_chapter_01", "9781847674951_chapter_02", "9781847674951_introduction", "9781847674951_chapter_03", "9781847674951_part_01", "9781847674951_chapter_04", "9781847674951_chapter_05", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/J1fQv1/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_9781847674951_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_9781847674951_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_9781847674951_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_love_1__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_love_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_love_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_9781847674951_booktitlepage__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_9781847674951_booktitlepage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_9781847674951_booktitlepage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_9781847674951_preface__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_9781847674951_preface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_9781847674951_preface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_9781847674951_dedication__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_9781847674951_dedication___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_9781847674951_dedication__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_9781847674951_tableofcontents__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_9781847674951_tableofcontents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_9781847674951_tableofcontents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_9781847674951_chapter_01__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_9781847674951_chapter_01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_9781847674951_chapter_01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_9781847674951_chapter_02__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_9781847674951_chapter_02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_9781847674951_chapter_02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_9781847674951_introduction__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_9781847674951_introduction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_9781847674951_introduction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_9781847674951_chapter_03__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_9781847674951_chapter_03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_9781847674951_chapter_03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_9781847674951_part_01__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_9781847674951_part_01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_9781847674951_part_01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_9781847674951_chapter_04__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_9781847674951_chapter_04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_9781847674951_chapter_04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_9781847674951_chapter_05__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_9781847674951_chapter_05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_9781847674951_chapter_05__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_9781847674951_chapter_05_01__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_9781847674951_chapter_05_01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_9781847674951_chapter_05_01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_9781847674951_chapter_05_02__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_9781847674951_chapter_05_02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_9781847674951_chapter_05_02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_9781847674951_chapter_05_03__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_9781847674951_chapter_05_03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_9781847674951_chapter_05_03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_9781847674951_chapter_05_04__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_9781847674951_chapter_05_04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_9781847674951_chapter_05_04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_9781847674951_chapter_05_05__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_9781847674951_chapter_05_05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_9781847674951_chapter_05_05__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_9781847674951_chapter_06__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_9781847674951_chapter_06___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_9781847674951_chapter_06__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_9781847674951_chapter_06_01__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_9781847674951_chapter_06_01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_9781847674951_chapter_06_01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_9781847674951_chapter_06_02__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_9781847674951_chapter_06_02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_9781847674951_chapter_06_02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_9781847674951_chapter_06_03__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_9781847674951_chapter_06_03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_9781847674951_chapter_06_03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_9781847674951_chapter_07__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_9781847674951_chapter_07___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_9781847674951_chapter_07__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_9781847674951_chapter_07_01__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_9781847674951_chapter_07_01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_9781847674951_chapter_07_01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_9781847674951_chapter_08__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_9781847674951_chapter_08___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_9781847674951_chapter_08__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_9781847674951_chapter_08_01__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_9781847674951_chapter_08_01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_9781847674951_chapter_08_01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_9781847674951_chapter_09__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_9781847674951_chapter_09___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_9781847674951_chapter_09__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_9781847674951_chapter_10__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_9781847674951_chapter_10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_9781847674951_chapter_10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_9781847674951_chapter_10_01__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_9781847674951_chapter_10_01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_9781847674951_chapter_10_01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_9781847674951_chapter_11__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_9781847674951_chapter_11___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_9781847674951_chapter_11__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_9781847674951_chapter_12__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_9781847674951_chapter_12___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_9781847674951_chapter_12__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_love_2__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_love_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_love_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_9781847674951_appendix__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_9781847674951_appendix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_9781847674951_appendix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_9781847674951_appendix_02__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_9781847674951_appendix_02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_9781847674951_appendix_02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_9781847674951_appendix_03__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_9781847674951_appendix_03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_9781847674951_appendix_03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_9781847674951_appendix_04__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_9781847674951_appendix_04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_9781847674951_appendix_04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_9781847674951_appendix_05__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_9781847674951_appendix_05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_9781847674951_appendix_05__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_9781847674951_appendix_06__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_9781847674951_appendix_06___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_9781847674951_appendix_06__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_9781847674951_appendix_07__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_9781847674951_appendix_07___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_9781847674951_appendix_07__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_9781847674951_index__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_9781847674951_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_9781847674951_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_9781847674951_index_01__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_9781847674951_index_01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_9781847674951_index_01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_9781847674951_index_02__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_9781847674951_index_02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_9781847674951_index_02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_9781847674951_index_03__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_9781847674951_index_03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_9781847674951_index_03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_9781847674951_index_04__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_9781847674951_index_04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_9781847674951_index_04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_9781847674951_index_05__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_9781847674951_index_05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_9781847674951_index_05__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_9781847674951_index_06__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_9781847674951_index_06___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_9781847674951_index_06__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_9781847674951_index_07__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_9781847674951_index_07___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_9781847674951_index_07__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_9781847674951_acknowledgements__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_9781847674951_acknowledgements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_9781847674951_acknowledgements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_9781847674951_abouttheauthor__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_9781847674951_abouttheauthor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_9781847674951_abouttheauthor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_9781847674951_insertedcopyright__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_9781847674951_insertedcopyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__components_9781847674951_insertedcopyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_last__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__components_last__);
/*jshint esversion: 6 */

























































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/9781847674951_tableofcontents",
    "name": "9781847674951_tableofcontents",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_9781847674951_tableofcontents___default.a
  }, {
    "path": "/9781847674951_chapter_01",
    "name": "9781847674951_chapter_01",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_9781847674951_chapter_01___default.a
  }, {
    "path": "/9781847674951_chapter_02",
    "name": "9781847674951_chapter_02",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_9781847674951_chapter_02___default.a
  }, {
    "path": "/9781847674951_introduction",
    "name": "9781847674951_introduction",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_9781847674951_introduction___default.a
  }, {
    "path": "/9781847674951_chapter_03",
    "name": "9781847674951_chapter_03",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_9781847674951_chapter_03___default.a
  }, {
    "path": "/9781847674951_part_01",
    "name": "9781847674951_part_01",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_9781847674951_part_01___default.a
  }, {
    "path": "/9781847674951_chapter_04",
    "name": "9781847674951_chapter_04",
    "component": __WEBPACK_IMPORTED_MODULE_15__components_9781847674951_chapter_04___default.a
  }, {
    "path": "/9781847674951_chapter_05",
    "name": "9781847674951_chapter_05",
    "component": __WEBPACK_IMPORTED_MODULE_16__components_9781847674951_chapter_05___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_54__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Walter Scott, W.E.K. Anderson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sir Walter Scott (1771–1832) was a poet, translator, playwright, and historical novelist, born in Edinburgh, Scotland. Although he was critically acclaimed for his poetry, his passion for Scottish oral tradition led him to write novels inspired by the history of his country. The first writer in the English language to achieve true international fame, Scott is best remembered for "), _c('I', [_vm._v("Ivanhoe")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/J1fQv1/tc-custom/9781847674951.jpg?1705692044699",
      "alt": "This image is the cover for the book Journal of Sir Walter Scott, Canongate Classics"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Journal of Sir Walter Scott, Canongate Classics\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This edition of the great Scottish author’s personal journal is “truly a classic . . . compelling right to the very last unfinished sentence” ("), _c('i', [_vm._v("Scotland on Sunday")]), _vm._v(", UK).")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The celebrated 18th and 19th century Scottish author of such classics as "), _c('i', [_vm._v("Ivanhoe")]), _vm._v(", "), _c('i', [_vm._v("Rob Roy")]), _vm._v(", and "), _c('i', [_vm._v("The Lady of the Lake")]), _vm._v(" delivers what many regard as his greatest work: a day-to-day account of the last six years of his life as he navigates financial ruin, bereavement, and increasing ill health. Laboring to pay off debts of more than £120,000, Scott emerges, not simply as a great writer, but as an almost heroic figure whose generosity and even temper shine through at all times."), _c('br'), _c('br'), _vm._v(" This edition of Scott’s journals presents a complete edited text and notes drawing on a wealth of other material including correspondence, reminiscences and the memoirs of Scott’s contemporaries. It remains one of the standards by which Scott scholarship is judged."), _c('br'), _c('br'), _c('b', [_vm._v("“Scott’s Journal is a hugely important piece of Scottish, and indeed European literature, published here with an incisive introduction, brilliantly judicious annotation and appendices and an excellent index . . . Walter Scott has never been so readable.” —"), _c('i', [_vm._v("The Herald")]), _vm._v(", UK")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Canongate\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "frontmatter TableOfContents"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_110259-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xv"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xv"
    }
  }, [_c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_110259-00001"
    }
  }, [_c('h1', [_vm._v("Contents")])])]), _c('div', {
    staticClass: "block toc",
    attrs: {
      "id": "rw-block-toc_110259-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xv"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_xv"
    }
  }, [_c('span', {
    staticClass: "sc"
  })]), _c('a', {
    attrs: {
      "href": "#/9781847674951_chapter_01"
    }
  }, [_vm._v("ABBREVIATIONS USED BY SCOTT")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110259-00001"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticClass: "sc"
  }, [_c('a', {
    attrs: {
      "href": "#/9781847674951_chapter_02"
    }
  }, [_vm._v("ABBREVIATIONS USED IN THE NOTES")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110259-00002"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticClass: "sc"
  }, [_c('a', {
    attrs: {
      "href": "#/9781847674951_introduction"
    }
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847674951_introduction#rw-h2_110262-00001"
    }
  }, [_vm._v("Scott’s Edinburgh: The Changing City")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847674951_introduction#rw-h2_110262-00002"
    }
  }, [_vm._v("The Law")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847674951_introduction#rw-h2_110262-00003"
    }
  }, [_vm._v("Abbotsford")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847674951_introduction#rw-h2_110262-00004"
    }
  }, [_vm._v("The Financial Crash")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847674951_introduction#rw-h2_110262-00005"
    }
  }, [_vm._v("The Arbitration")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847674951_introduction#rw-h2_110262-00006"
    }
  }, [_vm._v("Political Affairs")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/9781847674951_introduction#rw-h2_110262-00007"
    }
  }, [_vm._v("The People of the "), _c('i', [_vm._v("Journal")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110259-00003"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticClass: "sc"
  }, [_c('a', {
    attrs: {
      "href": "#/9781847674951_chapter_03"
    }
  }, [_vm._v("THE EVENTS OF THE "), _c('i', [_vm._v("JOURNAL")])])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110259-00004"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "href": "#/9781847674951_part_01"
    }
  }, [_vm._v("THE JOURNAL")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110259-00005"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticClass: "sc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ADDITIONAL NOTES")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110259-00006"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("APPENDICES")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847674951_appendix",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("A")]), _vm._v(". Chronology of the Life of Sir Walter Scott")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847674951_appendix_02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("B")]), _vm._v(". Country Houses of the "), _c('i', [_vm._v("Journal")]), _vm._v(" and their Owners")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847674951_appendix_03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("C")]), _vm._v(". Edinburgh Addresses")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847674951_appendix_04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("D")]), _vm._v(". Politics in the "), _c('i', [_vm._v("Journal")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847674951_appendix_05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("E")]), _vm._v(". Dating")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847674951_appendix_06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("F")]), _vm._v(". Silent Corrections")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/9781847674951_appendix_07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("G")]), _vm._v(". Memoranda")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110259-00007"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticClass: "sc"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110259-00002"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xvi"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xvi"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xvi"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xvi"
    }
  })])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_110260-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xvii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xvii"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_110260-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xvii"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "pb-rw_xvii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847674951_tableofcontents"
    }
  }, [_c('i', [_vm._v("Abbreviations Used by Scott")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table",
    attrs: {
      "id": "rw-table_110260-00001"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "ta"
    }
  }, [_c('caption', [_c('br')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("1. Advocate, The")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("The Lord Advocate, Sir William Rae")])]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("2. C and Coy.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Constable and Company")])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("3. Ch. Ba.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("The Lord Chief Baron of the Exchequer Court, Sir Samuel Shepherd")])]), _vm._v(" "), _c('tr', {
    staticClass: "row4"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("4. Ch. Com.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("The Lord Chief Commissioner of the Jury Court, the Rt. Hon. William Adam")])]), _vm._v(" "), _c('tr', {
    staticClass: "row5"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("5. Chief Baron")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("See 3 above")])]), _vm._v(" "), _c('tr', {
    staticClass: "row6"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("6. Chief Commissioner")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("See 4 above")])]), _vm._v(" "), _c('tr', {
    staticClass: "row7"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("7. H & R")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Hurst, Robinson and Company")])]), _vm._v(" "), _c('tr', {
    staticClass: "row8"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("8. James  "), _c('br'), _vm._v("James B "), _c('br'), _vm._v("J. B.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "xvii.png"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("James Ballantyne ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row9"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("9. J. G. L.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("John Gibson Lockhart")])]), _vm._v(" "), _c('tr', {
    staticClass: "row10"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("10. L. C. B.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("See 3 above")])]), _vm._v(" "), _c('tr', {
    staticClass: "row11"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("11. L. C. C.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("See 4 above")])]), _vm._v(" "), _c('tr', {
    staticClass: "row12"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("12. Lord Ch: Com.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("See 4 above")])]), _vm._v(" "), _c('tr', {
    staticClass: "row13"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("13. L. J. C.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("The Lord Justice-Clerk, the Rt. Hon. David Boyle")])]), _vm._v(" "), _c('tr', {
    staticClass: "row14"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("14. L. J. S.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Lady Jane Stuart")])]), _vm._v(" "), _c('tr', {
    staticClass: "row15"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("15. L. L. S.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Lady Louisa Stuart")])]), _vm._v(" "), _c('tr', {
    staticClass: "row16"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("16. Lord Register")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("The Principal Keeper of the Register of Sasines, the Rt. Hon. William Dundas")])]), _vm._v(" "), _c('tr', {
    staticClass: "row17"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("17. L. S.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Lady Scott")])]), _vm._v(" "), _c('tr', {
    staticClass: "row18"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("18. Missie")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Miss Macdonald Buchanan")])]), _vm._v(" "), _c('tr', {
    staticClass: "row19"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("19. R. C.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Robert Cadell")])]), _vm._v(" "), _c('tr', {
    staticClass: "row20"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("20. Sir A. F.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Sir Adam Ferguson")])]), _vm._v(" "), _c('tr', {
    staticClass: "row21"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("21. Solicitor, The")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("The Solicitor-General, John Hope")])]), _vm._v(" "), _c('tr', {
    staticClass: "row22"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("22. S. W. S.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Sir Walter Scott")])]), _vm._v(" "), _c('tr', {
    staticClass: "row23"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("23. W. C.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Will Clerk")])]), _vm._v(" "), _c('tr', {
    staticClass: "row24"
  }, [_c('td', {
    staticClass: "col2"
  }, [_vm._v("24. "), _c('i', [_vm._v("W—k")]), _vm._v(".\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Woodstock")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110260-00002"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xviii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xviii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xviii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xviii"
    }
  })])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_110261-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xix"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xix"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_110261-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xix"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "pb-rw_xix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847674951_tableofcontents"
    }
  }, [_c('i', [_vm._v("Abbreviations Used in the Notes")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table",
    attrs: {
      "id": "rw-table_110261-00001"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "txx"
    }
  }, [_c('caption'), _c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Abbots.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Abbotsford Collection, Nat. Lib. Scot., MSS 1552–4.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("A. L. C.")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("J. G. Cochrane, "), _c('i', [_vm._v("Abbotsford Library")]), _vm._v(" "), _c('i', [_vm._v("Catalogue")]), _vm._v(", 1838.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Bannatyne Club Minutes")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Nat. Lib. Scot., MS. 2046.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row4"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Bell’s Dictionary and Digest ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Bell’s Dictionary and Digest of the Law")]), _vm._v(" "), _c('i', [_vm._v("of Scotland")]), _vm._v(", ed. George Watson, 1882.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row5"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Blair-Adam Estate")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("William Adam, Blair-Adam Estate, 1834.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row6"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Cadell Letters")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Nat. Lib. Scot., MS. 1758 (vol. v of letters written by Scott to Cadell).")])]), _vm._v(" "), _c('tr', {
    staticClass: "row7"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Cadell’s Diary")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Nat. Lib. Scot., MS. 5188.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row8"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("C")]), _c('i', [_vm._v("entenary Catalogue ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("The Scott Centenary Exhibition Cata")]), _c('i', [_vm._v("logue")]), _vm._v(", 1872.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row9"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Charles Scott’s Journal")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("The Journal of Charles Scott, Nat. Lib. Scot., MS. 1614.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row10"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Cockburn’s "), _c('i', [_vm._v("Memorials")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Memorials of his Time")]), _vm._v(", Henry Cockburn, 1856.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row11"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Cole’s ‘Memorial of a Tour’")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Owen Blayney Cole, ‘Memorial of a Tour to Italy’, Cornhill Magazine, September 1923.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row12"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Croker Papers ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("The Correspondence and Diaries of J.")]), _vm._v(" "), _c('i', [_vm._v("W. Croker")]), _vm._v(", ed. L. J. Jennings, 1885.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row13"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Dalgleish i, ii, iii.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("‘Memoirs of William Dalgleish, Butler to Sir Walter Scott’, "), _c('i', [_vm._v("Cornhill Ma")]), _c('i', [_vm._v("gazine")]), _vm._v(", June, July, and August 1931.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row14"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Diaries of Helen Graham ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Diaries of Helen Graham")]), _vm._v(", ed. James Irvine, 1956.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row15"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Dibdin")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("J. C. Dibdin, "), _c('i', [_vm._v("Annals of the Edinburgh")]), _vm._v(" "), _c('i', [_vm._v("Stage")]), _vm._v(", 1888.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row16"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Disc. i and ii")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Discarded letters of Scott, collected by Grierson (but not printed in the "), _c('i', [_vm._v("Letters")]), _vm._v("), Nat. Lib. Scot., MSS. 1752–3.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row17"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("D. N. B.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Dictionary of National Biography")])])]), _vm._v(" "), _c('tr', {
    staticClass: "row18"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Douglas")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("The Journal of Sir Walter Scott")]), _vm._v(", ed. David Douglas, new edition, 1927.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row19"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Edgar Johnson")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Edgar Johnson’s "), _c('i', [_vm._v("Sir Walter Scott:")]), _vm._v(" "), _c('i', [_vm._v("The Great Unknown")]), _vm._v(", 1970.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row20"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Gell")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Reminiscences of Sir Walter Scott’s Residence in Italy")]), _vm._v(", 1832, "), _c('i', [_vm._v("by Sir William")]), _vm._v(" "), _c('i', [_vm._v("Gell")]), _vm._v(", ed. J. C. Corson, 1957.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row21"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Gibson’s "), _c('i', [_vm._v("Reminiscences")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("John Gibson, "), _c('i', [_vm._v("Reminiscences of Sir")]), _vm._v(" "), _c('i', [_vm._v("Walter Scott")]), _vm._v(", 1871.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row22"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Grierson")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("H. J. C. Grierson, Sir Walter Scott, Bart., 1938.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row23"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Hall’s "), _c('i', [_vm._v("Fragments")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Basil Hall, "), _c('i', [_vm._v("Fragments of Voyages")]), _vm._v(", Third Series, 1840.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row24"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Haydon’s "), _c('i', [_vm._v("Diary")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("The Diary of B. R. Haydon")]), _vm._v(", ed. W. B. Pope, 1960.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row25"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Herd")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Ancient and Modern Scottish Songs")]), _vm._v(", ed. David Herd, 1791.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row26"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Jamieson")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Dr. John Jamieson, "), _c('i', [_vm._v("Etymological Dic")]), _c('i', [_vm._v("tionary of the Scottish Language")]), _vm._v(", new edition, 1879.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row27"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("J. G. L.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("John Gibson Lockhart.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row28"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Lady Shelley’s Diary ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("The Diary of Frances, Lady Shelley,")]), _vm._v(" "), _c('i', [_vm._v("1818–73")]), _vm._v(", ed. Richard Edgecumbe, 1912–13.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row29"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Letters ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("The Letters of Sir Walter Scott")]), _vm._v(", ed. H. J. C. Grierson and others, 12 vols., 1932–7.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row30"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Letters from Scott’s Family ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Letters from Members of Sir Walter")]), _vm._v(" "), _c('i', [_vm._v("Scott’s Family")]), _vm._v(", ed. P. A. Wright- Henderson, 1905.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row31"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Letters to and from Scott")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Nat. Lib. Scot., MS. 5317.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row32"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Letters to Laidlaw")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Nat. Lib. Scot., MS. 860.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row33"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Letters to Scott")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Nat. Lib. Scot., MS. 869.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row34"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Life")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("J. G. Lockhart, "), _c('i', [_vm._v("Memoirs of the Life of")]), _vm._v(" "), _c('i', [_vm._v("Sir Walter Scott, Bart")]), _vm._v("., second edition, 1851.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row35"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Life of Moscheles")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Charlotte Moscheles, "), _c('i', [_vm._v("The Life of")]), _vm._v(" "), _c('i', [_vm._v("Moscheles")]), _vm._v(", 1873.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row36"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Life of Napoleon")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Sir Walter Scott, "), _c('i', [_vm._v("The Life of Napo")]), _c('i', [_vm._v("leon Buonaparte")]), _vm._v(", 1827.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row37"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Mackay’s "), _c('i', [_vm._v("Reminiscences")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("MacIntosh Mackay, "), _c('i', [_vm._v("Reminiscences")]), _vm._v(", no date.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row38"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Memoirs of Knighton")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Lady D. Knighton, "), _c('i', [_vm._v("Memoirs of Sir")]), _vm._v(" "), _c('i', [_vm._v("William Knighton")]), _vm._v(", 1838.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row39"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Memoirs of Mathews")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Mrs. Mathews, "), _c('i', [_vm._v("Memoirs of Charles")]), _vm._v(" "), _c('i', [_vm._v("Mathews")]), _vm._v(", 1839.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row40"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Memoirs of Moore ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Memoirs of Thomas Moore")]), _vm._v(", ed. Lord John Russell, 1853.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row41"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Memoirs of Mrs. Hemans ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Memoirs of Mrs. Hemans by her Sister")]), _vm._v(", 1839.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row42"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Misc. Prose Works ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("The Miscellaneous Prose Works of Sir")]), _vm._v(" "), _c('i', [_vm._v("Walter Scott")]), _vm._v(", 1834–40.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row43"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Mrs. Davy’s Journal")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Mrs. Davy, ‘Extracts from a Family Journal’, Nat. Lib. Scot., MS. 3389.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row44"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Mrs. Hughes’s Recollections ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Letters and Recollections of Sir Walter")]), _vm._v(" "), _c('i', [_vm._v("Scott by Mrs. Hughes")]), _vm._v(", ed. H. G. Hutchinson, 1904.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row45"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Nat. Lib. Scot.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("The National Library of Scotland.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row46"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("O. E. D. ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("The Oxford English Dictionary")]), _vm._v(".\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row47"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Omond")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("G. W. T. Omond, "), _c('i', [_vm._v("The Lord Advo")]), _c('i', [_vm._v("cates of Scotland")]), _vm._v(", 1883.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row48"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Partington’s "), _c('i', [_vm._v("Letter-Books ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("The Private Letter-Books of Sir Walter")]), _vm._v(" "), _c('i', [_vm._v("Scott")]), _vm._v(", ed. Wilfred Partington, 1930.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row49"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("P. M. L. A. ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Publications of the Modern Language")]), _vm._v(" "), _c('i', [_vm._v("Association")]), _vm._v(".\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row50"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Royal Society Minutes")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("The Royal Society Minute-Book, MS. in possession of the Royal Society of Edinburgh.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row51"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Sederunt Book")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("The Sederunt Book of the Trustees of James Ballantyne & Co., Nat. Lib. Scot., MSS 112–14.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row52"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Shortreed Papers")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Nat. Lib. Scot., MS. 8993.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row53"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Skene’s Memories ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Memories of Sir Walter Scott by James")]), _vm._v(" "), _c('i', [_vm._v("Skene")]), _vm._v(", ed. Basil Thomson, 1909.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row54"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("S. N. D. ")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("The Scottish National Dictionary")]), _vm._v(".\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row55"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Susan Frere")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Manuscript letters of Susan Frere, in the possession of Bartle Frere, Esq.")])]), _vm._v(" "), _c('tr', {
    staticClass: "row56"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Tait")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("The Journal of Sir Walter Scott")]), _vm._v(", ed. J. G. Tait, 1939–46.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row57"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Ticknor’s Life")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("George S. Hillard, "), _c('i', [_vm._v("Life, Letters and")]), _vm._v(" "), _c('i', [_vm._v("Journals of George Ticknor")]), _vm._v(", 1876.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row58"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Walpole")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("The Walpole Collection, Nat. Lib. Scot., MSS 3901–19. (Unless otherwise stated, Walpole letters are addressed to Scott.)")])]), _vm._v(" "), _c('tr', {
    staticClass: "row59"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("W. S.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Writer to the Signet")])]), _vm._v(" "), _c('tr', {
    staticClass: "row60"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Youngson")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("A. J. Youngson,"), _c('i', [_vm._v(" The Making of Clas")]), _c('i', [_vm._v("sical Edinburgh")]), _vm._v(", 1966.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row61"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row62"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2"
  })])])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110261-00002"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xxii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xxii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xxii"
    }
  })])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "frontmatter Introduction"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_110262-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxiii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xxiii"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_110262-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxiii"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "pb-rw_xxiii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847674951_tableofcontents"
    }
  }, [_c('i', [_vm._v("Introduction")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110262-00002"
    }
  }, [_vm._v("It is fortunate that Sir Walter Scott began his "), _c('i', [_vm._v("Journal")]), _vm._v(" when he did. He was already fifty-four, famous, and to all appearances wealthy. He was Laird of Abbotsford and a notable member of Edinburgh society; he numbered among his friends almost all the great men of his day; his public was the entire civilized world. As he wrote the first entry in November 1825 his fortunes were at their height. Yet within a few months the wheel had spun wildly and he had lost everything – his land, his money, and the wife he loved. The "), _c('i', [_vm._v("Journal")]), _vm._v(", which would have been the informal record of a major writer’s declining years, became instead the revelation of a great man’s courage in adversity.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00003"
    }
  }, [_vm._v("No one can fail to be impressed, like the early reviewer of Douglas’s edition, by its account ‘of indomitable manliness, and prodigious industry’."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-6",
      "id": "num-footnote-1-6-back"
    }
  }, [_vm._v("1")])]), _vm._v(" He writes through days of pain and sickness; he writes down the depression of spirits which afflicted him more often than his friends or family were allowed to know; he writes day in and day out, weekday and Sunday, in Edinburgh and at Abbotsford, to pay the debts which he considered debts of honour. The "), _c('i', [_vm._v("Journal")]), _vm._v(" confirms, too, the opinion of those who knew Scott, that he was one of the pleasantest of great writers. His generosity is everywhere apparent – not merely the generosity which sends "), _c('i', [_vm._v("£")]), _vm._v("10 to Haydon or "), _c('i', [_vm._v("£")]), _vm._v("50 to Gillies, but a generosity of judgement, a willingness to be pleased by new acquaintances or new books. His evenness of temper, which only illness seems to have ruffled, is remarkable. He is pestered by coxcombs and eccentrics; his precious time is picked away by bores and foreigners and friends of friends. Scott does not claim the privilege of withdrawing himself, but does the honours of the house till they are gone, and settles again to his work.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00004"
    }
  }, [_vm._v("The "), _c('i', [_vm._v("Journal")]), _vm._v(" is also to some extent a private diary of day-to-day events, although we have Lockhart’s word for it that it was intended for publication. ‘Scott clearly, and indeed avowedly, considered himself as writing what would one day be published’, he told Croker in 1853. ‘In his will he distinctly directs what shall be done with the money that his executors shall obtain in respect of this and other \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_xxiv"
    }
  }, [_vm._v("manuscripts.’"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-7",
      "id": "num-footnote-1-7-back"
    }
  }, [_vm._v("2")]), _vm._v(" No doubt Lockhart is right, although how far Scott’s bankruptcy and the need to turn every word he wrote to account may have altered his original purpose is matter for speculation. Certainly the internal evidence supports Lockhart’s contention. A reference to ‘those [who] may read my confessions’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-8",
      "id": "num-footnote-2-8-back"
    }
  }, [_vm._v("3")])]), _vm._v(" is scarcely conclusive, as it might refer only to his own family; but Scott’s reticence throughout the whole work seems to clinch the argument. He is much franker – and ruder – in his correspondence than in his "), _c('i', [_vm._v("Journal")]), _vm._v(". For the character of Mrs. Jobson, or Mrs. Thomas Scott, or his cousin Maxpopple, you have to go to the "), _c('i', [_vm._v("Letters")]), _vm._v("; you can make no guess at them from the "), _c('i', [_vm._v("Journal")]), _vm._v(". Obviously he had one eye on future publication, and had no wish to cause embarrassment to the people he wrote about or to his own family. Nonetheless there are trivialities that he would have expected to be excised, and much that was obvious to himself and his contemporaries which the lapse of time has made obscure. Some account of the world in which he lived is therefore a necessary prelude to the "), _c('i', [_vm._v("Journal")]), _vm._v(" itself.\n          ")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "rw-h2_110262-00001"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_c('a', {
    attrs: {
      "href": "#/9781847674951_tableofcontents"
    }
  }, [_vm._v("SCOTT’S EDINBURGH: THE CHANGING CITY")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110262-00006"
    }
  }, [_vm._v("The Edinburgh of Sir Walter Scott was a city of astonishing contrasts. Its centre was still the High Street running down the hill from the Castle to Holyrood House, but its tenement buildings and dirty wynds and closes were no longer the homes of the wealthy and the well-connected. They had moved to what they called the New Town, the severe and classical streets and squares which had been built to the north of Princes Street Gardens, linked to the Old Town by the steep slope of the Mound and the arches of the North Bridge. Like generations of Edinburgh men before him, Scott was born into the noisy, crowded squalor of the Old Town, although the family moved three years later from the College Wynd to one of a row of unpretentiously elegant houses in George Square, on the south side of the city. At the time of his marriage Scott took one of the new houses in Castle Street in the New Town, and there, but for the financial disaster of 1826, he would have stayed until his death.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00007"
    }
  }, [_vm._v("The New Town was largely created within Scott’s lifetime. Craig’s plan was finally accepted, and the first feus (in St. Andrew Square) were let only four years before he was born; when he married in 1797, development had moved west only as far as Castle Street; by the time of the "), _c('i', [_vm._v("Journal")]), _vm._v(" the town had grown considerably bigger, and there\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_xxv"
    }
  }, [_vm._v("were complaints that the atmosphere was affected by the extent of the expansion to the north. The great public buildings all belong to this period. The Assembly Rooms in George Street were opened in 1787; the old Parliament House, the seat of the Law Courts, was given a classical façade between 1807 and 1810 and became a New Town building at the heart of the Old Town. The Edinburgh Academy was opened in 1824, the Royal Institution at the foot of the Mound in 1826, and the Royal High School in Regent Road in 1829."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span')])]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-9",
      "id": "num-footnote-1-9-back"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00009"
    }
  }, [_vm._v("Every morning during the Session Scott passed from one world to another as the Clerks’ Coach trundled up the Mound to the Parliament House on the High Street. The change of oldways into new, which is the theme of "), _c('i', [_vm._v("Waverley, Rob Roy")]), _vm._v(", and "), _c('i', [_vm._v("Redgauntlet")]), _vm._v(", was visible around him in substantial stone and lime. At the endof the day’s work he returned from the Scotland about which he wrote to the new Scotland in which he lived. The New Town gave Scott and his generation an environment which combined gracious living and intimacy to a degree that can scarcely have been equalled anywhere else at any other time. Within half a mile of Scott’s house – in Princes Street, George Street, Heriot Row, Charlotte Square, Shandwick Place – lived most of his Edinburgh friends, a civilized, well-to-do, close-knit community, largely of advocates, many of them known to each other from their school and college days. Scott walked the mile home from Court in the afternoon, and he could go on foot to the dinner parties and supper parties for which Edinburgh was renowned. It was a far remove from the Edinburgh of the novels, from Prince Charles leaving Holyrood for Prestonpans, from Covenanters tried and tortured in the Laigh Hall, or Captain Porteous seized from the Heart of Midlothian and lynched in the Grassmarket. That Edinburgh survives in the novels. The "), _c('i', [_vm._v("Journal")]), _vm._v(" belongs to the New Town.\n         ")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "rw-h2_110262-00002"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_c('a', {
    attrs: {
      "href": "#/9781847674951_tableofcontents"
    }
  }, [_vm._v("THE LAW")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110262-00010"
    }
  }, [_vm._v("The most influential and frequently the most able men of Scott’s time in Edinburgh were lawyers. Whether or not he practised at the Bar, a young man of good connections normally attended classes in law and became a member of the Faculty of Advocates. Most of Scott’s friends in Edinburgh were therefore members of this ‘noblesse of the robe’,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-10",
      "id": "num-footnote-2-10-back"
    }
  }, [_vm._v("5")])]), _vm._v(" and references to the Parliament House and its Courts are so frequent that some knowledge of the structure of the legal system in Scott’s time is necessary to a full understanding of the "), _c('i', [_vm._v("Journal")]), _vm._v(".\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00011"
    }
  }, [_vm._v("The supreme civil court in Scotland (subject to a right of appeal to the House of Lords) is the Court of Session. The Judges are known as the Lords of Session, and in 1825 there were fifteen of them. The seven junior Lords of Session sat in the Outer House to hear cases at first instance; the other eight sat in the Inner House in two Divisions to hear appeals. The First Division was presided over by the Lord President, the Second by the Lord Justice-Clerk. Scott sat as Clerk of Session in the First Division.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00013"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxvi"
    }
  }, [_vm._v("The supreme criminal court, from which there is no appeal to the House of Lords, is the High Court of Justiciary. In Scott’s day the Judges of this Court were the Lord Justice-Clerk and five Lords of Session, known in this capacity as the Lords Commissioners of Justiciary. Since this Court had its own Clerks of Justiciary, Scott was professionally involved only in its sittings on Circuit at Jedburgh, which he had to attend as Sheriff of Selkirkshire.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_xxvi"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_110262-00014"
    }
  }, [_vm._v("The Teind Court, which sat every second Wednesday during session, performed administrative and judicial functions connected with parish churches, manses, stipends, and ‘teinds’, or tithes. Its Judges were the Lords of Session, but the Court had its own Clerks, so Scott was free on a ‘Teind Wednesday’.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00015"
    }
  }, [_vm._v("The Jury Court, established in the teeth of heated opposition as recently as 1815, introduced jury trials in civil causes to Scotland. The Lord Chief Commissioner, who presided, was Scott’s friend William Adam of Blair-Adam. This Court had no original jurisdiction but tried issues of fact remitted to it by, for instance, the Court of Session, the Admiralty Court, or the House of Lords. Its existence as a separate Court, which was appropriate while civil jury trial was an innovation in Scotland, came to an end in 1830 when it was merged with the Court of Session.")])]), _c('p', {
    attrs: {
      "id": "rw-p_110262-00016"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxvi"
    }
  }, [_vm._v("The Court of Exchequer concerned itself with such matters as Customs and Excise, the approval of Sheriffs’ accounts, and the collection of Crown debts. The Lord Chief Baron of the Exchequer Court (throughout most of the period of the "), _c('i', [_vm._v("Journal")]), _vm._v(" Scott’s close friend Sir Samuel Shepherd) was assisted by two Barons of Exchequer. The Court did very little, and Scott would not have refused a Baron’s gown had it been offered to him in 1826."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-11",
      "id": "num-footnote-1-11-back"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00017"
    }
  }, [_vm._v("The previous twenty years had been a period of upheaval and reform. Between 1808 and 1830 the Court of Session, which Cockburn described as ‘a mob of fifteen judges, meeting without previous consultation, and each impatient for independent eminence, and many of them liable to be called away and to return irregularly in the course of the same day’,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-12",
      "id": "num-footnote-2-12-back"
    }
  }, [_vm._v("7")])]), _vm._v(" was reshaped in the \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_xxvii"
    }
  }, [_vm._v("manner described above. In 1825 the prize jurisdiction of the Admiralty Court was transferred to the High Court of Admiralty in England, and there was a far-reaching reorganization of the Sheriff Courts. To many of these changes Scott was opposed. The tendency in every case was towards a closer conformity with England, dictated not by reason but by ‘Anglomania – a rage of imitating English forms and practices’,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-13",
      "id": "num-footnote-1-13-back"
    }
  }, [_vm._v("8")]), _vm._v(" and Scott, whose poems and novels celebrated, as he said of "), _c('i', [_vm._v("Waverley")]), _vm._v(", ‘some traits of those characters and manners peculiar to Scotland the last remnants of which vanishd during my own youth’,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-14",
      "id": "num-footnote-2-14-back"
    }
  }, [_vm._v("9")])]), _vm._v(" saw Scots Law and the Scottish Church as the last bastions of national independence. He was not, however, opposed to all legal reforms. Indeed he acted as Secretary to the Parliamentary Commission which prepared the way for the reforms of 1808, and he voted with Jeffrey and other Whigs to reduce the number of judges in the Court of Session – a reform finally effected in 1830.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00019"
    }
  }, [_vm._v("Scott did not practise long at the Bar. When the "), _c('i', [_vm._v("Journal")]), _vm._v(" opens he had held for more than twenty years two legal offices which brought him a decent salary and little danger of too much work. A Sheriff’s duties were wide-ranging, but not particularly onerous – especially in Selkirkshire, which had a small, scattered, and, if poaching were left out of the question, a generally law-abiding population. Minor breaches of the law of all kinds came before his Court, and, as was inevitable in days of slow communications, frequent civil disorder, and no police force, he had considerable administrative and magisterial functions. It is clear from the "), _c('i', [_vm._v("Journal")]), _vm._v(" that Scott performed his duties conscientiously. He works on Sheriff Court processes, regularly transmits the county money to the Sheriff-Clerk, super-intends elections to Parliament, creates a force of Special Constables during the unrest of 1830 and 1831, and conducts investigations into cases of assault and riotous behaviour; he attends the Circuit Court at Jedburgh, and occasionally presides himself in the Sheriff Court at Selkirk.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00020"
    }
  }, [_vm._v("The Sheriff, who was paid "), _c('i', [_vm._v("£")]), _vm._v("300 a year, was allowed to appoint a Sheriff-Substitute, resident in the county, to hear cases and conduct the day-to-day business on his behalf. During the years covered by the "), _c('i', [_vm._v("Journal")]), _vm._v(" Scott’s deputy was his cousin William Scott of Maxpoffle, usually referred to as ‘Max’ or ‘Maxpopple’, who was neither very intelligent nor very efficient, but who badly needed the salary. From the letters which survive it would appear that the real power lay in the hands of an admirable Sheriff-Clerk, Andrew Lang, grandfather of the man of letters.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00022"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxviii"
    }
  }, [_vm._v("During legal terms Scott was necessarily absent from his sheriffdom, by virtue of his other duties as one of the Principal Clerks to the Court of Session. The Clerks were not the mere scribes that their title suggests, but held a position roughly analogous to that of a Town Clerk or a Clerk of Parliament. They had charge of the papers connected with a case, and were responsible for ensuring that the correct legal procedures were followed. At the end of the debate they had to reduce the Judge’s decision as delivered from the Bench to a concise written decree or ‘interlocutor’. A Clerkship of Session was not a sinecure, but the salary of "), _c('i', [_vm._v("£")]), _vm._v("1300 with which it was rewarded was handsome remuneration for the work involved. The Court sat from the 12th of November to the 24th of December, from the 15th of January to the 11th of March, and from the 12th of May to the 11th of July. Scott was not at the table before 10 a.m. and was often finished for the day by 1 p.m. If the sitting was prolonged beyond 2 p.m. he felt aggrieved enough to mention it in his "), _c('i', [_vm._v("Journal")]), _vm._v(". Since cases were shared between three Clerks, there was often time during the day to write letters – although not novels, as he was at pains to make clear."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-15",
      "id": "num-footnote-1-15-back"
    }
  }, [_vm._v("10")]), _vm._v(" Saturday was a working day, but Monday was not, and Scott also had a clear day every second Wednesday, when there was a sitting of the Teind Court.\n         ")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "rw-h2_110262-00003"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_c('a', {
    attrs: {
      "href": "#/9781847674951_tableofcontents"
    }
  }, [_vm._v("ABBOTSFORD")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110262-00023"
    }
  }, [_vm._v("Because of his two official positions Scott divided his time between Edinburgh and Abbotsford. By 1825 the house, whose enlargement and embellishment had been one of his principal concerns for more than ten years, was at last complete. A great ball to celebrate his son’s engagement to Jane Jobson was held in January of that year. He could look forward to spending his last years in the ‘Conundrum Castle’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-16",
      "id": "num-footnote-2-16-back"
    }
  }, [_vm._v("11")])]), _vm._v(" which he had created beside the Tweed, devoting himself to the care of his rising woods and plantations. Financially Abbotsford may have been the Dalilah who brought Scott to ruin,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-17",
      "id": "num-footnote-3-17-back"
    }
  }, [_vm._v("12")])]), _vm._v(" but to see it, as so many commentators have done, as the embodiment of Scott’s yearning for a feudal past, which he could relive as Laird of Abbotsford, is perverse. The plain facts are that an estate was the sensible investment for a man who was getting on in the \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_xxix"
    }
  }, [_vm._v("world, that the Sheriff of Selkirkshire was bound to live for some part of the year on Tweedside, and that Scott's was only one of 'the numerous families having independent fortunes that have chosen the neighbourhood for a place of residence, attracted', the "), _c('i', [_vm._v("Statistical Account of Roxburghshire")]), _vm._v(" suggested in 1841, 'by the amenity of the situation'."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-18",
      "id": "num-footnote-1-18-back"
    }
  }, [_vm._v("13")]), _vm._v(" Most of Scott's friends owned houses and estates in the country round Edinburgh or in the Borders; and by comparison with Arniston or Melville Castle, Mellerstain and Minto, Abbotsford is homely rather than grandiose. The public rooms are intimate, the upstairs more on the scale of a cottage than of a Gothic castle. For all the extravagance of its details, Abbotsford is a house for living in. It pleased Scott to return to the country from which his ancestors came, but he had other good reasons for building there.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00025"
    }
  }, [_vm._v("Nonetheless he overreached himself. The house and its embellishments cost thousands of pounds that were always to be earned by the next novel or the next novel but one, and land was a constant temptation. As early as 1816, long before the house was built or money laid aside to pay for it, he had added Kaeside to Abbotsford; he bought Toftfield in 1817, and he carried as far as Italy the dream of buying the neighbouring estate of Faldonside from Nicol Milne.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00026"
    }
  }, [_vm._v("In 1825 Abbotsford was finished, and, unless Scott lost the favour of the public, it would be paid for in a few years’ time. But the financial storm-clouds were already gathering.")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "rw-h2_110262-00004"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_c('a', {
    attrs: {
      "href": "#/9781847674951_tableofcontents"
    }
  }, [_vm._v("THE FINANCIAL CRASH")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110262-00027"
    }
  }, [_vm._v("The country-wide financial crisis of 1825 had already brought down numerous banks and business houses when on 14 January 1826 Constable’s London agents, Hurst, Robinson & Coy., stopped payment. Their fall brought down in turn Archibald Constable & Coy., Scott’s publishers, and with them James Ballantyne & Coy., the firm which printed the Waverley Novels and in which Scott himself was a partner. As there was no limited liability in those days, Scott himself was held responsible not only for his private debts of "), _c('i', [_vm._v("£")]), _vm._v("20,000, but also for the entire debts of the concern, which amounted to nearly "), _c('i', [_vm._v("£")]), _vm._v("100,000.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00028"
    }
  }, [_vm._v("This huge sum is largely accounted for by the incautious use of Accommodation Bills by Scott, Ballantyne, and Constable. An Accommodation Bill was a type of Bill of Exchange where one party lent his name in order to ‘accommodate’ another and enable him to raise capital at a discount. In the case of an ordinary Bill of Exchange the party who signed as Acceptor intended to pay the sum due on the due date, but in the case of an Accommodation Bill the true intention was that the Drawer of the Bill would redeem or ‘retire’ it on or before the due date, thus relieving the Acceptor of his liability. If, however, the Drawer could not pay when the date came, the Acceptor was liable. The position of the Acceptor was therefore very much like that of a person guaranteeing an overdraft.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00030"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxx"
    }
  }, [_vm._v("Archibald Constable & Coy. and James Ballantyne & Coy. were financed to a great extent by accommodating each other. Their system was to keep the amount guaranteed by each firm roughly equal and to adjust the balance from time to time. At the crash Archibald Constable & Coy. had accommodated James Ballantyne & Coy. to the extent of "), _c('i', [_vm._v("£")]), _vm._v("29,088. 2s. 6d., and James Ballantyne & Coy. had accommodated Archibald & Coy. to the extent of "), _c('i', [_vm._v("£")]), _vm._v("29,624. 2s. 9d., but neither firm had funds sufficient to repay the debts guaranteed by the other.\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_xxx"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_110262-00031"
    }
  }, [_vm._v("Scott, as a partner in James Ballantyne & Coy., was liable on both sets of Bills, since the partnership was the Drawer of one set and the Acceptor of the other. In addition he was liable on a further set of Bills which he had accepted in order to accommodate James Ballantyne & Coy. In the event, the liability of both firms was discharged by Scott, since the dividend of 2s. 9d. in the "), _c('i', [_vm._v("£")]), _vm._v(" paid by Constable & Coy. was set off against interest.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00032"
    }
  }, [_vm._v("The full extent of Scott’s liability was not immediately recognized. The Trustees’ first calculation of the claims against Scott and James Ballantyne & Coy., and of the funds available to meet them, was as follows:")]), _vm._v(" "), _c('div', {
    staticClass: "table",
    attrs: {
      "id": "rw-table_110262-00001"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "txxx"
    }
  }, [_c('caption', [_c('br')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("£")])]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("s.")])]), _vm._v(" "), _c('td', {
    staticClass: "col4"
  }, [_c('i', [_vm._v("d")]), _vm._v(".\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Amount of Claims")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("104,081")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("15")]), _vm._v(" "), _c('td', {
    staticClass: "col4"
  }, [_vm._v("6")])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Funds")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("69,456")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
    staticClass: "col4"
  }, [_vm._v("4")])]), _vm._v(" "), _c('tr', {
    staticClass: "row4"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("34,625")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("13")]), _vm._v(" "), _c('td', {
    staticClass: "col4"
  }, [_vm._v("2"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-19",
      "id": "num-footnote-1-19-back"
    }
  }, [_vm._v("14")])])])])])])])])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110262-00033"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxx"
    }
  }, [_vm._v("This was an underestimate. By the end of 1827, when the first dividend came to be paid, the claims were more accurately assessed at "), _c('i', [_vm._v("£")]), _vm._v("120,899. 5s. 6d."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-2-20",
      "id": "num-footnote-2-20-back"
    }
  }, [_vm._v("15")]), _vm._v(" – and these figures did not include £10,000 raised on the estate a few days before the crash. The principal debts were:\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110262-00034"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxxi"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xxxi"
    }
  }, [_c('div', {
    staticClass: "table",
    attrs: {
      "id": "rw-table_110262-00002"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "txxxi"
    }
  }, [_c('caption', [_c('br')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("£ ")])]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("s. ")])]), _vm._v(" "), _c('td', {
    staticClass: "col4"
  }, [_c('i', [_vm._v("d")]), _vm._v(".\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Scott’s private debts")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("20,066")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("19")]), _vm._v(" "), _c('td', {
    staticClass: "col4"
  }, [_vm._v("9")])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("J. B. & Coy.’ s debts")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("12,615")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("6")]), _vm._v(" "), _c('td', {
    staticClass: "col4"
  }, [_vm._v("7")])]), _vm._v(" "), _c('tr', {
    staticClass: "row4"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Discounted bills granted by"), _c('br'), _vm._v("             A. C. & Coy. to J. B. & Coy.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("29,088")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
    staticClass: "col4"
  }, [_vm._v("6")])]), _vm._v(" "), _c('tr', {
    staticClass: "row5"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Discounted bills granted by"), _c('br'), _vm._v("             J. B. & Coy. to A. C. & Coy.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("29,624")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
    staticClass: "col4"
  }, [_vm._v("9")])]), _vm._v(" "), _c('tr', {
    staticClass: "row6"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Discounted bills granted by "), _c('br'), _vm._v("             Scott to J. B. & Coy.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("15,365")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("13")]), _vm._v(" "), _c('td', {
    staticClass: "col4"
  }, [_vm._v("2")])]), _vm._v(" "), _c('tr', {
    staticClass: "row7"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Debts for which Scott was liable, but which were proper debts of A. C. & Coy.")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("9,129")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("9")]), _vm._v(" "), _c('td', {
    staticClass: "col4"
  }, [_vm._v("0"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-21",
      "id": "num-footnote-1-21-back"
    }
  }, [_vm._v("16")])])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110262-00035"
    }
  }, [_vm._v("The assets of Scott and Ballantyne, individually and as a company, totalled "), _c('i', [_vm._v("£")]), _vm._v("48,494, of which Scott’s share was almost exactly half. It was made up as follows:\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "table",
    attrs: {
      "id": "rw-table_110262-00003"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "t-axxxi"
    }
  }, [_c('caption', [_c('br')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("£ ")])]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("s. ")])]), _vm._v(" "), _c('td', {
    staticClass: "col4"
  }, [_c('i', [_vm._v("d")]), _vm._v(".\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Life-rent of Abbotsford")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("8,491")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("10")]), _vm._v(" "), _c('td', {
    staticClass: "col4"
  }, [_vm._v("0")])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Farm Stock")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("1,000")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    staticClass: "col4"
  }, [_vm._v("0")])]), _vm._v(" "), _c('tr', {
    staticClass: "row4"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Library")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("5,000")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    staticClass: "col4"
  }, [_vm._v("0")])]), _vm._v(" "), _c('tr', {
    staticClass: "row5"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Furniture")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("3,000")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    staticClass: "col4"
  }, [_vm._v("0")])]), _vm._v(" "), _c('tr', {
    staticClass: "row6"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("39 Castle Street")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("2,500")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    staticClass: "col4"
  }, [_vm._v("0")])]), _vm._v(" "), _c('tr', {
    staticClass: "row7"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Coach House")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("200")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    staticClass: "col4"
  }, [_vm._v("0")])]), _vm._v(" "), _c('tr', {
    staticClass: "row8"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Copyrights")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("4,600")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    staticClass: "col4"
  }, [_vm._v("0")])]), _vm._v(" "), _c('tr', {
    staticClass: "row9"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("24,791")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("10")]), _vm._v(" "), _c('td', {
    staticClass: "col4"
  }, [_vm._v(" 0"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-22",
      "id": "num-footnote-2-22-back"
    }
  }, [_vm._v("17")])])])])])])])])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110262-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxxi"
    }
  }, [_vm._v("Scott’s assets were just sufficient to have met the private claims against him; they could not begin to pay off the debts of James Ballantyne & Coy. In any case it would not have been sensible to dispose of most of these assets for ready money, and the Trustees did not. On the understanding that Scott would write for their benefit, they left him Abbotsford to live in, along with his library and furniture, and since the copyrights were of infinitely greater value in their own hands they too were not sold. Their best hope was to trust in Scott’s own resolve to write his way out of his difficulties. ‘This right hand shall work it all off’, he had said,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-3-23",
      "id": "num-footnote-3-23-back"
    }
  }, [_vm._v("18")]), _vm._v(" and work it off, with Cadell’s help, he did.\n         ")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_xxxii"
    }
  }, [_vm._v("When the crash came three possibilities were open to Scott: Cessio, Sequestration, or a Trust Deed. By the procedure known as Cessio "), _c('i', [_vm._v("Bonorum")]), _vm._v(" an insolvent debtor could, if his creditors agreed, put all his goods at the disposition of his creditors. He remained liable for the full amount of his debts, but could no longer be imprisoned for his failure to pay. At one point in the "), _c('i', [_vm._v("Journal")]), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-24",
      "id": "num-footnote-1-24-back"
    }
  }, [_vm._v("19")]), _vm._v(" McCulloch of Ardwall avails himself of this procedure to procure his release from jail. For Scott, however, it was not the best solution, since it would have entailed the loss of his library, his furniture, and his life-rent of Abbotsford.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00038"
    }
  }, [_vm._v("Sequestration was similar to modern procedures. It gave the debtor an absolute discharge, provided that four-fifths of the creditors, in number and value, concurred. It was available only to debtors engaged in trade. When harried by Abud in 1827 Scott was nearly forced to apply for Sequestration. Had he done so, it would have eased his burden and perhaps lengthened his life, but it would not have suited his creditors, who would have received some shillings in the pound instead of the full amount. None the less Sequestration was the course Scott himself would have recommended to a client in his position."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-25",
      "id": "num-footnote-2-25-back"
    }
  }, [_vm._v("20")])]), _vm._v(" Why then did he not avail himself of it at the start? Firstly, because he was a gentleman. Sequestration was for debtors engaged in trade, and although Scott was legally entitled to it by virtue of his business interests, he could not take advantage of it without sinking himself for ever, in his own eyes and in the eyes of his friends, to the level of a shopkeeper. He might by this means have saved his library and bid his creditors defiance; but in doing so, he would, as he put it, in a court of honour deserve to lose his spurs.2 Secondly, almost all the money he owned and much of the money he owed was sunk in the estate of Abbotsford, which he had effectively removed from the reach of his creditors by settling it on his son Walter at his marriage only a year before. If he had petitioned for Sequestration, he could have paid perhaps 7"), _c('i', [_vm._v("s")]), _vm._v(". in the "), _c('i', [_vm._v("£")]), _vm._v("; had he still owned Abbotsford, instead of merely the life-rent, he might have paid double. Evil tongues would not be lacking to whisper that he had foreseen the crash, and to protect Abbotsford had taken steps which although legal were scarcely honourable.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00039"
    }
  }, [_vm._v("Instead, Scott took the third way that was open to him and signed a Trust Deed for his creditors. This had the advantage of allowing all parties to agree on the conditions that were to be observed. In this case the Trustees decided to sell 39 Castle Street, but to leave Scott his official salary to live on, and the use of his library and furniture at Abbotsford. Scott in turn bound himself in these terms:")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110262-00040"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxxiii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xxxiii"
    }
  }), _c('div', {
    staticClass: "block extract",
    attrs: {
      "id": "rw-block-extract_110262-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxxiii"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_xxxiii"
    }
  }, [_vm._v("I the said Sir Walter Scott have resolved to employ my time and talents on the production of such literary works as shall seem to me most likely to promote the ends I have in view, the sums arising from which works I am also desirous to devote to the payment of the debts owing by me as a Partner of the said Company [James Ballantyne & Coy.] and as an individual."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-26",
      "id": "num-footnote-1-26-back"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110262-00002"
    }
  }, [_vm._v("Throughout the period of the "), _c('i', [_vm._v("Journal")]), _vm._v(" that is in effect what Scott did. Almost every moment when he is free from the Court is employed in the attempt to write off his debts. On Sundays, or on wet days at Abbotsford, he works harder than on ordinary days. As 1827 succeeds 1826 the number of Entries which record six leaves completed in the day, instead of the original task of three, show that he is working twice as hard as before, and much harder than he ought. He has always written in the morning – that is, before breakfast – and in the forenoon at Abbotsford; now writing before dinner ‘has become a habit’,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-27",
      "id": "num-footnote-2-27-back"
    }
  }, [_vm._v("22")])]), _vm._v(" and usually he works also in the evening. In 1829 he begins to fall asleep as he writes "), _c('i', [_vm._v("Anne of Geierstein")]), _vm._v(". By 1831 the compulsion to write and keep writing, despite illness and disability, is so strong that Moore is told that ‘The great object in sending him abroad is to disengage his mind from the strong wish to write by which he is haunted.’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-28",
      "id": "num-footnote-3-28-back"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00041"
    }
  }, [_vm._v("The result of Scott’s unremitting labour was a staggering collection of titles. "), _c('i', [_vm._v("Woodstock")]), _vm._v(" was already begun at the time of the crash, and the first volume of the "), _c('i', [_vm._v("Life of Napoleon")]), _vm._v(" was finished. Between 1826 and 1831 Scott wrote five novels – "), _c('i', [_vm._v("Woodstock, The Fair Maid of Perth, Anne")]), _vm._v(" "), _c('i', [_vm._v("of Geierstein, Count Robert of Paris")]), _vm._v(", and "), _c('i', [_vm._v("Castle Dangerous")]), _vm._v("; one collection of short stories – "), _c('i', [_vm._v("Chronicles of the Canongate")]), _vm._v("; one play – "), _c('i', [_vm._v("Auchin")]), _c('i', [_vm._v("drane")]), _vm._v("; the nine-volume "), _c('i', [_vm._v("Life of Napoleon")]), _vm._v("; a two-volume "), _c('i', [_vm._v("History of Scotland")]), _vm._v(" for Dr. Lardner’s Cabinet Cyclopaedia; four series of "), _c('i', [_vm._v("Tales of a Grandfather")]), _vm._v("; Notes and Introduction to the Magnum edition of the novels; and two volumes of essays for the "), _c('i', [_vm._v("Miscellaneous")]), _vm._v(" "), _c('i', [_vm._v("Prose Works")]), _vm._v(".\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00042"
    }
  }, [_vm._v("The numbers of each edition and the profits to the Trust were of this order:")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110262-00043"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxxiv"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xxxiv"
    }
  }, [_c('div', {
    staticClass: "table",
    attrs: {
      "id": "rw-table_110262-00004"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "txxxiv"
    }
  }, [_c('caption', [_c('br')]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Copies")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("£")])])]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Woodstock")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("9850")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("6075")])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Napoleon")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("6000")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row4"
  }, [_c('td', {
    staticClass: "col1",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("and")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("2000")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("9413")])]), _vm._v(" "), _c('tr', {
    staticClass: "row5"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Chronicles of the Canongate")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("8750")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("2228")])]), _vm._v(" "), _c('tr', {
    staticClass: "row6"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Fair Maid of Perth")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("8500")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("4200")])]), _vm._v(" "), _c('tr', {
    staticClass: "row7"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Anne of Geierstein")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("8500")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("4200")])]), _vm._v(" "), _c('tr', {
    staticClass: "row8"
  }, [_c('td', {
    staticClass: "col1"
  }, [_c('i', [_vm._v("Count Robert of Paris")]), _vm._v(" and "), _c('i', [_vm._v("Castle Dangerous")])]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("5000")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("1750"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-29",
      "id": "num-footnote-1-29-back"
    }
  }, [_vm._v("24")])])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110262-00003"
    }
  }, [_vm._v("In addition the small Collected Editions brought in "), _c('i', [_vm._v("£")]), _vm._v("1950, and the Magnum Opus or Collected Edition, which was the means in the end of liquidating the debt, had contributed "), _c('i', [_vm._v("£")]), _vm._v("18,000 by the time Scott went abroad. In less than six years he made nearly "), _c('i', [_vm._v("£")]), _vm._v("50,000 for his creditors.\n         ")])]), _c('p', {
    attrs: {
      "id": "rw-p_110262-00044"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxxiv"
    }
  }, [_vm._v("He also made some thousands for himself. It was not in his nature to pinch and scrape. ‘Papa is a bad hand at economizing’, Anne told Moore. ‘All his great plans of retrenchment have ended in selling my horse.’"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-2-30",
      "id": "num-footnote-2-30-back"
    }
  }, [_vm._v("25")]), _vm._v(" In truth no amount of retrenchment could have enabled him to live within his official income of less than "), _c('i', [_vm._v("£")]), _vm._v("2000 a year, as long as he had Abbotsford, or as long as his fame drew every traveller of rank and eminence who visited Scotland to pass along Tweedside. His own generosity too made a mockery of his economies: "), _c('i', [_vm._v("£")]), _vm._v("10 to save Haydon from his creditors; "), _c('i', [_vm._v("£")]), _vm._v("5 to Laidlaw; "), _c('i', [_vm._v("£")]), _vm._v("20 to Charles; "), _c('i', [_vm._v("£")]), _vm._v("100 to Walter; "), _c('i', [_vm._v("£")]), _vm._v("50 to Gillies and "), _c('i', [_vm._v("£")]), _vm._v("50 again. ‘I will grow hard-hearted and do no more’,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-31",
      "id": "num-footnote-3-31-back"
    }
  }, [_vm._v("26")])]), _vm._v(" Scott resolves in despair; but the next appeal always finds the same open hand.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00045"
    }
  }, [_vm._v("Money had to be found from somewhere, and it came from the same unfailing source. In addition to the "), _c('i', [_vm._v("£")]), _vm._v("50,000 for his creditors, Scott earned close on "), _c('i', [_vm._v("£")]), _vm._v("6000 for himself. The four series of "), _c('i', [_vm._v("Tales of a")]), _vm._v(" "), _c('i', [_vm._v("Grandfather")]), _vm._v(" brought him more than "), _c('i', [_vm._v("£")]), _vm._v("3000; there was "), _c('i', [_vm._v("£")]), _vm._v("1500 from Dr. Lardner for his "), _c('i', [_vm._v("History of Scotland")]), _vm._v("; "), _c('i', [_vm._v("£")]), _vm._v("500 from Cadell for "), _c('i', [_vm._v("Chronicles of the Canongate")]), _vm._v("; "), _c('i', [_vm._v("£")]), _vm._v("100 or "), _c('i', [_vm._v("£")]), _vm._v("50 for every lengthy review for the "), _c('i', [_vm._v("Quarterly")]), _vm._v(" or "), _c('i', [_vm._v("Foreign Quarterly")]), _vm._v(". The Trustees were embar-rassed to find that Scott was writing for his own profit as well as for theirs. The first case was "), _c('i', [_vm._v("Chronicles of the Canongate")]), _vm._v(", which Scott intended to publish anonymously in a limited edition for a payment of "), _c('i', [_vm._v("£")]), _vm._v("500. When he changed his mind and allowed Cadell to extend the impression to 8000, he told the Trustees about the work and stipulated that a further "), _c('i', [_vm._v("£")]), _vm._v("2000 should be paid to them.1 "), _c('i', [_vm._v("Tales of a")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "pb-rw_xxxv"
    }
  }, [_c('i', [_vm._v("Grandfather")]), _vm._v(" posed them more of a problem. Scott kept the proceeds for himself, without a word to the Trustees, other than a remark ‘in a jocular manner’ to Gibson: ‘Remember I do not mean to give you this little Book, I must keep it for myself to pay my current expenses and for my family.’"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-32",
      "id": "num-footnote-1-32-back"
    }
  }, [_vm._v("27")]), _vm._v(" After anxious discussion they acted magnani-mously:\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "block extract",
    attrs: {
      "id": "rw-block-extract_110262-00002"
    }
  }, [_c('p', [_vm._v("taking into view how largely the creditors have drawn and were continuing to draw from the treasures of his genius since his embarrassments came upon him, and the "), _c('i', [_vm._v("high moral feeling")]), _vm._v(" from which his great and productive exertions on their behalf spring, and how indispensably necessary it was both for his health and his spirits that he should continue to live in the same easy and comfortable style to which he had long been accustomed, the Trustees did not see it to be their duty to interfere with him in reference to the works in question."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-33",
      "id": "num-footnote-2-33-back"
    }
  }, [_vm._v("28")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110262-00047"
    }
  }, [_vm._v("No claim was made either on his "), _c('i', [_vm._v("History of Scotland")]), _vm._v(" or his "), _c('i', [_vm._v("Quarterly")]), _vm._v(" money, and it was only when "), _c('i', [_vm._v("Castle Dangerous")]), _vm._v(" came to be written and they discovered that ‘without communicating… with the Trustees Sir Walter had disposed of the First Edition of this new Book to Mr. Cadell and had applied the author’s money to his own purposes’,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-34",
      "id": "num-footnote-3-34-back"
    }
  }, [_vm._v("29")])]), _vm._v(" that they had to make a stand. But by then Scott was too ill to be fully aware of what he was doing.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00048"
    }
  }, [_vm._v("His contention that these works were written in his own time, ‘in the hours snatched literally from rest and exercise’,1 is not to be taken as the whole truth, for the "), _c('i', [_vm._v("Journal")]), _vm._v(" Entries quite clearly show that, for instance, throughout the months of October 1827 and June 1828 he wrote nothing other than "), _c('i', [_vm._v("Tales of a Grandfather")]), _vm._v(". The sums involved, however, can never have amounted to more than an eighth of what he was paying into the Trust, and ultimately it was in everyone’s interest that he should be as free as possible from financial worries.\n         ")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "rw-h2_110262-00005"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_c('a', {
    attrs: {
      "href": "#/9781847674951_tableofcontents"
    }
  }, [_vm._v("THE ARBITRATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110262-00049"
    }
  }, [_vm._v("The Trustees of the two bankrupt companies – James Ballantyne & Coy., and Archibald Constable & Coy. – inevitably found themselves in dispute over a number of questions, and they agreed to submit their differences to the arbitration of Alexander Irving, who was raised to the Bench shortly afterwards as Lord Newton. Since the "), _c('i', [_vm._v("Journal")]), _vm._v("’s frequent references to the progress of the arbitration are confusing and in places apparently contradictory, it is worth setting out the individual points at issue.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00051"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxxvi"
    }
  }, [_vm._v("Constable’s Trustees laid claim to the "), _c('i', [_vm._v("Life of Napoleon")]), _vm._v(" and "), _c('i', [_vm._v("Wood-")]), _c('i', [_vm._v("stock")]), _vm._v(", on the grounds that they had agreed with Scott to publish them. Scott’s Trustees, in reply, argued that any agreement lapsed at the failure of Archibald Constable & Coy., for a company that no longer existed could not carry out its part of the bargain by publishing the works in question. While Lord Newton pondered, the works were completed and published, and by mutual agreement the profits were banked until the arbiter gave his judgement. When he declared in favour of Scott, on the grounds that the words ‘had never been the subject of a completed bargain’,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-35",
      "id": "num-footnote-1-35-back"
    }
  }, [_vm._v("30")]), _vm._v(" the Trustees were able at last to pay their first dividend.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00052"
    }
  }, [_vm._v("At the time of the crash six volumes of "), _c('i', [_vm._v("Miscellaneous Prose Works")]), _vm._v(" were in preparation. Two volumes were already in Constable’s possession, two volumes were in Ballantyne’s printing office, and two volumes were as yet unfinished. Since in that state they were of no use to anyone, Scott proposed in July 1826 that he should supply the necessary copy, and that the whole work should be published as soon as possible, the profits to be laid aside until Lord Newton decided to whom they rightly belonged. The "), _c('i', [_vm._v("Prose Works")]), _vm._v(" were accordingly published jointly by Cadell in Edinburgh and Longman in London; but as Lord Newton decided in favour of Archibald Constable & Coy. (‘altho’ they had not paid the price’, as the minutes of a meeting of Scott's Trustees complains, ‘but had merely granted Bills which were dishonoured and now rank on Sir Walter Scott's Estate’),"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-36",
      "id": "num-footnote-2-36-back"
    }
  }, [_vm._v("31")])]), _vm._v(" the only profit to the Trust was "), _c('i', [_vm._v("£")]), _vm._v("200 for reissuing and putting to press.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00053"
    }
  }, [_vm._v("Scott also lost the copyrights of his earlier novels. These he had sold to Constable, but he argued that part of them remained his property as "), _c('i', [_vm._v("£")]), _vm._v("3800 of the purchase price had never been paid. The arbiter declared otherwise; Constable’s Trustees put them up for sale, and Cadell and Scott's Trustees had to buy them back for "), _c('i', [_vm._v("£")]), _vm._v("8400."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-37",
      "id": "num-footnote-3-37-back"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00054"
    }
  }, [_vm._v("The final question to be settled was the ownership of the manu-scripts of the novels. Scott had given these to Constable, but the condition on which the gift was made – that the secret of his authorship should be preserved – had been infringed, he said, by Constable. Lord Newton decided, however, that they remained the "), _c('a', {
    attrs: {
      "id": "pb-rw_xxxvii"
    }
  }, [_vm._v("property of Constable’s creditors, as they were a gift of a remuneratory nature. They were sold at Evans’s rooms in London in 1831 for only a few hundred pounds. "), _c('i', [_vm._v("Waverley")]), _vm._v(" fetched "), _c('i', [_vm._v("£")]), _vm._v("18, "), _c('i', [_vm._v("Ivanhoe £")]), _vm._v("12, and "), _c('i', [_vm._v("Rob Roy")]), _vm._v(" the top price of "), _c('i', [_vm._v("£")]), _vm._v("50."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-38",
      "id": "num-footnote-1-38-back"
    }
  }, [_vm._v("33")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00056"
    }
  }, [_vm._v("On three out of the five main issues before him, Lord Newton decided against Scott. Nonetheless ‘the grand questions’."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-39",
      "id": "num-footnote-2-39-back"
    }
  }, [_vm._v("34")])]), _vm._v(" of the profits of "), _c('i', [_vm._v("Woodstock")]), _vm._v(" and the "), _c('i', [_vm._v("Life of Napoleon")]), _vm._v(" were settled in his favour, and the loss of the copyrights, on which all hopes of paying off the debt by the judicious management of further editions depended, was not irreparable.\n         ")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "rw-h2_110262-00006"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_c('a', {
    attrs: {
      "href": "#/9781847674951_tableofcontents"
    }
  }, [_vm._v("POLITICAL AFFAIRS")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110262-00057"
    }
  }, [_vm._v("Scott followed politics with more than a spectator’s interest. He was the friend of Canning, Peel, and Wellington, and acquainted with many other members of the Cabinet."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-40",
      "id": "num-footnote-3-40-back"
    }
  }, [_vm._v("35")])]), _vm._v(" His link with London during the turbulent years to which the "), _c('i', [_vm._v("Journal")]), _vm._v(" belongs was Lockhart, a faithful and frequent correspondent on political affairs. By instinct and long habit Scott was a high Tory, and on most of the important issues he held the views that one would expect. On the Catholic Question, however, his visit to Ireland in 1825 had made him change his mind, and he gave a guarded welcome to the passage of the Catholic ‘Emancipation’ Act in 1829, which threw open most civil and military offices to Roman Catholics.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00058"
    }
  }, [_vm._v("To Reform, however, he remained resolutely opposed. He did not understand the forces that were at work, nor see that the new patterns of production and employment forced on the country by the industrial revolution and the needs of the war against Napoleon had altered society beyond any possibility of going back. What he saw was a prosperous and contented population of peasants and small farmers turned in one generation into ‘the stern sullen unwashd artificers whom you see lounging sulkily along the streets of the towns in Lancashire’,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-41",
      "id": "num-footnote-4-41-back"
    }
  }, [_vm._v("36")])]), _vm._v(" and unruly mobs filled with revolutionary ideas.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00059"
    }
  }, [_vm._v("Reform of the franchise was, however, necessary as well as inevitable. Omond, in his book "), _c('i', [_vm._v("The Lord Advocates of Scotland")]), _vm._v(", describes a state of affairs which cried out for action:\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110262-00060"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxxviii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xxxviii"
    }
  }), _c('div', {
    staticClass: "block extract",
    attrs: {
      "id": "rw-block-extract_110262-00003"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxxviii"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_xxxviii"
    }
  }, [_vm._v("In Scotland the state of the representation was far worse than in England. The population was, in round numbers, two millions three hundred and sixty thousand. The franchise was in the hands of about three thousand persons. The county franchise was the privilege of the freeholders. Of these fully one-half were Paper Barons, voters who possessed no property, but had voting qualifications. In Midlothian, out of one hundred and seventy-two electors, one hundred and forty-one were paper voters…. In Buteshire, out of twenty-one electors, twenty were paper voters…. The burgh franchise was in the hands of the self- elected Town Councils. Edinburgh, the population of which was upward of one hundred and sixty-two thousand, had thirty-three electors, the members of its Town Council; but the average number of voters in a Scottish burgh was nineteen, the average number of the corporations. The distribution of the burgh seats was, moreover, grossly absurd. Glasgow, with a population of one hundred and forty-seven thousand, had one-fourth of a member, whom it shared with Renfrew, Rutherglen, and Dumbarton, whose united populations came to a little more than ten thousand. Paisley with twenty-six thousand inhabitants, Green-ock with twenty-two thousand, Kilmarnock with twelve thousand, Falkirk with eleven thousand, had no representation in Parliament. But five small burghs in Fife, the united populations of which amounted to only six thousand, returned a member."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-42",
      "id": "num-footnote-1-42-back"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("The reforms projected by Lord John Russell in March 1831 seem scarcely radical enough to make much impression on a situation as desperate as this. Only 60,000 new voters in Scotland were added by the new measures extending the franchise (i) to householders in the burghs rated at "), _c('i', [_vm._v("£")]), _vm._v("10, and (ii) to all those in the counties who possessed real property to the value of "), _c('i', [_vm._v("£")]), _vm._v("10, or were tenants on a long lease paying at least "), _c('i', [_vm._v("£")]), _vm._v("50 in rent. But to Scott these proposals, as embodied in three successive Reform Bills,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-43",
      "id": "num-footnote-2-43-back"
    }
  }, [_vm._v("38")])]), _vm._v(" were ‘the most uncalld for attack upon a free constitution… which ever was ventured in my day’."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-44",
      "id": "num-footnote-3-44-back"
    }
  }, [_vm._v("39")])]), _vm._v(" He campaigned against them with vigour, and urged his younger friends to adopt the same uncompromising principles. The news that the Third Reform Bill had finally received the Royal Assent in July 1832 was probably kept from him, but it would have consoled him a little, as he lay on his deathbed, to know that his young chief, the Duke of Buccleuch, as Scott had hoped he would, ‘to the last protested against the bill’."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-45",
      "id": "num-footnote-4-45-back"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110262-00062"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxxix"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xxxix"
    }
  }), _c('h2', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "rw-h2_110262-00007"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxxix"
    }
  }, [_c('span', {
    staticClass: "sc"
  })]), _c('a', {
    attrs: {
      "href": "#/9781847674951_tableofcontents"
    }
  }, [_vm._v("THE PEOPLE OF THE JOURNAL")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110262-00004"
    }
  }, [_vm._v("Sir Walter Scott was fifty-four in 1825 and Lady Scott a year older. There is no clear description of her in the "), _c('i', [_vm._v("Journal")]), _vm._v(", only the hint that she was not the person she had been. Other diarists were less reticent. ‘Lady Scott was a little, made-up sort of personage in my time,’ writes an Edinburgh lawyer, ‘luxuriant, dark, and I should say not natural curls, shading a yellow face, blushing under a real or artificial bloom of crimson, a very little figure, and a "), _c('i', [_vm._v("bustling")]), _vm._v(" demeanour exhibited both a physical and moral manner in singular contrast to the manly plainness of her illustrious husband.’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-46",
      "id": "num-footnote-1-46-back"
    }
  }, [_vm._v("41")])]), _vm._v(" Helen Graham was struck too by the ‘complete contrast to her husband: she is a funny looking little bodie and very fond of showy dress, and completely foreign both in manner and appearance. She is said to be very variable towards her acquaintances. She was so kind, sweet and hospitable to us; nothing could exceed it.’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-47",
      "id": "num-footnote-2-47-back"
    }
  }, [_vm._v("42")])]), _vm._v(" Lady Shelley found her in her younger days ‘the greatest bore in Europe’, speaking ‘an almost unintelligible broken English’,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-48",
      "id": "num-footnote-3-48-back"
    }
  }, [_vm._v("43")])]), _vm._v(" and Mrs. Grant of Laggan thought her a snob. Scott’s own testimony, however, should not be ignored. ‘Whatever were her failings,’ he wrote to Sophia after her death, ‘they hurt only herself and arose out of bodily illness and must be weighd against one of the most sincere loyal and generous hearts that ever blood warmd.’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-49",
      "id": "num-footnote-4-49-back"
    }
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00063"
    }
  }, [_vm._v("His elder son Walter was twenty-four when the "), _c('i', [_vm._v("Journal")]), _vm._v(" opens. He was tall and bewhiskered, rode beautifully, and was seriously devoted to his army duties as a Captain in the 15th Hussars. Scott adored him. ‘He has good sense and the most perfect good temper,’ he writes to Lady Louisa Stuart, ‘bel cavalier beau sabreur a very kind husband to his little wife.’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-50",
      "id": "num-footnote-5-50-back"
    }
  }, [_vm._v("45")])]), _vm._v(" But he was also obstinate,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-51",
      "id": "num-footnote-6-51-back"
    }
  }, [_vm._v("46")])]), _vm._v(" occasionally uncivil,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-52",
      "id": "num-footnote-7-52-back"
    }
  }, [_vm._v("47")])]), _vm._v(" and, on the evidence of those who met him in Italy, ‘rather an adept at the gaming-table’."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-53",
      "id": "num-footnote-8-53-back"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_xl"
    }
  }, [_vm._v("His wife Jane, whom he had married in January 1825, was Sir Adam Ferguson’s niece. ‘Poor Jane’s heart is so sincere and good that one must make considerable allowance for the narrowness of her education’,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-54",
      "id": "num-footnote-1-54-back"
    }
  }, [_vm._v("49")]), _vm._v(" Scott wrote to Walter, forgetting to mention the even greater allowances that should be made for the estate and fortune she brought with her. Mrs. Thomas Scott found her ‘rather retired’,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-55",
      "id": "num-footnote-2-55-back"
    }
  }, [_vm._v("50")])]), _vm._v(" and such of her letters as survive reveal a humourless, insipid girl. To Scott’s great grief she had no children. Neither the Lockharts nor Anne enjoyed her company,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-56",
      "id": "num-footnote-3-56-back"
    }
  }, [_vm._v("51")])]), _vm._v(" but she was at least preferable to her widowed mother, ‘the fat, vulgar Mrs. Jobson’. Mrs. Grant of Laggan says that she was not entirely happy at the match: ‘her Jane might have looked higher; it was only a baronetcy, and quite a late creation’."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-57",
      "id": "num-footnote-4-57-back"
    }
  }, [_vm._v("52")])]), _vm._v(" She was troublesome before the wedding – ‘A perfect allegory on the banks of the Nile and all for nonsense of the first water’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-58",
      "id": "num-footnote-5-58-back"
    }
  }, [_vm._v("53")])]), _vm._v(" – and no great favourite with her son-in-law after it."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-59",
      "id": "num-footnote-6-59-back"
    }
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00066"
    }
  }, [_vm._v("Scott’s younger son Charles was ‘a nice young man’,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-60",
      "id": "num-footnote-7-60-back"
    }
  }, [_vm._v("55")])]), _vm._v(" cleverer, more likeable, and more attached to his family than Walter. He was a little deaf and at times terribly afflicted by rheumatism. In 1825 he was still at Oxford; afterwards he was placed in the Foreign Office, and he died in 1841 of a fever caught while on a mission to Persia.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00067"
    }
  }, [_vm._v("Sophia was Scott’s favourite daughter, and ‘much of her father’s temper’ was evident in ‘her placidity of disposition’."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-61",
      "id": "num-footnote-8-61-back"
    }
  }, [_vm._v("56")])]), _vm._v(" He loved to hear her sing Scots songs and was proud of her skill on the harp. Anne did not share his opinion: ‘Sophia is rather too much with her harp,’ she writes to Missie, ‘I wish she would take example of old times and hang it up.’ She was not strong, but she clearly made the most of her indispositions – much of her life was spent upon her sofa. Walter calls her ‘a most established coddler’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-9-62",
      "id": "num-footnote-9-62-back"
    }
  }, [_vm._v("57")])]), _vm._v(" and ‘a croaker of the first magni-tude’,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-10-63",
      "id": "num-footnote-10-63-back"
    }
  }, [_vm._v("58")])]), _vm._v(" and Scott was pleased when she found ‘an anti-druggist’ like Dr. Gooch to look after her in London."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-11-64",
      "id": "num-footnote-11-64-back"
    }
  }, [_vm._v("59")])]), _vm._v(" She married John Gibson Lockhart in 1820. Their first child, Johnnie, who had a disease of the spine, was born in 1821. Walter and Charlotte were born during the "), _c('i', [_vm._v("Journal")]), _vm._v(" years, in 1826 and 1828.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00068"
    }
  }, [_vm._v("John Lockhart, Scott’s biographer, was by this time closer to him in some ways than either of his sons. He was of the literary world and Scott could discuss his work with him as with no one else. His departure for London to become editor of the "), _c('i', [_vm._v("Quarterly")]), _vm._v(" was a loss which was never made good, although it had the compensation of quick and full access to events in the capital. Lockhart wrote continually to Scott from London, two or three times a week if political affairs were interesting, and though these letters have salt enough to recall the satirist of the "), _c('i', [_vm._v("Blackwood")]), _vm._v(" days, they reveal a liking for his father-in-law and a fundamental kindness with which he is not always credited. To Scott he was ‘the Hidalgo’, prevented from reaching the highest eminence only by a characteristically Scottish mixture of pride and diffidence that made him reluctant to push himself in society.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00070"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xli"
    }
  }, [_vm._v("Scott’s younger daughter Anne became the companion of his last years. On the evidence of a young man who met her in Italy, ‘she was very pretty, with good eyes, clear colour, dark brown hair, and tall figure’,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-65",
      "id": "num-footnote-1-65-back"
    }
  }, [_vm._v("60")]), _vm._v(" and the truth of his description is attested by the fine portrait of her which hangs at Abbotsford. He added that ‘there was little or nothing of the parental Doric in her accent’. Andrew Shortreed, who met her in May 1827, found her ‘clever – good looking – unaffected – some what witty and rather arch’,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-66",
      "id": "num-footnote-2-66-back"
    }
  }, [_vm._v("61")])]), _vm._v(" and as a letter-writer she displays a satirical and irreverent wit at times too cutting for the comfort of those nearest to her. ‘Miss Scott seems very satirical’, was Helen Graham’s first impression of her. ‘I fancy as Sir Walter’s daughter, she thinks she ought to be clever, which she is not, I am sure, and so mistakes censure and satire for wit and cleverness. Scarcely a girl in Edinburgh she had not something or other to say of, and unfavourable in general, which is a bad sign, I really think, particularly to a person she never saw or knew before. I know I felt as if my turn would come to be talked ill of to somebody else, when I myself was not present.’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-67",
      "id": "num-footnote-3-67-back"
    }
  }, [_vm._v("62")])]), _vm._v(" That she was also strong-minded and capable Scott himself discovered only at the time of his wife’s death, but Lockhart had already discerned ‘what a strong fund of good sense lies under the disguize of her ladyship’s persifflage’."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-68",
      "id": "num-footnote-4-68-back"
    }
  }, [_vm._v("63")])]), _vm._v(" She was twenty-two when the "), _c('i', [_vm._v("Journal")]), _vm._v(" opens, and she died unmarried in 1833.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00071"
    }
  }, [_vm._v("Outside his immediate family the two men with whom Scott was most concerned during these years were his printer and his publisher. He first met James Ballantyne, usually referred to in the "), _c('i', [_vm._v("Journal")]), _vm._v(" as ‘James’ or ‘J. B.’, in the grammar school at Kelso. In 1802 Scott persuaded him to move his printing business to Edinburgh, and in 1805 became his partner in the firm which printed the Waverley Novels. He was indispensable to Scott. He carried out the elaborate arrangements of transcribing and double proofs by which his anonymity was preserved, and he was the representative of the popular taste to whose critical judgement Scott often deferred. Their correspondence at times bordered on acrimony, but Scott valued a man who knew his mind and was not afraid to speak it. The association remained unbroken by the crash, for the Trustees continued to employ Ballantyne as editor of the "), _c('i', [_vm._v("Edinburgh Weekly Journal")]), _vm._v(" and manager of the printing-house. His increasing melancholia, and growing addiction to religion of a fundamentalist kind, began to cool the friendship after 1829 and it did not survive Ballantyne’s conversion to Reform.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00073"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xlii"
    }
  }, [_vm._v("With Robert Cadell, Constable’s partner, Scott’s affairs were inextricably linked. As ‘a thorough man of business’"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-69",
      "id": "num-footnote-1-69-back"
    }
  }, [_vm._v("64")]), _vm._v(" he was the first to see, after the crash, that the man who became Scott’s publisher could pay off Scott’s debts and make his own fortune; and Scott’s publisher he duly became. A cautious man who yet took big risks successfully, he was a tireless worker, ‘with whose activity and zeal’ the Trustees declared themselves fully satisfied."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-70",
      "id": "num-footnote-2-70-back"
    }
  }, [_vm._v("65")])]), _vm._v(" He was a Whig, and a philistine. He knew little about books as literature, but prided himself on his ‘plain business way’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-71",
      "id": "num-footnote-3-71-back"
    }
  }, [_vm._v("66")])]), _vm._v(" of looking at them ‘as a Tradesman’."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-72",
      "id": "num-footnote-4-72-back"
    }
  }, [_vm._v("67")])]), _vm._v(" As time went on he became Scott’s confidential man of business, relieving him of petty worries, settling accounts for him, and lending him money without stint. The tone of his letters to Scott is deferential, but there is nothing to suggest that Scott was wrong in thinking that Cadell really liked him.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00074"
    }
  }, [_vm._v("Behind these two men lurks a third man of business, the polite precise figure of John Gibson, junior. On the retirement of his partner Hay Donaldson only a short time before the crash he had become Scott’s solicitor, and the creditors appointed him as one of the three Trustees. Naturally the main burden fell upon him, and he proved the ideal choice. His leading feature, according to Ballantyne, was caution – ‘what [a] useful one!’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-73",
      "id": "num-footnote-5-73-back"
    }
  }, [_vm._v("68")])]), _vm._v(" he adds feelingly – and his conduct of the Trust reveals a prudent, painstaking Edinburgh lawyer, who let nothing pass him by. He admired Scott immensely, and the letters written at the time, and his "), _c('i', [_vm._v("Reminiscences")]), _vm._v(" written long afterwards, betray an awe of the great man that he never quite lost.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00076"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xliii"
    }
  }, [_vm._v("In Session time Scott’s circle was centred on Parliament House and ‘the society of my brethren excellent friendly men whom I prefer for general society to what they call a literary set’."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-74",
      "id": "num-footnote-1-74-back"
    }
  }, [_vm._v("69")]), _vm._v(" His daily companions were the Clerks of Session, a brotherhood within a brotherhood, who shared with him the duties of the green leather table below the bench: Sir Robert Dundas, Hector Macdonald Buchanan, and Colin Mackenzie. But he had also known for upwards of forty years the judges who were now at the top of the profession; and the dinner-parties recorded in the "), _c('i', [_vm._v("Journal")]), _vm._v(" are as often as not gatherings of these old school friends and fellow students.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00077"
    }
  }, [_vm._v("Two later additions to Edinburgh society whom Scott particularly liked were William Adam of Blair-Adam (nephew of Robert Adam the architect), and the Lord Chief Baron, Sir Samuel Shepherd. From the first of these friendships sprang the ‘Blair-Adam Antiquarian Club’, whose annual meetings at Blair-Adam, from Friday until Monday at the summer solstice, Scott never failed to attend from 1817 to 1830. The party was made up by Admiral Adam and Anstruther Thomson (Adam’s son and son-in-law), Will Clerk, Sir Adam Ferguson, Thomas Thomson, and his brother the Revd. John Thomson of Duddingston, the artist.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00078"
    }
  }, [_vm._v("At Abbotsford the society of lawyers gave way to an exchange of visits with the neighbouring big houses along Tweed and Ettrick. Within walking distance were the three Ferguson sisters at Huntly Burn on the Abbotsford estate, and until 1825 the Lockharts at Chiefswood. Scott’s cousin Colonel Russell was at Ashestiel and a regular visitor at New Year. Scott did not share Anne’s opinion that ‘he is as great a bore as ever but it is a great advantage having the tweed between us for it is seldom fordable’."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-75",
      "id": "num-footnote-2-75-back"
    }
  }, [_vm._v("70")])]), _vm._v(" On Christmas Day Scott’s unvarying practice was to dine at Mertoun with Hugh Scott of Harden, whom he regarded as head of the family. As Appendix B at the end indicates, there was no lack of society. Apart from his visits to the chief of the clan (the Duke of Buccleuch), his time was passed for the most part among country gentlemen rather than the aristocracy.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00079"
    }
  }, [_vm._v("It is clear from the "), _c('i', [_vm._v("Journal")]), _vm._v(" that he preferred to that of almost any other the company of Tom Purdie, his man of all work at Abbotsford. ‘What a blessing there is in a man like Tom whom no familiarity can spoil’, he writes in January 1826,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-76",
      "id": "num-footnote-3-76-back"
    }
  }, [_vm._v("71")])]), _vm._v(" and two years later: ‘I shall be glad to be at Abbotsford to get rid of this town where I have not in the \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_xliv"
    }
  }, [_vm._v("proper and social sense of the word a single friend whose company pleases me. In the country I have always Tom Purdie.’"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-77",
      "id": "num-footnote-1-77-back"
    }
  }, [_vm._v("72")]), _vm._v(" They first met when Tom was brought up before the Sheriff for poaching in 1804."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-78",
      "id": "num-footnote-2-78-back"
    }
  }, [_vm._v("73")])]), _vm._v(" By the time of the "), _c('i', [_vm._v("Journal")]), _vm._v(" he accompanied Scott everywhere round the estate, and, improbably enough, also had the care of the library, in which he was, says Skene, ‘remarkably fastidious’. He always referred to the Waverley Novels as ‘our books’. He carried on a mock war with Sir Adam Ferguson, ‘whom he seemed to take a pleasure in assailing’."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-79",
      "id": "num-footnote-3-79-back"
    }
  }, [_vm._v("74")])]), _vm._v(" He could be trusted, Scott is supposed to have said, with anything except a bottle of whisky."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-80",
      "id": "num-footnote-4-80-back"
    }
  }, [_vm._v("75")])]), _vm._v(" He was, in short, a character.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00081"
    }
  }, [_vm._v("Scott’s three intimates at this time were Will Clerk, James Skene of Rubislaw, and Sir Adam Ferguson. William Clerk was a bachelor, the son of Lord Eldin, cultivated, fastidious, and a man of considerable talent; only his ‘blameable diffidence’,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-81",
      "id": "num-footnote-5-81-back"
    }
  }, [_vm._v("76")])]), _vm._v(" thought William Adam, prevented him from making his mark in both the legal and the literary world. It was this old college friend whom Scott asked to be his second when a duel with Gourgaud seemed likely.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00082"
    }
  }, [_vm._v("Scott first met James Skene of Rubislaw in the Edinburgh Light Dragoons, and the friendship thrived on their common interests in country life, German literature, and antiquities. Although not Scott’s intellectual equal (‘The early neglect of his education hangs by him in spite of his exertions’,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-82",
      "id": "num-footnote-6-82-back"
    }
  }, [_vm._v("77")])]), _vm._v(" Scott told Lockhart in 1830), Skene was an enthusiast, a traveller, and an artist. At the time of the "), _c('i', [_vm._v("Journal")]), _vm._v(" he was Curator of the Royal Society of Edinburgh and of the Society of Antiquaries, and Secretary of the Institution for the Encouragement of the Fine Arts. He was the brother-in-law both of Colin Mackenzie, Scott’s fellow Clerk of Session, and of Sir William Forbes, Scott’s old friend and rival, who was elected chairman of the creditors. On the day of their return to Edinburgh from Abbotsford it was the family custom to dine with the Skenes, and it was to Skene that Scott turned for sympathy on the day of the financial crash.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00083"
    }
  }, [_vm._v("‘The merry knight’ Sir Adam Ferguson divided his time between Edinburgh, his estate in Dumfriesshire, and his sisters at Huntly Burn, where he had lived himself until his marriage in 1821. He was the son of Professor Adam Ferguson, at whose house Scott met Burns; he had served with distinction in the Peninsular Campaign and had been a prisoner of war; in 1818 he was appointed Keeper of the Regalia of Scotland, and four years later was knighted during the King’s visit. The familiarity of more than forty years had increased rather than diminished Scott’s pleasure in the company of a man who never failed to be ‘in good fooling’.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110262-00085"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xlv"
    }
  }, [_vm._v("These people were closest to Scott during the "), _c('i', [_vm._v("Journal")]), _vm._v(" years. He had hundreds of other friends and a vast acquaintance. In the pages which follow, those who were of real importance to him are dealt with in a footnote on their first appearance; the remainder are briefly identified in the Index.\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_xlv"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_110262-00086"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xlv"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_xlvi"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xlvi"
    }
  }), _c('div', {
    staticClass: "block footnotes"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xlvi"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_xlvi"
    }
  }, [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-6"
    }
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-6-back"
    }
  }, [_vm._v("1")]), _vm._v(". David Masson, "), _c('i', [_vm._v("Edinburgh Sketches and Memories")]), _vm._v(", 1892, p. 204.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-7-back"
    }
  }, [_vm._v("2")])]), _vm._v(". "), _c('i', [_vm._v("Croker Papers")]), _vm._v(", iii. 295.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-8-back"
    }
  }, [_vm._v("3")])]), _vm._v(". "), _c('i', [_vm._v("Journal")]), _vm._v(", Entry for 29 April 1829.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-9-back"
    }
  }, [_vm._v("4")])]), _vm._v(". For details of these and other buildings see A. J. Youngson’s admirable "), _c('i', [_vm._v("The Making of Classical Edinburgh")]), _vm._v(", 1966.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-10-back"
    }
  }, [_vm._v("5")])]), _vm._v(". "), _c('i', [_vm._v("Redgauntlet")]), _vm._v(", Letter II.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-11-back"
    }
  }, [_vm._v("6")])]), _vm._v(". "), _c('i', [_vm._v("Journal")]), _vm._v(", Entry for 4 March 1826.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-12-back"
    }
  }, [_vm._v("7")])]), _vm._v(". Cockburn’s "), _c('i', [_vm._v("Memorials")]), _vm._v(", ch. 2.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-13-back"
    }
  }, [_vm._v("8")])]), _vm._v(". "), _c('i', [_vm._v("Substance of the Speeches delivered by some members of the Faculty of")]), _vm._v(" "), _c('i', [_vm._v("Advocates")]), _vm._v(", 1807, p. 33, Advocates Library C. 27.3.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-14-back"
    }
  }, [_vm._v("9")])]), _vm._v(". "), _c('i', [_vm._v("Letters")]), _vm._v(", iii. 457.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-15-back"
    }
  }, [_vm._v("10")])]), _vm._v(". "), _c('i', [_vm._v("Journal")]), _vm._v(", Entry for 21 March 1826 and note.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-16-back"
    }
  }, [_vm._v("11")])]), _vm._v(". "), _c('i', [_vm._v("Journal")]), _vm._v(", Entry for 6 January 1828.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-17-back"
    }
  }, [_vm._v("12")])]), _vm._v(". "), _c('i', [_vm._v("Journal")]), _vm._v(", Entry for 18 December 1825.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-18-back"
    }
  }, [_vm._v("13")])]), _vm._v(". p. 63.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-19-back"
    }
  }, [_vm._v("14")])]), _vm._v(". Sederunt Book, i. 17.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-20-back"
    }
  }, [_vm._v("15")])]), _vm._v(". Ibid., i. 333.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-21-back"
    }
  }, [_vm._v("16")])]), _vm._v(". Ibid., i. 4–9, and James Glen’s account of Scott’s affairs (which should be read) in "), _c('i', [_vm._v("Letters")]), _vm._v(", i. lxxx–xcv.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-22-back"
    }
  }, [_vm._v("17")])]), _vm._v(". Sederunt Book, i. 10–15.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-23-back"
    }
  }, [_vm._v("18")])]), _vm._v(". Cockburn’s "), _c('i', [_vm._v("Memorials")]), _vm._v(", ch. 7.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-24-back"
    }
  }, [_vm._v("19")])]), _vm._v(". Entry for 26 January 1831.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-25-back"
    }
  }, [_vm._v("20")])]), _vm._v(". "), _c('i', [_vm._v("Journal")]), _vm._v(", Entry for 24 January 1826.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-26-back"
    }
  }, [_vm._v("21")])]), _vm._v(". Sederunt Book, i. 41.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-27-back"
    }
  }, [_vm._v("22")])]), _vm._v(". "), _c('i', [_vm._v("Journal")]), _vm._v(", Entry for 6 February 1827.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-28-back"
    }
  }, [_vm._v("23")])]), _vm._v(". "), _c('i', [_vm._v("Memoirs of Moore")]), _vm._v(", vi. 227.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-29-back"
    }
  }, [_vm._v("24")])]), _vm._v(". Sederunt Book, ii. 193–200.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-30-back"
    }
  }, [_vm._v("25")])]), _vm._v(". "), _c('i', [_vm._v("Memoirs of Moore")]), _vm._v(", v. 125.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-31-back"
    }
  }, [_vm._v("26")])]), _vm._v(". "), _c('i', [_vm._v("Journal")]), _vm._v(", Entry for 12 June 1829.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-32-back"
    }
  }, [_vm._v("27")])]), _vm._v(". Sederunt Book, ii. 214.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-33-back"
    }
  }, [_vm._v("28")])]), _vm._v(". Ibid., ii. 214–15.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-34-back"
    }
  }, [_vm._v("29")])]), _vm._v(". Ibid., ii. 251.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-35"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-35-back"
    }
  }, [_vm._v("30")])]), _vm._v(". Sederunt Book, ii. 134.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-36"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-36-back"
    }
  }, [_vm._v("31")])]), _vm._v(". Ibid., ii. 200.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-37"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-37-back"
    }
  }, [_vm._v("32")])]), _vm._v(". See the Entry for 20 December 1827.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-38"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-38-back"
    }
  }, [_vm._v("33")])]), _vm._v(". Cunningham, 19 August 1831, Abbots.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-39"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-39-back"
    }
  }, [_vm._v("34")])]), _vm._v(". "), _c('i', [_vm._v("Journal")]), _vm._v(", Entry for 27 October 1827.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-40"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-40-back"
    }
  }, [_vm._v("35")])]), _vm._v(". For the Cabinets of the "), _c('i', [_vm._v("Journal")]), _vm._v(" years see Appendix D.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-41"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-41-back"
    }
  }, [_vm._v("36")])]), _vm._v(". "), _c('i', [_vm._v("Journal")]), _vm._v(", Entry for 24 November 1826.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-42"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-42-back"
    }
  }, [_vm._v("37")])]), _vm._v(". Omond, pp. 309–10.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-43"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-43-back"
    }
  }, [_vm._v("38")])]), _vm._v(". For the timetable of events see Appendix D, p. 825.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-44"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-44-back"
    }
  }, [_vm._v("39")])]), _vm._v(". Journal, ‘Interval’, p. 743.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-45"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-45-back"
    }
  }, [_vm._v("40")])]), _vm._v(". Omond, p. 328.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-46"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-46-back"
    }
  }, [_vm._v("41")])]), _vm._v(". Hamilton Russell, W. S. See "), _c('i', [_vm._v("Chambers Journal")]), _vm._v(", 6th series, vol. 5 (March 1902).\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-47"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-47-back"
    }
  }, [_vm._v("42")])]), _vm._v(". "), _c('i', [_vm._v("Diaries of Helen Graham")]), _vm._v(", p. 37.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-48"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-48-back"
    }
  }, [_vm._v("43")])]), _vm._v(". "), _c('i', [_vm._v("Lady Shelley’s Diary")]), _vm._v(", ii. 42.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-49"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-49-back"
    }
  }, [_vm._v("44")])]), _vm._v(". "), _c('i', [_vm._v("Letters")]), _vm._v(", x. 39.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-50"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-50-back"
    }
  }, [_vm._v("45")])]), _vm._v(". "), _c('i', [_vm._v("Letters")]), _vm._v(", x. 239.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-51"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-51-back"
    }
  }, [_vm._v("46")])]), _vm._v(". See, for instance, "), _c('i', [_vm._v("Letters")]), _vm._v(", x. 493 and 496.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-52"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-52-back"
    }
  }, [_vm._v("47")])]), _vm._v(". "), _c('i', [_vm._v("Letters")]), _vm._v(", xi. 190–1.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-8-53"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-53-back"
    }
  }, [_vm._v("48")])]), _vm._v(". Cole’s ‘Memorial of a Tour’, "), _c('i', [_vm._v("p. 261")]), _vm._v(".\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-54"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-54-back"
    }
  }, [_vm._v("49")])]), _vm._v(". "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 348.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-55"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-55-back"
    }
  }, [_vm._v("50")])]), _vm._v(".31 July 1827, Walpole.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-56"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-56-back"
    }
  }, [_vm._v("51")])]), _vm._v(". Lockhart, 23 February 1826, Walpole; and Anne, 17 June 1826, Abbots.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-57"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-57-back"
    }
  }, [_vm._v("52")])]), _vm._v(". Elizabeth Grant, "), _c('i', [_vm._v("Memoirs of a Highland Lady")]), _vm._v(", ed. Andrew Tod, Edinburgh, 1992, ii. 74.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-58"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-58-back"
    }
  }, [_vm._v("53")])]), _vm._v(". To Ballantyne, n.d. [1827], Letters to and from Scott.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-59"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-59-back"
    }
  }, [_vm._v("54")])]), _vm._v(". See, for instance, Walter, 5 October 1829, Walpole.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-60"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-60-back"
    }
  }, [_vm._v("55")])]), _vm._v(". "), _c('i', [_vm._v("Letters")]), _vm._v(", x. 84.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-8-61"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-61-back"
    }
  }, [_vm._v("56")])]), _vm._v(". Lockhart, 27 April 1826, Walpole.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-9-62"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-9-62-back"
    }
  }, [_vm._v("57")])]), _vm._v(". 22 July 1830, Disc.i. 93.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-10-63"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-10-63-back"
    }
  }, [_vm._v("58")])]), _vm._v(". 6 March 1831, Walpole.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-11-64"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-11-64-back"
    }
  }, [_vm._v("59")])]), _vm._v(". "), _c('i', [_vm._v("Journal")]), _vm._v(", Entry for 14 March 1826.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-65"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-65-back"
    }
  }, [_vm._v("60")])]), _vm._v(". Cole’s ‘Memorial of a Tour’, p. 261.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-66"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-66-back"
    }
  }, [_vm._v("61")])]), _vm._v(". 2–4 May 1827, Shortreed Papers.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-67"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-67-back"
    }
  }, [_vm._v("62")])]), _vm._v(". "), _c('i', [_vm._v("Diaries of Helen Graham")]), _vm._v(", pp. 37–8.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-68"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-68-back"
    }
  }, [_vm._v("63")])]), _vm._v(". 23 February 1826, Walpole.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-69"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-69-back"
    }
  }, [_vm._v("64")])]), _vm._v(". "), _c('i', [_vm._v("Letters")]), _vm._v(", xii. 28.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-70"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-70-back"
    }
  }, [_vm._v("65")])]), _vm._v(". Sederunt Book, ii. 203.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-71"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-71-back"
    }
  }, [_vm._v("66")])]), _vm._v(". 24 August 1827, Walpole.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-72"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-72-back"
    }
  }, [_vm._v("67")])]), _vm._v(". 21 March 1828, Walpole.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-73"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-73-back"
    }
  }, [_vm._v("68")])]), _vm._v(". 28 March 1826, Walpole.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-74"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-74-back"
    }
  }, [_vm._v("69")])]), _vm._v(". "), _c('i', [_vm._v("Letters")]), _vm._v(", xi. 358.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-75"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-75-back"
    }
  }, [_vm._v("70")])]), _vm._v(". To Sophia, 29 September 1826, Abbots.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-76"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-76-back"
    }
  }, [_vm._v("71")])]), _vm._v(". "), _c('i', [_vm._v("Journal")]), _vm._v(", Entry for 7 January.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-77"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-77-back"
    }
  }, [_vm._v("72")])]), _vm._v(". "), _c('i', [_vm._v("Journal")]), _vm._v(", Entry for 4 March 1828.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-78"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-78-back"
    }
  }, [_vm._v("73")])]), _vm._v(". "), _c('i', [_vm._v("Life")]), _vm._v(", ii. 192.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-79"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-79-back"
    }
  }, [_vm._v("74")])]), _vm._v(". "), _c('i', [_vm._v("Skene’s Memories")]), _vm._v(", p. 167.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-80"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-80-back"
    }
  }, [_vm._v("75")])]), _vm._v(". Dalgleish, i. 742.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-81"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-81-back"
    }
  }, [_vm._v("76")])]), _vm._v(". "), _c('i', [_vm._v("Blair-Adam Estate")]), _vm._v(", Intro., p. xlii.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-82"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-82-back"
    }
  }, [_vm._v("77")])]), _vm._v(". To Lockhart, 24 June 1830, Disc. ii. 81.\n            ")])])])])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_110263-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xlvii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xlvii"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_110263-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xlvii"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "pb-rw_xlvii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847674951_tableofcontents"
    }
  }, [_c('i', [_vm._v("The Events of the Journal")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table align-left layout width-auto",
    attrs: {
      "id": "rw-table-align-left_110263-00001"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "t-5"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("1825  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("WORKS IN HAND")])])]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("November  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Reminiscences of Ireland, and of Moore and Byron – Visit of Mrs. Coutts – Lockhart’s appointment as editor of the "), _c('i', [_vm._v("Quarterly")]), _vm._v(".\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon")]), _vm._v(", vol.i. "), _c('i', [_vm._v("Woodstock")]), _vm._v(", vol.i.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("December  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Visits from R. P. Gillies – Departure of Lockhart and Sophia for London – Fears of Constable’s failure – Christmas at Abbotsford – Attack of gallstones.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon")]), _vm._v(", vol. ii. ‘"), _c('i', [_vm._v("Bonnie Dundee")]), _vm._v("’. Introduction to "), _c('i', [_vm._v("Memoirs of Mme La Rochejacquelin")]), _vm._v(". Review of Pepys for the "), _c('i', [_vm._v("Quarterly")]), _vm._v(". Notes on Sheridan for Lockhart. \n                        ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table align-left layout width-auto",
    attrs: {
      "id": "rw-table-align-left_110263-00002"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "t-44"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("1826 ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("January  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("The Skenes, Knight, Mathews, and Scrope at Abbotsford – Scott returns to Edinburgh on the 16th and finds he is ruined – The creditors agree to a Trust.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Woodstock")]), _vm._v(", vols i and ii.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("February  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Cadell flees to the Sanctuary – Scott refuses to consider a seat on the Bench – New Exhibition Room opened – 39 Castle Street put up for sale – Scott attacks the Government in the first two "), _c('i', [_vm._v("Letters of Malachi")]), _vm._v(".\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Woodstock:")]), _vm._v(" vol. ii finished 11 February; vol. iii. "), _c('br'), _vm._v("             First and second "), _c('i', [_vm._v("Letters of Malachi Malagrowther")]), _vm._v(".\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row4"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("March  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Meetings of protest – A third "), _c('i', [_vm._v("Letter of Malachi – ")]), _vm._v("Quarrel with Lord Melville – Feelings of depression – Scott removes to Abbotsford on the 15th – Illness of Lady Scott – Letters from Croker, who has attacked"), _c('i', [_vm._v(" Malachi")]), _vm._v(" – First news of the money in Chancery belonging to Lady Scott.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Malachi Malagrowther")]), _vm._v(", Letter III. "), _c('br'), _vm._v("             Notes for "), _c('i', [_vm._v("Napoleon")]), _vm._v(". "), _c('i', [_vm._v("Woodstock:")]), _vm._v(" finished 26 March.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row5"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("April  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_c('i', [_vm._v("Woodstock")]), _vm._v(" sold for £8228 – Henry Scott of Harden to stand for Parliament – Lady Scott’s illness continues – Birth of Scott’s grandson, Walter, in Brighton – "), _c('i', [_vm._v("Woodstock")]), _vm._v(" succeeds in Edinburgh.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon")]), _vm._v(": vol. ii finished 12 April.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row6"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("May  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Anne Scott arrives from Cheltenham to help nurse Lady Scott – Scott returns to Edinburgh on the 11th, and lodges at 6 St. David Street – Success of "), _c('i', [_vm._v("Malachi")]), _vm._v(" – The Government measure dropped – Death and funeral of Lady Scott.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Review of Boaden’s "), _c('i', [_vm._v("Life of Kemble")]), _vm._v(" and Kelly’s Reminiscences for the "), _c('i', [_vm._v("Quarterly")]), _vm._v(". "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Chronicles of the Canongate")]), _vm._v(" begun on the 27th: Introductory’. "), _c('br'), _vm._v("             Notes on "), _c('i', [_vm._v("The Omen for Blackwood’s Magazine")]), _vm._v(".\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row7"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("June  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Constable’s claim to "), _c('i', [_vm._v("Woodstock")]), _vm._v(" and "), _c('i', [_vm._v("Napoleon")]), _vm._v(" – Hard work on Napoleon – Fear for the future of Scots Law – Short holidays at Abbotsford and Blair-Adam – "), _c('i', [_vm._v("Chronicles of the Canongate")]), _vm._v(" sold to Cadell.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon:")]), _vm._v(" vol. iii finished 12 June; vol. iv begun 14 June. "), _c('i', [_vm._v("Chronicles of the Canongate:")]), _vm._v(" ‘Introductory’ and ‘The Highland Widow’.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row8"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("July  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Davidoff at Abbotsford for the Selkirk election – End of the quarrel with Lord Melville – To Abbotsford on the 14th.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Chronicles of the Canongate:")]), _vm._v(" ‘The Highland Widow’ finished in mid-July. "), _c('i', [_vm._v("Napoleon")]), _vm._v(", vol. iv. Corrections to "), _c('i', [_vm._v("St. Ro- nan’s Well")]), _vm._v(".\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row9"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("August  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Niece Anne returns to Cheltenham – Walter and Jane arrive from Ireland – A great picnic at Cauldshiels Loch – Short visits to Drumlanrig and Blair-Adam.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon:")]), _vm._v(" vol. iv finished 13 August; vol. v.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row10"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("September  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Walter and Charles go to Ireland – Anne takes 3 Walker Street for the winter – Sir John Sinclair proposes a match for Scott – Visits to Jedburgh for the Circuit Court, and to Melville Castle about the Universities Commission.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon")]), _vm._v(", vol. v.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row11"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("October  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Charles returns to Oxford – Scott goes to London by way of Rokeby – Meets many London friends and passes a day at Windsor – Works on the St. Helena papers at the Colonial Office – Reaches Paris on the 29th.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon:")]), _vm._v(" vol v finished early in October.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row12"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("November  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("In Paris until the 7th – In London early on the 10th – Wellington offers to assist with "), _c('i', [_vm._v("Napoleon")]), _vm._v(" – Scott returns to Abbotsford early on the 26th (by way of Oxford, Cheltenham, Birmingham, and Manchester), and to Edinburgh on the 27th.  \n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row13"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("December  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Scott suffers from a cold at the beginning of the month, diarrhoea throughout the month, and rheumatism at its end – To Abbotsford for Christmas – Walter and Jane.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon")]), _vm._v(", vol. vi.\n                        ")])])])])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110263-00003"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xlviii"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_xlix"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_xlix"
    }
  }, [_c('div', {
    staticClass: "table align-left layout width-auto",
    attrs: {
      "id": "rw-table-align-left_110263-00003"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "t-184"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("1827 ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("January  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Rheumatism still severe throughout the month – Returns to Edinburgh on the 15th – Walter returns to Ireland – "), _c('i', [_vm._v("Napoleon")]), _vm._v(" to be extended to eight volumes.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon")]), _vm._v(", vols. vi and vii.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("February  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Hard work on "), _c('i', [_vm._v("Napoleon")]), _vm._v(" – Rheumatism – Edinburgh dinner-parties – Letter from Goethe – Scott confesses to the authorship of the Waverley Novels at the Theatrical Fund Dinner.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon")]), _vm._v(", vol. vii.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row4"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("March  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("To Abbotsford on the 12th – Hard work on "), _c('i', [_vm._v("Napoleon")]), _vm._v(".\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon")]), _vm._v(", vol. viii. Review of Home’s Works.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row5"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("April  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Fall of the Ministry – Circuit Court at Jedburgh – Hard work on "), _c('i', [_vm._v("Napoleon")]), _vm._v(".\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon")]), _vm._v(": vol. viii finished c. 14 April; vol. ix. Review of "), _c('i', [_vm._v("Home’s Works")]), _vm._v(". Criticism of Defoe for Prose Works.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row6"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("May  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("To Edinburgh on the 14th – Decides to write "), _c('i', [_vm._v("Tales of a Grandfather")]), _vm._v(".\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Review of Hoffmann’s "), _c('i', [_vm._v("Works")]), _vm._v(" for "), _c('i', [_vm._v("Foreign Quarterly Review")]), _vm._v(". "), _c('br'), _vm._v("             Criticism of Defoe. "), _c('i', [_c('br'), _vm._v("             Life of Napoleon")]), _vm._v(", vol. ix.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row7"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("June  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Oil Gas Coy. affairs – "), _c('i', [_vm._v("Life of Napoleon")]), _vm._v(" finished – "), _c('i', [_vm._v("Tales of a Grandfather")]), _vm._v(" sold to Cadell – Lockharts at Portobello – Scott at St. Andrews with the Blair-Adam Club.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Life of Napoleon")]), _vm._v(": vol. ix finished 7 June. ‘Culloden Papers’, or ‘Essay on Clanship’, "), _c('i', [_vm._v("for Prose Works. Chronicles of the Canongate:")]), _vm._v(" ‘Introduction’ and ‘Two Drovers’. "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Tales of a Grandfather.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "row8"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("July  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Four days at Abbotsford before removing there for the vacation on the 11th – Visit to the Edinburgh Academy – Conversation with Lord Melville about politics – Emus offered to the King and the Duke of Buccleuch – Excursions to Yarrow and Minto – Death of Constable – Lord Newton arbitrates in Scott’s favour.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("‘Culloden Papers’. "), _c('i', [_vm._v("Chronicles of the Canongate:")]), _vm._v(" ‘Two Drovers’ finished 15 July; ‘Surgeon’s Daughter’ begun 27 July. "), _c('i', [_c('br'), _vm._v("             Tales of a Grandfather:")]), _vm._v(" vol. i finished 26 July.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row9"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("August  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Visit from G. H. Gordon, who helps to arrange Scott’s correspondence – Death of Canning – Possibility of a duel with General Gourgaud – Williams resigns as Rector of Edinburgh Academy – Excursions to Fleurs and Kelso.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Chronicles of the Canongate: ")]), _vm._v("‘Surgeon’s Daughter’. "), _c('br'), _vm._v("             Review of Monteath’s "), _c('i', [_vm._v("The Forester’s Guide")]), _vm._v(".\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row10"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("September  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("To Glasgow with Lady Compton, by way of Melville Castle and Edinburgh; then to Blythswood, Corehouse, and Lanark.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Review continued. "), _c('i', [_vm._v("Chronicles of the Canongate: ")]), _vm._v("‘Surgeon’s Daughter’ finished 16 September. "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Tales of a Grandfather:")]), _vm._v(" vol. ii begun 17 September.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row11"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("October  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Scott in Northumberland to see the Duke of Wellington – Letters from Lady Jane Stuart – Arbitration decided mainly in Scott’s favour – Abud threatens the Trust.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Tales of a Grandfather:")]), _vm._v(" vol. iii half finished 16 October, two- thirds finished 20 October.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row12"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("November  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Scott returns to Edinburgh on the 4th – The Abud affair – Visits to Lady Jane Stuart – Prize Essay at the University – Plans to buy the copyrights – Union Scottish Assurance Coy. Meeting – A place in the Foreign Office promised to Charles.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("‘Ornamental Gardening’ begun 7 November, finished 25 November. "), _c('br'), _vm._v("             Last proof of "), _c('i', [_vm._v("Tales of a Grandfather")]), _vm._v(" corrected. ‘My Aunt Margaret’s Mirror’ begun.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row13"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("December  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Lord Newton decrees in Scott’s favour – First dividend of 6s. in the "), _c('i', [_vm._v("£")]), _vm._v(" declared – Further discussions of Abud, and of the copyrights – Cadell and Ballantyne dissatisfied with "), _c('i', [_vm._v("Chronicles of the Canongate;")]), _vm._v(" Scott fears the loss of his reputation – Meetings about the Advocates’ Library, and the Oil Gas Coy. – Huntly Gordon asks for two sermons – Cadell buys the copyrights for "), _c('i', [_vm._v("£")]), _vm._v("8400 – Scott returns by way of Arniston to Abbotsford.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("‘My Aunt Margaret’s Mirror’ finished 3 December. "), _c('br'), _vm._v(" "), _c('i', [_vm._v("The Fair Maid of Perth")]), _vm._v(" begun 5 December. Additions to "), _c('i', [_vm._v("Tales of a Grandfather")]), _vm._v(".\n                        ")])])])])])])]), _c('p', {
    attrs: {
      "id": "rw-p_110263-00005"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xlix"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_l"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_li"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_li"
    }
  }, [_c('div', {
    staticClass: "table align-left layout width-auto",
    attrs: {
      "id": "rw-table-align-left_110263-00004"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "t-362"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("1828")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("January  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Birth of Charlotte Lockhart – Scott insists that Cadell employ Ballantyne as printer – Disagreements with Longman over 2nd edition of "), _c('i', [_vm._v("Life of Napoleon")]), _vm._v(" – To Edinburgh on the 13th – Retirement of Colin Mackenzie – Death of Glengarry – Visit of Mr. Moscheles – Abud’s claim settled – Scott sits to Colvin Smith – Asked by Heath and Reynolds to edit "), _c('i', [_vm._v("The Keepsake")]), _vm._v(".\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Review of Molière for Gillies. "), _c('br'), _vm._v("             Revision of "), _c('i', [_vm._v("Tales of a Grandfather")]), _vm._v(". Corrections to "), _c('i', [_vm._v("Life of Napoleon")]), _vm._v(". "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Fair Maid of Perth:")]), _vm._v(" vol. i two-thirds written on the 21st, nearly finished on the 30th.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("February  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Visit to Dalkeith – Negotiations on behalf of the Oil Gas Coy. – Feelings of "), _c('i', [_vm._v("déjà-vu")]), _vm._v(" – ‘My Aunt Margaret’s Mirror’ offered to "), _c('i', [_vm._v("The Keepsake")]), _vm._v(" – Discussion on prisons – Ballantyne criticizes "), _c('i', [_vm._v("The Fair Maid of Perth")]), _vm._v(".\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Fair Maid of Perth:")]), _vm._v(" vol. i finished 5 February; vol. ii.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row4"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("March  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Fancy Dress Ball – Miss Stirling Grahame’s personifications – Agreement with the Coal Gas Coy. – To Abbotsford on the 13th – The Yeomanry – Cadell’s plans for the Magnum.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Fair Maid of Perth:")]), _vm._v(" vol. iii begun 5 March, finished 29 March. "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Tales of a Grandfather")]), _vm._v(" corrected for a 2nd edition.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row5"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("April  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Journey to London by way of Carlisle, Kenilworth, and Stratford – Terry’s bankruptcy – Quarrel with Lord Minto – Scott rectifies the Road Bill threatening Darnick – Meets Wellington, Croker, Coleridge, Sotheby, Joanna Baillie, Morritt, Knighton, Lord Melville, and other London friends.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("‘My Aunt Margaret’s Mirror’ revised for "), _c('i', [_vm._v("The Keepsake")]), _vm._v(". "), _c('br'), _vm._v("             Proofs of "), _c('i', [_vm._v("The Fair Maid of Perth")]), _vm._v(" finished.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row6"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("May  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Dinners at the Literary Society, the Royal Academy, and the Roxburghe Club – The Chancery business – Scott sits to Haydon, Northcote, and Chantry – Breakfasts at Lincoln’s Inn – Dines with the King, and with the Duchess of Kent – Visits the Lockharts in Brighton, and Walter at Hampton Court – Returns by Gill’s Hill and Rokeby. ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row7"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("June  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Reaches Abbotsford on the 2nd, and Edinburgh on the 4th – Williams gives up his London chair – At Blair-Adam from the 27th to the 30th.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Tales of a Grandfather")]), _vm._v(", 2nd series.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row8"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "header-gr1.png"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row9"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("9 July–9 January 1829: No Entries. ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row10"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "header-gr1.png"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })])])])])]), _vm._v(" "), _c('br')]), _c('p', {
    attrs: {
      "id": "rw-p_110263-00006"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_li"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_lii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_lii"
    }
  }, [_c('div', {
    staticClass: "table align-left layout width-auto",
    attrs: {
      "id": "rw-table-align-left_110263-00005"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "t-457"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("1829 ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("January  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Scott returns to Edinburgh on the 13th – Dr. Knox’s proposed paper on dissections – Thoughts on the anatomists – Visit to Milton- Lockhart and Allanton – Scott meets Green- shields and sits to Graham – Deaths of James Ferrier and Mary Ferguson – Execution of Burke – Cadell about to advertise the Magnum.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Anne of Geierstein")]), _vm._v(", vol. ii.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("February  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Meeting of the Club – Sale of Stuart of Dunearn’s pictures – Death of Mrs. Ballantyne – Skene assists with "), _c('i', [_vm._v("Anne of")]), _vm._v(" Geierstein – Stories of Waterloo – The Catholic Question.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Anne of Geierstein:")]), _vm._v(" vol. ii. finished 5 February; vol. iii.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row4"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("March  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("The booksellers place large orders for the Magnum – Ballantyne condemns "), _c('i', [_vm._v("Anne of Geierstein")]), _vm._v(", which is laid aside while the Catholic Question rages – Restoration of Mons Meg to Edinburgh Castle – Scott returns to Abbotsford on the 11th – Visit from Lord Dalhousie.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Notes for the Magnum and General Preface. "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Review of Tytler’s History of Scotland.")]), _vm._v(" "), _c('br'), _vm._v("             Notes on Boswell for Croker. \n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row5"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("April  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Visit from the Skenes – The Hunt meets at Abbotsford – Circuit Court – Death of Lord Buchan – "), _c('i', [_vm._v("Doom of Devorgoil")]), _vm._v(".\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Review of Ritson. Article for "), _c('i', [_vm._v("Blackwood’s. Anne of Geierstein")]), _vm._v(", vol. iii. "), _c('i', [_vm._v("Preface to House of As- pen")]), _vm._v(". "), _c('br'), _vm._v(" "), _c('i', [_vm._v("History of Scotland")]), _vm._v(" begun 18 April.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row6"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("May  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Scott returns to Edinburgh on the 11th – Dines at Dalhousie Castle – Walter’s illness – Great expectations of the Magnum – The General Assembly of the Church of Scotland – Edward Irving – Farewell dinners to Dalhousie and Hay Drummond – Reflections on the Psalmody.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Review of "), _c('i', [_vm._v("Le Duc de Guise à Naples")]), _vm._v(". "), _c('i', [_vm._v("History of Scotland")]), _vm._v(". Notes for the Magnum. \n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row7"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("June  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Scott alarmed by passing blood – The Theatre given to Mrs. Siddons – Cadell plans to buy the poetry copyrights – Scott sits to Graham – To Abbotsford on the 13th for four days – Sophia, Charles, and the children arrive by steamboat – Meeting of the Blair- Adam Club and visit to Falkland.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("History of Scotland")]), _vm._v(", half-volume finished 1 June. "), _c('i', [_vm._v("Tales of a Grandfather")]), _vm._v(", enlarged 3rd series.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row8"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("July  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("His children and grandchildren go to Abbotsford, where Scott joins them on the 9th – The Stewart Papers – Death of Shortreed – Mrs. Hemans at Chiefswood.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("T"), _c('i', [_vm._v("ales of a Grandfather. History of Scotland")]), _vm._v(".\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row9"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "header-gr1.png"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row10"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("21 July–22 May 1830: No Entries. ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row11"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "header-gr1.png"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })])])])])])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110263-00007"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_lii"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_liii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_liii"
    }
  }, [_c('div', {
    staticClass: "table align-left layout width-auto",
    attrs: {
      "id": "rw-table-align-left_110263-00006"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "t-571"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("1830 ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("May  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Death of Scott of Raeburn – New line proposed for the road – Scott intends to retire – The Lockharts arrive for the summer.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Demonology")])])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("June  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Edinburgh, Abbotsford, and Blair-Adam – Visit to Culross – Fanny Kemble acts in Edinburgh – Visit to Prestonpans – William IV proclaimed King.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Demonology: ")]), _vm._v("one-third finished 2 June, two-thirds finished 16 June.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row4"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("July  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Dinners of the Club and the Bannatyne – Miss Doe Sinclair in love with Scott – Return to Abbotsford.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Demonology")]), _vm._v(", seven-eighths finished 5 July.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row5"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "header-gr1.png"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row6"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("19 July–19 December: One Entry only. ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row7"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "header-gr1.png"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row8"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("December  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Second dividend of 3s. in the "), _c('i', [_vm._v("£")]), _vm._v(" – Scott presented with his library and furniture – Retirement from the Court – Scott’s two strokes – Political agitation – Scott stops a prisoner escaping from the Sheriff Court – Death of Bell Ferguson – New line for the road agreed.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Count Robert of Paris")]), _vm._v(". Notes to Woodstock. Political article on Income Tax (unfinished). \n                        ")])])])])])])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110263-00008"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_liii"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_liv"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_liv"
    }
  }, [_c('div', {
    staticClass: "table align-left layout width-auto",
    attrs: {
      "id": "rw-table-align-left_110263-00007"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "t-643"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("1831 ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("January  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Scott ‘Decidedly weaker in point of health’ – Prepares to make his will – Discusses politics with Henry Scott – Sits to MacDonald the sculptor – Uses Laidlaw as amanuensis.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Count Robert of Paris.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("February  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Goes to Edinburgh to make his will – Acquires a brace for his lame leg – Delayed by snow.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Count Robert of Paris")]), _vm._v(", vol. ii. "), _c('br'), _vm._v("             Notes on "), _c('i', [_vm._v("Redgauntlet")]), _vm._v(" and "), _c('i', [_vm._v("Tales of Crusaders.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "row4"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("March  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Reform meetings at Selkirk and Jedburgh – Scott refuses Cadell a half-share in the later copyrights – His typical day at this time – Reform Bill carried in the Commons – Scott sits to Grant.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Review of The British Herald ")]), _vm._v("(never published). "), _c('br'), _vm._v("             Address on the Reform Bill (rejected). "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Count Robert of Paris:")]), _vm._v(" vol. iii begun 16 March.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row5"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("April  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Manuscripts adjudged to Constable – Foundation stone laid for Tweed bridge – Scott’s third stroke on the 17th.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Count Robert of Paris.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "row6"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("May  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("The Lockharts arrive for the summer – J. B. and Cadell condemn vol. iii of "), _c('i', [_vm._v("Count Robert")]), _vm._v(" – Election at Jedburgh: ‘Burke Sir Walter’.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Count Robert of Paris ")]), _vm._v("nearly finished, but laid aside onthe 12th.\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row7"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "header-gr1.png"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row8"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("26 May–22 September: No Entries. ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row9"
  }, [_c('td', {
    staticClass: "col1"
  }), _vm._v(" "), _c('td', {
    staticClass: "col2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "header-gr1.png"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row10"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("September  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Yarrow visited with Wordsworth – Journey to London.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("Notes to the Magnum. "), _c('i', [_vm._v("Reliquiae Trotcosienses")]), _vm._v(".\n                        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row11"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("October  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("London friends – Reform riots – Stories of magic, and of Garrick – Portsmouth – The "), _c('i', [_vm._v("Barham")]), _vm._v(" sails for Malta on the 29th.\n                        ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row12"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("November  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("The voyage – Graham’s Island – In quaran- tine at Malta until the 28th – Friends and sightseeing. ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row13"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("December  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Scott leaves Malta on the 13th, arrives at Naples on the 17th, and lands there on the 25th.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_c('i', [_vm._v("Siege of Malta")]), _vm._v(" (never finished). "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Letters of the Seventeenth Century")]), _vm._v(", partly written by Lady Louisa Stuart.\n                        ")])])])])])])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110263-00009"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_liv"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_lv"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_lv"
    }
  }, [_c('div', {
    staticClass: "table align-left layout width-auto",
    attrs: {
      "id": "rw-table-align-left_110263-00008"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('table', {
    attrs: {
      "id": "t-763"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "row1"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("1832  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }), _vm._v(" "), _c('td', {
    staticClass: "col3"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "row2"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("January  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Visits to Court, the Opera, and the Library – Death of Johnnie Lockhart – Success of the Magnum, etc.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("As above. ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row3"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("February  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Excursion to Pompeii.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("As above. ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row4"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("March  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Excursion to Paestum.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("As above. ")])]), _vm._v(" "), _c('tr', {
    staticClass: "row5"
  }, [_c('td', {
    staticClass: "col1"
  }, [_vm._v("April  ")]), _vm._v(" "), _c('td', {
    staticClass: "col2"
  }, [_vm._v("Story of Il Bizarro – Journey to Rome.  ")]), _vm._v(" "), _c('td', {
    staticClass: "col3"
  }, [_vm._v("As above. ")])])])])])])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110263-00010"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_lv"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  })])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Part"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_110264-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_110264-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847674951_tableofcontents"
    }
  }, [_vm._v("SIR WALTER SCOTT BAR"), _c('sup', [_vm._v("T")]), _c('br'), _vm._v(" of "), _c('br'), _vm._v(" Abbotsford"), _c('br'), _vm._v(" HIS. GURNAL"), _c('sup', [_vm._v("*")]), _c('br'), _vm._v(" Vol. I.\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "block epigraph",
    attrs: {
      "id": "rw-block-epigraph_110264-00001"
    }
  }, [_c('p', {
    staticClass: "fp"
  }, [_vm._v("As I walked by myself "), _c('br'), _vm._v(" I talkd to my self\n            ")]), _vm._v(" "), _c('p', [_vm._v("And thus my self said to me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Old Song.")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110264-00001"
    }
  }, [_vm._v("A hard word so spelld on Authority of Miss Scott now Mrs. Lockhart.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  })])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_110265-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_110265-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }), _c('p', {
    staticClass: "title-num"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847674951_tableofcontents"
    }
  }, [_c('i', [_vm._v("1825")])])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "rw-h2_110265-00001"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("NOVEMBER ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00002"
    }
  }, [_vm._v("20 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" I have bethought me on seeing lately some volumes of Byron’s notes that he probably had hit upon the right way of keeping such a memorandum-book by throwing aside all pretence to regularity and order and marking down events just as they occurd to recollection. I will try this plan and behold I have a handsome lockd volume such as might serve for a Lady’s Album. "), _c('i', [_vm._v("Nota Bene")]), _vm._v(" John Lockhart and Anne"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-83",
      "id": "num-footnote-1-83-back"
    }
  }, [_vm._v("1")])]), _vm._v(" and I are to raise a society for the suppression of Albums. It is a most troublesome shape of mendicity – Sir, your autograph – a line of poetry – or a prose sentence among all the sprawling sonnets and blotted trumpery that dishonours these miscellanies – a man must have a good stomach that can swallow this botheration as a compliment.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00003"
    }
  }, [_vm._v("I was in Ireland last summer and had a most delightful tour."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-84",
      "id": "num-footnote-2-84-back"
    }
  }, [_vm._v("2")])]), _vm._v(" It cost me upwards of "), _c('i', [_vm._v("£")]), _vm._v("500 including "), _c('i', [_vm._v("£")]), _vm._v("100 left with Walter and Jane1 for we travelld a large party and in stile.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00004"
    }
  }, [_vm._v("There is much less exaggerated about the Irish than is to be expected. Their poverty is not exaggerated – it is on the extreme verge of human misery – their cottages would scarce serve for pig-sties even in Scotland – and their rags seem the very refuse of a rag-shop and are disposed on their bodies with such ingenious variety of wretchedness that you would think nothing but some sort of per-verted taste could have assembled so many shreds together. You are constantly fearful that some knot or loop will give and place the individual before you in all the primitive simplicity of Paradise. Then for their food they have only potatoes and too few of them. Yet the men look stout and healthy the women buxsome and well coloured.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00006"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("Dined with us being Sunday Will. Clerk"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-85",
      "id": "num-footnote-1-85-back"
    }
  }, [_vm._v("3")]), _vm._v(" and Chas. Kirkpatrick Sharpe. W. C. is the second son of the celebrated author of "), _c('i', [_vm._v("Naval")]), _vm._v(" "), _c('i', [_vm._v("Tactics")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-86",
      "id": "num-footnote-2-86-back"
    }
  }, [_vm._v("4")])]), _vm._v(" I have known him intimately since our college days and to my thinking, never met a man of greater powers or more complete information on all desirable subjects. In youth he had strongly the Edinburgh "), _c('i', [_vm._v("pruritus disputandi")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-87",
      "id": "num-footnote-3-87-back"
    }
  }, [_vm._v("5")])]), _vm._v(" but habits of society have greatly mellowd it and though still anxious to gain your suffrage to his opinion he endeavours rather to conciliate your opinion than conquer it by force. Still there is enough of tenacity of sentiment to prevent in London Society, where all must go slack and easy, W. C. from rising to the very top of the tree as a Conversation man, who must not only wind the thread of his argument gracefully but also know when to let go. But I like the Scotch taste better: there is more matter, more information, above all more spirit in it. Clerk will I am afraid leave the world little more than the report of his fame. He is too indolent to finish any considerable work.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00007"
    }
  }, [_vm._v("Chas. Kirkpatricke Sharpe"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-88",
      "id": "num-footnote-4-88-back"
    }
  }, [_vm._v("6")])]), _vm._v(" is another very remarkable man. He was bred a clergyman but did not take orders owing I believe to a peculiar effeminacy of voice which must have been unpleasant in reading prayers. Some family quarrels occasiond his being indifferently provided for by a small annuity from his elder brother extorted by an arbitral decree. He has infinite wit and a great turn for antiquarian lore as the publications of Kirkton"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-89",
      "id": "num-footnote-5-89-back"
    }
  }, [_vm._v("7")])]), _vm._v(" etc. bear witness. His drawings are the most fanciful and droll imaginable – a mixture between Hogarth and some of those foreign masters \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("who painted temptations of Saint Antony and such grotesque subjects. As a poet he has not a very strong touch. Strange that his finger-ends can describe so well what he cannot bring out clearly and firmly in words. If he were to make drawing a resource it might raise him a large income. But though a lover of antiquities and therefore of expensive trifles C. K. S. is too aristocratic to use his art to assist his revenue. He is a very complete genealogist and has made many detections in Douglas"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-90",
      "id": "num-footnote-1-90-back"
    }
  }, [_vm._v("8")]), _vm._v(" and other books on pedigree which our nobles would do well to suppress if they had an opportunity. Strange that a man should be curious after Scandal of centuries old. Not but Charles loves it fresh and fresh also for being very much a fashionable man he is always master of the reigning report and he tells the anecdote with such gusto that there is no helping sympathizing with him: the peculiarity of voice adding not a little to the general effect. My idea is that C. K. S. with his oddities tastes satire and high aristocratic feelings resembles Horace Walpole – perhaps in his person also in a general way. See Miss Aikin’s anecdotes"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-91",
      "id": "num-footnote-2-91-back"
    }
  }, [_vm._v("9")])]), _vm._v(" for description of the author of "), _c('i', [_vm._v("The Castle of Otranto")]), _vm._v(".\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00008"
    }
  }, [_vm._v("No other company at dinner except my cheerful and goodhumourd friend "), _c('i', [_vm._v("Missie")]), _vm._v(" MacDonald,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-92",
      "id": "num-footnote-3-92-back"
    }
  }, [_vm._v("10")])]), _vm._v(" so calld in fondness – One bottle of Champagne with the ladies’ assistance, 2 of claret. I observe that both these great Connoisseurs were very nearly if not quite agreed that there are "), _c('i', [_vm._v("no")]), _vm._v(" absolutely undoubted originals of Queen Mary. But how then should we be so very distinctly informd as to her features? What has become of all the originals which suggested these innumerable copies? Surely Mary must have been as unfortunate in this as in other particulars of her life.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00001"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00001"
    }
  }, [_vm._v("21 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MONDAY")]), _vm._v(" I am enamourd of my Journal. I wish the zeal may but last. Once more of Ireland – I said their poverty was not exaggerated. Neither is their wit – nor their goodhumour – nor their whimsical absurdity – nor their courage.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00009"
    }
  }, [_c('i', [_vm._v("Wit")]), _vm._v(". I gave a fellow a shilling on some occasion when sixpence was \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("the fee – ‘Remember you owe me sixpence, Pat.’ ‘May your Honour live till I pay you.’"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-93",
      "id": "num-footnote-1-93-back"
    }
  }, [_vm._v("11")]), _vm._v(" There was courtesy as well as wit in this and all the clothes on Pat’s back would have been dearly bought by the sum in question.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00010"
    }
  }, [_c('i', [_vm._v("Goodhumour")]), _vm._v(". There is perpetual kindness in the Irish cabbin – butter milk – potatoes – a stool is offerd or a stone is rolld that your honour may sit down and be out of their smoke and those who beg everywhere else seem desirous to exercize free hospitality in their own houses. Their natural disposition is turned to gaiety and happiness. While a Scotchman is thinking about the term day, or if easy on that subject about Hell in the next world, while an English man is making a little hell of his own in the present because his muffin is not well roasted, Pat’s mind is always turnd to fun and ridicule. They are terribly excitable to be sure and will murther you on slight suspicion and find out next day that it was all a mistake and that it was not yourself they meant to kill at all at all.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00011"
    }
  }, [_c('i', [_vm._v("Absurdity")]), _vm._v(". They were widening the road near Lord Claremont’s seat"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-94",
      "id": "num-footnote-2-94-back"
    }
  }, [_vm._v("12")])]), _vm._v(" as we passd. A number of cars were drawn up together at a particular point where we also halted as we understood they were blowing a rock and the "), _c('i', [_vm._v("shot")]), _vm._v(" was expected presently to go off. After waiting two minutes or so a fellow calld out something and our carriage as a planet and the cars for satellites started all forward at once, the Irishmen whooping and crying and the horses galloping. Unable to learn the meaning of this I had only left to suppose that they had delayd firing the intended "), _c('i', [_vm._v("shot")]), _vm._v(" till we should pass and that we were passing quickly to make the delay as short as possible. No such thing. By dint of making great haste we got within ten yards of the rock when the blast took place throwing dust and gravel on our carriage and had our postillions brought us a little nearer (it was not for want of hollowing and flogging that he did not) we should have had a still more serious share of the explosion. The explanation I received from the drivers was that they had been told by the overseer that as the "), _c('i', [_vm._v("mine")]), _vm._v(" had been so "), _c('i', [_vm._v("long")]), _vm._v(" in going off he dared say we would have time to pass it. So we just waited long enough to make the danger imminent. I have only to add that two or three people got behind the carriage just for nothing but to see how our honours got passd.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_vm._v("Went to the Oil Gas Committee this morning of which concern I am president or Chairman."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-95",
      "id": "num-footnote-1-95-back"
    }
  }, [_vm._v("13")]), _vm._v(" It has amused me much by bringing me into company with a body of active business-loving money-making citizens of Edinburgh, chiefly Whigs by the way, whose sentiments and proceedings amuse me. The Stock is rather low in the market, 35/-premium instead of "), _c('i', [_vm._v("£")]), _vm._v("5. 0. 0. It must rise however for the advantages of the Light are undeniable and folks will soon become accustom [d] to idle apprehensions or misapprehensions. From "), _c('i', [_vm._v("£")]), _vm._v("20 to "), _c('i', [_vm._v("£")]), _vm._v("25 should light a house capitally supposing you leave town in the vacation. The three last quarters cost me "), _c('i', [_vm._v("£")]), _vm._v("10.10. and the first, "), _c('i', [_vm._v("£")]), _vm._v("8, was greatly over charged. We will see what this – the worst and darkest quarter costs.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00013"
    }
  }, [_vm._v("Dined with Sir Robert Dundas"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-96",
      "id": "num-footnote-2-96-back"
    }
  }, [_vm._v("14")])]), _vm._v(" where we met Lord and Lady Melville."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-97",
      "id": "num-footnote-3-97-back"
    }
  }, [_vm._v("15")])]), _vm._v(" My little "), _c('i', [_vm._v("nieces")]), _vm._v(" ("), _c('i', [_vm._v("ex officio")]), _vm._v(") gave us some pretty musick. I do not know and cannot utter a note of music and complicated harmonies seem to me a babble of confused though pleasing sounds. Yet songs and simple melodies especially if connected with words and ideas have as much effect on me as on most people. But then I hate to hear a young person sing without feeling and expression suited to the song. I cannot bear a voice that has no more life in it than a pianoforte or a bugle horn. There is something about all the fine arts of soul and spirit which like the vital principle in Man defies the research of the most critical anatomist. You feel where it is not, yet you cannot describe what it is you want. Sir Joshua or some other great painter was looking at a painting on which much pains had been bestowd – ‘Why yes’ he said in a hesitating manner – ‘it is very clever – very well done – can’t find fault – but it wants some thing – it wants – it wants – damn me – it wants that’ – throwing his hand over his head and snapping his fingers. Tom Moore’s is the most exquisite warbling I ever heard.\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("Next to him David Macculloch"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-98",
      "id": "num-footnote-1-98-back"
    }
  }, [_vm._v("16")]), _vm._v(" for Scots songs. The last when a boy at Dumfries was much admired by Burns who used to get him to try over the words which he composed to new melodies. He is brother of Macculloch of Ardwall.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00002"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00002"
    }
  }, [_vm._v("22 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TUESDAY")]), _vm._v(" "), _c('i', [_vm._v("Moore")]), _vm._v(". I saw Moore"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-99",
      "id": "num-footnote-2-99-back"
    }
  }, [_vm._v("17")])]), _vm._v(" (for the first time I may say) this season. We had indeed met in public twenty years ago. There is a manly frankness and perfect ease and good breeding about him which is delightful. Not the least touch of the poet or the pedant. A little – very little man – less I think than Lewis"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-100",
      "id": "num-footnote-3-100-back"
    }
  }, [_vm._v("18")])]), _vm._v(" and somewhat like him in person, God knows not in conversation, for Matt though a clever fellow was a bore of the first description. Moreover he lookd always like a school boy. I remember a picture of him being handed about at Dalkeith House. It was a miniature I think by Saunders who had contrived to mufle Lewis’s person in a cloak and placed some poniard or darklanthorn appurtenance (I think) in his hand so as to give the picture the cast of a Bravo. ‘That like Matt Lewis’ said Duke Henry"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-101",
      "id": "num-footnote-4-101-back"
    }
  }, [_vm._v("19")])]), _vm._v(" to whom it had passd in turn. ‘Why that is like a man.’ Imagine the effect. Lewis was at his elbow. Now Moore has none of this insignificance. To be sure his person is much stouter than that of M. G. L. His countenance is decidedly plain but the expression is so very animated especially in speaking or singing that it is far more interesting than the finest features could have renderd.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00015"
    }
  }, [_vm._v("I was aware that Byron had often spoken both in private society and in his journal of Moore and myself in the same breath and with the same sort of regard."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-102",
      "id": "num-footnote-5-102-back"
    }
  }, [_vm._v("20")])]), _vm._v(" So I was curious to see what there could be in common betwixt us, Moore having lived so much in the gay world I in the country and with people of business and sometimes with\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("politicians, Moore a scholar – I none – He a musician and artist – I without knowledge of a note – He a democrat – I an aristocrat – with many other points of difference besides his being an Irishman, I a Scotchman, and both tolerably national. Yet there is a point of resemblance and a strong one. We are both goodhumoured fellows who rather seek to enjoy what is going forward than to maintain our dignity as Lions. And we have both seen the world too widely and too well not to contemn in our souls the imaginary consequence of literary people who walk with their noses in the air and remind me always of the fellow whom Johnson met in an ale-house and who calld himself ‘the great Twalmly, Inventor of the flood-gate iron for smoothing linen.’"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-103",
      "id": "num-footnote-1-103-back"
    }
  }, [_vm._v("21")]), _vm._v(" He also enjoys the "), _c('i', [_vm._v("Mot pour rire")]), _vm._v(" and so do I. Moore has I think been ill treated about Byron’s Memoirs. He surrenderd them to the family (Ld. Byron’s exors) and thus lost "), _c('i', [_vm._v("£")]), _vm._v("2000 which he had raised upon them at a most distressing moment of his life. It is true they offerd and pressd the money on him afterwards but they ought to have settled it with the Booksellers and not put poor Tom’s spirit in arms against his interest. I think at least it might have been so managed. At any rate there must be an authentic life of Byron by somebody. Why should they not give the benefit of their materials to Tom Moore whom Byron had made the depositary of his own Memoirs? But T. M. thinks that Cam Hobhouse"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-104",
      "id": "num-footnote-2-104-back"
    }
  }, [_vm._v("22")])]), _vm._v(" has the purpose of writing Byron’s life himself. He and Moore were at sharp words during the negotiation and there was some explanation necessary before the affair ended. It was a pity that nothing save the total destruction of Byron’s Memoirs would satisfy his Exors – But there was a reason – "), _c('i', [_vm._v("Premet Nox alta")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-105",
      "id": "num-footnote-3-105-back"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00016"
    }
  }, [_vm._v("It would be [a] delightful addition to life if T. M. had a cottage within two miles of one. We went to the theatre together and the House being luckily a good one received T. M. with rapture. I could have huggd them for it paid back the debt of the kind reception I met with in Ireland."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-106",
      "id": "num-footnote-4-106-back"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00018"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("Here is matter for a May morning."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-107",
      "id": "num-footnote-1-107-back"
    }
  }, [_vm._v("25")]), _vm._v(" But much fitter for a November one. The general distress in the city has affected H. and R.,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-108",
      "id": "num-footnote-2-108-back"
    }
  }, [_vm._v("26")])]), _vm._v(" Constable’s great agents. Should they "), _c('i', [_vm._v("go")]), _vm._v(" it is not likely that Constable can stand, and such an event would lead to great distress and perplexity on the part of J. B."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-109",
      "id": "num-footnote-3-109-back"
    }
  }, [_vm._v("27")])]), _vm._v(" and myself. Thank God I have enough at worst to pay 40/-in the pound taking matters at the very worst. But much distress and inconvenience must be the consequence. I had a lesson in 1814 which should have done good upon me."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-110",
      "id": "num-footnote-4-110-back"
    }
  }, [_vm._v("28")])]), _vm._v(" But success and abundance erazed it from my mind. But this is no time for journalizing or moralizing either. Necessity is like a sour-faced Cookmaid and I a turnspit whom she has flogged ere now till he mounted his wheel. If W-st-k can be out by 25 January it will do much and it is possible."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-111",
      "id": "num-footnote-5-111-back"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00019"
    }
  }, [_vm._v("Sir John Sinclair’s son has saved his comrade on shipboard (young Hope) by throwing himself overboard and keeping the other afloat – a very gallant thing. But the "), _c('i', [_vm._v("Gran Giag’ Asso")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-112",
      "id": "num-footnote-6-112-back"
    }
  }, [_vm._v("30")])]), _vm._v(" asks me to write a poem "), _c('i', [_vm._v("on the Civic crown")]), _vm._v(" of which he sends me a description quoted from Adam’s "), _c('i', [_vm._v("Antiquities")]), _vm._v(","), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-113",
      "id": "num-footnote-7-113-back"
    }
  }, [_vm._v("31")])]), _vm._v(" which mellifluous performance is to persuade the admiralty to give the young conservator promotion. Oh he is a rare Headpiece – an admirable Morion. I do not believe there is in nature such a full-acornd Boar."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-114",
      "id": "num-footnote-8-114-back"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00020"
    }
  }, [_vm._v("Could not write to purpose for thick coming fancies."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-9-115",
      "id": "num-footnote-9-115-back"
    }
  }, [_vm._v("33")])]), _vm._v(" The wheel would not turn easily and cannot be forced.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00001"
    }
  }, [_c('p', [_vm._v("My spinning wheel is auld and stiff")]), _vm._v(" "), _c('p', [_vm._v("    The rock o’t winna stand Sir.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00021"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00002"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_c('p', [_vm._v("To keep the temper-pin in tiff")])]), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_vm._v("   Employs aft my hand Sir."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-116",
      "id": "num-footnote-1-116-back"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00002"
    }
  }, [_vm._v("Went to dine at L— J— C—"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-117",
      "id": "num-footnote-2-117-back"
    }
  }, [_vm._v("35")])]), _vm._v(" as I thought by invitation but it was for tuesday se’en night. Returnd very well pleased not being exactly in the humour for company – and had a beefsteak. My appetite is surely excepting in quantity that of a farmer, for, eating moderately of anything, my epicurean pleasure is in the most simple diet. Wine I seldom taste when alone and use instead a little spirits and water. I have of late diminishd the quantity for fear of a weakness inductive to a diabetes, a disease which broke up my father’s health though one of the most temperate men who ever lived. I smoke a couple of segars instead which operates equally as a sedative –\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00003"
    }
  }, [_c('p', [_vm._v("Just to drive the cold winter away")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("And drown the fatigues of the day."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-118",
      "id": "num-footnote-3-118-back"
    }
  }, [_vm._v("36")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00022"
    }
  }, [_vm._v("I smoked a good deal about twenty years ago when at Ashestiel"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-119",
      "id": "num-footnote-4-119-back"
    }
  }, [_vm._v("37")])]), _vm._v(" but coming down one morning to the parlour I found as the room was small and confind that the smell was unpleasant and laid aside the use of the "), _c('i', [_vm._v("Nicotian weed")]), _vm._v(" for many years, but was again led to use it by the example of my son a Hussar officer, and my son-in-law an Oxford Student. I could lay it aside tomorrow – I laugh at the dominion of custom in this and many things.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00004"
    }
  }, [_c('p', [_vm._v("We make the giants first and then – "), _c('i', [_vm._v("do not")]), _vm._v(" kill them."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-120",
      "id": "num-footnote-5-120-back"
    }
  }, [_vm._v("38")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00003"
    }
  }, [_vm._v("23 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" On comparing notes with Moore I was confirmd in one or two points which I had always laid down in considering poor Byron’s [peculiarities]. One was that like Rousseau he was apt to be very suspicious, and a plain downright steadiness of manner was the true mode to maintain his good opinion. Will: Rose"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-121",
      "id": "num-footnote-6-121-back"
    }
  }, [_vm._v("39")])]), _vm._v(" told me that "), _c('a', {
    attrs: {
      "id": "pb-rw_12"
    }
  }, [_vm._v("once while sitting with Byron he fixd insensibly his eyes on his feet, one of which it must be rememberd was deformd. Looking up suddenly he saw Byron regarding him with a look of concentrated and deep displeasure which wore off when he observed no consciousness or embarassment in the countenance of Rose. Murray"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-122",
      "id": "num-footnote-1-122-back"
    }
  }, [_vm._v("40")]), _vm._v(" afterwards explaind this by telling Rose that Lord Byron was very jealous of having this personal imperfection noticed or attended to. In another point Moore confirmd my previous opinion. Namely that Byron loved mischiefmaking. Moore had written to him cautioning him against the project of establishing the paper called the "), _c('i', [_vm._v("Liberal")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-123",
      "id": "num-footnote-2-123-back"
    }
  }, [_vm._v("41")])]), _vm._v(" in communion with such men as P. B. Shelley and Hunt on whom he said the World had set its mark. Byron shewd this to the parties. Shelley wrote a modest and rather affecting expostulation to Moore."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-124",
      "id": "num-footnote-3-124-back"
    }
  }, [_vm._v("42")])]), _vm._v(" These two peculiarities of extreme suspicion and love of mischief are both shades of the malady which certainly tinctured some part of the character of this mighty genius and, without some tendency towards which, genius – I mean that kind which depends on the imaginative power – perhaps cannot exist to great extent. The wheels of a machine to play rapidly must not fit with the utmost exactness else the attrition diminishes the Impetus.\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00003"
    }
  }, [_vm._v("Another of Byron’s peculiarities was the love of mystifying which indeed may be referd to that of mischief. There was no knowing how much or how little to believe of his narratives. Instance. Mr. Bankes"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-125",
      "id": "num-footnote-4-125-back"
    }
  }, [_vm._v("43")])]), _vm._v(" expostulating with him upon a dedication which he had written in extravagant terms of praise to Cam Hobhouse, Byron told him that Cam had teased him into the dedication till he had said ‘Well; it shall be so – providing you will write the dedication yourself’ – and affirmd that Cam Hobhouse did write the high-colourd dedication accordingly. I mentiond this to Murray, having the report from Will Rose to whom Bankes had mentiond it. Murray in reply assured me that the dedication was written by Lord Byron himself and shewd it me in his own hand. I wrote to Rose to mention the thing to Bankes as it might have made mischief had the story got into the circle.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00023"
    }
  }, [_vm._v("Byron was disposed to think all men of imagination were addicted to mix fiction or poetry with their prose. He used to say he dared believe the celebrated courtezan of Venice about whom Rousseau makes so piquante a story was if one could see her a draggled taild wench enough. I believe that he embellishd his own amours considerably and that he was in many respects "), _c('i', [_vm._v("Le fanfaron des vices qu’il")]), _vm._v(" "), _c('i', [_vm._v("n’avait pas")]), _vm._v(". He loved to be thought awful mysterious and gloomy and sometimes hinted at strange causes. I believe the whole to have been the creation and sport of a wild and powerful fancy. In the same manner he "), _c('i', [_vm._v("cram’d")]), _vm._v(" people as it is termd about duels and what [not] which never existed or were much exaggerated.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00025"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  }, [_vm._v("Constable has been here as lame as a duck upon his legs but his heart and courage as firm as a cock. He has convinced me we will do well to support the London House."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-126",
      "id": "num-footnote-1-126-back"
    }
  }, [_vm._v("44")]), _vm._v(" He has sent them about "), _c('i', [_vm._v("£")]), _vm._v("5000 and proposes we should borrow on our joint security "), _c('i', [_vm._v("£")]), _vm._v("5000 for their accomodation. J. B. and R. Cadell"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-127",
      "id": "num-footnote-2-127-back"
    }
  }, [_vm._v("45")])]), _vm._v(" present. I must be guided by them and hope for the best. Certainly to part company would be to incur an awful risque.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00026"
    }
  }, [_vm._v("What I liked about Byron besides his boundless genius was his generosity of Spirit as well as purse and his utter contempt of all the affectations of literature from the School-magisterial stile to the lackadaisical.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00027"
    }
  }, [_vm._v("Byron’s example has formed a sort of Upper House of poetry. There is Lord Leveson Gower a very clever young man. Lord Porchester too, nephew to Mrs Scott of Harden, a young man who lies on the carpet and looks poetical and dandyish – fine lad too – But")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00005"
    }
  }, [_c('p', [_vm._v("There be many peers")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("Ere such another Byron."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-128",
      "id": "num-footnote-3-128-back"
    }
  }, [_vm._v("46")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Talking of Abbotsford it begins to be haunted by too much company of every kind. But especially foreigners. I do not like them. I hate fine waistcoats and breast pins upon dirty shirts. I detest the impudence that pays a stranger compliments and harangues about his works in the Author’s house, which is usually ill breeding. Moreover they are seldom long of making it evident that they know nothing about what they are talking of excepting having seen the "), _c('i', [_vm._v("Lady")]), _vm._v(" "), _c('i', [_vm._v("of the Lake")]), _vm._v(" at the Opera.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00005"
    }
  }, [_vm._v("Dined at Saint Catherine’s with Lord Advocate,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-129",
      "id": "num-footnote-4-129-back"
    }
  }, [_vm._v("47")])]), _vm._v(" with Lord and \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_14"
    }
  }, [_vm._v("Lady Mellville, Lord Justice Clerk, Sir Archd. Campbell of Succoth,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-130",
      "id": "num-footnote-1-130-back"
    }
  }, [_vm._v("48")]), _vm._v(" all class companions and acquainted well for more than 40 years. All excepting Lord J. C. were at Fraser’s class High School. Boyle joined us at college. There are besides, Sir Adam Fergusson,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-131",
      "id": "num-footnote-2-131-back"
    }
  }, [_vm._v("49")])]), _vm._v(" Colin Mackenzie,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-132",
      "id": "num-footnote-3-132-back"
    }
  }, [_vm._v("50")])]), _vm._v(" James Hope, Dr. James Buchan, Claud Russell,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-133",
      "id": "num-footnote-4-133-back"
    }
  }, [_vm._v("51")])]), _vm._v(" and perhaps two or three more of and about the same period. But\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00006"
    }
  }, [_c('p', [_c('i', [_vm._v("Rari apparent nantes in gurgite vasto")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-134",
      "id": "num-footnote-5-134-back"
    }
  }, [_vm._v("52")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00004"
    }
  }, [_vm._v("24"), _c('span', {
    staticClass: "sc"
  }, [_vm._v(" THURSDAY")]), _vm._v(" Talking of Strangers, London held some four or five years since one of those animals who are lions at first but by transmutation of two seasons become in regular course Boars. Ugo Foscolo"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-135",
      "id": "num-footnote-6-135-back"
    }
  }, [_vm._v("53")])]), _vm._v(" by name, a haunter of Murray’s Shop and of literary parties. Ugly as a baboon and intolerably conceited, he splutterd blusterd and disputed without even knowing the principles upon which men of sense render a reason and screamd all the while like a pig when they cut his throat.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00028"
    }
  }, [_vm._v("Another such Animalaccio is a brute of a Sicilian Marquis de Salvo"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-136",
      "id": "num-footnote-7-136-back"
    }
  }, [_vm._v("54")])]), _vm._v(" who wrote something about Byron. He inflicted two days on us at Abbotsford and they never know what to make of themselves in the forenoon; but sit tormenting the women to play at proverbs and such trash.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00006"
    }
  }, [_vm._v("Foreigner of a different caste. Count Olonym (Olonyne that’s it) son of the President of the Royal Society and a Capt. in the Imperial Guards. He is mean looking and sickly but has much sense, candour and general information.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00007"
    }
  }, [_vm._v("There was at Abbotsford and is here for education just now a young Count Davidow with a tutor Mr. Colyar. He is a nephew of the famous Orlows. It is quite surprizing how much sense and sound thinking this youth has at the early age of sixteen without the least self-conceit or forwardness. On the contrary he seems kind, modest and ingenuous. Yet to questions which I askd about the state of Russia he answerd with the precision and accuracy of twice his years. He is but sixteen. I should be sorry the saying were verified in him")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00029"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  }), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00007"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  }, [_vm._v("So wise and young they say never live long."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-137",
      "id": "num-footnote-1-137-back"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00030"
    }
  }, [_vm._v("Saw also at Abbotsford two Frenchmen whom I liked, friends of Miss Dumergue."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-138",
      "id": "num-footnote-2-138-back"
    }
  }, [_vm._v("56")])]), _vm._v(" One calld Le Noir"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-139",
      "id": "num-footnote-3-139-back"
    }
  }, [_vm._v("57")])]), _vm._v(" is the author of a tragedy which he had the grace never to quote and which I, though poked by some malicious persons, had not the grace even to hint at. They were disposed at first to be complimentary but I convinced them it was not the custom here and they took it well and were agreeable.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00031"
    }
  }, [_vm._v("A little bilious this morning for the first time these six months. It cannot be the London matters which stick on my stomach for that is mending and may have good effects on myself and others.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00032"
    }
  }, [_vm._v("Dined with Robert Cockburn."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-140",
      "id": "num-footnote-4-140-back"
    }
  }, [_vm._v("58")])]), _vm._v(" Company Lord Melville and family, Sir John and Lady Hope, Lord and Ly. R. Kerr"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-141",
      "id": "num-footnote-5-141-back"
    }
  }, [_vm._v("59")])]), _vm._v(" and so furth. Combination of Coalliers general and coals up to double price. The men will not work "), _c('i', [_vm._v("although")]), _vm._v(" or rather "), _c('i', [_vm._v("because")]), _vm._v(" they can make from 30/-to 40/-per week. L. R. K. told us that he had a letter from Lord Forbes (son of Earl Granard, Ireland) that he was asleep in his house at Castle Forbes when awaked by a sense of suffocation which deprived him of the power of stirring a limb yet left him the consciousness that the house was on fire. At this moment and while his apartment was in flames his large dog jumpd on the bed, seized his shirt and dragd him to the stair-case where the fresh air restored his powers of exertion and of escape. This is very different from most cases of preservation of life by the canine race, when the animal generally jumps into the water in which he has force and skill. That of fire is as hostile to him as to mankind.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00033"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00003"
    }
  })]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00005"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }, [_vm._v("25"), _c('span', {
    staticClass: "sc"
  }, [_vm._v(" FRIDAY")]), _vm._v(" Read Jeffrey’s neat and well intended address to the Mechanics upon their combinations."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-142",
      "id": "num-footnote-1-142-back"
    }
  }, [_vm._v("60")]), _vm._v(" Will it do good? – Umph. It takes only the hand of a Liliputian to light a fire but would require the diuretic powers of Gulliver to extinguish it."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-143",
      "id": "num-footnote-2-143-back"
    }
  }, [_vm._v("61")])]), _vm._v(" The Whigs will live and die in the heresy that the world is ruled by little pamphlets and speeches and that if you can sufficiently demonstrate that a line of conduct is most consistent with men’s interest you have therefore and thereby demonstrate [d] that they will at length after a few speeches on the subject adopt it of course. In this case we would have [no] need of laws or churches for I am sure there is no difficulty of proving that moral, regular, steady habits conduce to Men’s best interest and that vice is not sin merely but folly. But of these individuals each has passions and prejudices the gratification of which he prefers not only to the general weal but to that of himself as an individual. Under the action of these wayward impulses a man drinks to-day though he is sure of starving tomorrow – he murders tomorrow though [he] is sure to be hanged on Wednesday and people are so slow to believe that which makes against their own predominant passions that mechanics will combine to raise the price for one week though they destroy the manufacture for ever. The best remedy seems to be the probable supply of labourers from other trades. Jeffrey proposes each mechanic shall learn some other trade than his own and so have two strings to his bow. He does not consider the length of a double apprenticeship. To make a man a good weaver and a good tailor would require as much time as the patriarch served for his two wives. After all he would be but a poor workman at either craft. Each mechanic has indeed a second trade for he can dig and work rustic labour. Perhaps the best reason for breaking up the associations will prove to be the expenditure of the money which they have been simple enough to levy from the industrious to the support of the idle. How much provision for the sick and the aged, the widow and the orphan, have been expended in the attempt to get wages which the manufacturer cannot afford them at any profitable chance of selling his commodity.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00008"
    }
  }, [_vm._v("I had a bad fall last night coming home: there were unfinishd houses at the east end of Athole place and as I was on foot I crossd the street to avoid the material which lay about. But deceived by the moonlight I slippd ancle deep into a sea of mud (honest earth and water thank God) and fell on my hands. Never was there such a representative of "), _c('i', [_vm._v("Wall")]), _vm._v(" in Pyramus and Thisbe. I was absolutely rough cast. Luckily Lady S. had retired when I came home so I enjoyd my tub of water without either remonstrance or condoleances. Cockburn’s hospitality will get the benefit and renown of my downfall and yet has no claim to it. In future though I must take a coach at night. A controul on one’s freedom but it must be submitted to.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00034"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  }, [_c('div', {
    staticClass: "block sidebar floatgalley-outside",
    attrs: {
      "id": "rw-block-sidebar_110265-00001"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("N.B")]), _vm._v(". Within eight weeks after recording this graceful act of submissiom I found I was unable to keep a carriage\n            ")])])]), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00009"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  }, [_vm._v("I found a letter from R. C."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-144",
      "id": "num-footnote-1-144-back"
    }
  }, [_vm._v("62")]), _vm._v(" giving a cheer-ing account of things in London. Their correspondent"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-145",
      "id": "num-footnote-2-145-back"
    }
  }, [_vm._v("63")])]), _vm._v(" is getting into his"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-146",
      "id": "num-footnote-3-146-back"
    }
  }, [_vm._v("64")])]), _vm._v(" strength. Three days ago I would have been contented to buy this "), _c('i', [_vm._v("consola")]), _vm._v(", as Judy says,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-147",
      "id": "num-footnote-4-147-back"
    }
  }, [_vm._v("65")])]), _vm._v(" dearer than by a dozen falls in the mud – for had the great Constable fallen\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00008"
    }
  }, [_c('p', [_vm._v("O my countrymen what a fall were there!"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-148",
      "id": "num-footnote-5-148-back"
    }
  }, [_vm._v("66")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00035"
    }
  }, [_vm._v("Mrs. Coutts"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-149",
      "id": "num-footnote-6-149-back"
    }
  }, [_vm._v("67")])]), _vm._v(" with the Duke of Saint Albans and Lady Charlotte Beauclerk"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-150",
      "id": "num-footnote-7-150-back"
    }
  }, [_vm._v("68")])]), _vm._v(" calld to take leave of us. When at Abbotsford his suit\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_18"
    }
  }, [_vm._v("throve but coldly. She made me I believe her confident in sincerity. She had refused him twice and decidedly he was merely on the footing of friendship. I urged it was akin to Love. She allowd she might marry the Duke only she had at present the least intention that way. Is this frank admission more favourable for the Duke than an absolute protestation against the possibility of such a marriage? I think not. It is the fashion to attend Mrs. Coutts’ parties and to abuse her."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-151",
      "id": "num-footnote-1-151-back"
    }
  }, [_vm._v("69")]), _vm._v(" I have always found her a kind friendly woman without either affectation or insolence in the display of her wealth and most willing to do good if the means be shewn to her. She can be very entertaining too as she speaks without scruple of her stage life. So much wealth can hardly be enjoyd without some ostentation but what then? If the Duke marries her he ensures an immense fortune. If she marries him she has the first rank. If he marries a woman older than himself by twenty years She marries a man younger in wit by twenty degrees. I do not think he will dilapidate her fortune – he seems quiet and gentle. I do not think that she will abuse his softness – of disposition shall I say or of heart – The disparity of ages concerns no one but themselves – So they have my consent to marry if they can get each other’s. Just as this is written enter my Lord of Saint Albans and Lady Charlotte to beg I would recommend a book of sermons to Mrs. Coutts – much obliged for her good opinion – recommended Logan’s"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-152",
      "id": "num-footnote-2-152-back"
    }
  }, [_vm._v("70")])]), _vm._v(" – One poet should always speak for another – The mission I suppose was a little display on the part of good Mrs. Coutts of authority over her high aristocratic Suitor. I do not suspect her of turning Dévote and retract my consent given as above unless she remains ‘lively brisk and jolly.’\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00036"
    }
  }, [_vm._v("Dined quiet with Wife and daughter.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00037"
    }
  }, [_vm._v("R. Cadell lookd in in the evening on business. I here register my purpose to practise oeconomies. I have little temptation to do otherwise. Abbotsford is all that I can make it and too large for the property so I resolve –")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00038"
    }
  }, [_vm._v("No more Building")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00039"
    }
  }, [_vm._v("No purchases of Land till times are quite safe")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00040"
    }
  }, [_vm._v("No buying books or expensive trifles – I mean to any extent. And Clearing off encumbrances with the returns of this year’s labour:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00042"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_19"
    }
  }, [_vm._v("Which resolutions with health and my habits of industry will make me ‘Sleep in spite of thunder.’"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-153",
      "id": "num-footnote-1-153-back"
    }
  }, [_vm._v("71")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00043"
    }
  }, [_vm._v("After all it is hard that the vagabond Stock-jobbing Jews should for their own purposes make such a shake of credit as now exists in London and menace the credit of men trading on sure funds like H. and R. It is just like a set of pickpockets who raise a mob in which honest folks are knocked down and plunderd that they may pillage safely in the midst of the confusion they have excited.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00004"
    }
  }, [_c('p')]), _vm._v(" "), _c('div', {
    staticClass: "block sidebar floatgalley-outside",
    attrs: {
      "id": "rw-block-sidebar_110265-00002"
    }
  }, [_c('p', [_vm._v("I was obliged to give this up in consequence of my own misfortunes.")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00006"
    }
  }, [_vm._v("26"), _c('span', {
    staticClass: "sc"
  }, [_vm._v(" SATURDAY")]), _vm._v(" The court met late and sate till "), _c('i', [_vm._v("one")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-154",
      "id": "num-footnote-2-154-back"
    }
  }, [_vm._v("72")])]), _vm._v(" Detaind from that hour till four o’clock being engaged in the perplexd affairs of Mr. James Stewart of Brugh. This young gentleman is heir to a property of better than "), _c('i', [_vm._v("£")]), _vm._v("1000 a year in Orkney. His mother married very young and was wife mother and widow in the course of the first year. Being unfortunately under the direction of a careless perhaps an unfaithful agent She was unlucky enough to embarass her own affairs by money transactions with this person. I was askd to accept the situation of one of his curators and trust to clear out his affairs and hers – at least I will not fail for want of application. I have lent her "), _c('i', [_vm._v("£")]), _vm._v("300 on a second (and therefore doubtful) security over her house in Newington"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-155",
      "id": "num-footnote-3-155-back"
    }
  }, [_vm._v("73")])]), _vm._v(" bought for "), _c('i', [_vm._v("£")]), _vm._v("1000 and on which "), _c('i', [_vm._v("£")]), _vm._v("600 is already secured. I have no connection with the family except that of compassion and [may] not be rewarded even by thanks when the young man comes of age. I have known my father often so treated by those whom he had labourd to serve. But if we do not run some hazard in our attempts to do good where is the merit of them? So I will bring through my Orkney Laird if I can.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00044"
    }
  }, [_vm._v("Dined at home quiet with Lady S. and Anne.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00005"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00045"
    }
  }, [_vm._v("27"), _c('span', {
    staticClass: "sc"
  }, [_vm._v(" SUNDAY")]), _vm._v(" Some time since John Murray enterd into a contract with my son in law John G. Lockhart giving him on certain ample conditions the Management and Editorship of the "), _c('i', [_vm._v("Quarterly Review")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-156",
      "id": "num-footnote-4-156-back"
    }
  }, [_vm._v("74")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "pb-rw_20"
    }
  }, [_vm._v("for which they could certainly scarcely find a fitter person both from talents and character. It seems that Barrow"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-157",
      "id": "num-footnote-1-157-back"
    }
  }, [_vm._v("75")]), _vm._v(" and one or two stagers have taken alarm at Lockhart’s character as a satirist and his supposed accession to some of the freaks in Blackwood’s magazine"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-158",
      "id": "num-footnote-2-158-back"
    }
  }, [_vm._v("76")])]), _vm._v(" and down comes young D’Israeli"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-159",
      "id": "num-footnote-3-159-back"
    }
  }, [_vm._v("77")])]), _vm._v(" to Scotland imploring Lockhart to make interest with my friends in London to remove objections and so forth. I have no idea of telling all and sundry that my son in law is not a slanderer or a silly thoughtless lad although [he] was six or seven years ago engaged in some light satires. I only wrote to Heber"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-160",
      "id": "num-footnote-4-160-back"
    }
  }, [_vm._v("78")])]), _vm._v(" and to Southey"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-161",
      "id": "num-footnote-5-161-back"
    }
  }, [_vm._v("79")])]), _vm._v(" – the first upon the subject of the reports which had startled Murray (the most timorous as Byron calld him of all God’s booksellers) and such a letter as he may show Barrow if he judges proper – To Southey I wrote more generally acquainting him of my son’s appointment to the Editorship and mentioning his qualifications, touching at the same time on his very slight connection with "), _c('i', [_vm._v("Blackwd Magazine")]), _vm._v(" and his innocence as to those gambades which may have offended himself and Southey"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-162",
      "id": "num-footnote-6-162-back"
    }
  }, [_vm._v("80")])]), _vm._v(" and which I fear they may ascribe too truly to an eccentric neighbour of their own."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-163",
      "id": "num-footnote-7-163-back"
    }
  }, [_vm._v("81")])]), _vm._v(" I also mentiond that I heard nothing of the affair untill the month of October. I am concernd that Southey should know this for having been at the Lakes in September"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-164",
      "id": "num-footnote-8-164-back"
    }
  }, [_vm._v("82")])]), _vm._v(" I would not have him suppose that I \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_21"
    }
  }, [_vm._v(" had been using interest with Canning"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-165",
      "id": "num-footnote-1-165-back"
    }
  }, [_vm._v("83")]), _vm._v(" or Ellis"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-166",
      "id": "num-footnote-2-166-back"
    }
  }, [_vm._v("84")])]), _vm._v(" to supersede young Mr. Coleridge"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-167",
      "id": "num-footnote-3-167-back"
    }
  }, [_vm._v("85")])]), _vm._v(" their Editor and place my Son [in] law in the situation. Indeed I was never more surprized than when this proposal came upon us. I suppose it had come from Canning originally as he was sounding Anne when at Colonel Bolton’s"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-168",
      "id": "num-footnote-4-168-back"
    }
  }, [_vm._v("86")])]), _vm._v(" about Lockhart’s views <he> etc. To me he never hinted anything on the Subject. Other views are held out to Lockhart which may turn to great advantage. Only one person (John Cay"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-169",
      "id": "num-footnote-5-169-back"
    }
  }, [_vm._v("87")])]), _vm._v(" of Charlton) knows their object and truly I wish it had not been confided to any one. Yesterday I had a letter from Murray in answer to one I had written in something a determined stile for I had no idea of permitting him to start from the course after my son giving up his situation and profession merely because a contributor or two chose to suppose gratuitously that Lockhart was too imprudent for the situation. My physic has wrought well for it brought a letter from Murray saying all was right,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-170",
      "id": "num-footnote-6-170-back"
    }
  }, [_vm._v("88")])]), _vm._v(" that D’Israeli was sent to me not to Lockhart, and that I was only invited to write two confidential letters, and other incoher-encies which intimate his fright has got into another quarter. It is interlined and franked by Barrow"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-171",
      "id": "num-footnote-7-171-back"
    }
  }, [_vm._v("89")])]), _vm._v(" which shows that all is well and that John’s induction in to his office will be easy and pleasant. I have not the least fear of his success. His talents want only a worthy sphere of exertion. He must learn however to despize petty adversaries. No good sportsman ought to shoot at crows unless for some special purpose. To take notice of such men as Hazlitt and Hunt in the "), _c('i', [_vm._v("Quarterly")]), _vm._v(" would be to introduce them into a world which is scarce conscious of their existence. It is odd enough that many years since I had the principal share in erecting this Review which has been since  \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_22"
    }
  }, [_vm._v("so prosperous and now it is placed under management of my Son in Law upon the most honourable principle of "), _c('i', [_vm._v("detur digniori")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-172",
      "id": "num-footnote-1-172-back"
    }
  }, [_vm._v("90")]), _vm._v(" Yet there are sad drawbacks so far as family comfort is concernd. To-day is Sunday when they always dined with us and generally met a family friend or two. But we are no longer to expect them – In the country where their little cottage was within a mile or two of Abbotsford we shall miss their society still more for Chiefswood was the perpetual object of our walks, rides and drives. Lockhart is such an excellent family man so fond of his wife and child that I hope all will go well.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00046"
    }
  }, [_vm._v("A letter from Lockhart in the evening."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-173",
      "id": "num-footnote-2-173-back"
    }
  }, [_vm._v("91")])]), _vm._v(" All safe as to his unanimous reception in London. His predecessor young [Coleridge] handsomely and like a gentleman offers his assistance as a contributor etc.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00006"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00047"
    }
  }, [_vm._v("28"), _c('span', {
    staticClass: "sc"
  }, [_vm._v(" MONDAY")]), _vm._v(" I have the less dread or rather the less anxiety about the consequences of this migration that I repose much confidence in Sophia’s tact and good sense. Her manners are good and have the appearance of being perfectly natural. She is quite conscious of the limited range of her musical talents and never makes them common or produces them out of place – a rare virtue – Moreover she is proud enough and will not be easily netted and patronized by any of that class of Ladies who may be calld Lion-providers for town and country. She is domestic besides and will not be disposed to gad about. Then she seems an oeconomist and on "), _c('i', [_vm._v("£")]), _vm._v("3000, living quietly, there should be something to save."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-174",
      "id": "num-footnote-3-174-back"
    }
  }, [_vm._v("92")])]), _vm._v(" Lockhart must be liked where his good qualities are known and where his fund of information has room to be displayd. But notwithstanding a handsome exterior and face I am not sure he will succeed in London Society. He sometimes reverses the proverb and gives the "), _c('i', [_vm._v("volte strette e pensiere sciolti")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-175",
      "id": "num-footnote-4-175-back"
    }
  }, [_vm._v("93")])]), _vm._v(" – withdraws his attention from the company or attaches himself to some individual, gets into a corner and seems to be quizzing the rest. \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_23"
    }
  }, [_vm._v("This is the want of early habits of being in society and a life led much at College. Nothing is however so popular and so deservedly so as to take an interest in whatever is going forward in Society. A wise man always finds his account in it and will receive information and fresh views of life even in the Society of Fools. Abstain from society altogether when you are not able to play some part in it. This reserve and a sort of Hidalgo air joind to his character as a satirist have done the best humourd fellow in the world some injury in the opinion of Edinburgh folks."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-176",
      "id": "num-footnote-1-176-back"
    }
  }, [_vm._v("94")]), _vm._v(" In London it is of less consequence whether he please in general society or not since if he can establish himself as a genius it will only be calld ‘pretty Fanny’s way.’\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00048"
    }
  }, [_vm._v("People make me the oddest requests. It is not unusual for an Oxonian or Cantab who has out-run his allowance and of whom I know nothing to apply to me for the loan of "), _c('i', [_vm._v("£")]), _vm._v("20–"), _c('i', [_vm._v("£")]), _vm._v("50 or "), _c('i', [_vm._v("£")]), _vm._v("100. A Captain of the Danish naval service wrote to me that being in distress for a sum of money by which he might transport himself to Columbia to offer his services in assisting to free that province he had dreamd I generously made him a present of it. I can tell him his dream by contraries. I begin to find like Joseph Surface that too good a character is inconvenient."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-177",
      "id": "num-footnote-2-177-back"
    }
  }, [_vm._v("95")])]), _vm._v(" I don’t know what I have done to gain so much credit for generosity but I suspect I owe it to being supposed, as Puff says, one of ‘those whom Heaven has blessed with afluence.’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-178",
      "id": "num-footnote-3-178-back"
    }
  }, [_vm._v("96")])]), _vm._v(" Not too much of that neither, my dear petitioners, though I may thank myself that your ideas are not correct.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00049"
    }
  }, [_vm._v("Dined at Melville Castle whither I went through a snow storm. I was glad to find myself once more in a place connected with many happy days."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-179",
      "id": "num-footnote-4-179-back"
    }
  }, [_vm._v("97")])]), _vm._v(" Met Sir R. Dundas and my old friend George now Lord Abercrombie"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-180",
      "id": "num-footnote-5-180-back"
    }
  }, [_vm._v("98")])]), _vm._v(" with his lady and a beautiful girl his daughter. He is what he always was, the best humourd man living, and our meetings now more rare than usual [this] was seasond with many a recollection of old frolics and old friends. I am entertaind to see him just the same he has always been, never yielding up his own opinion\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_24"
    }
  }, [_vm._v("in fact and yet in words acquiescing in all that could be said against it. George was always like a willow; he never offerd resistance to the breath of argument but never moved from his rooted opinion, blow as it listed.\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_24"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_110265-00050"
    }
  }, [_vm._v("Exaggeration might make these peculiarities highly dramatic. Conceive a man who always seems to be acquiescing in your sentiments yet never changes his own and this with a sort of bonhommie which shows there is not a particle of deceit intended. He is only desirous to spare you the trouble of contradiction.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00007"
    }
  })]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00051"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_24"
    }
  }, [_vm._v("29 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TUESDAY")]), _vm._v(" A letter from Southey, malcontent about Murray having accomplishd the change in the "), _c('i', [_vm._v("Quarterly")]), _vm._v(" without speaking to him and quoting the twaddle of some old woman, male or female, about Lockhart’s earlier"), _c('i', [_vm._v(" jeux d’esprit")]), _vm._v(" but concluding most kindly that in regard to my daughter and me he did not mean to withdraw. That he has done yeoman’s service to the Review is certain – and his genius, his universal reading, his powers of regular industry and at the outset a name which though less generally popular than it deserves is still too respectable to be withdrawn without injury. I could not in reply point out to him what is the truth, that his rigid Toryism and high-church prejudices renderd him an unsafe coun-= sellor in a matter where the spirit of the age must be consulted. But I pointed out to him what I am sure is true that Murray, apprehensive of his displeasure, had not ventured to write to him out of mere timidity and not from any [depreciatory feeling]. I treated his old woman’s apprehensions and cautions and all that gossip about friends and enemies to which a splendid number or two will be a sufficient answer. And I accepted with due acknowlegment his proposal of continued support. I cannot say I was afraid of his withdrawing – Lockhart will have hard cards with him for great as Southey’s powers are he has not the art to make them work popularly. He is often diffuse and frequently sets much value on minute and unimportant facts and useless pieces of abstruse knowlege. Living too exclusively in a circle where he is idolized both for his genius and the excellence of his disposition he has acquired strong prejudices, though all of an upright and honourable cast. He rides his high church hobby too hard and it will not do to run a tilt upon it against all the world. Gifford"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-181",
      "id": "num-footnote-1-181-back"
    }
  }, [_vm._v("99")]), _vm._v(" used to crop his articles considerably and they bear marks of it being sometimes "), _c('i', [_vm._v("décousues")]), _vm._v(". Southey said that Gifford cut out his "), _c('i', [_vm._v("middle joints")]), _vm._v(". When\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_25"
    }
  }, [_vm._v(" Johncomes to use the carving knife I fear Dr. Southey will not be so tractable. "), _c('i', [_vm._v("Nous")]), _vm._v(" "), _c('i', [_vm._v("verrons")]), _vm._v(". I will not shew Southey’s letter to J. Lockhart for there is to him personally no friendly tone and it would startle the Hidalgo’s pride. It is to be wishd they may draw kindly together."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-182",
      "id": "num-footnote-1-182-back"
    }
  }, [_vm._v("100")]), _vm._v(" Southey says most truly that even those who most undervalue his reputation would were he to withdraw from the review exaggerate the loss it would thereby sustain. The bottom of all these feuds, though not named, is "), _c('i', [_vm._v("Blackwood’s")]), _vm._v(" "), _c('i', [_vm._v("Magazine")]), _vm._v("; all the squibs of which, which have sometimes exploded among the Lakers, Lockhart is renderd accountable for. He must now exert himself at once with spirit and prudence – He has good backing. Canning, Bishop Bloomfield,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-183",
      "id": "num-footnote-2-183-back"
    }
  }, [_vm._v("101")])]), _vm._v(" Gifford, Wright,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-184",
      "id": "num-footnote-3-184-back"
    }
  }, [_vm._v("102")])]), _vm._v(" Croker,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-185",
      "id": "num-footnote-4-185-back"
    }
  }, [_vm._v("103")])]), _vm._v(" Will Rose, and is there not besides the Douglas? An excellent plot, excellent friends, and full of preparations."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-186",
      "id": "num-footnote-5-186-back"
    }
  }, [_vm._v("104")])]), _vm._v(" It was no plot of my making I am sure. Yet men will say and believe that I, who never heard a word of the matter till first a hint from Wright and then the formal proposal of Murray to Lockhart announcd [it to me, was the maker of it]. I believe Canning and Charles Ellis were the prime movers. I will puzzle my brains no more about it.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00052"
    }
  }, [_vm._v("Dined at Justice Clk’s. The presidt,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-187",
      "id": "num-footnote-6-187-back"
    }
  }, [_vm._v("105")])]), _vm._v(" Capt Smollet etcaetera. Our new Commander in Chief or Commanding in Chief Honble Sir Robert O’Callaghan,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-188",
      "id": "num-footnote-7-188-back"
    }
  }, [_vm._v("106")])]), _vm._v(" brother to Earl of Lismore, a fine soldierly looking man with orders and badges. His brother an Agreeable and deserving the name whom I met at Lowther Castle"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-189",
      "id": "num-footnote-8-189-back"
    }
  }, [_vm._v("107")])]), _vm._v(" this season. He composes his own musick and sings his own poetry, has much \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_26"
    }
  }, [_vm._v("humour enhanced by a strong touch of national dialect which is always a rich sauce to an Irishman’s good things. Dandyish but not offensively, and seems to have a warm feeling for the credit of his country rather inconsistent with the trifling and selfish quietude of a mere man of society.\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_26"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00008"
    }
  })]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00053"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_26"
    }
  }, [_vm._v("30 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" I am come to the time when those who look out at the windows shall be darkend."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-190",
      "id": "num-footnote-1-190-back"
    }
  }, [_vm._v("108")]), _vm._v(" I must now wear spectacles constantly in reading and writing, though till this winter I have made a shift by using only their occasional assistance. Although my health cannot be better I feel my lameness becomes sometimes painful and often inconvenient. Walking on the pavement or causeway gives me trouble and I am glad when I have accomplishd my return on foot from the Parliament House to Castle Street"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-191",
      "id": "num-footnote-2-191-back"
    }
  }, [_vm._v("109")])]), _vm._v(" though I can (taking a competent time as old "), _c('i', [_vm._v("Braxie")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-192",
      "id": "num-footnote-3-192-back"
    }
  }, [_vm._v("110")])]), _vm._v(" said on another occasion) walk five or six miles in the country with pleasure. Well – such things must come and be received with cheerful submission. My early lameness"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-193",
      "id": "num-footnote-4-193-back"
    }
  }, [_vm._v("111")])]), _vm._v(" considerd, it was impossible for a man labouring under a bodily impediment to have been stronger or more active than I have been, and that for twenty or thirty years. Seams will slit and elbows will out quoth the tailor"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-194",
      "id": "num-footnote-5-194-back"
    }
  }, [_vm._v("112")])]), _vm._v(" – and as I was fifty four on 15 August last my mortal vestments are none of the newest. Then Walter, Charles and Lockhart are as active and handsome young fellows as you can see and while they enjoy strength and activity I can hardly be said to want it. I have perhaps all my life set an undue value on these gifts. Yet it does appear to me that high and independent feelings are naturally though not uniformly or inseparably connected with bodily advantages. Strong men are usually goodhumourd and active men often display the same elasticity of mind as of body. These are superiorities however that are often misused. But even for these things God shall call us to judgement."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-195",
      "id": "num-footnote-6-195-back"
    }
  }, [_vm._v("113")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00055"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_27"
    }
  }, [_vm._v("Some months since I joind with other literary folks in subscribing a petition for a pension to Mrs. G—of L—n"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-196",
      "id": "num-footnote-1-196-back"
    }
  }, [_vm._v("114")]), _vm._v(" which we thought was a tribute merited by her works as an authoress and in my opinion much more by the firmness and elasticity of mind with which she had borne a succession of great domestic calamity. Unhappily there was only about "), _c('i', [_vm._v("£")]), _vm._v("100 open on the pension list and this the ministers assigned in equal portions to Mrs. G—and a distressd Lady, grand daughter of a forfeited Scottish nobleman. Mrs. G—, proud as a Highland woman, vain as a poetess and absurd as a Blue Stocking, has taken this partition "), _c('i', [_vm._v("in malam partem")]), _vm._v(" and written to Lord Melville about her merits, and that her friends do not consider her claims as being fairly canvassd, with something like a demand that her petition be submitted to the King. This is not the way to make her "), _c('i', [_vm._v("plack a bawbee")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-197",
      "id": "num-footnote-2-197-back"
    }
  }, [_vm._v("115")])]), _vm._v(" and Lord M. a little "), _c('i', [_vm._v("miffd")]), _vm._v(" in turn sends the whole correspondence to me to know whether Mrs. G. will accept the "), _c('i', [_vm._v("£")]), _vm._v("50 or not. Now hating to deal with ladies when they are in an unreasonable humour I have got the goodhumourd Man of Feeling"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-198",
      "id": "num-footnote-3-198-back"
    }
  }, [_vm._v("116")])]), _vm._v(" to find out the lady’s mind and I take on myself the task of making her peace with Lord M— There is no great doubt how it will end for your scornful dog will always eat your dirty pudding. After all the poor lady is greatly to be pitied. Her sole remaining daughter, deep and far gone in a decline, has been seized with alienation of mind.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00056"
    }
  }, [_vm._v("Dined with my cousin R. R."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-199",
      "id": "num-footnote-4-199-back"
    }
  }, [_vm._v("117")])]), _vm._v(" being the first invitation since my uncle’s death. Our Cousin Lt. Col. Russell"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-200",
      "id": "num-footnote-5-200-back"
    }
  }, [_vm._v("118")])]), _vm._v(" of Ashestiel with his sister Anne, the former newly returnd from India. A fine gallant fellow and distinguishd as a cavalry officer. He came overland from India and has observed a good deal. General L— of L— "), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-201",
      "id": "num-footnote-6-201-back"
    }
  }, [_vm._v("119")])]), _vm._v(", in Logan’s orthography a "), _c('i', [_vm._v("fowl")]), _vm._v(","), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-202",
      "id": "num-footnote-7-202-back"
    }
  }, [_vm._v("120")])]), _vm._v(" Sir William Hamilton,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-203",
      "id": "num-footnote-8-203-back"
    }
  }, [_vm._v("121")])]), _vm._v(" Miss Peggy\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_28"
    }
  }, [_vm._v("Swinton,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-204",
      "id": "num-footnote-1-204-back"
    }
  }, [_vm._v("122")]), _vm._v(" William Keith and others. Knight Marischal"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-205",
      "id": "num-footnote-2-205-back"
    }
  }, [_vm._v("123")])]), _vm._v(" not well so unable to attend this convocation of kith and kin.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00009"
    }
  }), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "rw-h2_110265-00002"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("DECEMBER")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00057"
    }
  }, [_vm._v("1 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THURSDAY")]), _vm._v(" Colonel R. told me that the European government had discoverd an ingenious mode of diminishing the number of burnings of widows. It seems the Shaster"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-206",
      "id": "num-footnote-3-206-back"
    }
  }, [_vm._v("124")])]), _vm._v(" positively enjoins that the pile shall be so constructed that if the victim should repent even at the moment when it is set on fire she may still have the means of saving herself. The Bramins soon found it was necessary to assist the resolution of the sufferers by means of a little pit into which they contrive to let the poor widow sink so as to prevent her reaping any benefit from a late repentance. But the Government has brought them back to the rigour of their law and only permit the burning to go on when the pile is constructed with full opportunity of a "), _c('i', [_vm._v("locus penitentiae")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-207",
      "id": "num-footnote-4-207-back"
    }
  }, [_vm._v("125")])]), _vm._v(". Yet the widow is so degraded if she dare to survive that the number of burnings is still great. The quantity of female children destroyed by the Rajahpout tribes Col. R. describes as very great indeed. They are strangled by the mother. The principle is the aristocratic pride of these high castes who breed up no more daughters than they can reasonably hope to find matches for in their own tribe. Singular how artificial systems of feeling can be made to overcome that love of offspring which seems instinctive in the females not of the human race only but of the lower animals. This is the reverse of our system of increasing game by shooting the old cock-birds. It is a system would aid Malthus rarely."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-208",
      "id": "num-footnote-5-208-back"
    }
  }, [_vm._v("126")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00058"
    }
  }, [_c('i', [_vm._v("Nota Bene")]), _vm._v(" the day before yesterday I signed the Bond for "), _c('i', [_vm._v("£")]), _vm._v("5000 with Constable for relief of Robinson’s House. I am to be secured by good bills.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00059"
    }
  }, [_vm._v("I think this Journal will suit me well; if I can coax myself into an idea that is purely voluntary it may go on – "), _c('i', [_vm._v("Nulla dies sine linea")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-209",
      "id": "num-footnote-6-209-back"
    }
  }, [_vm._v("127")])]), _vm._v(" But never a being from my infancy upwards hated task-work as I hate it –\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_29"
    }
  }, [_vm._v(" And yet I have done a great deal in my day. It is not that I am idle in my nature neither. But propose to me to do one thing and it is inconceivable the desire I have to do something else, not that it is more easy or more pleasant but just because it is escaping from an imposed task. I cannot trace this love of contradiction to any distinct source but [it] has haunted me all my life. I could almost suppose it was mechanical and that the imposition of a piece of duty-labour operated on me like the mace of a bad billiard player, which gives an impulse to the ball indeed but sends it off at a tangent different from the course designed by the player. Now if I expend such eccentrick movements on this journal it will be turning this wretched propensity to some tolerable account. If I had thus employd the hours and half hours which I have while’d away in putting off something that must needs be done at last, My Conscience,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-210",
      "id": "num-footnote-1-210-back"
    }
  }, [_vm._v("128")]), _vm._v(" I should have had a journal with a witness.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00060"
    }
  }, [_vm._v("Sophia and Lockhart came to Edinr to-day and dined with us, meeting Hector Macdonald Buchanan,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-211",
      "id": "num-footnote-2-211-back"
    }
  }, [_vm._v("129")])]), _vm._v(" his Lady and Missy (familiarly so called) – James Skene"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-212",
      "id": "num-footnote-3-212-back"
    }
  }, [_vm._v("130")])]), _vm._v(" and his Lady – Lockhart’s friend Cay – etc.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00061"
    }
  }, [_vm._v("They are lucky to be able to assemble so many real friends whose good wishes I am sure will follow them in their new undertaking.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00010"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00062"
    }
  }, [_vm._v("2 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("FRIDAY")]), _vm._v(" Rather a blank day for the Gurnal."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-213",
      "id": "num-footnote-4-213-back"
    }
  }, [_vm._v("131")])]), _vm._v("Correcting proofs in the morning – Court from ½ past ten till two – poor dear Colin Mackenzie, one of the wisest kindest and best men of his time, in the country – I fear with very indifferent health"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-214",
      "id": "num-footnote-5-214-back"
    }
  }, [_vm._v("132")])]), _vm._v(" – from two till five transacting business with J. B. All seems to go smoothly.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00063"
    }
  }, [_vm._v("Sophia dined with us alone, Lockhart being gone to the West to bid farewell to his father and brothers. Evening spent in talking with Sophia on their future prospects. God bless her, poor girl. She never gave me a moment’s reason to complain of her. But O my God that "), _c('a', {
    attrs: {
      "id": "pb-rw_30"
    }
  }, [_vm._v("poor delicate child,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-215",
      "id": "num-footnote-1-215-back"
    }
  }, [_vm._v("133")]), _vm._v(" so clever, so animated, yet holding by this earth with so fearfully slight a tenure – Never out of his mother’s thoughts, almost never out of his father’s arms when he has but a single moment to give to anything. "), _c('i', [_vm._v("Deus providebit")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-216",
      "id": "num-footnote-2-216-back"
    }
  }, [_vm._v("134")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00011"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00064"
    }
  }, [_vm._v("3 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SATURDAY")]), _vm._v(" R. P. G."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-217",
      "id": "num-footnote-3-217-back"
    }
  }, [_vm._v("135")])]), _vm._v("came to call last night to excuse himself from dining with Lockhart’s friends to-day. I really fear he is near an actual stand-still. He has been extremely improvident. When I first knew him he had an excellent estate and now he is deprived I fear of the whole reversion of the price. And this from no vice or extreme except a wasteful mode of buying pictures and other costly trifles at high prices and selling them again for nothing, besides an extravagant house-keeping and profuse hospitality. An excellent disposition with a considerable fund of acquired knowledge would have renderd him an agreeable companion had he not affected singularity and renderd himself accordingly singularly affected. He was very near being a poet but a miss is as good as a mile and he always fell short of the mark. I knew him first many years ago when he was desirous of my acquaintance but he was too poetical for me or I was not poetical enough for him so that we continued only ordinary acquaintance with goodwill on either side, which R. P. G. really deserves as a more friendly generous creature never lived. Lockhart hopes to get something done for him, being sincerely attachd to him, but says he has no hopes till he is utterly ruind. That point I fear is not far distant but what Lockhart can do for him then I cannot guess. His last effort faild owing to a curious reason. He had made some translations from the German which he does extremely [well],"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-218",
      "id": "num-footnote-4-218-back"
    }
  }, [_vm._v("136")])]), _vm._v(" for give him ideas and he never wants choice of good words, and Lockhart had got Constable to offer some sort of terms for them. R. P. G. has always, though possessing a beautiful power of handwriting, had some whim or other about imitating that of some other person and has written for months in the imitation of one or\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_31"
    }
  }, [_vm._v("other of his friends. Now at present he has renounced this amusement and chuses to write with a brush upon large cartridge paper somewhat in the Chinese fashion. So when his work which was only to extend to one or two volumes arrived on the shoulders of two porters in immense bales our jolly Bibliopolist backd out of the treaty and would have nothing more to do with R. P."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-219",
      "id": "num-footnote-1-219-back"
    }
  }, [_vm._v("137")]), _vm._v(" He is a creature that is or would be thought of imagination all compact"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-220",
      "id": "num-footnote-2-220-back"
    }
  }, [_vm._v("138")])]), _vm._v(" and is influenced by strange whims. But he is a kind, harmless, friendly soul and I fear has been cruelly plunderd of money which he now wants sadly.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00065"
    }
  }, [_vm._v("Dined with Lockhart’s friends, about fifty in number, who gave him a parting entertainment. John Hope Solicitor Genl."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-221",
      "id": "num-footnote-3-221-back"
    }
  }, [_vm._v("139")])]), _vm._v(" in the chair and Robert Dundas"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-222",
      "id": "num-footnote-4-222-back"
    }
  }, [_vm._v("140")])]), _vm._v(" Croupier. The company most highly respectable and any man might be proud of such an indication of the interest they take in his progress in life. Tory principles rather too violently upheld by some speakers. I came home about ten. The party sate late.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00012"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00066"
    }
  }, [_vm._v("4 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" Lockhart and Sophia with his brother William dined with us"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-223",
      "id": "num-footnote-5-223-back"
    }
  }, [_vm._v("141")])]), _vm._v(" and talkd over our separation and the mode of their settling in London"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-224",
      "id": "num-footnote-6-224-back"
    }
  }, [_vm._v("142")])]), _vm._v(" and other family topics.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00013"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00067"
    }
  }, [_vm._v("5 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MONDAY")]), _vm._v(" This morning Lockhart and Sophia left us early and without leave-taking. When I arose at eight o’clock they were "), _c('i', [_vm._v("Gone")]), _vm._v(". This was very right. I hate red eyes and blowing of noses. "), _c('i', [_vm._v("Agere et pati")]), _vm._v(" "), _c('i', [_vm._v("Romanum est")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-225",
      "id": "num-footnote-7-225-back"
    }
  }, [_vm._v("143")])]), _vm._v(" Of all schools commend me to the Stoicks. We cannot indeed overcome our affections nor ought we if we could, but we repress them within due bounds and avoid coaxing them to make fools of those who should be their masters. I have lost some of the \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("comforts to which I chiefly lookd for enjoyment – well – I must make the more of such as remain. God bless them.\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_110265-00068"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_32"
    }
  }, [_vm._v("And so I will unto my holy work again"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-226",
      "id": "num-footnote-1-226-back"
    }
  }, [_vm._v("144")]), _vm._v(" which at present is the description of that "), _c('i', [_vm._v("heilige Kleeblat")]), _vm._v(" – that worshipful triumvirate Danton, Robespierre and Marat."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-227",
      "id": "num-footnote-2-227-back"
    }
  }, [_vm._v("145")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00069"
    }
  }, [_vm._v("I cannot conceive what possesses me over every person besides to mislay papers. I received a letter Saturday at e’en enclosing a bill for "), _c('i', [_vm._v("£750 no deaf nuts")]), _vm._v(" – well I read it and note the contents, and this day as if it had been a wind bill in the literal sense of the words I search every-where and lose three hours of my morning – turn over all my confusion in the writing desk – break open one or two letters lest I should have enclosed the sweet and quickly convertible document in them by mistake – send for a joiner and disorganize my scrutoire lest it should have fallen aside by mistake – I find it at last – the place where is of little consequence. But this trick must be amended.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00070"
    }
  }, [_vm._v("Dined at the Royal Society Club where as usual was a pleasant meeting of from 20 of 25. It is a very good institution. We pay two guineas only for six dinners in the year present or absent. Dine at 5 or rather ½ past five at the Royal hotel where we have an excellent dinner with soups fish etc. and all in good order, port and Sherry till half past seven then coffee and we go to the Society."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-228",
      "id": "num-footnote-3-228-back"
    }
  }, [_vm._v("146")])]), _vm._v(" This has great influence in keeping up the attendance, it being found that this preface of a good dinner to be paid for whether you partake or not brings out many a philosopher who might not otherwise have attended the Society.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00071"
    }
  }, [_vm._v("Harry Mackenzie now in his eighty second or third year read part of an Essay on Dreams."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-229",
      "id": "num-footnote-4-229-back"
    }
  }, [_vm._v("147")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00072"
    }
  }, [_vm._v("Supd at Dr. Russell’s usual party"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-230",
      "id": "num-footnote-5-230-back"
    }
  }, [_vm._v("148")])]), _vm._v(" – which shall serve for one while.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00014"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00073"
    }
  }, [_vm._v("6 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TUESDAY")]), _vm._v(" A rare thing this literature or love of fame or notoriety which accompanies it. Here is Mr. H. M."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-231",
      "id": "num-footnote-6-231-back"
    }
  }, [_vm._v("149")])]), _vm._v(" on the very brink of human dissolution as actively anxious about it as if the curtain must not soon be closed on that and every thing else. He calls me his literary confessor and I am sure I am glad to return the kindnesses which he shewd me long since in George’s Square. No man is less known from his writings. We would suppose a retired, modest, somewhat affected man with a white handkerchief and a sigh ready for every sentiment. No such thing. H. M. is alert as a contracting tailor’s needle in every sort of business, a politician and a sportsman, shoots and fishes in a sort even to this day, and is the life of the company with anecdote and fun. Sometimes his daughter tells me he is in low spirits at home but really I never see anything of it in Society.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00075"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_33"
    }
  }, [_vm._v("There is a maxim almost universal in Scotland which I would like much to see contrould. Every youth of every temper and almost every description of character is sent either to study as a lawyer or to a Writer’s office as an apprentice. The Scottish seem to conceive Themis the most powerful of Goddesses. Is a lad stupid the Law will sharpen him – Is he too mercurial the law will make him sedate. Has he an estate he may get a sherrifdom – is he poor the richest Lawyers have emerged from poverty – Is he a Tory – he may become a Depute Advocate. Is he a Whig he may with far better hope expect to become in reputation at least ‘that rising counsel’ Mr.— when in fact he only rises at tavern dinners. Upon some such wild views lawyers and writers multiply till there is no life for them and men give up the chase hopeless and exhausted and go into the army at five and twenty instead of eighteen with a turn for expence perhaps – almost certainly for profligacy and with a heart embitterd against the loving parents or friends who compelld them to lose six or seven years in dusting the rails of the stove with their black gowns or scribbling nonsense for twopence a page all day and laying out twice their earnings at night in whisky punch. Here is R. L."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-232",
      "id": "num-footnote-1-232-back"
    }
  }, [_vm._v("150")]), _vm._v(" now – four or five years ago from certain indications I assured his friends L— would never be a writer – goodnatured lad too when Bacchus is out the question but at other times so pugnacious that it was evident he could only be properly placed where fighting was to be a part of his duty regulated by time and place and paid for accordingly. Well – time money and instruction have been thrown away, and now after fighting two regular boxing matches and a duel with pistols in the course of one week, he tells them roundly he will be no writer, which common sense might have told them before. He has now perhaps acquired habits of insubordination unfitting him for the army where he might have been tamed at an earlier period. He is too old for the Navy and so he must go to India, a Guinea-pig on board a Chinaman\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_34"
    }
  }, [_vm._v("– with what hope or view it is melancholy to guess. J. G. L. did all man could to get his friends to consent to his going into the army in time. The Lad has goodhumour, courage and most gentlemanlike feelings. But he is incurably dissipated I hear, so goes to die in youth in a foreign land.\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_34"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_110265-00076"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_34"
    }
  }, [_vm._v("Thank God I let Walter take his own way and I trust he will be a useful honourd soldier, being for his time high in the service, whereas at home he would probably have been a wine-bibbing, moorfowl shooting, fox hunting Fife Squire living at Lochore"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-233",
      "id": "num-footnote-1-233-back"
    }
  }, [_vm._v("151")]), _vm._v(" without either aim or end – And well if he were no worse. Dined at home with L. S. and Anne. Wrote in the Evening.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00015"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00077"
    }
  }, [_vm._v("7 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" Teind day"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-234",
      "id": "num-footnote-2-234-back"
    }
  }, [_vm._v("152")])]), _vm._v(" at home of course. Wrote answers to [one] or two letters which have [been] lying on my desk like snakes hissing at me for my dilatoriness. Bespoke a ton of Palm oil from Sir John Tobin."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-235",
      "id": "num-footnote-3-235-back"
    }
  }, [_vm._v("153")])]), _vm._v(" Received a letter from Sir W. Knighton"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-236",
      "id": "num-footnote-4-236-back"
    }
  }, [_vm._v("154")])]), _vm._v(" mentioning that the King acquiesced in my proposal that Constable’s "), _c('i', [_vm._v("Miscellany")]), _vm._v(" should be dedicated to him."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-237",
      "id": "num-footnote-5-237-back"
    }
  }, [_vm._v("155")])]), _vm._v(" Enjoind however not to make this public till the drat. of dedication shall be approved. This letter tarried so long I thought some one had insinuated the proposal was "), _c('i', [_vm._v("infra dig")]), _vm._v(". I don’t think so. The purpose is to bring all the standard works both in sciences and the liberal arts within the reach of the lower classes and enable them thus to use with advantage the education which is given them at every hand. To make boys learn to read and then place no good books within their reach is to give men an appetite and leave nothing in the pantry save unwholesome and poisonous food which depend upon it they will eat rather than starve. Sir William it seems has been in Germany.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00079"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_35"
    }
  }, [_vm._v("Mighty dark this morning: it is past ten and I am using my lamp. The vast number of houses built beneath us to the North"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-238",
      "id": "num-footnote-1-238-back"
    }
  }, [_vm._v("156")]), _vm._v(" certainly render our street darker during the days when frost or haze prevents the smoke from rising. After all it may be my older eyes. I remember two years ago when Ld. H— "), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-239",
      "id": "num-footnote-2-239-back"
    }
  }, [_vm._v("157")])]), _vm._v(" began to fail somewhat in his limbs he observed that Ld. S— "), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-240",
      "id": "num-footnote-3-240-back"
    }
  }, [_vm._v("158")])]), _vm._v(" came to court at a more early hour than usual, whereas it was he himself who took longer time to walk the usual distance betwixt his house and the Parlt. Square. I suspect old gentlemen often make such mistakes.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00080"
    }
  }, [_vm._v("A letter from Southey"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-241",
      "id": "num-footnote-4-241-back"
    }
  }, [_vm._v("159")])]), _vm._v(" in a very pleasant strain as to Lockhart and myself – of Murray he has perhaps ground to complain, as well for consulting him late in the business as for the manner in which he intimated [it] to young Coleridge who had no reason to think himself handsomely treated though he has acquiesced in the arrangement in a very gentleman-like tone. With these matters we of course have nothing to do, having no doubt that the situation was vacant when M— offerd it as such. Southey says, in alteration of Byron’s phrase, that M. is the most timorous not of God’s but of the Devil’s booksellers. The truth I take to be that Murray was pushd in the change of editor (which was really become necessary) probably by Gifford, Canning, Ellis etc. and when he had fixd with Lockhart by their advice his constitutional nervousness made him delay entering upon a full explanation with Coleridge. But it is all settled now. I hope Lockhart will be able to mitigate their high-church bigotry – it is not for the present day, savouring too much of "), _c('i', [_vm._v("Jure divino")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-242",
      "id": "num-footnote-5-242-back"
    }
  }, [_vm._v("160")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00081"
    }
  }, [_vm._v("Dined quiet with Lady S. and Anne. Anne is practizing Scots songs which I take as a kind compliment to my own taste as hers leads her chiefly to foreign music. I think the good girl sees that I want and must miss her sister’s peculiar talent in singing the airs of our native country which, imperfect as my musical ear is, make and always have made the most pleasing impression on me – and so if she puts a constraint on herself for my sake, I can only say in requital God Bless Her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00083"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }, [_vm._v("I have much to comfort me in the present aspect of my family. My eldest son independent in fortune united to an affectionate wife – and of good hopes in his profession. My second with a good deal of talent and in the way I trust of cultivating it to good purpose. Anne an honest downright good Scots lass in whom I would only wish to correct a spirit of satire – And Lockhart is Lockhart to whom I can most willingly confide the happiness [of the] daughter who chose him, and whom he has chosen.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_110265-00084"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_36"
    }
  }, [_vm._v("My dear wife, the partner of early cares and successes, is I fear frail in health – though I trust and pray she may see me out. Indeed if this troublesome complaint goes on – it bodes no long existence – My brother"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-243",
      "id": "num-footnote-1-243-back"
    }
  }, [_vm._v("161")]), _vm._v(" was affected with the same weakness which before he was fifty brought on mortal symptoms. The poor Major had been rather a free liver. But my father, the most abstemious of men save when the duties of hospitality required him to be very moderately free with his bottle and that was very seldom, had the same weakness of the powers of retention which now annoy me and he I think was not above seventy when cut off. Square the odds and goodnight Sir Walter about sixty. I care not, if I leave my name unstaind and my family properly settled. "), _c('i', [_vm._v("Sat est vixisse")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-244",
      "id": "num-footnote-2-244-back"
    }
  }, [_vm._v("162")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00016"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00085"
    }
  }, [_vm._v("8 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THURSDAY")]), _vm._v(" Talking of the "), _c('i', [_vm._v("Vixisse")]), _vm._v(" it may not be impertinent to notice that Knox,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-245",
      "id": "num-footnote-3-245-back"
    }
  }, [_vm._v("163")])]), _vm._v(" a young poet of considerable talent, died here a week or two since. His father was a respectable yeoman and he himself succeeding to good farms under the Duke of Buccleuch became too soon his own Master and plunged into dissipation and ruin. His poetical talent – a very fine one – then shewd itself in a fine strain of pensive poetry calld I think the "), _c('i', [_vm._v("Lonely Hearth")]), _vm._v(", far superior to those of Michael Bruce,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-246",
      "id": "num-footnote-4-246-back"
    }
  }, [_vm._v("164")])]), _vm._v(" whose "), _c('i', [_vm._v("consumptition")]), _vm._v(" by the way has been the life of his verses. But poetry, nay good poetry, is a drug in the present day. I am a wretched patron – I cannot go about with a subscription\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_37"
    }
  }, [_vm._v("paper like a pocket pistol about me and draw unawares on some honest country gentleman who has as much alarm as if I had used the phrase Stand and Deliver, and parts with his money with a grimace indicating some suspicion that the crown-piece thus levied goes ultimately into the Collector’s own pocket. This I see daily done and I have seen such collectors when they have exhausted Papa and Mamma continue their trade among the Misses and conjure out of their pockets those little funds which should carry them to a play or an assembly. It is well people will go through this – it does some good I suppose and they have great merit who can sacrifice their pride so far as to attempt it in this way. For my part I am a bad promoter of subscriptions but I wishd to do what I could for this lad whose talent I really admired, and I am not addicted to admire heaven-born poets or poetry that is reckond very good "), _c('i', [_vm._v("considering")]), _vm._v(". I had him, Knox, at Abbotsford about ten years ago but found him unfit for that sort of society. I tried to help him but there were temptations he could never resist. He scrambled on writing for the booksellers and magazines and living like the Otways and Savages and Chattertons of former days though I do not know that he was in actual want. His connection with me terminated in begging a subscription or a guinea now and then. His last works were Spiritual hymns and which he wrote very well. In his own line of Society he was said to exhibit infinite humour but all his works are grave and pensive a stile, perhaps like Master Stephen’s melancholy affected for the nonce."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-247",
      "id": "num-footnote-1-247-back"
    }
  }, [_vm._v("165")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00086"
    }
  }, [_vm._v("Mrs. G. of L."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-248",
      "id": "num-footnote-2-248-back"
    }
  }, [_vm._v("166")])]), _vm._v(" intimates that she will take her pudding – her pension I mean (See 30 November) – and is contrite as H. M."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-249",
      "id": "num-footnote-3-249-back"
    }
  }, [_vm._v("167")])]), _vm._v(" vouches. I am glad the stout old girl is not foreclosed, faith. Cabbing a pension in these times is like hunting a pig with a soap’d tail, monstrous apt to slip through your fingers.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00087"
    }
  }, [_vm._v("Dined at home with Lady S. and Anne.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00017"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("9 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("FRIDAY")]), _vm._v(" Yesterday I read and wrote the whole day and evening. To-day I shall not be so happy having Gas Light Coy to attend at two. I must be brief in journalising.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00088"
    }
  }, [_vm._v("The gay world has been kept in hot water lately by the impudent publication of the celebrated Harriet Wilson."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-250",
      "id": "num-footnote-4-250-back"
    }
  }, [_vm._v("168")])]), _vm._v(" W—n from earliest possibility I suppose <who> lived with half the gay world at hack and manger; and now obliges such as will not pay hush-money with a history of whatever she knows or can invent about them. She must\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_38"
    }
  }, [_vm._v("have been assisted in the stile spelling and diction though the attempt at wit is very poor – that at pathos sickening. But there is some good retailing of conversations in which the stile of the speakers so far as known to me is exactly imitated, and some things told as said by individuals of each other which will sound unpleasantly in each other’s ears. I admire the address ofL—d A—y,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-251",
      "id": "num-footnote-1-251-back"
    }
  }, [_vm._v("169")]), _vm._v(" himself very severely handled from time to time. Someone asked him if H. W. had been pretty correct on the whole – ‘Why faith’ he replied ‘I believe so’ – when, raising his eyes, he saw Quentin Dick whom the little jilt had treated atrociously. ‘What concerns the present company always excepted you know’ added LordA—ywith infinite presence of mind. As he was "), _c('i', [_vm._v("in pari casu")]), _vm._v(" with Q. D. no more could be said. After all H. W. beats Con Philips, Anne Bellamy and all former demireps out and out. I think I suppd once inher company more than twenty years since atMat Lewis’s in Argyle Street where the Company, as the Duke says to Lucio, chanced to be fairer than honest."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-252",
      "id": "num-footnote-2-252-back"
    }
  }, [_vm._v("170")])]), _vm._v(" She was far from beautiful if it be the same "), _c('i', [_vm._v("chiffonne")]), _vm._v(" but a smart saucy girl with good eyes and dark hair and the manners of a wild schoolboy. I am glad this accidental meeting has escaped her memory – or perhaps is not accurately recorded in mine – for being a sort of French Faulkner who hawk at all they see"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-253",
      "id": "num-footnote-3-253-back"
    }
  }, [_vm._v("171")])]), _vm._v(" I might have had a distinction which I am far from deserving.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00089"
    }
  }, [_vm._v("Dined at Sir John Hay’s"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-254",
      "id": "num-footnote-4-254-back"
    }
  }, [_vm._v("172")])]), _vm._v(" – a large party. Skenes there – the Newenhams"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-255",
      "id": "num-footnote-5-255-back"
    }
  }, [_vm._v("173")])]), _vm._v(" and others, strangers. In the morning a meeting of O. Gas Committee. The concern lingers a little.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00009"
    }
  }, [_c('p', [_vm._v("It may do weel for ought it’s done yet")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("But only – it’s no just begun yet."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-256",
      "id": "num-footnote-6-256-back"
    }
  }, [_vm._v("174")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00090"
    }
  }, [_vm._v("10 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SATURDAY")]), _vm._v(" A stormy and rainy day – walkd from the court through the rain. I don’t dislike this – Egad, I rather like it – for no man that ever stepd on heather has less dread than I of Le catch-cold and I seem to regain in buffetting with the wind a little of the high spirit with which in younger days I used to enjoy a Tam-of-Shanter ride through darkness wind and rain, the boughs groaning and cracking over my head, the good horse free to the road and impatient for home and feeling the weather as little as I did.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00091"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00010"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_c('p', [_vm._v("The storm around might roar and rustle")])]), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_39"
    }
  }, [_vm._v("We didna mind the storm a whistle."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-257",
      "id": "num-footnote-1-257-back"
    }
  }, [_vm._v("175")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Answerd two letters – One answer to a schoolboy who writes himself Captain of Giggleswick School (a most imposing title) entreating the youngster not to commence editor of a Magazine to be entitled the "), _c('i', [_vm._v("Yorkshire Muffin")]), _vm._v(" I think at seventeen years old. 2do. to a soldier of the 79th. shewing why I cannot oblige him by getting his discharge, and exhorting him rather to bear with the wickedness and profanity of the service than take the very "), _c('i', [_vm._v("precarious step of deser")]), _c('i', [_vm._v("tion")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-258",
      "id": "num-footnote-2-258-back"
    }
  }, [_vm._v("176")])]), _vm._v(" This is the old receipt of Durandarte Patience cousin and shufle "), _c('i', [_vm._v("the cards")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-259",
      "id": "num-footnote-3-259-back"
    }
  }, [_vm._v("177")])]), _vm._v(" and I suppose the correspondents will think I have been too busy in offering my counsel where I was askd for assistance.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00092"
    }
  }, [_vm._v("A third rogue writes to tell me, rather of the latest if the matter was of consequence, that he approves of the first three volumes of the "), _c('i', [_vm._v("H. of")]), _vm._v(" "), _c('i', [_vm._v("Midlothian")]), _vm._v(" but totally condemns the fourth."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-260",
      "id": "num-footnote-4-260-back"
    }
  }, [_vm._v("178")])]), _vm._v(" Doubtless he thinks his opinion worth the sevenpence Sterling which his letter costs. However an author should be reasonably well pleased when three fourths of his works are acceptable to the reader. The Knave demands of me in a postscript to get back the sword of Sir W. Wallace from England where it was carried from Dunbarton Castle. I am not Mr. Genl of the Ordnance that I know. It was wrong however to take away that and Mons Meg. If I go to town this spring I will renew my negotiation with the Great Duke for recovery of Mons Megs."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-261",
      "id": "num-footnote-5-261-back"
    }
  }, [_vm._v("179")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00094"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_40"
    }
  }, [_vm._v("There is no theme more awful than to attempt to cast a glance among the clouds and mists which hide the broken extremity of the celebrated Bridge of Mirza"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-262",
      "id": "num-footnote-1-262-back"
    }
  }, [_vm._v("180")]), _vm._v(" – yet when every day brings us nearer that termination one would almost think that our views should become clearer as the regions we are approaching are brought nigher – Alas it is not so – there is a curtain to be withdrawn, a veil to be rent, before we shall see things as they really are. There are few I trust who disbelieve the existence of a God – nay I doubt if at all times and in all moods any single individual ever adopted that hideous creed though some have professd it. With the belief of a Deity that of the Immortality of the soul and of the State of future rewards and punish-ments is indissolubly linked. More we are not to know but neither are we prohibited from our attempts however vain to pierce the solemn sacred gloom. The expressions used in scripture are doubtless smoking metaphorical, for penal fires and heavenly melody are only applicable to bodies endowd with senses, and at least till the period of the resurrection of the body the spirits of men, whether entering into the perfection of the just or committed to the regions of punishment, are incorporeal. Neither is [it] to be supposed that the glorified bodies which shall arise on [the] last day will be capable of the same gross indulgences with which they are now solaced. That the idea of Mahomet’s paradise is inconsistent with the purity of our heavenly religion will be readily granted, and see XII Mark 27 verse."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-263",
      "id": "num-footnote-2-263-back"
    }
  }, [_vm._v("181")])]), _vm._v(" Harmony is obviously chosen as the least corporeal of all gratifications of the sense and as the type of love, unity and a state of peace and of perfect happiness. But they have a poor idea of the Deity and the rewards which are destined for the Just made perfect who can only adopt the literal sense of an eternal concert – a never-ending Birthday Ode. I rather suppose there should be understood some commission from the Highest, some duty to discharge with the applause of a satisfied conscience – that the Deity who himself must be supposed to feel love and affection for the beings he has calld into existence should delegate a portion of those powers I for one cannot conceive altogether so wrong a conjecture. We would then find reality in Milton’s sublime machinery desired by Milton of the Guardian Saints or genii of Kingdoms. Nay, we would approach to the Catholic idea of the employment of Saints, though without approaching the absurdity of Saint-worship which degrades their religion. There would be, we must suppose, in these employments difficulties to be overcome and exertions to be made, for all which the Celestial beings employd would have certain appropriate powers. I cannot help thinking that a life of active benevolence is more consistent with my ideas than an eternity of music. But it is all speculation and it is impossible even to guess what we shall [do] unless we could ascertain the equally difficult previous question what we are to be. But there is a God and a just God – a judgement and a future life – and all who own so much let them act according to the faith that is in them. I would [not] of course limit the range of my genii to this confined earth – There is the universe with all its endless extent of worlds.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00096"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_41"
    }
  }, [_vm._v("Company at home Sir Adam Fergusson and his Lady. Colonel and Miss Russells, Count Davidoff and Mr. Collyar – By the bye I observe that all men whose name is obviously derived from some mechanical trade all endeavour to disguize and antiquate as it were their names by spelling them after some quaint manner or other. Thus we have Collyar – Smythe – Tailleure – as much as to say ‘My ancestor was indeed a mechanic but it was a world of time ago when the word was spelld very unlike the modern’ – then we had young Whitebank"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-264",
      "id": "num-footnote-1-264-back"
    }
  }, [_vm._v("182")]), _vm._v(" and Will: Allan the artist,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-265",
      "id": "num-footnote-2-265-back"
    }
  }, [_vm._v("183")])]), _vm._v(" a very agreeable, simple mannerd and pleasant man.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00018"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00097"
    }
  }, [_vm._v("11 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" A touch of the "), _c('i', [_vm._v("morbus eruditorum")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-266",
      "id": "num-footnote-3-266-back"
    }
  }, [_vm._v("184")])]), _vm._v(" to which I am as little subject as most folks and have it less now than when young. It is a tremor of the heart the pulsation of which becomes painfully sensible – a disposition to causeless alarm – much lassitude – and decay of vigour of mind and activity of intellect. The reins feel weary and painful and the mind is apt to receive and encourage gloomy apprehensions and causeless fears. Fighting with this fiend is not always the best way to conquer him – I have always found exercize and the open air better than reasoning. But such weather as is now without doors does not encourage "), _c('i', [_vm._v("La petitte guerre")]), _vm._v(" so we must give him battle in form; by letting both mind and body know that supposing one the House of Commons and the other the House of Peers, my will is Sovereign over both. There is a fine description of this species of mental weakness in the fine play of Beaumont and Fletcher calld "), _c('i', [_vm._v("The Lover’s Progress")]), _vm._v(" where [a] man warnd that his death is approaching works himself into an agony of fear and calls for assistance though there is no apparent danger. The apparition of the Innkeeper’s ghost in the same play hovers between the ludicrous and [the uncanny]. To me the touches of the former quality which it contains seem to augment the effect of the latter – they seem to give reality to the supernatural as being circumstance [s] with which an inventor would hardly have garnishd his story.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00099"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_42"
    }
  }, [_vm._v("Will Clerk says he has a theory on the vitrified forts."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-267",
      "id": "num-footnote-1-267-back"
    }
  }, [_vm._v("185")]), _vm._v(" I wonder if he and I agree. I think accidental conflagration is the cause.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00019"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00100"
    }
  }, [_vm._v("12 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MONDAY")]), _vm._v(" Hogg"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-268",
      "id": "num-footnote-2-268-back"
    }
  }, [_vm._v("186")])]), _vm._v(" came to breakfast this morning, having taken and brought for his companion the Galashiels bard David Thompson"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-269",
      "id": "num-footnote-3-269-back"
    }
  }, [_vm._v("187")])]), _vm._v(" as to a meeting of huzz Tividale poets. The honest grunter opines with a delightful naïveté that Moore’s verses are far "), _c('i', [_vm._v("owre")]), _vm._v(" sweet – answerd by Thompson that Moore’s ears or notes, I forget which, were finely strung. ‘They are far owre finely strung’ replied He of the forest ‘for mine are just reeght’ – It reminded me of Queen Bess when questioning Melville"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-270",
      "id": "num-footnote-4-270-back"
    }
  }, [_vm._v("188")])]), _vm._v(" sharply and closely whether Queen [Mary was] taller than her and extracting an answer in the affirmative she replied ‘Then your Queen is too tall for I am just the proper height.’\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00101"
    }
  }, [_vm._v("Was engaged the whole day with Sheriff Court processes. There is something sickening in seeing poor devils drawn into great expence about trifles by interested attorneys. But too cheap access to litigation has its evils on the other hand, for the proneness of the lower class to gratify spite and revenge in this way would be a dreadful evil were they able to endure the expence. Very few cases come before the Sheriff Court of Selkirkshire that ought to come anywhere – wretched wranglings about a few pounds, begun in spleen and carried on from obstinacy, and at length from fear of the conclusion to the banquet of illhumour ‘D—n—n of expences’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-271",
      "id": "num-footnote-5-271-back"
    }
  }, [_vm._v("189")])]), _vm._v(" – I try to check it as well as I can. ‘But so ’twill be when I am gone.’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-272",
      "id": "num-footnote-6-272-back"
    }
  }, [_vm._v("190")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00103"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_43"
    }
  }, [_vm._v("Dined at home and spent the evening in writing. Anne and Lady Scott at the theatre to see Mathews"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-273",
      "id": "num-footnote-1-273-back"
    }
  }, [_vm._v("191")]), _vm._v(" – A very clever man my friend Mathews but it is tiresome to be funny for a whole evening, so I was content and stupid at home.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00104"
    }
  }, [_vm._v("An odd optical delusion has amused me these two last nights. I have been of late for the first time condemnd to the constant use of spectacles. Now when I have laid them aside to step into a room dimly lighted out of the strong light which I use for writing I have seen or seemd to see through the rims of the same spectacles which I have left behind me. At first the impression was so lively that I put my hand to my eyes believing I had the actual spectacles on at the moment. But what I saw was only the Eidolon or image of said useful servants. This fortifies some of Dr. Hibbert’s positions about spectral appearances."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-274",
      "id": "num-footnote-2-274-back"
    }
  }, [_vm._v("192")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00020"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00105"
    }
  }, [_vm._v("13 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TUESDAY")]), _vm._v(" Letter from Lady Stafford, kind and friendly after the wont of Banzu-Mohr-ar-chat."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-275",
      "id": "num-footnote-3-275-back"
    }
  }, [_vm._v("193")])]), _vm._v(" That is wrong spelld I know. Her countenance is something for Sophia whose company should be, as Ladies are said to chuse their liquor, little and good –To be acquainted with persons of mere "), _c('i', [_vm._v("ton")]), _vm._v(" is a nuisance and a scrape – to be known to persons of real fashion and fortune is in London a very great advantage. She is besides sure of the hereditary and constant friendship of the Buccleuch ladies"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-276",
      "id": "num-footnote-4-276-back"
    }
  }, [_vm._v("194")])]), _vm._v(" as well as those of Montagu"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-277",
      "id": "num-footnote-5-277-back"
    }
  }, [_vm._v("195")])]), _vm._v(" and of the Harden family,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-278",
      "id": "num-footnote-6-278-back"
    }
  }, [_vm._v("196")])]), _vm._v(" of the Marchss. of Northampton,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-279",
      "id": "num-footnote-7-279-back"
    }
  }, [_vm._v("197")])]), _vm._v(" Lady Melville and others, also the Miss Ardens upon whose kind offices I have some claim"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-280",
      "id": "num-footnote-8-280-back"
    }
  }, [_vm._v("198")])]), _vm._v(" and would count upon them whether such claim existed or no. So she is well enough establishd among the Right Hand file"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-9-281",
      "id": "num-footnote-9-281-back"
    }
  }, [_vm._v("199")])]), _vm._v(" which is very necessary in London where second-rate fashion is like false jewels.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00011"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_44"
    }
  }, [_vm._v("Went to the yearly Court of the Edinr. Assurance Company"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-282",
      "id": "num-footnote-1-282-back"
    }
  }, [_vm._v("200")]), _vm._v(" to which I am one of those graceful and useless appendages calld Directors Extraordi [na] ry – an extraordinary director I should prove had they made me an ordinary one – there were there Moneyers and great Oneyers"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-283",
      "id": "num-footnote-2-283-back"
    }
  }, [_vm._v("201")])]), _vm._v(" – men of metal – Discounters and counters – Sharp grave prudential faces, eyes weak with cyphering by lamplight. Men who say to gold ‘Be thou paper’ and to paper ‘Be thou turnd into fine gold’ – Many a bustling sharp-faced keen eyed writer too – some perhaps speculating with their clients’ property. My reverend seigniors"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-284",
      "id": "num-footnote-3-284-back"
    }
  }, [_vm._v("202")])]), _vm._v(" had expected a motion for printing their contract which I as a piece of light artillery was brought down and got into battery to oppose. I should certainly have done this on the general ground that while each partner could at any time obtain sight of the contract at a call on the Directors or Managers it would be absurd to print it for the use of the company, and that exposing it to the world at large was in all respects unnecessary and might teach rival companies to avail themselves of our rules and calculations, if false for the purpose of exposing our errors, if correct for the purpose of improving their own schemes on our model. But my eloquence was not required, no one renewing the motion under question. So off I came my ears still ringing with the sounds of thousands and tens of thousands and my eyes dazzled with the golden gleam effused by so many capitalists.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00012"
    }
  }, [_vm._v("Walkd home with the Solicitor,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-285",
      "id": "num-footnote-4-285-back"
    }
  }, [_vm._v("203")])]), _vm._v(" decidedly the most hopeful young man of his time. High connexion – great talent – spirited ambition – a ready and prompt elocution with a good voice and dignified manner, prompt and steady courage, vigilant and constant assiduity, popularity with the young men and the good opinion of the old, will if I mistake not carry him as [far as] any man who has been since the days of old Hal Dundas."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-286",
      "id": "num-footnote-5-286-back"
    }
  }, [_vm._v("204")])]), _vm._v(" He is hot though and rather hasty. This should be amended – they who would play at single-stick must bear with patience a rap over the knuckles. Dined quietly with Lady Scott and Anne.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00107"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_45"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_45"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00021"
    }
  })]), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_45"
    }
  }, [_vm._v("14 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" Affairs very bad in the money market in London. It must come here and I have far too many engagements not to feel it. To cut the matter at once I intend to borrow "), _c('i', [_vm._v("£")]), _vm._v("10,000 with which my son’s marriage contract allows me to charge my estate – At Whitsunday and Marts I will have enough to pay up the incumbrance of "), _c('i', [_vm._v("£")]), _vm._v("3000 due to old Moss’s daughter and "), _c('i', [_vm._v("£")]), _vm._v("5000 to Misses Fergusson in whole or part."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-287",
      "id": "num-footnote-1-287-back"
    }
  }, [_vm._v("205")]), _vm._v(" This will enable us to dispense in a great measure with Bank assistance and sleep in spite of thunder."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-288",
      "id": "num-footnote-2-288-back"
    }
  }, [_vm._v("206")])]), _vm._v(" I do not know whether it is this business which makes me a little bilious or rather the want of exercize during the season of late and change of the weather to too much heat. Thank God my circumstances are good, upon a fair balance which I have are <not> certainly not less than "), _c('i', [_vm._v("£")]), _vm._v("40,000 or nearby "), _c('i', [_vm._v("£")]), _vm._v("50,000 above the world. But the Sun and Moon shall dance on the green ere carelessness or hope of gain or facility of getting cash shall make me go too deep again, were it but for the disquiet of the thing.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00013"
    }
  }, [_vm._v("Dined Ly. Scott and Anne quietly.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00022"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00108"
    }
  }, [_vm._v("15 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THURSDAY")]), _vm._v(" R. P. G. came"), _c('i', [_vm._v(" sicut mos est")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-289",
      "id": "num-footnote-3-289-back"
    }
  }, [_vm._v("207")])]), _vm._v(" at five o’clock to make me confident of the extremities of his distress. It is clear all he has to do is to make the best agreement he can with his creditors. I remember many years since the poor fellow told me he thought there was something interesting in having difficulties – Poor lad he will have enough of them now. He talks about writing translations for the booksellers from the German to the amount of "), _c('i', [_vm._v("£")]), _vm._v("500 and "), _c('i', [_vm._v("£")]), _vm._v("600 but this is like a man proposing to run a whole day at top-speed. Yet if he had good subjects R. P. G. is one of the best translators I know, and something must be done for him certainly though I fear it will be necessary to go to the bottom of the ulcer – palliatives won’t do. Heis terribly imprudent, yet a worthy and benevolent creature – a great bore withal –\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00014"
    }
  }, [_vm._v("Dined alone with family. I am determined not to stand mine host to all Scotland and England as I have done. This shall be a saving since it must be a borrowing year – We heard from Sophia they are got safe to town but as Johnie had a little bag of meal with him to make his porridge on the road the whole Inn-yard assembled to see the operation. Junor his maid was of opinion that England was an awfu’ country to make parritch in. God bless the poor baby and restore his perfect health.")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00109"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_46"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_46"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00023"
    }
  })]), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_46"
    }
  }, [_vm._v("16 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("FRIDAY")]), _vm._v(" R. P. G. and his friend Robt. Wilson"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-290",
      "id": "num-footnote-1-290-back"
    }
  }, [_vm._v("208")]), _vm._v(" came, the former at five as usual, the latter at three as appointed. R. W. frankly said that R. P. G.’ s case was quite desperate – that he was insolvent and that any attempt to save him at present would be just so much cash thrown away. God knows at this moment I have none to throw away uselessly. For poor Gillies there was a melancholy mixture of pathos and affectation in his statement which really affected me while it told me that it would be useless to help him to money on such very empty plans. I endeavourd to persuade him to make a virtue of necessity, resign all to his creditors, and begin the world on a new leaf. I offerd him Chiefswood"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-291",
      "id": "num-footnote-2-291-back"
    }
  }, [_vm._v("209")])]), _vm._v(" for a temporary retirement. Lady Scott thinks I was wrong, and no body could less desire such a neighbour, all his affectations being caviare to me. But then the wife and children –\n         ")]), _vm._v(" "), _c('p', [_vm._v("Went again to the Solicitor on a wrong night – being askd for tomorrow. Lady Scott undertakes to keep my engagements recorded in future. "), _c('i', [_vm._v("Sed quis custodiat ipsam custodem?")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-292",
      "id": "num-footnote-3-292-back"
    }
  }, [_vm._v("210")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00024"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00110"
    }
  }, [_vm._v("17 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SATURDAY")]), _vm._v(" Dined with the Solicitor, Ld Ch. Baron,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-293",
      "id": "num-footnote-4-293-back"
    }
  }, [_vm._v("211")])]), _vm._v(" Sir William Boothby, nephew of old Sir Brooke the dandy poet. Annoyd with anxious presentiments which the night’s post must dispel or confirm. All in London as bad as possible.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00025"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00111"
    }
  }, [_vm._v("18 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" Ballantyne calld on me this morning. "), _c('i', [_vm._v("Venit illa suprema")]), _vm._v(" dies."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-294",
      "id": "num-footnote-5-294-back"
    }
  }, [_vm._v("212")])]), _vm._v(" My extremity is come. Cadell has received letters from London which all but positively announce the failure of Hurst and Robinson so that Constable and Coy must follow and I must go with poor\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_47"
    }
  }, [_vm._v("James Ballantyne for company. I suppose it will involve my all. But if they leave me "), _c('i', [_vm._v("£")]), _vm._v("500 I can still make it "), _c('i', [_vm._v("£")]), _vm._v("1000 or "), _c('i', [_vm._v("£")]), _vm._v("1200 a year. And if they take my salaries of "), _c('i', [_vm._v("£")]), _vm._v("1300 and "), _c('i', [_vm._v("£")]), _vm._v("300"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-295",
      "id": "num-footnote-1-295-back"
    }
  }, [_vm._v("213")]), _vm._v(" they cannot but give me something out of them. I have been rash in anticipating funds to buy land. But then I made from "), _c('i', [_vm._v("£")]), _vm._v("5000 to "), _c('i', [_vm._v("£")]), _vm._v("10,000 a year, and land was my temptation. I think no body can lose a penny, that is one comfort – Men will think pride has had a fall. Let them indulge their own pride in thinking that my fall makes them higher or seem so at least. I have the satisfaction to recollect that my prosperity has been of advantage to many and that some at least will forgive my transient wealth on account of the innocence of my intentions and my real wish to do good to the poor. This news will make sad hearts at Darnick"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-296",
      "id": "num-footnote-2-296-back"
    }
  }, [_vm._v("214")])]), _vm._v(" and in the cottages of Abbotsford which I do not nourish the least hope of preserving. It has been my Dalilah and so I have often termd it – and now – the recollection of the extensive woods I have planted and the walks I have formed from which strangers must derive both the pleasure and profit will excite feelings likely to sober my gayest moments. I have half resolved never to see the place again – how could I tread my hall with such a diminishd crest? How live a poor indebted man where I was once the wealthy – the honourd? My children are provided – thank God for that. I was to have gone there on Saturday in joy and prosperity to receive my friends –my dogs will wait for me in vain – it is foolish – but the thoughts of parting from these dumb creatures have moved me more than any of the painful reflections I have put down – poor things I must get them kind masters. There may be yet those who loving me may love my dog because it has been mine. I must end this or I shall lose the tone of mind with which men should meet distress. I find my dogs’ feet on my knees – I hear them whining and seeking me everywhere – this is nonsense but it is what they would do could they know how things are – poor Will Laidlaw"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-297",
      "id": "num-footnote-3-297-back"
    }
  }, [_vm._v("215")])]), _vm._v(" – poor Tom Purdie"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-298",
      "id": "num-footnote-4-298-back"
    }
  }, [_vm._v("216")])]), _vm._v(" – this will be news to wring \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_48"
    }
  }, [_vm._v("your heart and many a poor fellow’s besides to whom my prosperity was daily bread.\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_48"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_110265-00112"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_48"
    }
  }, [_vm._v("Ballantyne behaves like himself and sinks his own ruin in con-templating mine. I tried to enrich him indeed and now all – all is gone. He will have the "), _c('i', [_vm._v("Journal")]), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-299",
      "id": "num-footnote-1-299-back"
    }
  }, [_vm._v("217")]), _vm._v(" still, that is a comfort, for sure they cannot find a better Editor – "), _c('i', [_vm._v("They")]), _vm._v(" – alas who will "), _c('i', [_vm._v("they")]), _vm._v(" be? the "), _c('i', [_vm._v("unbekanten Obern")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-300",
      "id": "num-footnote-2-300-back"
    }
  }, [_vm._v("218")])]), _vm._v(" who are to dispose of my all as they will? Some hard-eyed banker – some of those men of millions whom I described."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-301",
      "id": "num-footnote-3-301-back"
    }
  }, [_vm._v("219")])]), _vm._v(" Cadell shewd more kind and personal feeling to me than I thought he had possessd. He says there are some properties of works that will revert to me, the copy money not being paid. But it cannot be any very great matter I should think. Another person"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-302",
      "id": "num-footnote-4-302-back"
    }
  }, [_vm._v("220")])]), _vm._v(" did not afford me all the sympathy I expected, perhaps because I seemd to need little support – Yet that is not her nature which is generous and kind. She thinks I have been imprudent trusting men so far – perhaps so – but whatsoever I do I must sell my books to some one and these folks gave me the largest price. If they had kept their ground I could have brought myself round fast enough by the plan of 14 Decemr. I now view matters at the very worst and suppose that my all must go to supply the deficiencies of Constable. I fear it must be so. His connections with Hurst and Robinson have been so intimate that they must be largely involved. This is the worst of the concern; our own is comparatively plain sailing.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00113"
    }
  }, [_vm._v("Poor Gillies calld yesterday to tell me he was in extremity. God knows I had every cause to have returnd him the same answer. I must think his situation worse than mine as through his incoherent miserable tale I could see that he had exhausted each access to credit, and yet fondly imagines that bereft of all his accustomd indulgences he can work with a literary zeal unknown to his happier days. I hope he may labour enough to gain the mere support of his family. For myself the magic wand of the Unknown is shiverd in his grasp. He must henceforth be termd the Too well Known."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-303",
      "id": "num-footnote-5-303-back"
    }
  }, [_vm._v("221")])]), _vm._v(" The feast of fancy is over with the feeling of independence. I can no longer have the delight of waking in the morning with bright ideas in my mind,\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_49"
    }
  }, [_vm._v("haste to commit them to paper, and count them monthly as the means of planting such groves and purchasing such wastes, replacing my dreams’ fiction by other prospective visions of walks by\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_49"
    }
  }), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00011"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_49"
    }
  }, [_c('p', [_vm._v("Fountain-heads and pathless groves")])]), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_49"
    }
  }, [_vm._v("Places which pale passion loves"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-304",
      "id": "num-footnote-1-304-back"
    }
  }, [_vm._v("222")]), _vm._v(" –\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "block sidebar floatgalley-outside",
    attrs: {
      "id": "rw-block-sidebar_110265-00003"
    }
  }, [_c('p', [_vm._v("Turn back to p. 41–42. I turnd the page accidentally and the partner of a Bankrupt concern ought not to waste two leaves of paper.")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00007"
    }
  }, [_vm._v("This cannot be – But I may make substantial husbandry – write history and such substantial concerns. They will not be received with the same enthusiasm– at least I much doubt the general knowlege that an author must write for his bread, at least for improving his pittance, degrades him and his productions in the public eye. He falls into the secondrate rank of estimation.")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00012"
    }
  }, [_c('p', [_vm._v("While the harness sore galls and the spurs his sides goad")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("The high mettled racer’s a hack on the road."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-305",
      "id": "num-footnote-2-305-back"
    }
  }, [_vm._v("223")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00008"
    }
  }, [_vm._v("It is a bitter thought, but if tears start at it let them flow. I amso much of this mind that if any one would now offer to relieve all my embarassments on condition I would continue the exertions which brought it there, dear as the place is to me, I hardly think I could undertake the labour on which I enterd with my usual alacrity only this morning; though not without a boding feeling of my exertions proving useless. Yet to save Abbotsford I would attempt all that was possible. My heart clings to the place I have created. There is scarce a tree on it that does not owe its being to me and the pain of leaving it is greater than I can tell. I have about "), _c('i', [_vm._v("£")]), _vm._v("10,000 of Constable’s for which I am bound to give literary value. But if I am obliged to pay other debts for him I will take leave to retain this sum at his credit. We shall have made some "), _c('i', [_vm._v("kittle")]), _vm._v(" questions of literary property, amongst us."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-306",
      "id": "num-footnote-3-306-back"
    }
  }, [_vm._v("224")])]), _vm._v(" Once more ‘Patience cousin and shuffle the cards.’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-307",
      "id": "num-footnote-4-307-back"
    }
  }, [_vm._v("225")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00114"
    }
  }, [_vm._v("I have endeavourd at times to give vent to thoughts naturally so painful by writing these notices – partly to keep them at bay by busying myself with [the] history of the French Convention."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-308",
      "id": "num-footnote-5-308-back"
    }
  }, [_vm._v("226")])]), _vm._v(" I thank God I can do both with reasonable composure. I wonder how Anne will bear this afliction? She is passionate but stout-hearted and courageous in important matters though irritable in trifles. I am glad Lockhart and his wife are gone – Why? – I cannot tell but I "), _c('i', [_vm._v("am")]), _vm._v(" pleased to be left to my own regrets without being melted by condoleances though of the most sincere and affectionate kind.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00116"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_50"
    }
  }, [_vm._v("Anne bears her misfortune gallantly and well with a natural feeling no doubt of the rank and consideration she is about to lose. Lady Scott is incredulous and persists in cherishing hope where there is no ground for hope. I wish it may not bring on the Gloom of Spirits which has given me such distress. If she were the active person she once was that would not be. Now I fear it more than what Constable or Cadell will tell me this evening – To that my mind is made up.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_50"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_110265-00117"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_50"
    }
  }, [_vm._v("Oddly enough it happend. Mine honest friend Hector"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-309",
      "id": "num-footnote-1-309-back"
    }
  }, [_vm._v("227")]), _vm._v(" came in before dinner to ask a copy of my seal of arms, with a sly kindliness of intimation that it was for some agreeable purpose.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00118"
    }
  }, [_c('i', [_vm._v("Half past eight")]), _vm._v(". I closed this book under the consciousness of impending ruin. I open it an hour after, thanks be to God!, with the strong hope that matters may be got over safely and honourably in a mercantile sense. Cadell came at eight to communicate a letter from Hurst and Robinson intimating they had stood the storm and, though clamourous for assistance from Scotland, saying they had prepared their strongholds without need of the Banks. This is all so far well. But I will not borrow any money on my estate till I see things reasonably safe. Stocks have risen from 42 to 46,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-310",
      "id": "num-footnote-2-310-back"
    }
  }, [_vm._v("228")])]), _vm._v(" a strong proof that confidence is restored. But I will yield to no delusive hopes. And fall back fall edge my resolutions hold. Whitaker the rascally bookseller whose slip for "), _c('i', [_vm._v("£")]), _vm._v("200,000 or thereabouts has brought ruin nearly on the trade kept seven hunters and be damnd to him. He must have ridden a fine weight to be sure with "), _c('i', [_vm._v("£")]), _vm._v("200,000 of honest people’s cash about him. I shall always think the better of Cadell for this – not merely because his feet are beautiful on the mountains who brings good tidings"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-311",
      "id": "num-footnote-3-311-back"
    }
  }, [_vm._v("229")])]), _vm._v(" but because he shewd feeling – deep feeling, poor fellow – he who I thought had no more than his numeration table and who if he had had his whole compting-house full of sensibility had yet his wife and children to bestow it upon. I will not forget this if I get through. I love the virtues of rough and round men. The others are apt to escape in salt rheum, sal volatile and a white pocket handkerchief. An odd thought strikes me. When I die will the journal of these day [s] be taken out of the Ebony cabinet at Abbotsford and read as the transient pout of a man worth "), _c('i', [_vm._v("£")]), _vm._v("60,000 with wonder that the well seeming Baronet should ever have experienced such a hitch? Or will it be found in some obscure lodginghouse where the decayd son of chivalry has hung up his scutcheon for some 20/-a week and where one or two old friends will look grave and whisper to each other, ‘poor gentleman’ – ‘a well meaning man’ – ‘nobody’s enemy but his own’ – ‘thought his parts could never wear out’ – ‘family poorly left’, ‘pity he took that foolish title’? Who can answer this question?\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00120"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_51"
    }
  }, [_vm._v("What a life mine has been. Half educated, almost wholly neglected or left to myself – stuffing my head with most nonsensical trash and undervalued in society for a time by most of my companions – getting forward and held a bold and clever fellow, contrary to the opinion of all who thought me amere dreamer – Broken-hearted for two years"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-312",
      "id": "num-footnote-1-312-back"
    }
  }, [_vm._v("230")]), _vm._v("–My heart handsomely pieced again"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-313",
      "id": "num-footnote-2-313-back"
    }
  }, [_vm._v("231")])]), _vm._v(" – but the crack will remain till my dying day – Rich and poor four or five times – Once at the verge of ruin yet opend new sources of wealth almost overflowing"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-314",
      "id": "num-footnote-3-314-back"
    }
  }, [_vm._v("232")])]), _vm._v(" – now taken in my pitch of pride and nearly winged (unless the good news hold) because London chuses to be in an uproar and in the tumult of bulls and bears a poor inoffensive lion like myself is pushd to the wall – And what is to be the end of it? God knows and so ends the chatechism."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-315",
      "id": "num-footnote-4-315-back"
    }
  }, [_vm._v("233")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00026"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00121"
    }
  }, [_vm._v("19 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MONDAY")]), _vm._v(" Ballantyne here before breakfast. He looks on Caddel’s last night’s news with more confidence than I do. But I must go to work be my thoughts sober or lively. Constable came in and sate an hour. The old gentleman is firm as a rock and scorns the idea of Hurst and Robinson stopping. He talks of going up to London next week and making sales of our interest in "), _c('i', [_vm._v("W—k")]), _vm._v(" and "), _c('i', [_vm._v("Boney")]), _vm._v(" which would put a hedge round his finances. He is a very clever fellow and will I think bear us through.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00122"
    }
  }, [_vm._v("Dined at Lord Chief Baron’s – Ld. Justice Clerk, Lord President, Captn Scarlett, a gentlemanlike young man, the son of the great counsell"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-316",
      "id": "num-footnote-5-316-back"
    }
  }, [_vm._v("234")])]), _vm._v(" and a friend of my son Walter. Lady Charlotte Hope"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-317",
      "id": "num-footnote-6-317-back"
    }
  }, [_vm._v("235")])]), _vm._v(" and\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_52"
    }
  }, [_vm._v("other woman kind."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-318",
      "id": "num-footnote-1-318-back"
    }
  }, [_vm._v("236")]), _vm._v(" R. Dundas, Arnistoun, and his pleasant and good-humourd little wife whose quick intelligent look pleases me more, though her face be very plain, than a hundred mechanical Beauties.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00027"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00123"
    }
  }, [_vm._v("20 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TUESDAY")]), _vm._v(" Smoke the New pen."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-319",
      "id": "num-footnote-2-319-back"
    }
  }, [_vm._v("237")])]), _vm._v(" Oho-a-"), _c('i', [_vm._v("Swift")]), _vm._v(". The ordinary Bramahs become execrable so the knave puts the extras upon us. I like Ch: Ba: Shepherd very much – as much I think as any man I have learnd to know of late years. There [is] a neatness and precision, a closeness and truth, in the tone of [his] conversation which shows what a lawyer he must have been. Perfect goodhumour and suavity of manner with a little warmth of temper on suitable occasions. His great deafness alone prevented him from being Lord Chief Justice. I never saw a man so patient under such a malady. He loves society and converses excellently yet is often obliged in a mixd company particularly to lay aside his trumpet, retire into himself and withdraw from the talk. He does this with an expression of patience on his countenance which touches one much. He has occasion for patience otherwise I should think, for Lady S. is fine and fidgetty and too anxious to have everything point device.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00124"
    }
  }, [_vm._v("Constable’s licence for the dedication"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-320",
      "id": "num-footnote-3-320-back"
    }
  }, [_vm._v("238")])]), _vm._v(" is come which will make him happy.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00028"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00125"
    }
  }, [_vm._v("21 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" Dined with James Ballantyne and met my old friend Matthews the Comedian with his son,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-321",
      "id": "num-footnote-4-321-back"
    }
  }, [_vm._v("239")])]), _vm._v(" now grown up a clever, rather forward lad who makes songs in the stile of John Smith"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-322",
      "id": "num-footnote-5-322-back"
    }
  }, [_vm._v("240")])]), _vm._v(" or Colman"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-323",
      "id": "num-footnote-6-323-back"
    }
  }, [_vm._v("241")])]), _vm._v(" and sings them with spirit. Rather lengthy though.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00127"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_53"
    }
  }, [_vm._v("There has been odd associations attending my two last meetings with Matthews. The last time I saw [him] before yesterday evening he dined with me in company with poor Sir Alexander Boswell who was killd within two or three months"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-324",
      "id": "num-footnote-1-324-back"
    }
  }, [_vm._v("242")]), _vm._v(" – I never saw Sir Alex. more. The time before was in 1815 when John Scott of Gala and I were returning from France and passd through London when we brought Matthews down as far as Leamington. Poor Byron lunchd with us or rather made an early dinner at Long’s and a most brilliant day we had of it. I never saw Byron so full of fun frolic wit and whim. He was as playful as a kitten – Well – I never saw him again – So this Man of mirth with his merry meetings has brought me no luck. I like better that he should throw in his talent of mimicry and humour into the present current tone of the Company than that he should be required to give this that or t’other "), _c('i', [_vm._v("bitt")]), _vm._v(" selected from his public recitations – They are good certainly – excellent – But then you "), _c('i', [_vm._v("must")]), _vm._v(" laugh and that is always severe to me. When I do laugh in sincerity the joke must be or seem unpremeditated. I could not help thinking in the midst of the glee what late gloom was over the minds of three of the company, Cadell, J. B., and the Journalist’s. What a strange scene if the surge of conversation could suddenly ebb like the tide and [shew] us the state of people’s real minds. Savary"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-325",
      "id": "num-footnote-2-325-back"
    }
  }, [_vm._v("243")])]), _vm._v(" might have been gay in such a party with all his forgeries in his heart.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00013"
    }
  }, [_c('p', [_vm._v("No eye the rocks discover")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("Which lurk beneath the deep."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-326",
      "id": "num-footnote-3-326-back"
    }
  }, [_vm._v("244")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00009"
    }
  }, [_vm._v("Life could not be endured were it seen in reality.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00128"
    }
  }, [_vm._v("Things are mending in town and H. and R. write with confidence and are it would seem strongly supported by wealthy friends. Cadell and Constable are confident of their making their way through the storm and the impression of their stability is general in London. I hear the same from Lockhart. Indeed I now believe that they wrote gloomy letters to Constable chiefly to get as much money out of them as they possibly could. But they had well nigh over done it. This being Teind Wednesday must be a day of leisure and labour.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00015"
    }
  }, [_vm._v("Sophia has got a house, 25 Pall-Mall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00016"
    }
  }, [_vm._v("Dined at home with Lady Scott and Anne.")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00129"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_54"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_54"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00029"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00130"
    }
  }, [_vm._v("22 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THURSDAY")]), _vm._v(" I wrote six of my close pages yesterd [ay] which is about twenty four pages in print. What is more I think it comes off twangingly. The story is so very interesting in itself that there is no fear of the book answering. Superficial it must be but I do not disown the charge. Better a superficial book which brings well and strikingly together the known and acknowleged facts than a dull boring narrative pausing to see further into a mill stone at every moment than the nature of the Mill stone admits. Nothing is so tiresome as walking through some beautiful scene with a minute philosopher, a botanist or pebble gatherer who is eternally calling your attention from the grand features of the natural scenery to look at grasses and chucky stones. Yet in their way they give useful information and so does the minute historian – Gad, I think that will look well in the preface.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00131"
    }
  }, [_vm._v("My bile is quite gone. I really believe it arose from mere anxiety. What a wonderful connexion between the mind and body.")])]), _c('p', {
    attrs: {
      "id": "rw-p_110265-00132"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_54"
    }
  }, [_vm._v("The air of ‘Bonnie Dundee’ running in my head to-day I [wrote] a few verses to it before dinner, taking the key-note from the story of Claverse leaving the Scottish Convention of Estates in 1688–9. I wonder if they are good – Ah poor Will: Erskine,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-327",
      "id": "num-footnote-1-327-back"
    }
  }, [_vm._v("245")]), _vm._v(" thou couldst and wouldst have told me. I must consult J. B. who is as honest as was W. E. But then though he has good taste too there is a little of "), _c('i', [_vm._v("Big Bow")]), _vm._v("-"), _c('i', [_vm._v("wow")]), _vm._v(" about it. Can’t say what made me take a frisk so uncommon of late years as to write verses of free will. I suppose the same impulse which makes birds sing when [a] storm seems blown over.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00133"
    }
  }, [_vm._v("Dined at Lord Minto’s."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-328",
      "id": "num-footnote-2-328-back"
    }
  }, [_vm._v("246")])]), _vm._v(" There were Lord and Lady Ruthven, Will: Clerk and Tho. Thomson,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-329",
      "id": "num-footnote-3-329-back"
    }
  }, [_vm._v("247")])]), _vm._v(" a right choice party. There was also my very old friend Mrs. Brydone,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-330",
      "id": "num-footnote-4-330-back"
    }
  }, [_vm._v("248")])]), _vm._v(" the relict of the traveller and\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_55"
    }
  }, [_vm._v("daughter of Principal Robertson and really worthy of such a connection, Lady Minto who is also peculiarly agreeable and her sister Mrs. Admiral Adam"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-331",
      "id": "num-footnote-1-331-back"
    }
  }, [_vm._v("249")]), _vm._v(" in the evening.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00030"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00134"
    }
  }, [_vm._v("23 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("FRIDAY")]), _vm._v(" The present Lord Minto is a very agreeable, well-informd and sensible man but he possesses neither the high breeding, ease of manner or eloquence of his father the first Earl."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-332",
      "id": "num-footnote-2-332-back"
    }
  }, [_vm._v("250")])]), _vm._v(" That Sir Gilbert was indeed a man among a thousand. I knew him very intimately in the beginning of the century and, which was very agreeable, was much at his house on very easy terms. He loved the Muses and worshipd them in secret and used to read some of [his] poetry which was but middling. One upon a walk with his lady which involved certain conclusions (most delicately couchd) but which it is not usual to allude [to]. Singu [l] ar that the wish to show what he thought and what perhaps was a clever thing was stronger than the feelings which induced to secrecy. Oh Vanity, where will you lead us poor authors. Tom Campbell"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-333",
      "id": "num-footnote-3-333-back"
    }
  }, [_vm._v("251")])]), _vm._v(" lived at Minto but it was in a state of dependence which he brookd very ill. He was kindly treated but would not see it in the right view and suspected slights and so on where no such thing was meant. There was a turn of Savage"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-334",
      "id": "num-footnote-4-334-back"
    }
  }, [_vm._v("252")])]), _vm._v(" about Tom though without his blackguardism – a kind of waywardness of mind and irritability that must have made a man of his genius truly unhappy.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00017"
    }
  }, [_vm._v("Lord Minto, with the mildest manners, was very tenacious of his opinions although he changed them twice in the crises of politics. He was the early friend of Fox and made a figure towards the end of the Americain war or during the struggles betwixt Fox and Pitt. Then came the Revolution and he joined the Anti Gallican party so keenly that he declared against Addington’s peace with France and was for a time I believe a Wyndamite. He was reconciled to the Whigs on the Fox and Grenville coalition but I have heard that Fox contrary to his wont retaind such personal feelings as led him [to] object to Sir Gilbert Elliot having a seat in the Cabinet. So he was sent Governor General to India – a better thing I take it for his fortune. He died shortly after his return at Hatfield or Barnet on his way down to his native country. He was a most pleasing and amiable man: I was very "), _c('a', {
    attrs: {
      "id": "pb-rw_56"
    }
  }, [_vm._v("sorry for his death though I do not know how we should have met, for the contested election in 1805"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-335",
      "id": "num-footnote-1-335-back"
    }
  }, [_vm._v("253")]), _vm._v(" had placed some coldness betwixt the present Lord and me. I was certainly anxious for Sir Alexr. Don"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-336",
      "id": "num-footnote-2-336-back"
    }
  }, [_vm._v("254")])]), _vm._v(" both as friend of my most kind friend Charles Duke of Buccleuch"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-337",
      "id": "num-footnote-3-337-back"
    }
  }, [_vm._v("255")])]), _vm._v(" and on political accounts, and these thwartings are what men in public life do not like to endure. After a cessation of friendship for some years we have come about again – We never had the slightest personal dispute or disagreement. But politics are the blowpipe beneath whose influence the best cemented friendships too often disseve [r] and ours after all was only a very familiar acquaintance.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00135"
    }
  }, [_vm._v("It is very odd that the common people at Minto and the neighbourhood will not believe at this hour that the first Earl is dead. They think he had done some thing in India which he could not answer for – that the house was rebuilt on a scale unusually large to give him a suite of secret apartments and that he often walks about the woods and crags of Minto at night with a white night-cap and long white beard. The circumstance of his having died on the road down to Scotland is the sole foundation of this absurd legend which shows how willing the vulgar are to gull themselves when they can find no one else to take the trouble. I have seen people who could read write and cypher shrug their shoulders and look mysterious when this subject was mentiond. One very absurd addition was made on occasion of a great ball at Minto House which it was said was given to draw all people away from the grounds that the conceald Earl might have leisure for his exercize. This was on the principle in the German play"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-338",
      "id": "num-footnote-4-338-back"
    }
  }, [_vm._v("256")])]), _vm._v(" where to hide their conspiracy the Associates join in a chorus song.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00136"
    }
  }, [_vm._v("We dined at home. Mr. Davidoff and his tutor kept an engagement with us to dinner notwithstanding the death of the Emperor Alexander."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-339",
      "id": "num-footnote-5-339-back"
    }
  }, [_vm._v("257")])]), _vm._v(" They went to the play with the women kind. I staid at home to write.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00031"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00137"
    }
  }, [_vm._v("24 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SATURDAY")]), _vm._v(" Wrote Walter and Jane"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-340",
      "id": "num-footnote-6-340-back"
    }
  }, [_vm._v("258")])]), _vm._v(" – and gave [the] former an accompt of how things had been borne through in the money market and of the loan of "), _c('i', [_vm._v("£")]), _vm._v("10,000 – Constable has a scheme of publishing\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_57"
    }
  }, [_vm._v("the works of the Author of W—y in a superior stile at "), _c('i', [_vm._v("£")]), _vm._v("1.1. volume."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-341",
      "id": "num-footnote-1-341-back"
    }
  }, [_vm._v("259")]), _vm._v(" He says he will answer for making "), _c('i', [_vm._v("£")]), _vm._v("20,000 of this and liberally offerd me any share of the profit. I have no great claim to any as I have only to contribute the Notes which are light work, yet a few thousands coming in will be a good thing, besides the P. Office."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-342",
      "id": "num-footnote-2-342-back"
    }
  }, [_vm._v("260")])]), _vm._v(" Constable, though valetudinary and cross with his partner, is certainly as good a pilot in these rough seas as ever man put faith in. His rally put me in mind of the old song.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00014"
    }
  }, [_c('p', [_vm._v("The tailor raise and shook his duds")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("He gar’d the "), _c('i', [_vm._v("bills")]), _vm._v(" flee aff in cluds\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("And they that staid gat fearfu’ thuds")]), _vm._v(" "), _c('p', [_vm._v("    The Tailor proved a man O."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-343",
      "id": "num-footnote-3-343-back"
    }
  }, [_vm._v("261")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00010"
    }
  }, [_vm._v("We are for Abbotsford to-day with a light heart – ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00032"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "rw-p_110265-00138"
    }
  }, [_vm._v("Abbotsford.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00033"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    staticStyle: {
      "text-align": "justify"
    },
    attrs: {
      "id": "rw-p_110265-00139"
    }
  }, [_vm._v("25 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" Arrived here last night at Seven. Our halls are silent compared to last year but let us be thankful when we think how near the chance appeard but a week since that these halls would have been ours no longer – "), _c('i', [_vm._v("Barbarus has segetes?")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-344",
      "id": "num-footnote-4-344-back"
    }
  }, [_vm._v("262")])]), _vm._v(" – "), _c('i', [_vm._v("Nullum numen abest si sit")]), _vm._v(" "), _c('i', [_vm._v("prudentia")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-345",
      "id": "num-footnote-5-345-back"
    }
  }, [_vm._v("263")])]), _vm._v(" There shall be no lack of wisdom – But come – "), _c('i', [_vm._v("il faut cultiver")]), _vm._v(" "), _c('i', [_vm._v("notre jardin")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-346",
      "id": "num-footnote-6-346-back"
    }
  }, [_vm._v("264")])]), _vm._v(" – Let us see – I will write out ‘The bonnets of Bonny Dundee’. I will sketch a preface to "), _c('i', [_vm._v("La Rochejacquelin")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-347",
      "id": "num-footnote-7-347-back"
    }
  }, [_vm._v("265")])]), _vm._v(" for Constable’s "), _c('i', [_vm._v("Miscellany")]), _vm._v(" and try about a specimen of notes for the W—y novels. If together with letters and by-business it will be a good day’s work.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00015"
    }
  }, [_c('p', [_vm._v("I make a vow")]), _vm._v(" "), _c('p', [_vm._v("And keep it true"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-348",
      "id": "num-footnote-8-348-back"
    }
  }, [_vm._v("266")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00011"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_58"
    }
  }, [_vm._v("I will take no invitation excepting for dinner only save to Newton Don and Mertoun tomorrow instead of Christmas Day."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-349",
      "id": "num-footnote-1-349-back"
    }
  }, [_vm._v("267")]), _vm._v(" On this day of General Devotion I have a particular call for gratitude!!.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00034"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00012"
    }
  }, [_vm._v("26 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MONDAY")]), _vm._v(" My God! what poor creatures we are. After all my fair proposals yesterday I was seized with a most violent pain in the right kidney and parts adjacent which, joind to deadly sickness which it brought on, forced me instantly to go to bed and send for Clarkson."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-350",
      "id": "num-footnote-2-350-back"
    }
  }, [_vm._v("268")])]), _vm._v(" He came and engineerd, pronouncing the complaint to be gravel augmented by bile – I was in great agony till about two o’clock but awaked with the pain gone. I got up, had a fire in my dressing closet, and had Dalgleish"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-351",
      "id": "num-footnote-3-351-back"
    }
  }, [_vm._v("269")])]), _vm._v(" to shave me – two trifles which I only mention because they [are] contrary to my hardy and independent personal habits. But although a man cannot be a heroe to his valet, his valet in sickness becomes of great use to him. I cannot expect that this first will be the last visit of this cruel complaint but shall we receive good at the hand of God and not receive evil?"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-352",
      "id": "num-footnote-4-352-back"
    }
  }, [_vm._v("270")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00035"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00141"
    }
  }, [_vm._v("27 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TUESDAY")]), _vm._v(" Slept twelve hours at a stretch being much exhausted with pain of last night and the action of the medicine. Totally without pain to-day but uncomfortable with the effects of calomel, which with me at least is like the assistance of an auxiliary army, just one degree more tolerable than the enemy it chases away. Calomel contempla-tions are not worth recording.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00142"
    }
  }, [_vm._v("I wrote an introduction and a few notes to the "), _c('i', [_vm._v("Memoirs of Made La")]), _vm._v(" "), _c('i', [_vm._v("Rochejacquelin")]), _vm._v(","), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-353",
      "id": "num-footnote-5-353-back"
    }
  }, [_vm._v("271")])]), _vm._v(" being all that I was equal to.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00143"
    }
  }, [_vm._v("Sir Adam Fergusson came over"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-354",
      "id": "num-footnote-6-354-back"
    }
  }, [_vm._v("272")])]), _vm._v(" and tried to marry my verses to the tune of ‘Bonnie Dundee.’ They seem well adapted to each other.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00144"
    }
  }, [_vm._v("Dined with Lady Scott and Anne.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00145"
    }
  }, [_vm._v("Worked at Pepys in the evening with the purpose of review for "), _c('a', {
    attrs: {
      "id": "pb-rw_59"
    }
  }, [_vm._v("Lockhart."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-355",
      "id": "num-footnote-1-355-back"
    }
  }, [_vm._v("273")]), _vm._v(" Notwithstanding the depressing effects of the calomel I feel the pleasure of being alone and uninterrupted. Few men leading a quiet life and without any strong or highly varied change of circumstances have seen more variety of Society than I – few have enjoyd it more or been "), _c('i', [_vm._v("bored")]), _vm._v(" as it [is] calld less by the company of tiresome people. I have rarely if ever found any one out of whom I could not extract amusement or edification and were I obliged to account for hints afforded on such occasions I should make an ample deduction from my inventive powers. Still however, from the earliest time I can remember, I preferd the pleasures of being alone to waiting for visitors, and have often taken a bannock and a bit of cheese to the wood or hill to avoid dining with company. As I grew from boyhood to manhood I saw this would not do and that to gain a place in men’s esteem I must mix and bustle with them. Pride and an excitation of spirits supplied the real pleasure which others seem to feel in society and certainly upon many occasions it was real. Still if the question was eternal company without the power of retiring within yourself or Solitary confinement for life I should say ‘Turnkey, Lock the cell.’ My life, though not without its fits of waking and strong exertion, has been a sort of dream spent in\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00016"
    }
  }, [_c('p', [_vm._v("Chewing the cud of sweet and bitter fancy."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-356",
      "id": "num-footnote-2-356-back"
    }
  }, [_vm._v("274")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00146"
    }
  }, [_vm._v("I have worn a wishing cap the power of which has been to divert present griefs by a touch of the wand of imagination and gild over the future prospect by prospects more fair than can ever be realized. Somewhere it is said that this castle building – this wielding of the aerial trowel – is fatal to exertions in actual life. I cannot tell – I have not found it so – I cannot indeed say like Made. Genlis that in the imaginary scenes in which I have acted a part I ever prepared myself for anything which actually befell me. But I have certainly fashiond out much that made the present hour pass pleasantly away and much that has enabled me to contribute to the amusement of the public. Since I was five years old I cannot remember the time when I had not some ideal part to play for my own solitary amusement.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-000002"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00013"
    }
  }, [_vm._v("28 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" Some how I think the attack on Christmas day has been of a critical kind and having gone off so well may be productive\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_60"
    }
  }, [_vm._v("rather of health than continued indisposition. If one is to get a renewal of health in his fifty fourth year he must look to pay fine for it. Last night George Thompson"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-357",
      "id": "num-footnote-1-357-back"
    }
  }, [_vm._v("275")]), _vm._v(" came to see how I was, poor fellow. He has talent, is well informd, and has an excellent heart, but there is an eccentricity about him that defies description. I wish to God I saw him provided in a country kirk. That with a rational wife, that is if there is such a thing to be gotten for him, would I think bring him to a steady temper. At present he is between the tyning"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-358",
      "id": "num-footnote-2-358-back"
    }
  }, [_vm._v("276")])]), _vm._v(" and the winning. If I could get him to set to any hard study he would do something clever.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00147"
    }
  }, [_c('i', [_vm._v("How to make a critic")]), _vm._v(" – A sly rogue sheltering himself under the generick name of Mr. Campbell requested me through the penny post the loan of "), _c('i', [_vm._v("£")]), _vm._v("50 for two years, having an impulse as he said to make this demand. As I felt no corresponding impulse I beggd to decline a demand which might have been as reasonably made by any Campbell on earth and another impulse has determined the Man of fifty pounds to send me anonymous abuse of my works and temper and selfish disposition. The severity of the joke lies in 14d. for postage,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-359",
      "id": "num-footnote-3-359-back"
    }
  }, [_vm._v("277")])]), _vm._v(" to avoid which his next epistle shall go back to the clerks of the Post Office as not for S. W. S."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-360",
      "id": "num-footnote-4-360-back"
    }
  }, [_vm._v("278")])]), _vm._v(" How the severe rogue would be disappointed if he knew I never lookd at more than the first and last line of his satirical effusions.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110265-00018"
    }
  }, [_vm._v("When I first saw that a literary profession was to be my fate I endeavourd by all efforts of stoicism to divest myself of that irritable degree of sensibility – or to speak plainly of Vanity – which makes the poetical race miserable and ridiculous. The anxiety of a poet for praise and for compliments I have always endea [vourd to avoid].")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00148"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_61"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_61"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00036"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00014"
    }
  }, [_c('span', [_vm._v("29 ")]), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THURSDAY")]), _vm._v(" Base feeling this same Calomel gives one. Mean poor and abject – a wretch as Will Rose says.\n         ")])]), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00017"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_61"
    }
  }, [_c('p', [_vm._v("Fie fie on silly coward man")])]), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_61"
    }
  }, [_vm._v("That he should be the slave o’t."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-361",
      "id": "num-footnote-1-361-back"
    }
  }, [_vm._v("279")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00015"
    }
  }, [_vm._v("Then it makes one sinfully dogged and snappish, as Dr. Rutt [y] the Quaker says in his "), _c('i', [_vm._v("gurnal")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-362",
      "id": "num-footnote-2-362-back"
    }
  }, [_vm._v("280")])]), _vm._v(" Sent Lockhart four pages on Sheridan’s plays"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-363",
      "id": "num-footnote-3-363-back"
    }
  }, [_vm._v("281")])]), _vm._v(" – not very good I think but the demand came sudden. Must go to "), _c('i', [_vm._v("W—k")]), _vm._v(" yet am vexd by that humour of contradiction which makes me incline to do anything else in presence. Commenced preface for New Edition novels."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-364",
      "id": "num-footnote-4-364-back"
    }
  }, [_vm._v("282")])]), _vm._v(" The city of Cork send my freedom in a silver box."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-365",
      "id": "num-footnote-5-365-back"
    }
  }, [_vm._v("283")])]), _vm._v(" I thought I was out of their grace for going to see Blarney rather than the cove"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-366",
      "id": "num-footnote-6-366-back"
    }
  }, [_vm._v("284")])]), _vm._v(" for which I was attackd and defended in the papers when in Ireland. I am sure they are so civil that I would have gone wherever they wishd me to go if I had had any one to have told me what I ought to be most inquisitive about\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110265-00018"
    }
  }, [_c('p', [_vm._v("For if I should as Lion come in strife")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("Into such place ’twere pity of my life."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-367",
      "id": "num-footnote-7-367-back"
    }
  }, [_vm._v("285")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110265-00016"
    }
  }, [_vm._v("30 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("FRIDAY")]), _vm._v(" Spent at home and in labour – with the weight of unpleasant news from Edinburgh. J. B. is like to be pinched next week unless the loan can be brought forward. I must and have endeavourd to supply him. At present the result of my attempts are uncertain. I am even more anxious about C. and Coy unless they can get assistance from their London friends to whom they gave much. All is in God’s hands. The worst can only be what I have before anticipated. But I must I think renounce the Segars. They brought back (using two this evening) the irritation of which I had no feelings while abstaining from them. \n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00150"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_62"
    }
  }, [_vm._v("Dined alone with Gordon,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-368",
      "id": "num-footnote-1-368-back"
    }
  }, [_vm._v("286")]), _vm._v(" Lady S. and Anne.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110265-00151"
    }
  }, [_vm._v("James Curle,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-369",
      "id": "num-footnote-2-369-back"
    }
  }, [_vm._v("287")])]), _vm._v(" Melrose, has handsomely lent me "), _c('i', [_vm._v("£")]), _vm._v("600. He has done kindly. I have served him before and will again if in my power.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110265-00037"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110265-00152"
    }
  }, [_vm._v("31 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SATURDAY")]), _vm._v(" Took a good sharp walk the first time since my illness and found myself the better in health and spirits. Being Hogmanae"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-370",
      "id": "num-footnote-3-370-back"
    }
  }, [_vm._v("288")])]), _vm._v(" there dined with us Colonel Russell and his sisters, Sir Adam Fergusson and Lady, Colonel Fergusson"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-371",
      "id": "num-footnote-4-371-back"
    }
  }, [_vm._v("289")])]), _vm._v(" with Mary and Margaret"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-372",
      "id": "num-footnote-5-372-back"
    }
  }, [_vm._v("290")])]), _vm._v(" – An auld-warld party who made themselves happy in the auld fashion. I felt so tired about eleven that I was forced to steal to Bed.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block footnotes"
  }, [_c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-83"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-83-back"
    }
  }, [_vm._v("1")])]), _vm._v(". For the members of Scott’s family, see Introduction, pp. xxxix—xli.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-84"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-84-back"
    }
  }, [_vm._v("2")])]), _vm._v(". The main purpose of Scott’s tour the previous July and August was to visit Walter and Jane, newly married, and quartered in Dublin. Lockhart and Anne were of the party. They went also to Maria Edgeworth at Edgeworthstown, and on the return journey passed some days at Storrs, on Lake Windermere, where Colonel Bolton was entertaining Canning. Wordsworth escorted them as far as Lowther Castle by way of Rydal Mount and Southey’s house at Keswick. "), _c('i', [_vm._v("Life")]), _vm._v(", viii. 1–52.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-85"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-85-back"
    }
  }, [_vm._v("3")])]), _vm._v(". See Introduction, p. xliv.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-86"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-86-back"
    }
  }, [_vm._v("4")])]), _vm._v(". "), _c('i', [_vm._v("An Essay on Naval Tactics, etc")]), _vm._v("., by John Clerk, 1790, reputed to have inspired Nelson’s tactics at Trafalgar.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-87"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-87-back"
    }
  }, [_vm._v("5")])]), _vm._v(". ‘Itch for argument’.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-88"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-88-back"
    }
  }, [_vm._v("6")])]), _vm._v(". C. K. Sharpe (1781–1851), antiquary, artist, cynic, and dilettante, first met Scott in Oxford in 1802. He was living now at 93 Princes Street with his mother. Some of his characteristics are given to Sir Mungo Malagrowther in "), _c('i', [_vm._v("The Fortunes of Nigel")]), _vm._v(".\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-89"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-89-back"
    }
  }, [_vm._v("7")])]), _vm._v(". "), _c('i', [_vm._v("Secret and True History of the Church of Scotland from the Restoration to")]), _vm._v(" "), _c('i', [_vm._v("the year 1678")]), _vm._v(", 1817.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-90"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-90-back"
    }
  }, [_vm._v("8")])]), _vm._v(". Sir Robert Douglas’s "), _c('i', [_vm._v("Peerage of Scotland")]), _vm._v(", revised by John Philp Wood, 1813.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-91"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-91-back"
    }
  }, [_vm._v("9")])]), _vm._v(". Laetitia Matilda Hawkins’s "), _c('i', [_vm._v("Anecdotes, Biographical Sketches, and")]), _vm._v(" "), _c('i', [_vm._v("Memoirs")]), _vm._v(", 1822, pp. 91–117.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-92"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-92-back"
    }
  }, [_vm._v("10")])]), _vm._v(". Jemima, the tall, cheerful, noisy daughter of Hector Macdonald Buchanan, Scott’s fellow Clerk of Session. She was a frequent visitor and Scott was fond of her although he thought the Buchanan girls ‘accustomd to racket about a little too much’. "), _c('i', [_vm._v("Letters")]), _vm._v(", x. 506.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-93"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-93-back"
    }
  }, [_vm._v("11")])]), _vm._v(". This story goes the rounds as ‘a good anecdote by Sir Walter Scott’ and is heard in London three years later by Puckler Muskau. "), _c('i', [_vm._v("A")]), _vm._v(" "), _c('i', [_vm._v("Regency Visitor")]), _vm._v(", ed. E. M. Butler, 1957, p. 289.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-94"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-94-back"
    }
  }, [_vm._v("12")])]), _vm._v(". Clermont in Co. Louth.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-95"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-95-back"
    }
  }, [_vm._v("13")])]), _vm._v(". The Edinburgh Oil Gas Light Coy., of which Scott had been chairman since 1823, was never commercially successful. It struggled until 1828, when it sold out to its older rival the Edinburgh Gas Light Coy. For some account of the affairs of the company see Note 1, pp. 805–6. Abbotsford was one of the first houses in Scotland to be lit by gas.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-96"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-96-back"
    }
  }, [_vm._v("14")])]), _vm._v(". Sir Robert Dundas of Beechwood (1761–1836), Scott’s fellow Clerk of Session, with whose family the Scotts had lived on terms of great intimacy.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-97"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-97-back"
    }
  }, [_vm._v("15")])]), _vm._v(". Robert Saunders Dundas, second Viscount Melville (1771–1851), son of the great Lord Melville and a school friend of Scott’s, was at this time First Lord of the Admiralty and a powerful source of patronage in Scotland.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-98"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-98-back"
    }
  }, [_vm._v("16")])]), _vm._v(". David McCulloch, a Bengal merchant who had now retired to Cheltenham, and James McCulloch of Ardwall, near Gatehouse-of-Fleet in Kirkcudbrightshire, were brothers of Scott’s sister-in-law, Mrs. Thomas Scott.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-99"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-99-back"
    }
  }, [_vm._v("17")])]), _vm._v(". Thomas Moore (1779–1852), the Irish poet and biographer, whose visit to Abbotsford earlier in the autumn is described by Lockhart in his "), _c('i', [_vm._v("Life")]), _vm._v(", viii. 65–72. Moore’s "), _c('i', [_vm._v("Life of Byron")]), _vm._v(", which appeared in 1830, was dedicated to Scott.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-100"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-100-back"
    }
  }, [_vm._v("18")])]), _vm._v(". Matthew Lewis (1775–1818), author of "), _c('i', [_vm._v("The Monk")]), _vm._v(", whom Scott first met in Edinburgh in 1798. Lewis was the first man of letters to show him some attention and Scott contributed to his "), _c('i', [_vm._v("Tales of Wonder")]), _vm._v(", 1801.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-101"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-101-back"
    }
  }, [_vm._v("19")])]), _vm._v(". Henry, third Duke of Buccleuch (1746–1812).\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-102"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-102-back"
    }
  }, [_vm._v("20")])]), _vm._v(". For an account of Scott’s meetings with Byron in 1815 see Lockhart’s "), _c('i', [_vm._v("Life")]), _vm._v(", v. 38–45 and 88. Byron, who had attacked Scott in "), _c('i', [_vm._v("English Bards and Scotch Reviewers")]), _vm._v(", made amends in "), _c('i', [_vm._v("Don Juan")]), _vm._v(", where he called him. ‘The Ariosto of the North’.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-103"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-103-back"
    }
  }, [_vm._v("21")])]), _vm._v(". Boswell’s "), _c('i', [_vm._v("Life of Johnson")]), _vm._v(", iv. 193.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-104"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-104-back"
    }
  }, [_vm._v("22")])]), _vm._v(". John Cam Hobhouse (1786–1869), statesman and author, the early friend and travelling companion of Lord Byron, and his literary executor.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-105"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-105-back"
    }
  }, [_vm._v("23")])]), _vm._v(". ‘Deep night will cover it.’ Horace’s Odes, 1. iv. 16.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-106"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-106-back"
    }
  }, [_vm._v("24")])]), _vm._v(". At the Edinburgh Theatre there werèshouts, cheers, bravo, and applause’ when Scott, Moore, Lockhart, and Sophia entered in time to see "), _c('i', [_vm._v("The Abbot")]), _vm._v("; and Moore, ‘though modestly reluctant, at last yielded, and bowed, hand on heart, with graceful animation’. Dibdin, pp. 317–18.\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Scott’s arrival in the theatre in Dublin the previous July had been greeted by ‘a perfect cataract and thunder of roaring’ which had brought the play to a standstill. "), _c('i', [_vm._v("Life")]), _vm._v(", viii. 21.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-107"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-107-back"
    }
  }, [_vm._v("25")])]), _vm._v(". "), _c('i', [_vm._v("Twelfth Night")]), _vm._v(", iii. 4.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-108"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-108-back"
    }
  }, [_vm._v("26")])]), _vm._v(". Hurst, Robinson and Co., the London booksellers whose fall brought on the failure of Constable and ultimately Scott’s ruin.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-109"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-109-back"
    }
  }, [_vm._v("27")])]), _vm._v(". James Ballantyne.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-110"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-110-back"
    }
  }, [_vm._v("28")])]), _vm._v(". The failure of his venture into publishing as John Ballantyne & Coy. "), _c('i', [_vm._v("Life")]), _vm._v(", iv. 73–123.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-111"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-111-back"
    }
  }, [_vm._v("29")])]), _vm._v(". To bolster confidence in Constable & Coy., Scott agreed with Cadell on this day to advertise that "), _c('i', [_vm._v("Woodstock")]), _vm._v(" would be published on 25 January. "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 301. In fact it did not appear until the following April.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-112"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-112-back"
    }
  }, [_vm._v("30")])]), _vm._v(". Scott’s charity always fails him when he has to mention Sir John Sinclair of Ulbster (1754–1835). A Highland landowner, with advanced ideas on farming, he had been President of the Board of Agriculture and supervised "), _c('i', [_vm._v("The Statistical Account of Scotland")]), _vm._v(". At this time he held the sinecure of Commissioner of Excise. For a later impertinence see the Entry for 13 September 1826.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-113"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-113-back"
    }
  }, [_vm._v("31")])]), _vm._v(". Alexander Adam’s "), _c('i', [_vm._v("Roman Antiquities")]), _vm._v(", 1791. Adam had been Scott’s headmaster.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-8-114"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-114-back"
    }
  }, [_vm._v("32")])]), _vm._v(". An allusion to "), _c('i', [_vm._v("Cymbeline")]), _vm._v(", ii. 4.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-9-115"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-9-115-back"
    }
  }, [_vm._v("33")])]), _vm._v(". "), _c('i', [_vm._v("Macbeth")]), _vm._v(", v. 3.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-116"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-116-back"
    }
  }, [_vm._v("34")])]), _vm._v(". ‘My Jo Janet’ in Allan Ramsay’s "), _c('i', [_vm._v("Tea-Table Miscellany")]), _vm._v(".\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-117"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-117-back"
    }
  }, [_vm._v("35")])]), _vm._v(". The Lord Justice-Clerk, the Rt. Hon. David Boyle (1772–1853).\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-118"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-118-back"
    }
  }, [_vm._v("36")])]), _vm._v(". From ‘Come, come, my Hearts of Gold’ with and ‘Every man take a glass in his hand’. "), _c('i', [_vm._v("The Vocal Miscellany")]), _vm._v(", i. 163 and 103.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-119"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-119-back"
    }
  }, [_vm._v("37")])]), _vm._v(". From 1804 to 1812, the year in which he moved to Abbotsford, Scott rented Ashestiel from his cousin Colonel Russell who was at that time in India.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-120"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-120-back"
    }
  }, [_vm._v("38")])]), _vm._v(". Adapted from Fielding’s"), _c('i', [_vm._v(" Tom Thumb the Great")]), _vm._v(", i. 5.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-121"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-121-back"
    }
  }, [_vm._v("39")])]), _vm._v(". William Stewart Rose (1775–1843), poet and translator of Ariosto, who until 1824 was Reading-Clerk in the House of Lords. Scott first met him in London in 1803. He, as well as Lady Louisa Stuart, wrote introducing Morritt to Scott.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-122"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-122-back"
    }
  }, [_vm._v("40")])]), _vm._v(". John Murray (1778–1843) of Albemarle Street. He was Constable’s London agent until 1813 and publisher of the "), _c('i', [_vm._v("Quarterly")]), _vm._v(". He introduced Scott to Byron.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-123"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-123-back"
    }
  }, [_vm._v("41")])]), _vm._v(". A quarterly magazine of which only four numbers appeared, remembered chiefly for Byron’s "), _c('i', [_vm._v("Vision of Judgment")]), _vm._v(" (1822) in the first number.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-124"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-124-back"
    }
  }, [_vm._v("42")])]), _vm._v(". See Moore’s "), _c('i', [_vm._v("Life of Byron")]), _vm._v(", v. 313–21.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-125"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-125-back"
    }
  }, [_vm._v("43")])]), _vm._v(". William John Bankes (d. 1855), the traveller, wit, and friend of Byron.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-126"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-126-back"
    }
  }, [_vm._v("44")])]), _vm._v(". Hurst, Robinson.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-127"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-127-back"
    }
  }, [_vm._v("45")])]), _vm._v(". For Robert Cadell see Introduction, p. xlii.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-128"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-128-back"
    }
  }, [_vm._v("46")])]), _vm._v(". An allusion to "), _c('i', [_vm._v("Cymbeline")]), _vm._v(", iii. 1.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-129"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-129-back"
    }
  }, [_vm._v("47")])]), _vm._v(". Sir William Rae, Bart. (1769–1842). His house of St. Catherine’s lay three miles south of Princes Street.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-130"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-130-back"
    }
  }, [_vm._v("48")])]), _vm._v(". Raised to the bench as Lord Succoth in 1809.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-131"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-131-back"
    }
  }, [_vm._v("49")])]), _vm._v(". See Introduction, pp. xliv–xlv.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-132"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-132-back"
    }
  }, [_vm._v("50")])]), _vm._v(". Colin Mackenzie of Portmore, W. S. (1770–1830), a fellow Clerk of Session and a close friend.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-133"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-133-back"
    }
  }, [_vm._v("51")])]), _vm._v(". Prominent in Edinburgh as Writer to the Signet, doctor, and accountant respectively.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-134"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-134-back"
    }
  }, [_vm._v("52")])]), _vm._v(". Virgil’s "), _c('i', [_vm._v("Aeneid")]), _vm._v(", i. 118, with the first two words transposed: ‘Here and there they appear swimming in the wide whirlpool.’\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-135"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-135-back"
    }
  }, [_vm._v("53")])]), _vm._v(". He came to London from Italy in 1816, ‘a very singular man, uniting opposite qualities, and generally very pleasing in the early part of an acquaintance’. Redding’s "), _c('i', [_vm._v("Memoirs of Thomas Campbell")]), _vm._v(", i. 192. He stimulated the fashionable interest in Italian literature by his lectures and critical writings.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-136"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-136-back"
    }
  }, [_vm._v("54")])]), _vm._v(". Carlo, Marchese di Salvo, author of "), _c('i', [_vm._v("Lord Byron en Italie et en Grèce")]), _vm._v(", 1825, whom Scott refers to in a letter as ‘a very accomplished and well informed man’. "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 237.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-137"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-137-back"
    }
  }, [_vm._v("55")])]), _vm._v(". "), _c('i', [_vm._v("Richard III")]), _vm._v(", iii. 1.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-138"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-138-back"
    }
  }, [_vm._v("56")])]), _vm._v(". Lady Scott’s friend. See the Entry for 18 October 1826 and note.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-139"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-139-back"
    }
  }, [_vm._v("57")])]), _vm._v(". Pierre Lebrun, author of two tragedies ("), _c('i', [_vm._v("Marie Stuart")]), _vm._v(", 1820, and "), _c('i', [_vm._v("Le")]), _vm._v(" "), _c('i', [_vm._v("Cid d’Andalousie")]), _vm._v(", 1825). Scott made the same mistake about his name in Paris the following year, ‘demandant par une erreur amusante ‘‘M. Lenoir”’. Margaret Bain’s"), _c('i', [_vm._v(" Les Voyageurs français en")]), _vm._v(" "), _c('i', [_vm._v("Écosse")]), _vm._v(", 1931. It is probably Lebrun’s visit which is described in Mrs "), _c('i', [_vm._v("Hughes’s Recollections")]), _vm._v(", p. 208.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-140"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-140-back"
    }
  }, [_vm._v("58")])]), _vm._v(". Robert Cockburn, a wine-merchant who lived at 7 Atholl Crescent. He was a brother of Lord Cockburn and an old Yeomanry friend of Scott’s.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-141"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-141-back"
    }
  }, [_vm._v("59")])]), _vm._v(". Lord Robert Kerr was Assistant Adjutant-General of the forces in Scotland.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-142"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-142-back"
    }
  }, [_vm._v("60")])]), _vm._v(". Francis Jeffrey (1773–1850) was editor of the "), _c('i', [_vm._v("Edinburgh Review")]), _vm._v(" and a prominent Whig advocate. In 1829 he became Dean of the Faculty and in 1830 Lord Advocate. The pamphlet referred to is "), _c('i', [_vm._v("Combinations of Workmen, etc")]), _vm._v("., Constable, 1825.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-143"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-143-back"
    }
  }, [_vm._v("61")])]), _vm._v(". Swift’s "), _c('i', [_vm._v("Gulliver’s Travels")]), _vm._v(", pt. 1, ch. 5.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-144"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-144-back"
    }
  }, [_vm._v("62")])]), _vm._v(". Robert Cadell.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-145"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-145-back"
    }
  }, [_vm._v("63")])]), _vm._v(". Robinson of Hurst, Robinson.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-146"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-146-back"
    }
  }, [_vm._v("64")])]), _vm._v(". However, Lady Scott could not do without. ‘We are to œconomize in order to keep the carriage’, Scott writes to Sophia on 17 February 1826. ‘Now this matter of the carriage is of great consequence as a daily drive about two is really essential to Mamas health and spirits.’ "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 427. It had always meant much to her. After the success "), _c('i', [_vm._v("of Waverley")]), _vm._v(", ‘Mrs. Scott set up a carriage, a Barouche landau built in London, and which from the time she got it she was seldom out of’. Mrs. Grant’s "), _c('i', [_vm._v("Memoirs of a Highland Lady")]), _vm._v(", ii. 72.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-147"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-147-back"
    }
  }, [_vm._v("65")])]), _vm._v(". ‘This alludes to a strange old woman, keeper of a public-house among the Wicklow mountains, who, among a world of oddities, cut short every word ending in tion, by the omission of the termination. Consola for consolation – "), _c('i', [_vm._v("bothera")]), _vm._v(" for botheration, etc. Lord Plunkett had taken care to parade Judy and all her peculiarities.’ J. G. L. (This and the other notes by Lockhart are taken from the "), _c('i', [_vm._v("Life")]), _vm._v(", in which much of the "), _c('i', [_vm._v("Journal")]), _vm._v(" was published for the first time.)\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-148"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-148-back"
    }
  }, [_vm._v("66")])]), _vm._v(". "), _c('i', [_vm._v("Julius Caesar")]), _vm._v(", iii. 2.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-149"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-149-back"
    }
  }, [_vm._v("67")])]), _vm._v(". Mrs. Coutts, described by Benson Hill as ‘a fat, bare-“necked”, downy-chinned, rouged, elderly dame, in velvet and ermine’ (Dibdin, p. 317), had been an actress in her youth and was now the very wealthy widow of Thomas Coutts the banker, to whom Scott was distantly related. She married the Duke of St. Albans in 1827. ‘I daresay the marriage will turn out very well,’ Anne Scott writes to Miss Millar, ‘for, though he is a great fool, yet he is very good-natured.’ "), _c('i', [_vm._v("Letters from Scott’s Family")]), _vm._v(", p. 128.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-150"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-150-back"
    }
  }, [_vm._v("68")])]), _vm._v(". His sister.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-151"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-151-back"
    }
  }, [_vm._v("69")])]), _vm._v(". Even her visit to Abbotsford was not passed without some incivility from Scott’s other guests. See "), _c('i', [_vm._v("Life")]), _vm._v(", viii. 72–6.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-152"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-152-back"
    }
  }, [_vm._v("70")])]), _vm._v(". John Logan (1748–88), a versatile but unlucky man of letters, who was tutor to Sir John Sinclair and later minister of South Leith church. His poems were published in 1781, and two volumes of sermons posthumously.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-153"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-153-back"
    }
  }, [_vm._v("71")])]), _vm._v(". "), _c('i', [_vm._v("Macbeth")]), _vm._v(", iv. 1.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-154"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-154-back"
    }
  }, [_vm._v("72")])]), _vm._v(". For Scott’s duties as a Clerk of Session see Introduction, pp. xxvii–xxviii.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-155"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-155-back"
    }
  }, [_vm._v("73")])]), _vm._v(". A fashionable southern suburb of Edinburgh, which began to be built in the 1820s. This loan was never recovered either by Scott or his Trustees, owing to the continued embarrassment of her affairs and the falling value of property. Sederunt Book, ii. 61.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-156"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-156-back"
    }
  }, [_vm._v("74")])]), _vm._v(". Scott had been instrumental in founding the Quarterly in 1809. As its new editor Lockhart was to receive ‘from "), _c('i', [_vm._v("£")]), _vm._v("1250 to "), _c('i', [_vm._v("£")]), _vm._v("1,500 per annum’. Lockhart, 27 November 1825, Abbots.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-157"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-157-back"
    }
  }, [_vm._v("75")])]), _vm._v(". John Barrow (1764–1848), the explorer and geographer, a self-made man who was at this time a Secretary at the Admiralty under Lord Melville. He was an indefatigable writer and contributed more than two hundred articles to the "), _c('i', [_vm._v("Quarterly")]), _vm._v(".\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-158"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-158-back"
    }
  }, [_vm._v("76")])]), _vm._v(". Lockhart was one of the original contributors to the Tory "), _c('i', [_vm._v("Blackwood’s Magazine")]), _vm._v(" founded in 1817, and was suspected of being part-author of the ‘Chaldee Manuscript’ which offended many Edinburgh notabilities.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-159"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-159-back"
    }
  }, [_vm._v("77")])]), _vm._v(". Benjamin Disraeli was twenty-one at this time. He published "), _c('i', [_vm._v("Vivian")]), _vm._v(" "), _c('i', [_vm._v("Grey")]), _vm._v(" the following year, entered Parliament in 1837, and became Prime Minister in 1868.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-160"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-160-back"
    }
  }, [_vm._v("78")])]), _vm._v(". Richard Heber (1773–1833), the book-collector and M. P. for Oxford University. He first met Scott in Constable’s shop when he spent the winter of 1800 in Edinburgh, and he assisted him with the "), _c('i', [_vm._v("Minstrelsy")]), _vm._v(". In 1826 he resigned his seat after a homosexual scandal.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-161"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-161-back"
    }
  }, [_vm._v("79")])]), _vm._v(". Southey was a principal contributor to the "), _c('i', [_vm._v("Quarterly")]), _vm._v(" and a friend of John Taylor Coleridge, the previous editor. Scott was anxious to assure him that when they discussed the "), _c('i', [_vm._v("Quarterly")]), _vm._v(" in August he did not then know that Lockhart was to be offered the editorship. "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 297.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-162"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-162-back"
    }
  }, [_vm._v("80")])]), _vm._v(". A slip for ‘Wordsworth’.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-163"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-163-back"
    }
  }, [_vm._v("81")])]), _vm._v(". Professor John Wilson (1785–1854), better known as ‘Christopher North’, who lived at Elleray near Windermere.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-8-164"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-164-back"
    }
  }, [_vm._v("82")])]), _vm._v(". A slip for ‘August’.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-165"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-165-back"
    }
  }, [_vm._v("83")])]), _vm._v(". George Canning (1770–1827) had been a friend of Scott’s since Ellis had introduced them in 1805, and they were associated in founding the "), _c('i', [_vm._v("Quarterly")]), _vm._v(". At this time Canning was Foreign Secretary. He became Prime Minister a few months before his death in 1827.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-166"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-166-back"
    }
  }, [_vm._v("84")])]), _vm._v(". Charles Ellis (1771–1845), M. P. for Seaford, cousin of Scott’s friend George Ellis, and Canning’s second in his duel with Castlereagh. He was created Baron Seaford in 1826.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-167"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-167-back"
    }
  }, [_vm._v("85")])]), _vm._v(". Not the poet, but his nephew John Taylor Coleridge, who had edited the "), _c('i', [_vm._v("Quarterly")]), _vm._v(" since 1824.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-168"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-168-back"
    }
  }, [_vm._v("86")])]), _vm._v(". At Storrs, Windermere, during the journey home from Ireland.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-169"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-169-back"
    }
  }, [_vm._v("87")])]), _vm._v(". John Cay (1790–1865), of Charlton in Northumberland, at this time Sheriff of Linlithgow.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-170"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-170-back"
    }
  }, [_vm._v("88")])]), _vm._v(". Scott enclosed Murray’s letter in one written to Lockhart the previous day. Murray writes that ‘There is nothing to apprehend’. "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 302–3 and note.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-171"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-171-back"
    }
  }, [_vm._v("89")])]), _vm._v(". The interlineation reads ‘No one has any ill will against Mr. Lockhart!!!’ "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 303 n.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-172"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-172-back"
    }
  }, [_vm._v("90")])]), _vm._v(". ‘Let it be given to the more deserving.’\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-173"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-173-back"
    }
  }, [_vm._v("91")])]), _vm._v(". Scott replied at once, promising a review of Pepys for the "), _c('i', [_vm._v("Quarterly")]), _vm._v(" and inviting Lockhart to come the following Sunday to discuss ‘the few ideas which occur to me about your new and important task’. "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 308.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-174"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-174-back"
    }
  }, [_vm._v("92")])]), _vm._v(". ‘I am sure it will please you to hear’, writes Sophia on 1 February 1826, ‘we have been most prudent with regard to money matters since we came here… From the first I determined against a carriage till we see how we get on and pay our household servants every week.’ Walpole.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-175"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-175-back"
    }
  }, [_vm._v("93")])]), _vm._v(". In a letter Scott translates "), _c('i', [_vm._v("Volto sciolto e pensiere strett")]), _vm._v("i as ‘ “An open countenance & close thoughts.” There is no occasion to let anyone see what you exactly think of him.’ "), _c('i', [_vm._v("Letters")]), _vm._v(", v. 449–50.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-176"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-176-back"
    }
  }, [_vm._v("94")])]), _vm._v(". In London, however, he ‘really takes pains to make himself agreeable in society’. Sophia, 1 February 1826, Walpole\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-177"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-177-back"
    }
  }, [_vm._v("95")])]), _vm._v(". Sheridan’s "), _c('i', [_vm._v("School for Scandal")]), _vm._v(", ii. 2.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-178"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-178-back"
    }
  }, [_vm._v("96")])]), _vm._v(". Sheridan’s "), _c('i', [_vm._v("Critic")]), _vm._v(", i. 2.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-179"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-179-back"
    }
  }, [_vm._v("97")])]), _vm._v(". As the boyhood friend of the second Viscount Melville, Scott had been a frequent visitor in the days of the great Lord Melville.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-180"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-180-back"
    }
  }, [_vm._v("98")])]), _vm._v(". George Abercromby (1770–1843), another boyhood friend, was married to Lord Melville’s sister. He was the eldest son of General Sir Ralph Abercromby (1738–1801) and inherited the barony from his mother, who had been created Baroness Abercromby of Aboukir in recognition of her husband’s victory against the French at Alexandria in 1801\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-181"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-181-back"
    }
  }, [_vm._v("99")])]), _vm._v(". William Gifford (1756–1826), who edited the "), _c('i', [_vm._v("Quarterly")]), _vm._v(" from its inception until 1824, a little, bitter, deformed man, known as a translator and satirist as well as reviewer.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-182"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-182-back"
    }
  }, [_vm._v("100")])]), _vm._v(". Sheridan’s "), _c('i', [_vm._v("Rivals")]), _vm._v(", i. 1.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-183"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-183-back"
    }
  }, [_vm._v("101")])]), _vm._v(". Charles James Blomfield (1786–1857), Bishop of Chester (and later of London), contributor to the "), _c('i', [_vm._v("Quarterly")]), _vm._v(" on classical subjects.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-184"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-184-back"
    }
  }, [_vm._v("102")])]), _vm._v(". William Wright of Lincoln’s Inn.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-185"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-185-back"
    }
  }, [_vm._v("103")])]), _vm._v(". John Wilson Croker (1780–1857), M. P. for Downpatrick and Secretary at the Admiralty, the friend of Wellington and Peel, and a frequent contributor to the "), _c('i', [_vm._v("Quarterly")]), _vm._v(". His caustic tongue made him some enemies, but he retained Scott’s friendship despite an attack on his "), _c('i', [_vm._v("Letters of Malachi")]), _vm._v(". See the Entries for 17 and 28 March 1826.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-186"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-186-back"
    }
  }, [_vm._v("104")])]), _vm._v(". An allusion to Hotspur’s plot in 1 "), _c('i', [_vm._v("Henry IV")]), _vm._v(", ii. 3. ‘The Douglas’ is Scott himself.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-187"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-187-back"
    }
  }, [_vm._v("105")])]), _vm._v(". The Lord President of the Court of Session, the Rt. Hon. Charles Hope of Granton (1763–1851), who had held the offices of Lord Advocate and Lord Justice-Clerk before becoming Lord President in 1811. He was the father of John Hope, the Solicitor-General.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-188"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-188-back"
    }
  }, [_vm._v("106")])]), _vm._v(". Major-General the Hon. Sir Robert William O’Callaghan (1770– 1840) commanded the forces at Edinburgh until 1830. Will Clerk describes him as ‘a rich morceau when he becomes a little mellow’. 6 January 1829, Walpole.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-8-189"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-189-back"
    }
  }, [_vm._v("107")])]), _vm._v(". During Scott’s return journey from Ireland.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-190"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-190-back"
    }
  }, [_vm._v("108")])]), _vm._v(". Ecclesiastes 12: 3.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-191"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-191-back"
    }
  }, [_vm._v("109")])]), _vm._v(". A distance of just over half a mile.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-192"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-192-back"
    }
  }, [_vm._v("110")])]), _vm._v(". Robert MacQueen, Lord Braxfield (1722–99), the legendary hanging judge whose coarse jocularity is well described by Cockburn in chapter 2 of his "), _c('i', [_vm._v("Memorials")]), _vm._v(". Scott, who dedicated his thesis to the old man, liked to repeat the comment he is alleged to have made to a prisoner: ‘Ye’re a vera clever chiel’, man, but ye wad be nane the waur o’ a hanging.’ "), _c('i', [_vm._v("Life")]), _vm._v(", vi. 203.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-193"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-193-back"
    }
  }, [_vm._v("111")])]), _vm._v(". An attack of polio at the age of eighteen months left Scott with a limp for the rest of his life.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-194"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-194-back"
    }
  }, [_vm._v("112")])]), _vm._v(". Foote’s "), _c('i', [_vm._v("Maid of Bath")]), _vm._v(", i.1.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-195"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-195-back"
    }
  }, [_vm._v("113")])]), _vm._v(". Ecclesiastes 11: 9.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-196"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-196-back"
    }
  }, [_vm._v("114")])]), _vm._v(". Mrs. Anne Grant, widow of the minister of Laggan, and author of "), _c('i', [_vm._v("Letters from the Mountains, Superstitions of the Highlands, andMemoirs of a")]), _vm._v(" "), _c('i', [_vm._v("Highland Lady")]), _vm._v(". She was now seventy years old, very poor and very lame.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-197"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-197-back"
    }
  }, [_vm._v("115")])]), _vm._v(". To make her farthing into a halfpenny.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-198"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-198-back"
    }
  }, [_vm._v("116")])]), _vm._v(". Henry Mackenzie (1745–1831), the aged but still active author of "), _c('i', [_vm._v("The Man of Feeling")]), _vm._v(" (1771).\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-199"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-199-back"
    }
  }, [_vm._v("117")])]), _vm._v(". Robert Rutherford. W. S. (1790–1866).\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-200"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-200-back"
    }
  }, [_vm._v("118")])]), _vm._v(". Later Major-General Sir James Russell (1781–1859). Anne Scott considered him a bore, ‘but it is a great advantage having the tweed between us for it is seldom fordable’. To Sophia, 29 September 1826, Abbots. Scott, however, enjoyed his company.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-201"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-201-back"
    }
  }, [_vm._v("119")])]), _vm._v(". Baron Lynedoch of Lynedoch (1748–1843), at this time Governor of the garrison at Dumbarton Castle.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-202"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-202-back"
    }
  }, [_vm._v("120")])]), _vm._v(". ‘The "), _c('i', [_vm._v("civilest")]), _vm._v(" way of caa’ing a man a "), _c('i', [_vm._v("guse")]), _vm._v(".’ Letters, v. 128.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-8-203"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-203-back"
    }
  }, [_vm._v("121")])]), _vm._v(". Sir William Hamilton (1788–1856), the Professor of Civil History at Edinburgh, a Balliol friend of Lockhart’s and a foe to the phrenologists.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-204"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-204-back"
    }
  }, [_vm._v("122")])]), _vm._v(". Scott was connected with the Swintons through his maternal grandmother.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-205"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-205-back"
    }
  }, [_vm._v("123")])]), _vm._v(". Sir Alexander Keith of Ravelston (1780–1833) had ridden as Knight Marischal in the procession during the King’s visit in 1822. William Keith was one of his younger brothers. Scott was connected with the family through his mother.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-206"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-206-back"
    }
  }, [_vm._v("124")])]), _vm._v(". ‘Any one of the sacred writings of the Hindus’. "), _c('i', [_vm._v("O. E. D")]), _vm._v(".\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-207"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-207-back"
    }
  }, [_vm._v("125")])]), _vm._v(". A phrase used in Scots Law meaning ‘opportunity for change of intention’.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-208"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-208-back"
    }
  }, [_vm._v("126")])]), _vm._v(". Scott sent to Lockhart on 17 February a short article on the burnings for publication in the "), _c('i', [_vm._v("Representative. Letters")]), _vm._v(", ix. 427.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-209"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-209-back"
    }
  }, [_vm._v("127")])]), _vm._v(". ‘No day without a line’, a proverb quoted by Pliny.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-210"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-210-back"
    }
  }, [_vm._v("128")])]), _vm._v(". The catch-phrase of Bailie Nicol Jarvie in "), _c('i', [_vm._v("Rob Roy")]), _vm._v(".\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-211"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-211-back"
    }
  }, [_vm._v("129")])]), _vm._v(". A Clerk of Session since 1805 and intimate family friend. His Highland prejudices endeared him to Scott. He was the brother of Staffa and a kinsman of Napoleon’s Maréchal Macdonald. He adopted his wife’s name on marriage.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-212"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-212-back"
    }
  }, [_vm._v("130")])]), _vm._v(". See Introduction, p. xliv.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-213"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-213-back"
    }
  }, [_vm._v("131")])]), _vm._v(". ‘A hard word so spelld on Authority of Miss Scott Mrs. Lockhart’. Title-page of the "), _c('i', [_vm._v("Journal")]), _vm._v(".\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-214"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-214-back"
    }
  }, [_vm._v("132")])]), _vm._v(". Scott wrote to him while the Court sat, urging him to rest until January: ‘The business is very easy and you will really act very unwisely as well as unkindly if you do not leave us to manage it, but endanger your health so deservedly valued by your bretheren and many others.’ "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 313.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-215"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-215-back"
    }
  }, [_vm._v("133")])]), _vm._v(". His grandson John Lockhart (1821–31), the ‘Hugh Littlejohn’ of "), _c('i', [_vm._v("Tales of a Grandfather")]), _vm._v(". Scott dreaded the effect on him of London air: ‘Poor little fellow he is most likely to suffer by this change of residence.’ "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 319.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-216"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-216-back"
    }
  }, [_vm._v("134")])]), _vm._v(". ‘God will provide.’\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-217"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-217-back"
    }
  }, [_vm._v("135")])]), _vm._v(". Robert Pearce Gillies (1788–1858), a nephew of Scott’s friend the judge Lord Gillies. He was in dire financial straits as usual and about to remove to London, where he became the first editor of the "), _c('i', [_vm._v("Foreign Quarterly Review")]), _vm._v(". In 1840 he fled to Boulogne to elude his creditors, and on his return was imprisoned for two years. His relatively worthless "), _c('i', [_vm._v("Recollections of Sir Walter Scott")]), _vm._v(" was published in 1837.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-218"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-218-back"
    }
  }, [_vm._v("136")])]), _vm._v(". Scott owned his translation of Hoffmann’s "), _c('i', [_vm._v("The Devil’s Elixirs")]), _vm._v(", 1824.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-219"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-219-back"
    }
  }, [_vm._v("137")])]), _vm._v(". ‘Mr. Gillies was, however, warmly welcomed by another publisher in Edinburgh, who paid him "), _c('i', [_vm._v("£")]), _vm._v("100 for his bulky manuscripts, and issued the book in 1825 under the title of "), _c('i', [_vm._v("The Magic Ring")]), _vm._v(", 3 vols. Its failure with the public prevented a repetition of the experiment!’ Douglas.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-220"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-220-back"
    }
  }, [_vm._v("138")])]), _vm._v(". An allusion to ‘the lunatic, the lover, and the poet’ in "), _c('i', [_vm._v("A Midsummer")]), _vm._v(" "), _c('i', [_vm._v("Night’s Dream, v.i.")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-221"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-221-back"
    }
  }, [_vm._v("139")])]), _vm._v(". John Hope (1794–1858), Solicitor-General for Scotland 1822–30. Dean of the Faculty of Advocates 1830, and later Lord Justice-Clerk. He was the eldest son of the Lord President, Charles Hope.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-222"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-222-back"
    }
  }, [_vm._v("140")])]), _vm._v(". Robert Dundas of Arniston (1797–1838), son of the Lord Chief Baron.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-223"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-223-back"
    }
  }, [_vm._v("141")])]), _vm._v(". ‘Consuming little meat and much small beer.’ "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 321.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-224"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-224-back"
    }
  }, [_vm._v("142")])]), _vm._v(". On the advice of Terry, Murray, and Disraeli, they decided ‘to rent for 6 months a handsome & convenient "), _c('i', [_vm._v("ready furnished")]), _vm._v(" house in the best possible situation’. Terry, 16 November 1825, Abbots.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-225"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-225-back"
    }
  }, [_vm._v("143")])]), _vm._v(". ‘To do and to suffer is Roman.’\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-226"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-226-back"
    }
  }, [_vm._v("144")])]), _vm._v(". A reminiscence of "), _c('i', [_vm._v("Richard III")]), _vm._v(", iii. 7.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-227"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-227-back"
    }
  }, [_vm._v("145")])]), _vm._v(". "), _c('i', [_vm._v("Life of Napoleon")]), _vm._v(", vol. ii, ch. 9.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-228"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-228-back"
    }
  }, [_vm._v("146")])]), _vm._v(". The Royal Society of Edinburgh, of which Scott was President. 1820–32.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-229"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-229-back"
    }
  }, [_vm._v("147")])]), _vm._v(". ‘A supplement to a Paper on Dreams formerly read to the Society.’ Royal Society Minutes.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-230"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-230-back"
    }
  }, [_vm._v("148")])]), _vm._v(". Dr. James Russell (1754–1836), Regius Professor of Clinical Surgery at Edinburgh University and Vice-president of the Royal Society, habitually held a supper party at 30 Abercromby Place after the fortnightly meetings of the Society.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-231"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-231-back"
    }
  }, [_vm._v("149")])]), _vm._v(". Henry Mackenzie who, according to Lockhart, had been consulting Sir Walter about collecting his own juvenile poetry, and who apparently intended Scott to write his life. Disc. ii. 227.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-232"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-232-back"
    }
  }, [_vm._v("150")])]), _vm._v(". Robert Lockhart, brother of Scott’s son-in-law.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-233"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-233-back"
    }
  }, [_vm._v("151")])]), _vm._v(". His wife Jane’s estate.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-234"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-234-back"
    }
  }, [_vm._v("152")])]), _vm._v(". See Introduction, p. xxvi.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-235"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-235-back"
    }
  }, [_vm._v("153")])]), _vm._v(". A Liverpool merchant who recommended it for making gas and sent Scott a trial cask in 1824. Walpole, 19 January 1824. He had been knighted in 1820 while Lord Mayor of Liverpool.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-236"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-236-back"
    }
  }, [_vm._v("154")])]), _vm._v(". Sir William Knighton (1776–1836), physician and private secretary to George IV. Scott first met him during the royal visit to Scotland in 1822, and the friendship was kept in good repair by correspondence.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-237"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-237-back"
    }
  }, [_vm._v("155")])]), _vm._v(". Scott had made the request in October. "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 262. The Dedication, which was approved before 20 December, was in the following terms: ‘To His Majesty KING GEORGE IV, The generous Patron even of the most humble attempts towards the advantage of his subjects, THE MISCELLANY, designed to extend Useful Knowledge and Elegant Literature, by placing Works of standard merit within the attainment every class of Readers, is most humbly inscribed by his Majesty’s humble and devoted servant, ARCHIBALD CONSTABLE. "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 327.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-238"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-238-back"
    }
  }, [_vm._v("156")])]), _vm._v(". The development north of Queen Street as far as Royal Circus and Great King Street took place between 1803 and 1823.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-239"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-239-back"
    }
  }, [_vm._v("157")])]), _vm._v(". George Fergusson of Hermand, who took the title of Lord Hermand when he succeeded Braxfield on the Bench in 1799. ‘He was fond of the pleasures, and not least the liquid ones, of the table’, says Cockburn ("), _c('i', [_vm._v("Memorials")]), _vm._v(", ch. 2), and was a man of decided and outspoken views.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-240"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-240-back"
    }
  }, [_vm._v("158")])]), _vm._v(". Sir Archibald Campbell, raised to the Bench in 1809 as Lord Succoth.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-241"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-241-back"
    }
  }, [_vm._v("159")])]), _vm._v(". See "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 309 n.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-242"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-242-back"
    }
  }, [_vm._v("160")])]), _vm._v(". ‘By divine right’.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-243"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-243-back"
    }
  }, [_vm._v("161")])]), _vm._v(". Major John Scott.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-244"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-244-back"
    }
  }, [_vm._v("162")])]), _vm._v(". ‘It is enough to have lived.’\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-245"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-245-back"
    }
  }, [_vm._v("163")])]), _vm._v(". William Knox, from Lilliesleaf near Melrose, who had died on 12 November, aged thirty-six. Lockhart’s note says: ‘His publisher (Mr. Anderson junior, of Edinburgh) remembers that Sir Walter occasionally wrote to Knox and sent him money – "), _c('i', [_vm._v("£")]), _vm._v("10 at a time.’\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-246"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-246-back"
    }
  }, [_vm._v("164")])]), _vm._v(". Michael Bruce (1746–67), the son of a Kinross-shire weaver. Scott probably had in mind his ‘Elegy – Written in Spring’, which is given added point by its author’s untimely death.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-247"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-247-back"
    }
  }, [_vm._v("165")])]), _vm._v(". An allusion to Ben Jonson’s "), _c('i', [_vm._v("Everyman in his Humour")]), _vm._v(", i. 2.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-248"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-248-back"
    }
  }, [_vm._v("166")])]), _vm._v(". Mrs. Grant of Laggan.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-249"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-249-back"
    }
  }, [_vm._v("167")])]), _vm._v(". Henry Mackenzie.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-250"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-250-back"
    }
  }, [_vm._v("168")])]), _vm._v(". Harriet Wilson’s "), _c('i', [_vm._v("Memoirs")]), _vm._v(", 1825.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-251"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-251-back"
    }
  }, [_vm._v("169")])]), _vm._v(". Lord Alvanley (1789–1849), the spendthrift wit to whom Brummel’s famous remark about the Prince Regent was addressed: ‘Alvanley, who’s your fat friend?’\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-252"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-252-back"
    }
  }, [_vm._v("170")])]), _vm._v(". "), _c('i', [_vm._v("Measure for Measure")]), _vm._v(", iv. 3.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-253"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-253-back"
    }
  }, [_vm._v("171")])]), _vm._v(". "), _c('i', [_vm._v("Hamlet")]), _vm._v(", ii. 2.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-254"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-254-back"
    }
  }, [_vm._v("172")])]), _vm._v(". Sir John Hay of Haystoun near Peebles, a fellow Director of the Edinburgh Academy.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-255"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-255-back"
    }
  }, [_vm._v("173")])]), _vm._v(". Probably the Newenhams of Coolmore near Cork to whom Mrs. Scott of Harden had introduced Walter and Jane. "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 80. They had visited Scotland in 1823. "), _c('i', [_vm._v("Diaries of Helen Graham")]), _vm._v(", pp. 29–31.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-256"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-256-back"
    }
  }, [_vm._v("174")])]), _vm._v(". Burns’s ‘Dedication to Gavin Hamilton’.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-257"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-257-back"
    }
  }, [_vm._v("175")])]), _vm._v(". Burn’s ‘Tam o’ Shanter’, ll. 51–2.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-258"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-258-back"
    }
  }, [_vm._v("176")])]), _vm._v(". It appears from the Walpole Collection that the schoolboy was called George Woods and wanted ‘a few lines on any subject’ for his ‘Yorkshire Magazine and Provincial Repository’, a more modest demand than that of the soldier, Joseph Wallace: ‘All I request of you is to apply to the Commander in chief I dare to say that you may know him.’ 5 and 11 December 1825, Walpole.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-259"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-259-back"
    }
  }, [_vm._v("177")])]), _vm._v(". Cervantes’ "), _c('i', [_vm._v("Don Quixote")]), _vm._v(", pt. ii, ch. 23.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-260"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-260-back"
    }
  }, [_vm._v("178")])]), _vm._v(". Since"), _c('i', [_vm._v(" The Heart of Mid-Lothian")]), _vm._v(" was extended from three to four volumes, to fulfil the contract for a four-volume second series of "), _c('i', [_vm._v("Tales of My Landlord")]), _vm._v(" (see Grierson, p. 164), the correspondent was a shrewder literary critic than Scott allows.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-261"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-261-back"
    }
  }, [_vm._v("179")])]), _vm._v(". The Great Duke is of course Wellington. Mons Meg, a huge fifteenth-century cannon, was returned to Edinburgh Castle in 1829 thanks to Scott’s efforts. See the Entry for 9 March 1829.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-262"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-262-back"
    }
  }, [_vm._v("180")])]), _vm._v(". See Addison’s "), _c('i', [_vm._v("Spectator")]), _vm._v(", no. 159.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-263"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-263-back"
    }
  }, [_vm._v("181")])]), _vm._v(". ‘He is not the God of the dead but the God of the living.’\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-264"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-264-back"
    }
  }, [_vm._v("182")])]), _vm._v(". Alexander Pringle junior, of Whytbank.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-265"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-265-back"
    }
  }, [_vm._v("183")])]), _vm._v(". William Allan (1782–1850), a ‘zealous cavalier & tory’ ("), _c('i', [_vm._v("Letters")]), _vm._v(", vii. 55) whose pictures on medieval and historical subjects Scott much admired. He became President of the Royal Scottish Academy in 1837, and was knighted in 1842.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-266"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-266-back"
    }
  }, [_vm._v("184")])]), _vm._v(". ‘The illness of the learned’, that is, depression, or ‘the Black Dog’ as Scott calls it elsewhere.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-267"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-267-back"
    }
  }, [_vm._v("185")])]), _vm._v(". ‘A hill-fort of a type occurring in Scotland… the stones of which have been converted into a vitreous substance by the action of fire.’ "), _c('i', [_vm._v("O. E. D")]), _vm._v(".\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-268"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-268-back"
    }
  }, [_vm._v("186")])]), _vm._v(". James Hogg (1770–1835), the ‘Ettrick Shepherd’, poet, and contributor to "), _c('i', [_vm._v("Blackwood’s")]), _vm._v(". He was introduced to Scott by Laidlaw and assisted in the collection of ballads for the "), _c('i', [_vm._v("Minstrelsy")]), _vm._v(". His personal vanity is well illustrated by his "), _c('i', [_vm._v("Domestic Manners of Sir")]), _vm._v(" "), _c('i', [_vm._v("Walter Scott")]), _vm._v(", 1834.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-269"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-269-back"
    }
  }, [_vm._v("187")])]), _vm._v(". David Thomson, a Galashiels weaver with a turn for poetry. "), _c('i', [_vm._v("Life")]), _vm._v(", vii.93.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-270"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-270-back"
    }
  }, [_vm._v("188")])]), _vm._v(". Sir James Melville, whose "), _c('i', [_vm._v("Memoirs")]), _vm._v(" was published by the Bannatyne Club in 1827.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-271"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-271-back"
    }
  }, [_vm._v("189")])]), _vm._v(". Burns’s ‘Address to the Unco Guid’, l. 40.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-272"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-272-back"
    }
  }, [_vm._v("190")])]), _vm._v(". Moore’s ‘Those evening Bells’ in "), _c('i', [_vm._v("National Airs")]), _vm._v(" (1815).\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-273"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-273-back"
    }
  }, [_vm._v("191")])]), _vm._v(". Charles Mathews (1776–1835) the comedian.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-274"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-274-back"
    }
  }, [_vm._v("192")])]), _vm._v(". Dr. Samuel Hibbert’s "), _c('i', [_vm._v("Sketches of the Philosophy of Apparitions, or an")]), _vm._v(" "), _c('i', [_vm._v("Attempt to trace such Illusions to their Physical Causes")]), _vm._v(", 1824. The second edition (1825) was dedicated to Scott.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-275"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-275-back"
    }
  }, [_vm._v("193")])]), _vm._v(". Banamhorar-Chat: Elizabeth, Lady Stafford (1765–1839) and Countess of Sutherland in her own right. Her Gaelic title means ‘The Great Lady of the Cat’. She was a fellow resident of George Square in Scott’s youth, and presented a set of colours to be carried in the ‘bickers’ described by Lockhart. "), _c('i', [_vm._v("Life")]), _vm._v(", i. 135–9.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-276"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-276-back"
    }
  }, [_vm._v("194")])]), _vm._v(". The Duke of Buccleuch’s sisters.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-277"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-277-back"
    }
  }, [_vm._v("195")])]), _vm._v(". The daughters of Baron Montagu, the Duke of Buccleuch’s uncle.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-278"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-278-back"
    }
  }, [_vm._v("196")])]), _vm._v(". See p. 91, n. 1.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-279"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-279-back"
    }
  }, [_vm._v("197")])]), _vm._v(". Margaret, the daughter of Scott’s old friend Mrs. Maclean Clephane.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-8-280"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-280-back"
    }
  }, [_vm._v("198")])]), _vm._v(". Their mother, Lady Alvanley, died in Edinburgh, and the arrangements for the funeral and the erection of a suitable monument were made by Scott.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-9-281"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-9-281-back"
    }
  }, [_vm._v("199")])]), _vm._v(". "), _c('i', [_vm._v("Coriolanus")]), _vm._v(", ii. 1.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-282"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-282-back"
    }
  }, [_vm._v("200")])]), _vm._v(". At this time eleven insurance companies had their head offices in Edinburgh. Scott was Governor of the Scottish Union, as well as Extraordinary Director of the Edinburgh Life Assurance Company of 24 George Street, referred to here.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-283"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-283-back"
    }
  }, [_vm._v("201")])]), _vm._v(". An allusion to i "), _c('i', [_vm._v("Henry IV")]), _vm._v(", ii. 1.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-284"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-284-back"
    }
  }, [_vm._v("202")])]), _vm._v(". "), _c('i', [_vm._v("Othello")]), _vm._v(", i.3.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-285"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-285-back"
    }
  }, [_vm._v("203")])]), _vm._v(". The Solicitor-General, John Hope.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-286"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-286-back"
    }
  }, [_vm._v("204")])]), _vm._v(". The first Viscount Melville (1742–1811), ‘the uncrowned King of Scotland’, whose rule by patronage stretched from 1783 until 1806. Throughout his tenure of different Cabinet posts he was, in effect, the arbiter on all Scottish affairs. Scott had been intimate with the family, through his friendship with the son, from an early age.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-287"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-287-back"
    }
  }, [_vm._v("205")])]), _vm._v(". Scott borrowed "), _c('i', [_vm._v("£")]), _vm._v("10,000 from Mr. Farie of Farme, paid "), _c('i', [_vm._v("£")]), _vm._v("3000 to John Moss’s daughter, Mrs. Stevenson of Melrose, to clear off the mortgage on Kaeside, and sank the remaining "), _c('i', [_vm._v("£")]), _vm._v("7000 in James Ballantyne & Coy. The money due to the Misses Ferguson was still unpaid when the crash came. Sederunt Book i. 71; ii. 127–8.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-288"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-288-back"
    }
  }, [_vm._v("206")])]), _vm._v(". "), _c('i', [_vm._v("Macbeth")]), _vm._v(", iv. 1.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-289"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-289-back"
    }
  }, [_vm._v("207")])]), _vm._v(". ‘As his custom is’. The point is that he arrives at or just before the dinner-hour.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-290"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-290-back"
    }
  }, [_vm._v("208")])]), _vm._v(". Robert Sym Wilson, W.S., Secretary to the Royal Bank of Scotland.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-291"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-291-back"
    }
  }, [_vm._v("209")])]), _vm._v(". As the Lockharts were now in London, Chiefswood, the small house on the Abbotsford estate which they used when in the country, was temporarily uninhabited. It was later let to Captain Hamilton.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-292"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-292-back"
    }
  }, [_vm._v("210")])]), _vm._v(". ‘But who is to guard the guardian herself?’ – an adaptation of Juvenal’s "), _c('i', [_vm._v("Satires")]), _vm._v(", vi. 347.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-293"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-293-back"
    }
  }, [_vm._v("211")])]), _vm._v(". Sir Samuel Shepherd (1760–1840). Before becoming Lord Chief Baron of the Court of Exchequer in Scotland he had been Attorney-General, and but for his deafness might have risen higher. He was a member of the Blair-Adam Club and a close, although not an early, friend of Scott’s. Scott sketches his character in the Entry for 20 December 1825.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-294"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-294-back"
    }
  }, [_vm._v("212")])]), _vm._v(". ‘That final day has come’ – a reminiscence of Virgil’s "), _c('i', [_vm._v("venit summa")]), _vm._v(" "), _c('i', [_vm._v("dies")]), _vm._v(" in "), _c('i', [_vm._v("Aeneid")]), _vm._v(", i. 118.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-295"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-295-back"
    }
  }, [_vm._v("213")])]), _vm._v(". As Clerk of Session and Sheriff of Selkirkshire respectively.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-296"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-296-back"
    }
  }, [_vm._v("214")])]), _vm._v(". The village between Abbotsford and Melrose.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-297"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-297-back"
    }
  }, [_vm._v("215")])]), _vm._v(". William Laidlaw (1780–1845), factor on the Abbotsford estate since 1816, and nephew of Scott’s first Sheriff-Substitute, Charles Erskine. Scott met him in his ballad-collecting days, and the friendship ripened with the years. Kaeside, on the hill above Abbotsford, was the frequent object of Scott’s walk, especially when there was politics to discuss, and the loss of Laidlaw was a cruel deprivation. Happily he was restored in 1829 when Purdie’s death left the estate without a manager. Laidlaw wrote a little in prose and verse, and acted as Scott’s amanuensis during his illness in 1819 and again in his declining months.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-298"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-298-back"
    }
  }, [_vm._v("216")])]), _vm._v(". See Introduction, pp. xliii–xliv.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-299"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-299-back"
    }
  }, [_vm._v("217")])]), _vm._v(". "), _c('i', [_vm._v("The Edinburgh Weekly Journal")]), _vm._v(". After the crash James Ballantyne continued to edit this paper and to manage the printing side of James Ballantyne and Coy.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-300"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-300-back"
    }
  }, [_vm._v("218")])]), _vm._v(". ‘Unknown superiors’.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-301"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-301-back"
    }
  }, [_vm._v("219")])]), _vm._v(". In the Entry for 13 December.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-302"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-302-back"
    }
  }, [_vm._v("220")])]), _vm._v(". Lady Scott.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-303"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-303-back"
    }
  }, [_vm._v("221")])]), _vm._v(". Scott’s authorship of the Waverley Novels was acknowledged at the meeting of his creditors a month later, although the better-known confession at the Theatrical Fund Dinner was not made until February 1827.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-304"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-304-back"
    }
  }, [_vm._v("222")])]), _vm._v(". Beaumont and Fletcher’s "), _c('i', [_vm._v("The Nice Valour")]), _vm._v(", iii. 3.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-305"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-305-back"
    }
  }, [_vm._v("223")])]), _vm._v(". ‘Ballad’ in Charles Dibdin’s "), _c('i', [_vm._v("Liberty Hall")]), _vm._v(".\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-306"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-306-back"
    }
  }, [_vm._v("224")])]), _vm._v(". ‘Kittle’ means ‘tricky’. Later events proved the truth of this prophecy. Constable’s creditors laid claim to "), _c('i', [_vm._v("Woodstock, The Life of")]), _vm._v(" "), _c('i', [_vm._v("Napoleon")]), _vm._v(", and the manuscripts of the novels.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-307"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-307-back"
    }
  }, [_vm._v("225")])]), _vm._v(". "), _c('i', [_vm._v("Don Quixote")]), _vm._v(", pt. ii, ch. 23.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-308"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-308-back"
    }
  }, [_vm._v("226")])]), _vm._v(". "), _c('i', [_vm._v("Life of Napoleon")]), _vm._v(", vol. ii, ch. 6.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-309"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-309-back"
    }
  }, [_vm._v("227")])]), _vm._v(". Hector Macdonald Buchanan.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-310"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-310-back"
    }
  }, [_vm._v("228")])]), _vm._v(". These figures are deleted in the original and ‘This was a mistake’ added in the margin.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-311"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-311-back"
    }
  }, [_vm._v("229")])]), _vm._v(". An allusion to Isaiah 52: 7.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-312"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-312-back"
    }
  }, [_vm._v("230")])]), _vm._v(". Scott had unsuccessfully wooed Williamina Belsches, who in January 1797 married Sir William Forbes. See "), _c('i', [_vm._v("Sir Walter Scott’s")]), _vm._v(" "), _c('i', [_vm._v("Congé")]), _vm._v(", by Lord Sands, third edition, 1931.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-313"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-313-back"
    }
  }, [_vm._v("231")])]), _vm._v(". By his marriage to Charlotte Carpenter on Christmas Eve 1797.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-314"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-314-back"
    }
  }, [_vm._v("232")])]), _vm._v(". The failure of John Ballantyne & Coy., Scott’s publishing house, was followed the next year by the success of "), _c('i', [_vm._v("Waverley")]), _vm._v(", the first of his novels.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-315"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-315-back"
    }
  }, [_vm._v("233")])]), _vm._v(". An allusion to Falstaff’s soliloquy,"), _c('i', [_vm._v(" 1 Henry IV")]), _vm._v(", v. 1.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-316"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-316-back"
    }
  }, [_vm._v("234")])]), _vm._v(". The ‘great counsell’ was James Scarlett (1769–1844), later Baron Abinger; his son was James Yorke Scarlett (1799–1871) who rose to the rank of major-general.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-317"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-317-back"
    }
  }, [_vm._v("235")])]), _vm._v(". The Lord President’s wife.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-318"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-318-back"
    }
  }, [_vm._v("236")])]), _vm._v(". A phrase from Anthony à Wood, much used by Monkbarns in"), _c('i', [_vm._v(" The")]), _vm._v(" "), _c('i', [_vm._v("Antiquary")]), _vm._v(" and by Scott himself.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-319"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-319-back"
    }
  }, [_vm._v("237")])]), _vm._v(". A new make of pen from Joseph Bramah of Piccadilly, the inventor of patent locks and pens.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-320"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-320-back"
    }
  }, [_vm._v("238")])]), _vm._v(". To his "), _c('i', [_vm._v("Miscellany")]), _vm._v(". See the Entry for 7 December and note. Scott wrote at once to Constable with the good news. "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 339.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-321"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-321-back"
    }
  }, [_vm._v("239")])]), _vm._v(". Charles James Mathews (1803–78), later known as a comic actor and adapter of plays. ‘On Tuesday we met the man of men – the great "), _c('i', [_vm._v("Well-Known")]), _vm._v(" – at James Ballantyne’s. Charles was all hopes, all fears. Ballantyne, with great kindness, placed him next Sir Walter at dinner’, wrote the elder Mathews to his wife."), _c('i', [_vm._v(" Memoirs of Mathews")]), _vm._v(", iii. 511. Scott invited father and son to visit Abbotsford when they had finished their Scottish engagements. They arrived on 11 January.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-322"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-322-back"
    }
  }, [_vm._v("240")])]), _vm._v(". A slip for James Smith (1775–1839), the wit, parodist and critic, joint-author with his brother Horace of "), _c('i', [_vm._v("Rejected Addresses")]), _vm._v(". Some of his sketches were actually written for the elder Mathews.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-323"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-323-back"
    }
  }, [_vm._v("241")])]), _vm._v(". George Colman the younger (1762–1836), dramatist and humorous poet.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-324"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-324-back"
    }
  }, [_vm._v("242")])]), _vm._v(". A slip for ‘weeks’. For the duel in which Boswell was killed see the Entry for 14 December 1826 and note.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-325"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-325-back"
    }
  }, [_vm._v("243")])]), _vm._v(". Henry Savary, a banker’s son in Bristol, recently tried for forgery.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-326"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-326-back"
    }
  }, [_vm._v("244")])]), _vm._v(". John Gay’s "), _c('i', [_vm._v("What d’ye call it")]), _vm._v(", sc. 8.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-327"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-327-back"
    }
  }, [_vm._v("245")])]), _vm._v(". William Erskine (1769–1822), the gentle, scholarly, retiring ‘little man of feeble make’ who had been one of Scott’s most intimate friends from 1792. He was raised to the Bench in 1822 as Lord Kinnedder, and died a few months later, snuffed out by unfounded rumours of immorality. See "), _c('i', [_vm._v("Life")]), _vm._v(", i. 279 and vi. 393.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-328"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-328-back"
    }
  }, [_vm._v("246")])]), _vm._v(". Gilbert Elliot, second Earl of Minto (1782–1859). He was a Whig and later First Lord of the Admiralty.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-329"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-329-back"
    }
  }, [_vm._v("247")])]), _vm._v(". Thomas Thomson (1768–1852) was the son of a clergyman and a brilliant graduate of Glasgow University. His bent for legal antiquarianism led him as Vice-president and later President of the Bannatyne Club to superintend the Club’s publications, thirteen of which he edited himself. As Deputy Clerk-Register he brought some order into the records of Scotland, many of which he also published for the first time. He was a member of the Blair-Adam Club and a brother of the Revd. John Thomson of Duddingston.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-330"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-330-back"
    }
  }, [_vm._v("248")])]), _vm._v(". Lord Minto’s mother-in-law, the widow of Patrick Brydone, author of "), _c('i', [_vm._v("A Tour through Sicily and Malta")]), _vm._v(", 1773.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-331"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-331-back"
    }
  }, [_vm._v("249")])]), _vm._v(". The daughter-in-law of Scott’s great friend William Adam of Blair-Adam.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-332"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-332-back"
    }
  }, [_vm._v("250")])]), _vm._v(". Gilbert, first Earl of Minto (1751–1814), Governor of Corsica 1794–6, an eyewitness of the Battle of St. Vincent, and Governor-General of India from1807 to 1813. A triumphal welcome had been prepared for him in Hawick, but the Earl died of a chill on the way from London.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-333"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-333-back"
    }
  }, [_vm._v("251")])]), _vm._v(". Thomas Campbell (1777–1844), the poet.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-334"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-334-back"
    }
  }, [_vm._v("252")])]), _vm._v(". Richard Savage (1697–1743), the subject of Dr. Johnson’s short "), _c('i', [_vm._v("Life")]), _vm._v(".\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-335"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-335-back"
    }
  }, [_vm._v("253")])]), _vm._v(". A slip for‘1812’.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-336"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-336-back"
    }
  }, [_vm._v("254")])]), _vm._v(". Sir Alexander Don (1751–1815), fifth baronet, of Newton Don near Kelso, at this time M. P. for Roxburghshire.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-337"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-337-back"
    }
  }, [_vm._v("255")])]), _vm._v(". The fourth Duke (1772–1819).\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-338"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-338-back"
    }
  }, [_vm._v("256")])]), _vm._v(". ‘See Canning’s "), _c('i', [_vm._v("German Play")]), _vm._v(", in the Anti-Jacobin.’ J. G. L.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-339"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-339-back"
    }
  }, [_vm._v("257")])]), _vm._v(". He had died on 1 December. Scott met him in Paris in 1815.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-340"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-340-back"
    }
  }, [_vm._v("258")])]), _vm._v(". He sent Jane a copy of ‘Bonny Dundee’ and received a characteristic reply: ‘Many thanks for the beautiful song you sent me, I am quite delighted with it and shall try to sing it as well as I can, although you know I am not very fond of performing in that way.’ 14 January 1826, Walpole. For the letter to Walter see "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 345.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-341"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-341-back"
    }
  }, [_vm._v("259")])]), _vm._v(". It is characteristic of Constable that his plan (abandoned because of his bankruptcy) should have been for a series ‘in a Superior stile’ and at double the usual price; equally characteristic of Cadell that the Magnum Opus which took its place should be a cheap edition for the mass market.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-342"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-342-back"
    }
  }, [_vm._v("260")])]), _vm._v(". James Ballantyne’s printing concern, in which Scott was a partner and for which a new edition would mean work and profit.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-343"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-343-back"
    }
  }, [_vm._v("261")])]), _vm._v(". The Taylor Johnson’s "), _c('i', [_vm._v("Musical Museum")]), _vm._v(", no. 490.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-344"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-344-back"
    }
  }, [_vm._v("262")])]), _vm._v(".‘(Will) a stranger (reap) these crops?’ Virgil’s "), _c('i', [_vm._v("Eclogues")]), _vm._v(", i. 71.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-345"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-345-back"
    }
  }, [_vm._v("263")])]), _vm._v(". ‘No divinity is lacking if we had prudence’ – an adaptation of Juvenal’s "), _c('i', [_vm._v("Satires")]), _vm._v(", x. 365.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-346"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-346-back"
    }
  }, [_vm._v("264")])]), _vm._v(". "), _c('i', [_vm._v("Candide")]), _vm._v(", ch. 30.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-347"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-347-back"
    }
  }, [_vm._v("265")])]), _vm._v(". "), _c('i', [_vm._v("The Memoirs of La Rochejacquelein")]), _vm._v(" was published as vol. v of Constable’s "), _c('i', [_vm._v("Miscellany")]), _vm._v(".\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-8-348"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-8-348-back"
    }
  }, [_vm._v("266")])]), _vm._v(". ‘Gil Morrice’, st. 7, in Percy’s "), _c('i', [_vm._v("Reliques")]), _vm._v(".\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-349"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-349-back"
    }
  }, [_vm._v("267")])]), _vm._v(". Christmas dinner at Mertoun, the seat of the Scotts of Harden, was ‘an engagement of 150 years standing when we are all in the County’. "), _c('i', [_vm._v("Letters")]), _vm._v(", xi. 448. With Christmas on a Sunday, however, the festivities this year were held on the 26th.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-350"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-350-back"
    }
  }, [_vm._v("268")])]), _vm._v(". James Clarkson, the doctor from Melrose.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-351"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-351-back"
    }
  }, [_vm._v("269")])]), _vm._v(". Scott’s butler. He continued to serve Scott after the crash and, unknown to Scott, recorded some of his experiences. See, for instance, notes 2–6, pp. 806–9.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-352"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-352-back"
    }
  }, [_vm._v("270")])]), _vm._v(". Job 2: 10.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-353"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-353-back"
    }
  }, [_vm._v("271")])]), _vm._v(". These were urgently required by Constable, as a letter to Ballantyne of the same date makes clear. "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 351.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-354"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-354-back"
    }
  }, [_vm._v("272")])]), _vm._v(". From Huntly Burn, where he was spending Christmas with his sisters.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-355"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-355-back"
    }
  }, [_vm._v("273")])]), _vm._v(". This too was urgent: it was to appear in the January "), _c('i', [_vm._v("Quarterly")]), _vm._v(", as the first article of Lockhart’s first number. Scott was working under the double handicap of his illness and of having left his copy of Pepys in Edinburgh. "), _c('i', [_vm._v("Letters")]), _vm._v(", ix. 358.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-356"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-356-back"
    }
  }, [_vm._v("274")])]), _vm._v(". "), _c('i', [_vm._v("As You Like It")]), _vm._v(", iv. 3.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-357"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-357-back"
    }
  }, [_vm._v("275")])]), _vm._v(". The Revd. George Thomson, son of the minister in Melrose, the original of Dominie Sampson, and formerly tutor to Scott’s sons. He had a wooden leg and an eccentric manner. ‘I hope he will not go utterly mad till I can get some hapless congregation for him’, wrote Scott in May 1826 ("), _c('i', [_vm._v("Letters")]), _vm._v(", x. 26) but repeated efforts to recommend his ‘very worthy friend George Thompson’ ("), _c('i', [_vm._v("Letters")]), _vm._v(", vii. 46), for whom he had a real regard, were in vain.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-358"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-358-back"
    }
  }, [_vm._v("276")])]), _vm._v(". ‘Losing’.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-359"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-359-back"
    }
  }, [_vm._v("277")])]), _vm._v(". In Scott’s day postage was paid by the recipient not the sender. The cost of a letter from London to Edinburgh was 13"), _c('i', [_vm._v("d")]), _vm._v(". Scott says elsewhere that unsolicited packages cost him "), _c('i', [_vm._v("£")]), _vm._v("100 a year. See the Entry for 6 January 1828.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-360"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-360-back"
    }
  }, [_vm._v("278")])]), _vm._v(". This abbreviation of ‘Sir Walter Scott’ was coined by Tom Purdie, who took it upon himself, when Scott became a baronet, to change the markings on the Abbotsford sheep from ‘WS’ to ‘SWS’. "), _c('i', [_vm._v("Life")]), _vm._v(", ix. 32.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-361"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-361-back"
    }
  }, [_vm._v("279")])]), _vm._v(". Burns’s ‘O Poortith Cauld and Restless Love’, ll. 11–12.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-362"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-362-back"
    }
  }, [_vm._v("280")])]), _vm._v(". "), _c('i', [_vm._v("A Spiritual Diary and Soliloquies")]), _vm._v(", by Dr. John Rutty (1698–1775).\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-363"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-363-back"
    }
  }, [_vm._v("281")])]), _vm._v(". To assist him with an article on Moore’s"), _c('i', [_vm._v(" Life of Sheridan")]), _vm._v(". Lockhart had written on the 25th asking for ‘what it wd cost you no trouble (certainly no reading) to throw off at once’. Letters, ix. 352n.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-364"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-364-back"
    }
  }, [_vm._v("282")])]), _vm._v(". See the entry for 24 December and note.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-365"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-365-back"
    }
  }, [_vm._v("283")])]), _vm._v(". Only the letter from Cork arrived on this day; the silver box came on 5 January.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-6-366"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-6-366-back"
    }
  }, [_vm._v("284")])]), _vm._v(". Queenstown.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-7-367"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-7-367-back"
    }
  }, [_vm._v("285")])]), _vm._v(". "), _c('i', [_vm._v("A Midsummer Night’s Dream")]), _vm._v(", v. 1.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-368"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-1-368-back"
    }
  }, [_vm._v("286")])]), _vm._v(". George Huntly Gordon was the son of Major Pryse Gordon, who showed Scott the field of Waterloo in 1815. Debarred by his deafness from becoming a minister of the Scottish Church as he had intended, he acted for many years as Scott’s amanuensis, copying the manuscript for the press to preserve the author’s anonymity and cataloguing his library. In 1826 Scott helped to procure him a post as assistant private secretary to the Secretary of the Treasury.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-369"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-369-back"
    }
  }, [_vm._v("287")])]), _vm._v(". The lawyer who transacted most of Scott’s local business. After the crash, the Trustees appointed him to supervise the day-to-day financial management of the estate.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-370"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-370-back"
    }
  }, [_vm._v("288")])]), _vm._v(". New Year’s Eve.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-371"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-371-back"
    }
  }, [_vm._v("289")])]), _vm._v(". Sir Adam Ferguson’s brother James.\n            ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-5-372"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-5-372-back"
    }
  }, [_vm._v("290")])]), _vm._v(". The Misses Ferguson.\n            ")])])])])])])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_110266-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_63"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_63"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_110266-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_63"
    }
  }), _c('p', {
    staticClass: "title-num"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_63"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847674951_tableofcontents"
    }
  }, [_c('i', [_vm._v("1826")])])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "rw-h2_110266-00001"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("JANUARY ")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110266-00001"
    }
  }, [_vm._v("1 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" A year has passd – another has commenced. These solemn divisions of time influence our feelings as they recur. Yet there is nothing in it – for every day in the year closes a twelve month as well as the 31st December. The latter is only the solemn pause as when a guide during a wild and mountainous road calls on a party to pause and look back at the scenes which they have just passd. To me this New Year opens sadly. There are these troublesome pecuniary difficulties which however I think this week should end. There is the absence of all my children, Anne excepted, from our little family festival. There is besides that ugly report of the 15 Hussars going to India. Walter I suppose will have some step in view and will go"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-373",
      "id": "num-footnote-1-373-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" and I fear Jane will not dissuade Him.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00002"
    }
  }, [_vm._v("A hard frosty day – cold but dry and pleasant under foot. Walkd into the plantations with Anne and Anne Russell. A thought strikes me allied to this period of the year. People say that the whole human frame in all its parts and divisions is gradually in the act of decaying and renewing. What a curious time-piece it would be that could indicate to us the moment this gradual and insensible change had so completely taken place that no atom was left of the original person who had existed at a certain period but there existed in his stead another person having the same limbs thewes and sinews, the same face and lineaments, the same consciousness – a new ship built on an old plank – A pair of transmigrated stockings like those of Sir John Cutler all green silk without one thread of the original black silk left! Singular – to be at once another and the same.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00001"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00003"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("2 MONDAY")]), _vm._v(" Weather"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-374",
      "id": "num-footnote-2-374-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" clearing up in Edinburgh once more and all will I believe do well. I am pressd to get on with "), _c('i', [_vm._v("Woodstock")]), _vm._v(" and must\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_64"
    }
  }, [_vm._v("try. I wish I could open a good vein of interest which would breathe freely. I must take my old way and write myself into goodhumour with my task. It is only when I dally with what I am about, look back and aside instead of keeping my eyes straight forward, that I feel these cold sinkings of the heart – All men I suppose do, less or more. They are like the sensation of a sailor when the ship is cleard for action and all are at their places – gloomy enough – but the first broadside puts all to rights.\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_64"
    }
  }, [_vm._v("`\n\n\n         "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00004"
    }
  }, [_vm._v("Dined at Huntlyburn with the Fergussons en masse.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00002"
    }
  })]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00005"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_64"
    }
  }, [_vm._v("3 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TUESDAY")]), _vm._v(" Promises a fair day and I think the progress of my labours will afford me a little exercize which I greatly need to help off the calomel feeling. Walkd with Colonel Russell from eleven till two, the first good day’s exercise I have had since coming here. We went through all the Terrace, the Roman planting, over by the Stell and Haxellcleuch"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-375",
      "id": "num-footnote-1-375-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" and so by the Rhymer’s glen to Chiefswood, which gave my heart a twinge so disconsolate it seemd. Yet all is for the best. Calld at Huntly Burn and shook hands with Sir Adam and his Lady just going off. When I returnd, signd the Bond for "), _c('i', [_vm._v("£")]), _vm._v("10,000 which will disencumber me of all pressing claims."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-376",
      "id": "num-footnote-2-376-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" When I get forwards "), _c('i', [_vm._v("W—k")]), _vm._v(" and "), _c('i', [_vm._v("Nap")]), _vm._v(". there will be "), _c('i', [_vm._v("£")]), _vm._v("12,000 and upwards, and I hope to add "), _c('i', [_vm._v("£")]), _vm._v("3000 against this time next year or the devil must hold [the] dice.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00006"
    }
  }, [_vm._v("J. B. writes me seriously on the carelessness of my style. I do not think I am more careless than usual but I dare say he is right. I will be more cautious.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00003"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00007"
    }
  }, [_vm._v("4 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" Despatchd the deed yesterday executed. Yesterday Mr. and Mrs. Skene, my excellent friends, came to us from Edinburgh."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-377",
      "id": "num-footnote-3-377-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Skene, distinguishd for his attainments as a draughtsman and for his highly gentlemanlike feelings and character, is Laird of Rubislaw near Aberdeen. Having had an elder brother his education was somewhat neglected in early life, against which disadvantage he made a most gallant [fight] exerting himself much to obtain those accomplishments which [he] has since possessed. Admirable in all exercises there enterd a good deal of the cavalier into his early character. Of late he has given himself much to the study of antiquities. His wife, a most excellent person, was tenderly fond of Sophia. They bring so much oldfashioned kindness and good humour with them, besides the\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_65"
    }
  }, [_vm._v("recollections of other times, that they must be always wellcome guests. Letter from Mr. Scrope"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-378",
      "id": "num-footnote-1-378-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" announcing a visit.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00004"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00008"
    }
  }, [_vm._v("5 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THURSDAY")]), _vm._v(" Got the desired accomodation with Coutts which will put J. B. quite straight but am a little anxious still about Constable. He has immense stock to be sure and most valuable but he may have sacrifices to make to convert a large proportion of it into ready money. The accounts from London are most disastrous – many wealthy persons totally ruind and many many more have been obliged to purchase their safety at a price they will feel all their lives. I do not hear things are so bad in Edinburgh and J. B.’s business has been transacted by the Banks with liberality."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-379",
      "id": "num-footnote-2-379-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00009"
    }
  }, [_vm._v("Colonel Russell told us last night that the Last of the Moguls, a descendant of Kubla Khan though having no more power than his effigies at the back of a set of playing-cards, refused to meet Lord Hastings because the Governor General would not agree to remain standing in his presence. Pretty well for the blood of Timur in these degenerate days.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00010"
    }
  }, [_vm._v("Much alarmed. I had walkd till twelve with Skene and Colonel Russell and then sate down to my work. To my horror and surprize I could neither write nor spell but put down one word for another and wrote nonsense."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-380",
      "id": "num-footnote-3-380-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" I was much overpowerd at the same time and could not conceive the reason. I fell asleep however in my chair and slept for two hours. On waking my head was clearer and I began to recollect that last night I had taken the anodyne left for the purpose by Clarkson and being disturbd in the course of the night I had not slept it off.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00011"
    }
  }, [_vm._v("Received from the Corporation of Corke a very handsome silver snuff box with my freedom of that ancient city – Obliged to give up writing to-day – read Pepys"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-381",
      "id": "num-footnote-4-381-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" instead.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00012"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_66"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_66"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_c('br')])]), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110266-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_66"
    }
  }, [_vm._v("The Scotts of Harden were to have dined but sent an apology storm coming on. Russells left us this morning to go to Haining."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-382",
      "id": "num-footnote-1-382-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00005"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00013"
    }
  }, [_vm._v("6 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("FRIDAY")]), _vm._v(" This seems to be a feeding storm – coming on by little and little. Wrought all day and dined quiet. My disorder is wearing off and the quiet society of the Skenes suits with my present humour. I really thought I was in for some very bad illness. Curious expression of an Indian-born boy just come from Bengal, a son of my cousin George Swinton."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-383",
      "id": "num-footnote-2-383-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" The child saw a hare run across the fields and exclaimd ‘See there is a little tiger.’\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00006"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("7"), _c('span', {
    staticClass: "sc"
  }, [_vm._v(" SATURDAY")]), _vm._v(" Sunday."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-384",
      "id": "num-footnote-3-384-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Knight,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-385",
      "id": "num-footnote-4-385-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" a young artist, son of the performer, came to paint my picture at the request of Terry"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-386",
      "id": "num-footnote-5-386-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" – This is very far from being agreeable as I submitted to this distressing state of constraint last year"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-6-387",
      "id": "num-footnote-6-387-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" – to Newton"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-7-388",
      "id": "num-footnote-7-388-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" at request of Lockhart, Leslie"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-8-389",
      "id": "num-footnote-8-389-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" at request of my American friend,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-9-390",
      "id": "num-footnote-9-390-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Wilkie for his picture of the King’s arrival at Holy Rood House"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-10-391",
      "id": "num-footnote-10-391-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" and some one beside. I am as tired of the operation as old Maida"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-11-392",
      "id": "num-footnote-11-392-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" who had been so often sketchd that he got up and went away with signs of Loathing whenever he saw an artist unfurl his paper and handle his brushes. But this young man is civil and modest and I have agreed he shall sit in the room while I work and ta125ke the best likeness he can without compelling me into forced attitudes or the yawning fatigues of an actual sitting. I think if he has talent he may do more my way than in the customary mode – at least I cannot have the hangdog look which the unfortunate Theseus has who is doomd to sit for what seems an eternity."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-393",
      "id": "num-footnote-1-393-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00014"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_67"
    }
  }, [_vm._v("I wrought till two o’clock, indeed till I was almost nervous with correcting and scribbling. I then walkd or rather was dragd through the snow by Tom Purdie while Skene accompanied. What a blessing there is in a man like Tom whom no familiarity can spoil, whom you may scold and praise and joke with, knowing the quality of the man is unalterable in his love and reverence to his master. Use an ordinary servant in the same way and he will be your master in a month.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_67"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_110266-00015"
    }
  }, [_vm._v("We should thank God for the snow as well as summer-flowers. This brushing exercize has put all my nerves into tone again which were really jard with fatigue untill my very back-bone seemd breaking. This comes of trying to do too much.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00016"
    }
  }, [_vm._v("J.B.’ s news are as good as possible – prudence – prudence and all will do excellently.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00007"
    }
  })]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00017"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_67"
    }
  }, [_vm._v("8 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" Frost and snow still. Wrote to excuse myself from attending the funeral of my aunt Mrs. Curl which takes place tomorrow at Kelso. She was a woman of the old Sandyknow breed with the strong sense, high principle and indifferent temper which belongd to my father’s family. She lived with great credit on a moderate income and I believe gave away a great deal of it."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-394",
      "id": "num-footnote-2-394-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00008"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00018"
    }
  }, [_vm._v("9 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MONDAY")]), _vm._v(" Matthews the Comedian and his son came to spend a day at Abbotsford."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-395",
      "id": "num-footnote-3-395-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" The last is a clever young man with much of his father’s talent for mimicry. Rather forward though."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-396",
      "id": "num-footnote-4-396-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" Mr. Scrope also came out which fills our house.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00019"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_68"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_68"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00009"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00020"
    }
  }, [_c('span', [_vm._v("10 ")]), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TUESDAY")]), _vm._v(" Bodily Health, the mainspring of the microcosm, seems quite restored. No more flinching or nervous fits but the sound mind in the sound body. What poor things does a fever fit or an overflowing of the bile make of the master of creation.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110266-00002"
    }
  }, [_vm._v("The snow begins to fall thick this morning.")])]), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_68"
    }
  }, [_c('p', [_vm._v("The Landlord then aloud did say")])]), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_68"
    }
  }, [_vm._v("As how he wishd they would go away."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-397",
      "id": "num-footnote-1-397-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110266-00002"
    }
  }, [_vm._v("To have our friends shut up here would be rather too much of a good thing.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00021"
    }
  }, [_vm._v("The day cleard up and was very pleasant. Had a good walk and lookd at the curling. Mr. Matthews made himself very amusing in the evening. He has the goodnature to show his accomplishments without pressing and without the appearance of feeling pain. On the contrary I dare say he enjoys the pleasure he communicates."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-398",
      "id": "num-footnote-2-398-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00010"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00022"
    }
  }, [_vm._v("11 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" I got proof Sheets in which it seems I have repeated a whole passage of history which had been told before. James is in an awful stew and I cannot blame him. But then he should consider the hyasymus"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-399",
      "id": "num-footnote-3-399-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" which I was taking and the anxious botheration about the money market. However as Chaucer says\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00002"
    }
  }, [_c('p', [_vm._v("There is na workeman")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("That can bothe wirken wel and hastilie")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("This must be done at leisure parfaitly."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-400",
      "id": "num-footnote-4-400-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00023"
    }
  }, [_vm._v("Matthews, his son, Scrope and the Skenes still our guests.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00011"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00024"
    }
  }, [_vm._v("12 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THURSDAY")]), _vm._v(" Mathews last night gave us a very perfect imitation of Old Cumberland who carried the poetic jealousy and irritabi [lity] further than any man I ever saw."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-401",
      "id": "num-footnote-5-401-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" He was a great flatterer too, the old rogue. Will Erskine used to admire him. I think he wanted originality – a very high bred man in point of manners in Society.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00025"
    }
  }, [_vm._v("My little artist Knight gets on better with his portrait – the features are however too pinchd I think.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00027"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_69"
    }
  }, [_vm._v("Upon the matter, the days pass pleasantly enough – work till one or two, then an hour or two hours’ walk in the snow, then lighter work or reading. Late dinner"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-402",
      "id": "num-footnote-1-402-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v(" and singing or chat in the evening. Matthews has really all the will as well as the talent to be amusing. He confirms my idea of ventriloquism (which is an absurd word) as being merely the art of imitating sounds at a greater or less distance assisted by some little points of trick [ery] to influence the imagination of the audience. The vulgar idea of a peculiar organization (beyond fineness of ear and of utterance) is nonsense.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00012"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00028"
    }
  }, [_vm._v("13 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("FRIDAY")]), _vm._v(" Our party are about to disperse.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00003"
    }
  }, [_c('p', [_vm._v("Like youthful steers unyoked east north and south."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-403",
      "id": "num-footnote-2-403-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110266-00003"
    }
  }, [_vm._v("I am not sorry, being one of those whom too much mirth always inclines to sadness – the missing so many of my own family together with the serious inconveniences to which I have been exposed gave me at present a desire to be alone. The Skenes return to Edinburgh. So does Mr. Scrope – item the little artist – Matthews to New Castle, his son to Liverpool"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-404",
      "id": "num-footnote-3-404-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" – So "), _c('i', [_vm._v("exeunt omnes")]), _vm._v(".\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00029"
    }
  }, [_vm._v("Mathews assures me that Sheridan was generally very dull in society and sate sullen and silent swallowing glass after glass rather a hindrance than a help. But there was a time when he broke out with a resumption of what had been going on done with great force and generally attacking some person in the company or some opinion which he had expressd. I never saw Sheridan but in large parties. He had a Bardolph countenance with heavy features but his eye possessd the most distinguishd brilliancy. Mathews says it is very simple in Tom Moore to admire how Sheridan came by the means of paying the price of Drury Lane Theatre when all the world knows he never paid it at all and that Lacy who sold it was reduced to want by his breach of faith."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-405",
      "id": "num-footnote-4-405-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00030"
    }
  }, [_vm._v("Dined quiet with Anne, Lady Scott, and Gordon.")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00031"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_70"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_70"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00013"
    }
  })]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00032"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_70"
    }
  }, [_vm._v("14 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SATURDAY")]), _vm._v(" An odd mysterious letter from Constable who is gone post to London to put something to rights which is wrong betwixt them, their banker and another monied friend. It strikes me to be that sort of letter which I have seen men write when they are desirous that their disagreeable intelligence should be rather apprehended than avowd. I thought he had been in London a fortnight ago disposing of property to meet this exigence and so I think he should. Well – I must have patience. But these tirrits and frights"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-406",
      "id": "num-footnote-1-406-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" are truly annoying. Luckily the funny people are gone and I will not have the task of grinning when I am serious enough.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00033"
    }
  }, [_vm._v("Dined as yesterday.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00034"
    }
  }, [_vm._v("A letter from J. B. mentioning Constable’s journey but without expressing much if any apprehension. He knows C. well and saw him before his departure and makes no doubt of his being able easily to extricate whatever may be entangled. I will not therefore make myself more uneasy than I can help doing so surely if I will. At least I have given up segars since the year began and have now no wish to return to the habit as it is calld. I see no reason why one should not be able to vanquish with God’s assistance these noxious thoughts which foretell evil but cannot remedy it.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00014"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00035"
    }
  }, [_vm._v("15 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" Like yesterday a hard frost – thermometer at 10 yesterday was at 8½ to-day 12."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-407",
      "id": "num-footnote-2-407-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" Water in my dressing room frozen to flint. Yet I had a fine walk yesterday, the sun shining delightfully on ‘grim nature’s visage hoar’."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-408",
      "id": "num-footnote-3-408-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" Were it not the plague of being dragd along by another person I should like this weather as well as summer. But having Tom Purdie to do this office reconciles me to it – "), _c('i', [_vm._v("I cannot")]), _vm._v(" "), _c('i', [_vm._v("cleik")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-409",
      "id": "num-footnote-4-409-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('i', [_vm._v("with John")]), _vm._v(" as old Mrs. Muir used to say. I mean that an ordinary Menial servant thus hookd to your side reminds me of the twin bodies mentiond by Pitscottie"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-410",
      "id": "num-footnote-5-410-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" being two trunks on the same waist and legs. One died before the other and remaind a dead burthen on the back of its companion. Such is the close union with a person whom you cannot well converse with and whose presence is yet indispensible to your getting on. An actual companion whether humble or your equal is still worse. But T. Purdie is just the thing, kneaded up between the\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_71"
    }
  }, [_vm._v("friend and servant as well as Uncle Toby’s Bowling Green"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-411",
      "id": "num-footnote-1-411-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" between sand and clay. You are certain he is proud as well as patient under his burthen and you are under no more constraint than with a poney. I must ride him to-day if the weather holds up. Meantime I will correct that curious fellow Pepys’ "), _c('i', [_vm._v("Diary")]), _vm._v(", I mean the article I have made of it for the "), _c('i', [_vm._v("Quarterly")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-412",
      "id": "num-footnote-2-412-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00015"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00036"
    }
  }, [_vm._v("16 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MONDAY")]), _vm._v(" Came through cold roads to as cold news. Hurst and Robinson have sufferd a Bill of "), _c('i', [_vm._v("£")]), _vm._v("1000 to come back on Constable which I suppose infers the ruin of both houses. We will soon see. Constable it seems, who was to have set off in the last week of December, dawdled here till in all human probability his going or staying became a matter of mighty little consequence. He could not be there till Monday night and his resources must have come too late. Dined with the Skenes."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-413",
      "id": "num-footnote-3-413-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00016"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00037"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("17 TUESDAY")]), _vm._v(" James Ballantyne this morning, good honest fellow, with a visage as black as the crook. He hopes no salvation, has indeed taken measures to stop. It is hard after having fought such a battle. Have apologised attending the R. Society Club who have a Gaudeamus on this day and seemd to count much on my being the Praeses –\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00038"
    }
  }, [_vm._v("My old acquaintance Miss Eliz. Clerk, sister of Willie, dead suddenly. I cannot chuse but wish it had been S. W. S. and yet the feeling is unmanly. I have Anne, my wife, and Charles to look "), _c('a', {
    attrs: {
      "id": "pb-rw_72"
    }
  }, [_vm._v("after. I felt rather sneaking as I came home from the P. House,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-414",
      "id": "num-footnote-1-414-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" felt as if I were liable "), _c('i', [_vm._v("Monstrari digito")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-415",
      "id": "num-footnote-2-415-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" in no very pleasant way. But this must be born "), _c('i', [_vm._v("cum caeteris")]), _vm._v(", and thank God however uncomfortable I do not feel despondent.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00039"
    }
  }, [_vm._v("I have seen Cadell Ballantyne and Hogarth."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-416",
      "id": "num-footnote-3-416-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" All advise me to execute a trust of my property for payment of my obligations. So does John Gibson"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-417",
      "id": "num-footnote-4-417-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" and so I resolve to do. My wife and daughter are gloomy but yet patient. I trust by my hold on the works to make it every man’s interest to be very gentle with me. Cadell makes it plain that by patience they will in six months realize "), _c('i', [_vm._v("£")]), _vm._v("20,000, which can be attainable by no effort of their own.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00017"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00040"
    }
  }, [_vm._v("18 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" He that sleeps too long in the morning let him borrow the pillow of a debtor. So says the Spaniard and so say I. I had of course an indifferent night of it. I wish these two days were over. But the worst is over. The Bank of Scotland has behaved very well, expressing a resolution to serve Constable’s house and me to the uttermost, but as no one can say to what extent Hurst and Robinson’s failure may go borrowing would but linger it out."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-418",
      "id": "num-footnote-5-418-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00018"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00041"
    }
  }, [_vm._v("19 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THURSDAY")]), _vm._v(" During yesterday I received several visits from friends. Skene, Colin McKenzie, who I am glad to see looks well, with every offer of Service. The Royal Bank also sent Sir John Hope and Sir H. Jardine"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-6-419",
      "id": "num-footnote-6-419-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" to offer to comply with my wishes. The advocate"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-7-420",
      "id": "num-footnote-7-420-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" came on the same errand. But I gave all the same answer that my intention was to put the whole into the hands of a trustee and to be contented with the event, and that all I had to ask was time to do so and to extricate my affairs. I was assured of every accomodation in this way. From all quarters I have had the same kindness. Letters from Constable and Robinson have arrived. The last persist in saying they will pay all and every body. They say moreover in a postscript that had Constable been in town ten days sooner all would have been well. When I saw him on 24th December he proposed starting in three days, but dallied God knows why in a kind of infatuation I think till things had got irretrieveably wrong. There would have been no want of support here and his stock under his own management would have made a return immensely greater than it can under any other. "), _c('i', [_vm._v("Now")]), _vm._v(" I fear the loss must be great as his fall will involve many of the country dealers who traded with him.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110266-00003"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_73"
    }
  }, [_vm._v("I feel quite composed and determined to labour. There is no remedy. I guess (as Mathews makes his Yankees say) that we shall not be troubled with visitors and I "), _c('i', [_vm._v("calculate")]), _vm._v(" that I will not go out at all so what can I do better than labour? Even yesterday I went about making notes on "), _c('i', [_vm._v("Waverley")]), _vm._v(" according to Constable’s plan."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-421",
      "id": "num-footnote-1-421-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")]), _vm._v(" It will do good one day. To-day when I lock this volume I go to "), _c('i', [_vm._v("W—k")]), _vm._v(". Heigho –\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00043"
    }
  }, [_vm._v("Knight came to stare at me to complete his portrait. He must have read a tragic page comparative to what he saw at Abbotsford.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00044"
    }
  }, [_vm._v("We dined of course at home, and before and after dinner I finish about 20 printed pages of "), _c('i', [_vm._v("Woodstock")]), _vm._v(" but to what effect others must judge. A painful scene after dinner and another after supper endeavouring to convince these poor dear creatures that they must not look for miracles but consider the misfortune as certain and only to be lessend by patience and labour.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00019"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00045"
    }
  }, [_vm._v("20 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("FRIDAY")]), _vm._v(" Indifferent night – very bilious which may be want of exercize. A letter from Sir J. Sinclair whose absurd vanity leads him to thrust his finger into everyman’s pie proposing that the Hurst and Robinson should sell their prints, of which he says they have a large collection, by way of lottery like Boydell."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-422",
      "id": "num-footnote-2-422-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00004"
    }
  }, [_c('p', [_vm._v("In scenes like these which break our heart")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("Comes Punch like you and lets a f—."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-423",
      "id": "num-footnote-3-423-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00046"
    }
  }, [_c('i', [_vm._v("Mais pourtant cultivons notre jardin")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-424",
      "id": "num-footnote-4-424-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" The publick favour is my only lottery. I have long enjoyd the foremost prize and something in my breast tells me my Evil Genius will not overwhelm me if I stand by myself. Why should I not? I have no enemies – many attachd friends –\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_74"
    }
  }, [_vm._v("the popular ascendancy which I have maintaind is of the kind which is rather improved by frequent appearances before the public. In fact Critics may say what they will but ‘"), _c('i', [_vm._v("hain")]), _vm._v(" your reputation and "), _c('i', [_vm._v("tyne")]), _vm._v(" your reputation’"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-425",
      "id": "num-footnote-1-425-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")]), _vm._v(" is a true proverb.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00047"
    }
  }, [_vm._v("Sir William Forbes"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-426",
      "id": "num-footnote-2-426-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" calld, the same kind honest friend as ever, with all offers of assistance etc. etc. etc. All anxious to serve me and careless about their own risk of loss – And these are the cold, hard, money making men whose questions and Controul I apprehended.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00048"
    }
  }, [_vm._v("Lord Ch: Commissioner Adam"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-427",
      "id": "num-footnote-3-427-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" also came to see me and the meeting though pleasing was melancholy. It was the first time we have met since the "), _c('i', [_vm._v("break-up")]), _vm._v(" of his hopes in the death of his eldest son"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-428",
      "id": "num-footnote-4-428-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" on his return from India where [he] was Chief in Council and highly esteemd. Lord C. C. is not a very early friend of mine for I scarce knew him till his settlement in Scotland with his present office. But I have since lived much with him and taken kindly to him as one of the most pleasant, kind hearted, benevolent and pleasing men I have ever known. It is high treason among the Tories to express regard for him or respect for the Jury Court in which he prescribes. I was against that experiment as much as any one. But it is an experiment, and the establishment (which the fools will not perceive) is the onlything which I see likely to give some prospects of ambition to our bar which has been diminishd otherwise so much. As for the Chief Commissioner I dare say he jobs as all other people of consequence\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_75"
    }
  }, [_vm._v("do in elections and so forth. But he is the personal friend of the King and the decided enemy of whatever strikes at the constitutional rights of the Monarch. Besides I love him for the various changes which he has endured through life and which have been so great as to make him entitled to be regarded in one point of view as the most fortunate in the other the most unfortunate man in the world. He has gaind and lost two fortunes by the same good fortune and the same rash confidence which has raised and now threatens my "), _c('i', [_vm._v("peculium")]), _vm._v(". And his quiet, noble and generous submission under circumstances more painful than mine, for the loss of world’s wealth was aggravated by the death of his youngest and darling son in the West Indies, furnishd me at the time and now with a noble example – So the Tories and Whigs may go be damnd together as names that have distracted Old Scotland and torn asunder the most kindly feelings since the first day they were invented. Yetd—nthem they are spells to rouse all our angry passions, and I dare say notwithstanding the opinion of my private and calm moments I will open on the cry again so soon as something occurs to chafe my mood. And yet God knows I would fight in honourable contest with word or blow for my political opinions but I cannot permit that strife to ‘mix its waters with my daily meal’,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-429",
      "id": "num-footnote-1-429-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")]), _vm._v(" those waters of bitterness which poison all mutual love and confidence betwixt the well disposed on each side, and prevent them if need were from making mutual concessions and balancing the constitution against the Ultras of both parties. The good man seems something broken by these aflictions.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00020"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-cont_110266-00008"
    }
  }, [_vm._v("21 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SATURDAY")]), _vm._v(" Susannah in "), _c('i', [_vm._v("Tristram Shandy")]), _vm._v(" thinks Death is best met in bed."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-430",
      "id": "num-footnote-2-430-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" I am sure trouble and vexation is not. The watches of the night pass wearily when disturbd by fruitless regrets and disagreeable anticipations. But let it pass.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00005"
    }
  }, [_c('p', [_vm._v("Well Goodman Time or blunt or keen")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("Move thou quick or take thy leisure")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("Longest day will have its een")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("Weariest life but treads a measure."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-431",
      "id": "num-footnote-3-431-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00049"
    }
  }, [_vm._v("I have seen Caddell"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-432",
      "id": "num-footnote-4-432-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" who is very much downcast for the risque of their copy-rights being thrown away by a hasty sale. I suggested that if they went very cheap some means might be fallen on to keep up their\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_76"
    }
  }, [_vm._v("value or purchase them in. I fear the split betwixt Constable and Caddell"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-433",
      "id": "num-footnote-1-433-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")]), _vm._v(" will render impossible what might otherwise be hopeful enough. It is the Italian race-horses, I think, which instead of riders have spurs tied to their sides so as to prick them into a constant gallop. Caddell tells me their gross profit was sometimes "), _c('i', [_vm._v("£")]), _vm._v("10,000 a year but much swallowd up with expences and his partner’s draugh [t] s which came to "), _c('i', [_vm._v("£")]), _vm._v("4000 yearly. What there is to show for this God knows. Constable’s apparent expences were very much within bounds.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00050"
    }
  }, [_vm._v("Colin McKenzie enterd and with his usual kindness engages to use his influence to recommend some moderate proceeding to Constable’s crers which may permit him to go on and turn that species of property to account which no man alive can manage so well as he."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-434",
      "id": "num-footnote-2-434-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00051"
    }
  }, [_vm._v("Followd Mr. Gibson with a most melancholy tale. Things are so much worse with Constable than I apprehended that I shall neither save Abbotsford nor any thing else – Naked we enterd the world and naked we leave it. Blessed be the name of the Lord."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-435",
      "id": "num-footnote-3-435-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00021"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110266-00004"
    }
  }, [_c('span', [_vm._v("22 ")]), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" I feel neither dishonourd nor broken down by the bad – miserably bad news I have received. I have walkd my last on the domains I have planted, sate the last time in the halls I have built. But death would have taken them from me if misfortune had spared them. My poor people whom I loved so well!! There is just another dye to turn up against me in this run of ill luck – i.e. If I should break my magic wand in a fall from this elephant and lose my popularity with my fortune. Then "), _c('i', [_vm._v("Woodstock")]), _vm._v(" and "), _c('i', [_vm._v("Boney")]), _vm._v(" may both go to the papermaker and I may take to smoking cigars and drinking grog or turn devotee and intoxicate the brain another way. In prospect of absolute ruin I wonder if they would let me leave the Court of Session. I should like methinks to go abroad\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00052"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_77"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_77"
    }
  }), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00006"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_77"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_77"
    }
  }, [_vm._v("And lay my banes far from the Tweed."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-436",
      "id": "num-footnote-1-436-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00053"
    }
  }, [_vm._v("But I find my eyes moistening and that will not do. I will not yield without a fight for it. It is odd, when I set myself to work "), _c('i', [_vm._v("doggedly")]), _vm._v(" as Dr. Johnson would say,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-437",
      "id": "num-footnote-2-437-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" I am exactly the same man that I ever was – neither low spirited nor "), _c('i', [_vm._v("distrait")]), _vm._v(". In prosperous times I have sometimes felt my fancy and powers of language flag – but adversity is to me at least a tonic and bracer – the fountain is awakend from its inmost recesses as if the spirit of afliction had troubled it in his passage.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00054"
    }
  }, [_vm._v("Poor Mr. Pole the harper sent to offer me "), _c('i', [_vm._v("£")]), _vm._v("500 or "), _c('i', [_vm._v("£")]), _vm._v("600, probably his all."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-438",
      "id": "num-footnote-3-438-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" There is much good in the world after all. But I will involve no friend either rich or poor – My own right hand shall do it – Else will I be "), _c('i', [_vm._v("done")]), _vm._v(" in the slang language and "), _c('i', [_vm._v("undone")]), _vm._v(" in common parlance.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00055"
    }
  }, [_vm._v("I am glad that beyond my own family, who are excepting L. S."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-439",
      "id": "num-footnote-4-439-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" young and able to bear sorrow of which this is the first taste to some of them, most of the hearts are past aching which would have been inconsolable on this occasion. I do not mean that many will not seriously regret and some perhaps lament my misfortunes. But my dear mother, my almost sister Christy R—d,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-440",
      "id": "num-footnote-5-440-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" – poor Will: Erskine – these would have been mourners indeed –\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00056"
    }
  }, [_vm._v("Well – exertion – exertion – O Invention rouze thyself. May man be kind – may God be propitious. The worst is I never quite know when I am right or wrong and Ballantyne, who does know in some degree, will fear to tell me. Lockhart would be worth gold just now but he too would be too diffident to speak broad out. All my hope is in the continued indulgence of the public.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00057"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_78"
    }
  }, [_vm._v("I have a funeral letter to the burial of the Chevalier Yelin, a foreigner of learning and talent, who has died at the Royal Hotel. He wishd to be introduced to me and was to have read a paper before the Royal Society when this introduction was to have taken place. I was not at the society that evening"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-441",
      "id": "num-footnote-1-441-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")]), _vm._v(" and the poor gentleman was taken ill in the meeting and unable to proceed. He went to his bed and never arose again – and now his funeral will be the first public place that I shall appear at – he dead and I ruind. This is what you call a meeting.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00022"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00058"
    }
  }, [_vm._v("23 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MONDAY")]), _vm._v(" Slept ill not having been abroad these eight days. "), _c('i', [_vm._v("Splendida bilis")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-442",
      "id": "num-footnote-2-442-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" Then a dead sleep in the morning and when the awakenings came a strong feeling how well I could dispence with it for once and for ever. This passes away however as better and more dutiful thoughts arise in my mind.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00059"
    }
  }, [_vm._v("I know not if my imagination has flaggd – probably it has but at least my powers of labour have not diminishd during the last melancholy week. On Monday and tuesday my exertions were suspended. Since Wednesday inclusive I have written thirty eight of my close manuscript pages of which seventy make a volume of the usual novel size.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00060"
    }
  }, [_vm._v("Wrote till twelve a.m. finishing half of what I call a good day’s work, ten pages of print or rather twelve. Then walkd in the Princes Street pleasure grounds"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-443",
      "id": "num-footnote-3-443-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" with good Samaritan James Skene,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-444",
      "id": "num-footnote-4-444-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" the only\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_79"
    }
  }, [_vm._v("one among my numerous friends who can properly be termd "), _c('i', [_vm._v("amicus")]), _vm._v(" "), _c('i', [_vm._v("omnium horarum")]), _vm._v(","), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-445",
      "id": "num-footnote-1-445-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")]), _vm._v(" others being too busy or too gay and several being estranged by habit. The walks have been conducted on the whole with much taste though Skene has undergone much criticism,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-446",
      "id": "num-footnote-2-446-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" the usual reward of public exertions, on account of his plans. It is singular to walk close beneath the grim old Castle and think what scenes it must have seen and how many generations of three score and ten have risen and past away. It is a place to cure one of too much sensation over earthly subjects of mutation. My wife and girl’s tongues are chatting in a lively manner in the drawing-room. It does me good to hear them.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00023"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00061"
    }
  }, [_vm._v("24 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TUESDAY")]), _vm._v(" Constable came yesterday and saw me for half an hour. He seemd irritable but kept his temper under command. Was a little shockd when I intimated that I was disposed to regard the present works in progress as my own. I think I saw two things – 1. That he is\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_80"
    }
  }, [_vm._v("desirous to return in to the management of his own affairs without Cadell if he can. 2. That he relies on my connexion as the way of helping us out of the slough. Indeed he said he was ruind utterly without my countenance. I certainly will befriend him if I can but Constable without Cadell is like getting the clock without the pendulum – the one having the ingenuity – the other the caution of the business – I will see my way before making any bargain, and I will help them I am sure if I can without endangering my last cast for freedom. Workd out my task yesterday.\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_80"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_110266-00062"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_80"
    }
  }, [_vm._v("My kind friend Mrs. Coutts has got the cadetship for Pringle Shortreed"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-447",
      "id": "num-footnote-1-447-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")]), _vm._v(" in which I was peculiarly interested.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00063"
    }
  }, [_vm._v("I went to the Court for the first time to-day and like the man with the large nose thought everybody was thinking of me and my mishaps. Many were undoubtedly and all rather regrettingly, some obviously affected. It is singular to see [the] difference of men’s manner whilst they strive to be kind or civil in their way of addressing me. Some smiled as they wishd me good day as if to say ‘Think nothing about it my lad; it is quite out of our thoughts –’ Others greeted me with the affected gravity which one sees and despises at a funeral. The best-bred, all I believe meaning equally well, just shook hands and went on."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-448",
      "id": "num-footnote-2-448-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00064"
    }
  }, [_vm._v("A foolish puff in the papers calling on men and gods to assist a popular author who having choused the public of many thousands had not the sense to keep wealth when he had it.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00065"
    }
  }, [_vm._v("If I am hard pressd and measures used against me I must use all measures of legal defence and subscribe myself bankrupt in a petition for sequestration. It is the course I would have advised a client to take and would have the effect of saving my land, which is secured by my "), _c('a', {
    attrs: {
      "id": "pb-rw_81"
    }
  }, [_vm._v("son’s contract of marriage. I might save my library etc. by assistance of friends and bid my creditors defiance. But for this I would in a court of Honour deserve to lose my spurs for – No, if they permit me, I will be their vassal for life and dig in the mine of my imagina [tion] to find diamonds (or what may sell for such) to make good my engagements, not to enrich myself. And this from no reluctance to allow myself to be calld the Insolvent which I probably am but because I will not put out of the [reach] of my creditors the resources mental or literary which yet remain to me."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-449",
      "id": "num-footnote-1-449-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00066"
    }
  }, [_vm._v("Went to the funeral of Chevalier Yelin, the literary foreigner mentiond on 22d. How many and how various are the ways of afliction. Here is this poor man dying at a distance from home, his friend"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-450",
      "id": "num-footnote-2-450-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" heart-broken, his wife and family anxiously expecting letters and doomd only to learn they have lost a husband and father for ever. He lies buried on the Calton hill"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-451",
      "id": "num-footnote-3-451-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" near learnd and scientific dust – the graves of David Hume"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-452",
      "id": "num-footnote-4-452-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" and John Playfair"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-453",
      "id": "num-footnote-5-453-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" being side by side.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00024"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00067"
    }
  }, [_vm._v("25 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" Anne is ill this morning – May God help us; if it should prove serious as I have known it in such cases where am I to find courage or comfort?\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block sidebar floatgalley-right",
    attrs: {
      "id": "rw-block-sidebar_110266-00001"
    }
  }, [_c('p', [_c('i', [_vm._v("£")]), _vm._v("24J. B.\n            ")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00068"
    }
  }, [_vm._v("A thought has struck me – can we do nothing for ourselves with the goblin drama calld the "), _c('i', [_vm._v("Fortunes of Devorgoil")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-6-454",
      "id": "num-footnote-6-454-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" – Could it not be added to "), _c('i', [_vm._v("Woodstock")]), _vm._v(" as a fourth volume? – Terry refused a gift of it but he was quite and entirely wrong – It is not good but it may be made so – Poor Will Erskine liked it much. Gave my wife her "), _c('i', [_vm._v("£")]), _vm._v("12 allowance. "), _c('i', [_vm._v("£")]), _vm._v("24 to last till Wednesday fort-night."), _c('i', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00025"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00069"
    }
  }, [_vm._v("26 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THURSDAY")]), _vm._v(" Spoke to J. B. last night about "), _c('i', [_vm._v("Devorgoil")]), _vm._v(" who does not seem to relish the proposal, alleging the comparative failure of "), _c('i', [_vm._v("Halidon")]), _vm._v(" "), _c('i', [_vm._v("Hill")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-7-455",
      "id": "num-footnote-7-455-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" Aye, says Self conceit, but he has not read it – and when he does it is the sort of wild fanciful work betwixt heaven and earth which men of solid parts do not estimate. Pepys thought Shakespeare’s "), _c('i', [_vm._v("Midsummer’s")]), _vm._v(" "), _c('i', [_vm._v("Night’s Dream")]), _vm._v(" the most silly play he had ever seen and Pepys was probably judging on the same grounds with J. B. though presumptuous enough to form conclusions against a very different work from any of mine. How if I send it to Lockhart by and bye?\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00071"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_82"
    }
  }, [_vm._v("I calld to-day at Constable’s. Both partners seemd secure that Hurst and Robinson were to go on and pay. Strange that they should have stopd. Constable very anxious to have husbanding of the books. I told him the truth that I would be glad to have his assistance – and that he should have the benefit of the agency but that he was <not> to consider past transactions as no rule for settling those in future since I must needs make the most out of the labours I could: item, that I or whoever might act for me would of course after what has happend look especially to the security. He said if Hurst and Robinson were to go on bank notes would be laid down. I conceive indeed that they would take "), _c('i', [_vm._v("W")]), _vm._v("—"), _c('i', [_vm._v("k")]), _vm._v(" and "), _c('i', [_vm._v("Napoleon")]), _vm._v(" almost at loss rather than break the connection in the public eye.\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_82"
    }
  }, [_c('div', {
    staticClass: "block sidebar floatgalley-right",
    attrs: {
      "id": "rw-block-sidebar_110266-00002"
    }
  }, [_c('p', [_c('i', [_vm._v("£")]), _vm._v("6 5\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("   1 1")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_82"
    }
  }, [_vm._v("Sir William Arbuthnot and Mr. Kinnear"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-456",
      "id": "num-footnote-1-456-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")]), _vm._v(" were very kind. But cui "), _c('i', [_vm._v("bono")]), _vm._v("?"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-457",
      "id": "num-footnote-2-457-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" Received "), _c('i', [_vm._v("£")]), _vm._v("6.5. paid back of deposit for Wool stapling Stock Coy. Gave it to my wife with direction to repay Anne "), _c('i', [_vm._v("£")]), _vm._v("1.1.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00073"
    }
  }, [_vm._v("Gibson comes with a joyful face announcing all the Creditors had unanimously agreed to a private trust."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-458",
      "id": "num-footnote-3-458-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" This is handsome and\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_83"
    }
  }, [_vm._v("confidential and must warm my best efforts to get them out of the scrape. I will not doubt – to doubt is to lose. Sir William Forbes took the chair and behaved as he has ever done with the generosity of ancient faith and early friendship. They"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-459",
      "id": "num-footnote-1-459-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")]), _vm._v(" are deeper concernd than most. In what scenes have Sir William and I not born share together – desperate and almost bloody affrays, rivalries – deep drinking matches, and finally with the kindest feelings on both sides somewhat separated by his retiring much within the bosom of his family and I moving little beyond mine. It is fated our planets should cross though and that at the period most interesting for me – Down – down – a hundred thoughts. – Jane Russel drank tea with us.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00074"
    }
  }, [_vm._v("I hope I will sleep better to-night. If I do not I shall get ill and then I cannot keep my engagements. Is it not odd? I can command my eyes to be awake when toil and weariness sit on my eyelids but to draw the curtain of oblivion is beyond my power. I remember some of the wild Buccaneers in their impiety succeeded pretty well by shutting hatches and burning brimstone and assafœtida to make a tolerable imitation of "), _c('i', [_vm._v("hell")]), _vm._v(" but their "), _c('i', [_vm._v("heaven")]), _vm._v(" was a wretched affair – It is one of the worst things about this system of ours that it is a hundred times more easy to inflict pain than to create pleasure.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00026"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00075"
    }
  }, [_vm._v("27 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("FRIDAY")]), _vm._v(" Slept better and less bilious owing doubtless to the fatigue of the preceding night and the more comfortable news."), _c('i', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "block sidebar floatgalley-right",
    attrs: {
      "id": "rw-block-sidebar_110266-00003"
    }
  }, [_c('p', [_c('i', [_vm._v("£")]), _vm._v("136\n            ")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I drew my salaries of various kinds amounting to "), _c('i', [_vm._v("£")]), _vm._v("300 and upwards ("), _c('i', [_vm._v("£")]), _vm._v("336 including cash due for su [r]-plusages to county) and sent with John Gibson’s consent "), _c('i', [_vm._v("£")]), _vm._v("200 to pay off things at Abbotsford which must be paid. Wrote Laidlaw with the money directing him to make all preparations for reduction."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-460",
      "id": "num-footnote-2-460-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _c('i', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110266-00004"
    }
  }, [_vm._v("Anne ill of Rheumatism – I believe caught cold by vexation and exposing herself to bad weather.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00077"
    }
  }, [_vm._v("The Celtic Society present me with the most splendid broadsword I ever saw. A beautiful piece of art and a most noble weapon. Honble Mr. Stewart (2d son of the Earl of Moray) General Graham Stirling and MacDougal"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-461",
      "id": "num-footnote-3-461-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" attended as a committee to present it. This was very kind of my friends the Celts by whom I have had so many merry meetings. It will be a rare legacy to Walter; for myself, good lack, it is like Lady Dowager Don’s prize in a lottery of hardware, she, being a venerable lady who always wore a haunch-hoop silk negligee and triple rufles at the elbow, having the luck to gain a pair of silver spurs and a whip to correspond.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00078"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_84"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_84"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00027"
    }
  })]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00079"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_84"
    }
  }, [_vm._v("28 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SATURDAY")]), _vm._v(" Ballantyne and Cadell wish that Mr. Alexr. Cowan should be Constable’s trustee instead of J. B.’ s. Gibson is determined to hold by Cowan. I will not interpose although I think Cowan’s services might do us more good as Constable’s trustee than as our own."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-462",
      "id": "num-footnote-1-462-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")]), _vm._v(" But I will not begin with thwarting the managers of my affairs or even exerting strong influence. It is not fair. These last four or five days I have wrought little; to-day I set on the steam and ply my paddles.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00028"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00080"
    }
  }, [_vm._v("29 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" The proofs of vol. I"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-463",
      "id": "num-footnote-2-463-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" came so thick in yesterday that much was not done. But I begin to be hard at work to-day and must not "), _c('i', [_vm._v("gurnalize")]), _vm._v(" much.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00081"
    }
  }, [_vm._v("Mr. Jollie, who is to be my trustee in conjunction with Gibson, came to see me – a pleasant and goodhumourd man and has high reputation as a man of business."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-464",
      "id": "num-footnote-3-464-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" I told him and I will keep my word that he would at least have no trouble by my interfering and thwarting their management"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-465",
      "id": "num-footnote-4-465-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" which is the not unfrequent case of trusters and trustees.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00082"
    }
  }, [_vm._v("Constable’s business seems unintelligible. No man thought the house worth less than "), _c('i', [_vm._v("£")]), _vm._v("150,000 – Constable told me when he was making his will that he was worth "), _c('i', [_vm._v("£")]), _vm._v("80,000. Great profits on almost all their adventures. No bad speculations yet neither stock nor debt to show. Constable might have eat up his share but Cadell was very frugal – No doubt trading almost entirely on accomodation is dreadfully expensive.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00029"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00083"
    }
  }, [_vm._v("30 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MONDAY")]), _vm._v(" "), _c('i', [_vm._v("False delicacy")]), _vm._v(". Mr. Gibson, Mr. Cowan, and Mr. J. B., were with me last night to talk over important matters and suggest an\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_85"
    }
  }, [_vm._v("individual for a certain highly confidential situation. I was led to mention a person of whom I knew nothing but that he was an honest and intelligent man. All seemd to acquiesce and agreed to move the thing to the party concernd this morning and so Mr. G. and Mr. C. left me, when J. B. let out that it was their unanimous opinion that we should be in great trouble were the individual appointed from faults of temper etc. which would make it difficult to get on with him. With a hearty curse I hurried J. B. to let them know that I had no partiality for the man whatever and only named him because he had been proposed for a similar situation elsewhere. This is provoking enough that they would let me embarass my affairs with a bad man (an unfit one I mean) rather than contradict me. I dare say great men are often used so.\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_85"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_110266-00084"
    }
  }, [_vm._v("I labourd freely yesterday. The stream rose fast – if clearly is another question but there is bulk for it at least, about 30 printed pages.")])]), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00007"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_85"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_85"
    }
  }, [_vm._v("And now again boys to the Oar."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-466",
      "id": "num-footnote-1-466-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00085"
    }
  }, [_vm._v("31 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TUESDAY")]), _vm._v(" There being nothing in the Roll to-day I stay at home from the Court and add another day’s perfect labour to "), _c('i', [_vm._v("Woodstock")]), _vm._v(" which is worth five days of snatched intervals when the current of thought and invention is broken in upon and the mind shaken and diverted from its purpose by a succession of petty interr-uptions. I have now no pecuniary provisions to embarass me, and I think now the shock of the discovery is past and over I am much better off on the whole. I am as if I had shaken off from my shoulders a great mass of garments rich indeed but cumbrous and always more a burthen than a comfort. I am free of an hundred petty public duties imposed on me as a man of consideration, of the expense of a great hospitality, and what is better of the great wast [e] of time connected with it. I have known in my day all kinds of society and can pretty well estimate how much or how little one loses by retiring from all but that which is very intimate. I sleep and eat and work as I am wont and, if I could see those about me as indifferent to the loss of rank as I am I should be completely happy. As it is time must salve that sore, to time I trust it.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00086"
    }
  }, [_vm._v("Since the 16th of this month no guest has broken bread in my house save G. H. Gordon"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-467",
      "id": "num-footnote-2-467-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" one morning at Breakfast. This happend never before since I had a house of my own. But I have plaid Abou\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_86"
    }
  }, [_vm._v("Hassan long enough and if the Caliph comes I would turn him back again."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-468",
      "id": "num-footnote-1-468-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "rw-h2_110266-00002"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("FEBRUARY")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00087"
    }
  }, [_vm._v("1 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" A most generous letter (though not more so than I expected) from Walter and Jane offering to interfere with their fortune etc."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-469",
      "id": "num-footnote-2-469-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" God Almighty forbid – that were too unnatural in me to accept tho’ dutiful and affectionate in them to offer. They talk of India still – with my damaged fortune I cannot help them to remain by exchange and so forth. He expects if they go to go out eldest Captain, when by staying two or three years he will get the step of Major."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-470",
      "id": "num-footnote-3-470-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" His whole thoughts are with his profession and I understand that when you quit or exchange when a regiment goes on\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_87"
    }
  }, [_vm._v("distant or disagreeable service you are not accounted as serious in your profession. God send what is for the best.\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_87"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_110266-00088"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_87"
    }
  }, [_vm._v("Remitted Charles a bill for "), _c('i', [_vm._v("£")]), _vm._v("40. "), _c('i', [_vm._v("£")]), _vm._v("35 advanced at Christmas makes "), _c('i', [_vm._v("£")]), _vm._v("75. He must be frugal."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-471",
      "id": "num-footnote-1-471-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" "), _c('p', [_vm._v("Attended the court and saw J. B. and Cadell as I returnd. Both very gloomy. Came home to work etc. about two.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00030"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00089"
    }
  }, [_vm._v("2 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THURSDAY")]), _vm._v(" An odd visit this morning from Miss Jane Bell of North Shields whose law suit with a Methodist parson of the name of Hill made some noise."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-472",
      "id": "num-footnote-2-472-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" The worthy divine had in the basest manner interfered to prevent this lady’s marriage by two anonymous letters in which he contrived to refer the lover to whom they were address [d] for further corroboration to "), _c('i', [_vm._v("himself")]), _vm._v(". The whole imposture makes the subject of a little pamphlet publishd by Marshall of NewCastle. The Lady ventured for redress into the thicket of English law – lost one suit – gaind another with "), _c('i', [_vm._v("£")]), _vm._v("300 damages and was ruind. The appearance and person of Miss Bell is prepossessing. She is about thirty years old, a brunette with regular and pleasing features markd with melancholy – an enthusiast in literature and probably in religion. She had been at Abbotsford to see me and made her way to me here in the vain hope that she could get her story workd up into a novel and certainly the thing is capable of interesting situations. It throws a curious light upon the aristocratic or rather Hierocratic influence exercised by the Methodist preachers within the Connexion as it is calld. Admirable food this would be [for] the Quarterly or any other reviewers who might desire to feed fat their grudge against this sept."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-473",
      "id": "num-footnote-3-473-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" But there are two reasons against such a vindication. First it would do the poor sufferer no good. 2dly. It would hurt the Methodistic Connexion very much which I for one would not like to injure. They have their faults and are peculiarly liable to those of hypocrisy and spiritual ambition and priest-craft. On the other hand they do infinite good, carrying religion into classes in Society where it would scarce be found to penetrate did it rely merely upon proof of its\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_88"
    }
  }, [_vm._v("doctrines upon calm reasons and upon rational argument. To these the Methodists add a powerful appeal to the feelings and passions and though I believe this is often exaggerated into absolute enthusiasm yet I consider upon the whole they do much to keep alive a sense of religion and the practice of morality necessarily connected with it. It is much to the discredit of the Methodist clergy that when the villainous calumniator was actually convicted of guilt morally worse than many men are hangd for they only degraded him from the first to the second class of their preachers, leaving a man, who from mere hatred at Miss Bell’s brother who was a preacher like himself had proceeded in such a deep and infamous scheme to ruin the character and destroy the happiness of an innocent person, in possession of the pulpit and an authorized teacher of others. If they believed him innocent they did too much, if guilty far too little.\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_88"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_110266-00090"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_88"
    }
  }, [_vm._v("I wrote to my Nephew Walter"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-474",
      "id": "num-footnote-1-474-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")]), _vm._v(" to-day cautioning him against a little disposition which he has to satire or "), _c('i', [_vm._v("méchanceté")]), _vm._v(" which may be a great stumbling block in his career in life – Otherwise I presage well of him. He is Lieutenant of Engineers with high character for math-ematical science – is acute – very well mannerd and I think good-hearted. He has seen enough of the world too to regulate his own course through life better than most lads at his age.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00031"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00091"
    }
  }, [_vm._v("3 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("FRIDAY")]), _vm._v(" This is the first morning since my troubles that I felt at awaking\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00008"
    }
  }, [_c('p', [_vm._v("I had drunken deep")]), _vm._v(" "), _c('p', [_vm._v("Of all the blessedness of sleep."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-475",
      "id": "num-footnote-2-475-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110266-00005"
    }
  }, [_vm._v("I made not the slightest pause nor dreamd a single dream nor even changed my side. This is a blessing to be grateful for. There is to be a meeting of the Creditors to-day but I care not for the issue. If they drag me into the Court "), _c('i', [_vm._v("obtorto collo")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-476",
      "id": "num-footnote-3-476-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(" instead of going into this scheme of arrangement they will do themselves a great injury and perhaps eventually do me good though it would give me much pain.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00092"
    }
  }, [_vm._v("J. B. is severely critical on what he calls imitations of Mrs. "), _c('a', {
    attrs: {
      "id": "pb-rw_89"
    }
  }, [_vm._v("Radcliffe in "), _c('i', [_vm._v("Woodstock")]), _vm._v(" – many will think with him – yet I am of opinion he is quite wrong or, as friend J. F."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-477",
      "id": "num-footnote-1-477-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")]), _vm._v(" says, "), _c('i', [_vm._v("vrong")]), _vm._v(". In the first place I am to look on the mere fact of another author having treated a subject happily as a bird looks on a potatoe bogle"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-478",
      "id": "num-footnote-2-478-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])]), _vm._v(" which scares it away from a field otherwise as free to its depredations as any one’s else. In 2d place I have taken a wide difference – my object is not to excite fear of supernatural things in my reader but to show the effect of such fear upon the agents in the story – one a man of sense and firmness, one a man unhinged by remorse – one a stupid unin-quiring clown – one a learnd and worthy but superstitious divine. In 3d. place the book turns on this hinge and cannot want it. But I will try to insinuate the refutation of Aldiboronti’s"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-479",
      "id": "num-footnote-3-479-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" exception into the prefatory matter.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00093"
    }
  }, [_vm._v("From the 19 January to the 2d. february inclusive is exactly fifteen days during which time (with the intervention of some days’ idleness to let imagination brood on the task a little) I have written a volume. I think for a bett I could have done it in ten days. Then I must have had no court of Session to take me up two or three hours every morning and dissipate my attention and powers of working for the rest of the day. A volume at cheapest is worth "), _c('i', [_vm._v("£")]), _vm._v("1000. This is working at the rate of "), _c('i', [_vm._v("£")]), _vm._v("24,000 a year, but then we must not bake bunns faster than people have appetite to eat them. They are not essential to the market like potatoes.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00094"
    }
  }, [_vm._v("John Gibson came to tell me in the evening that a Meeting to-day had approved of the proposed trust. I know not why but the news gave me little concern. I heard it as a party indifferent. I remember hearing that Mandrin"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-480",
      "id": "num-footnote-4-480-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" testified some horror when he found himself bound alive on the wheel and saw an executioner approach with a bar of iron to break his limbs. After the second and third blow he fell a laughing and being askd the reason by his confessor said he laughd at his own folly which had anticipated increased agony at every blow when it was obvious that the "), _c('i', [_vm._v("first")]), _vm._v(" must have jarrd and confounded the system of the nerves so much as to render the succeeding blows of little consequence. I suppose it is so with the moral feeling – At least I could not bring myself to be anxious whether these matters were settled one way or other.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00095"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_90"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_90"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00032"
    }
  })]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110266-00006"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_90"
    }
  }, [_vm._v("4 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SATURDAY")]), _vm._v(" Wrote to Mr. Laidlaw"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-481",
      "id": "num-footnote-1-481-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")]), _vm._v(" to come to town on Monday and see the trustees. To farm or not to farm is the question."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-482",
      "id": "num-footnote-2-482-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])]), _vm._v(" With our careless habits it were best I think to risk as little as possible. Lady Scott will not exceed with ready money in her hand but calculating on the produce of a farm is different and neither she nor I are capable of that minute œconomy. Two cows should be all we should keep. But I find Lady S. inclines much for the farm. If she had her youthful activity and could manage it it would be well and would amuse her. But I fear it is too late a week.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00096"
    }
  }, [_vm._v("Returnd from Court by Constable, and found Cadell has fled to the Sanctuary"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-483",
      "id": "num-footnote-3-483-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])]), _vm._v(" being threatend with ultimate diligence by the B. of S."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-484",
      "id": "num-footnote-4-484-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])]), _vm._v(" about some "), _c('i', [_vm._v("£")]), _vm._v("1900 drawn out of their Cash accot. the day before the stop. If this be a vindictive measure it is harsh useless bad"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-485",
      "id": "num-footnote-5-485-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _vm._v(" of them, and flight on the contrary seems no good sign on his part. I hope he won’t prove his father or Grandfather at Prestonpans\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00009"
    }
  }, [_c('p', [_vm._v("And Cadell dressd amang the rest")]), _vm._v(" "), _c('p', [_vm._v("    Wi gun and good claymore, man,")]), _vm._v(" "), _c('p', [_vm._v("On gelding grey he rode that day")]), _vm._v(" "), _c('p', [_vm._v("    Wi pistols set before, man.")]), _vm._v(" "), _c('p', [_vm._v("The cause was gude he’d spend his blude")]), _vm._v(" "), _c('p', [_vm._v("    Before that he would yield, man,")]), _vm._v(" "), _c('p', [_vm._v("But the night before he left the corps")]), _vm._v(" "), _c('p', [_vm._v("    And never faced the field, man."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-6-486",
      "id": "num-footnote-6-486-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00098"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_91"
    }
  }, [_vm._v("Harden"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-487",
      "id": "num-footnote-1-487-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")]), _vm._v(" and Mrs. Scott calld on mamma. I was abroad. Henry"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-488",
      "id": "num-footnote-2-488-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])]), _vm._v(" calld on me.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00099"
    }
  }, [_vm._v("Wrote only two pages (of manuscript) and a half to-day – As the boatswain said, one can’t dance always nowther. But were we sure of the quality of the stuff what opportunities for labour does this same system of retreat afford us. I am convinced that in three years I could do more than in the last ten but for the mine being I fear exhausted. Give me my popularity, "), _c('i', [_vm._v("an awful postulate")]), _vm._v(", and all my present difficulties shall be a joke in five years – and it is not lost yet at least.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00033"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00100"
    }
  }, [_vm._v("5 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" Rose after a sound sleep and here am I without bile or any thing to perturb my inward man. It is just about three weeks since so great a change took place in my relations in society and already I am indifferent to it. But I have been always told my feelings of joy and sorrow, pleasure and pain, enjoyment and privation, are much colder than those of other people.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00010"
    }
  }, [_c('p', [_vm._v("I think the Romans call it stoicism."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-489",
      "id": "num-footnote-3-489-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Missie"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-490",
      "id": "num-footnote-4-490-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])]), _vm._v(" was in the drawing room and over heard William Clerk and me laughing excessively at some foolery or other in the back room to her no small surprize which she did not keep to herself. But do people suppose that he was less sorry for his poor sister"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-491",
      "id": "num-footnote-5-491-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])]), _vm._v(" or I for my lost fortune? If I have a very strong passion in the world it is "), _c('i', [_vm._v("pride")]), _vm._v(" and that never hinged upon world’s gear which was always with me Light come Light go.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00034"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110266-00007"
    }
  }, [_vm._v("6 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MONDAY")]), _vm._v(" Letters received yesterday from Lord Montagu, John Morritt, and Mrs. Hughes"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-6-492",
      "id": "num-footnote-6-492-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])]), _vm._v(" – kind and dear friends all with solicitous \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_92"
    }
  }, [_vm._v("enquiries. But it is very tiresome to have to tell my story over again and I really hope I have [no] more friends intimate enough to ask me for it. I detest letter writing and envy the Old Hermit of Prague who never saw pen or ink"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-493",
      "id": "num-footnote-1-493-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")]), _vm._v(" – What then! one must write; it is a part of the Law we live on. Talking of writing I finishd my six pages neat and handsome yesterday. N.B. At night I fell asleep and the oil dripd from the lamp upon my manuscript. Will this extreme unction make it go smoothly down with the public?\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00011"
    }
  }, [_c('p', [_vm._v("Thus idly ‘we profane the sacred time’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-494",
      "id": "num-footnote-2-494-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")])])]), _vm._v(" "), _c('p', [_vm._v("By silly pun, light jest, and lighter rhyme.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110266-00006"
    }
  }, [_vm._v("I have a song to write too and I am not thinking of it – I trust it will come upon me at once – A sort of catch it should be."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-495",
      "id": "num-footnote-3-495-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])]), _vm._v(" I walkd out feeling a little overwrought. Saw Constable and turnd over Clarendon."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-496",
      "id": "num-footnote-4-496-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])]), _vm._v(" Cadell not yet out of hiding. This is simple work.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block sidebar floatgalley-right",
    attrs: {
      "id": "rw-block-sidebar_110266-00004"
    }
  }, [_c('p', [_c('i', [_vm._v("£")]), _vm._v("240 to John Gibson\n            ")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110266-00007"
    }
  }, [_vm._v("Obliged to borrow "), _c('i', [_vm._v("£")]), _vm._v("240 to be repaid in Spring from John Gibson to pay my Nephew’s outfitt and passage to Bombay."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-497",
      "id": "num-footnote-5-497-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])]), _vm._v(" I wish I could have got this money otherwise but I must not let the orphan boy and such a clever fellow miscarry through my fault. His education etc. has been at my expense ever since he came from America.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00035"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00101"
    }
  }, [_vm._v("7 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TUESDAY")]), _vm._v(" Had letters yesterday from Lady Davy"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-6-498",
      "id": "num-footnote-6-498-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])]), _vm._v(" and Lady Louisa Stuart."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-7-499",
      "id": "num-footnote-7-499-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])]), _vm._v(" Two very different persons. Lady Davy, daughter\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_93"
    }
  }, [_vm._v("an [d] coheiress of a wealthy Antigua Merchant, has been known to me all my life. Her father was a relation of ours of a Scotch calculation. He was of a good family, Kerr of Bloodielaws, but decayd. Miss Jane Kerr married first Mr. Apreece, Son of a Welch Baronet: The match was not happy. I had lossd all acquaintance with her for a long time when about twenty years ago we revived it in London. She was then a widow, gay, clever and most actively ambitious to play a distinguishd part in London society. Her fortune though handsome and easy was not large enough to make way by dint of showy entertainments and so forth so she took the "), _c('i', [_vm._v("blue")]), _vm._v(" line and by great tact and management actually establishd herself as a leader of literary fashion. Soon after, she resided in Edinburgh for a season or two and studied the Northern Lights. One of the best of them, poor Jack Playfair, was disposed ‘to shoot madly from his sphere’"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-500",
      "id": "num-footnote-1-500-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128")]), _vm._v(" and I believe askd her – but he was a little too old. She found a fitter husband in every respect in Sir Humphrey Davy"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-501",
      "id": "num-footnote-2-501-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])]), _vm._v(" to whom she gave a handsome fortune and whose splendid talents and situation as President of the Royal Society gave her naturally a distinguishd place in the literary society of the Metropolis. Now this is a very curious instance of an active minded woman forcing her way to the point from which she seemd furthest excluded – for though clever and even witty she had no peculiar accomplishment and certainly no great taste either for science or letters naturally. I was once in the Hebrides with her"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-502",
      "id": "num-footnote-3-502-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130")])]), _vm._v(" and I admired to observe how amid sea-sickness, fatigue, some danger, and a good deal of indifference as to what she saw, she gallantly maintaind her determination to see everything. It markd her strength of character and she joind to it much tact and always addressd people on the right side. So she stands high and deservedly so, for to these active qualities more French I think than English and partaking of the Creole vivacity and suppleness of character, she adds I believe honourable principles and an excellent heart – As a lion-catcher I could pit her against the world – She flung her "), _c('i', [_vm._v("lasso")]), _vm._v(" (see Hall’s "), _c('i', [_vm._v("South America")]), _vm._v(")"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-503",
      "id": "num-footnote-4-503-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131")])]), _vm._v(" over Byron himself. But then, poor soul, she is not happy. She has a temper and Davy has a temper and these tempers are not one temper but two tempers and they quarrell like cat and dog, which may be good for stirring up the stagnation of domestic life but they let the world see it and that is not so well. Now in all this I may be thought a little harsh on my friend but it is \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_94"
    }
  }, [_vm._v("between my Gurnal andme, and moreover I would cry heartily if anything were to ail my little cousin though she be addicted to rule the cerulean atmospher [e]. Then I suspect the cares of this as well as other empires overbalance its pleasures. There must be difficulty in being always in the right humour to hold a court. There are usurpers to be encounterd and insurrections to be put down –An incessant troop [of] bien-seances to be discharge [d], a sort of etiquette which is the curse of all courts – An old Lion cannot get ham-strung quietly at four hundred miles distance but the Empress must send him her condoleance and a pot of lip-salve. To be sure the monster is "), _c('i', [_vm._v("consanguinean")]), _vm._v(" as Sir Toby says."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-504",
      "id": "num-footnote-1-504-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00102"
    }
  }, [_vm._v("Lookd in at Constable’s coming home. Cadell emerged from Alsatia;"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-505",
      "id": "num-footnote-2-505-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])]), _vm._v(" borrowd Clarendon."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-506",
      "id": "num-footnote-3-506-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00103"
    }
  }, [_vm._v("Home by ½ past 12. Much comfort in a stupid assistant. Sir R. D. and R. H."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-507",
      "id": "num-footnote-4-507-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])]), _vm._v(" have two very clever men of business"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-508",
      "id": "num-footnote-5-508-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136")])]), _vm._v(" whom the agents like and carry their business to these two offices to favour the Assistants. Mine, a good creature,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-6-509",
      "id": "num-footnote-6-509-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")])]), _vm._v(" only accomplishes the character of an Assistant so far as the three first letters go. So he gets fewer pence and I less trouble.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00104"
    }
  }, [_vm._v("My old friend Sir Peter Murray"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-7-510",
      "id": "num-footnote-7-510-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")])]), _vm._v(" calld to offer his own assistance, Lord Justice-Clerk’s and Abercromby’s to negotiate for me a seat upon the Bench instead of my Sheriffdom and Clerkship. I explaind to him the use which I could make of my pen was not I thought consistent with that situation, and that besides I had neglected the law too long to permit me to think of that situation. But this was kindly and honourably done. I can see people think me much worse of [f] than I think myself. They may be right. But I will not be beat till I have tried a rally and a bold one.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00036"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00105"
    }
  }, [_vm._v("8 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" Slept ill, and rather bilious in the morning. Many of the Bench now are my Juniors. I will not seek "), _c('i', [_vm._v("ex elemosyna")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-8-511",
      "id": "num-footnote-8-511-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")])]), _vm._v(" a place which had I turnd my studies that way I might have aspired to long\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_95"
    }
  }, [_vm._v("ago "), _c('i', [_vm._v("ex meritis")]), _vm._v(". My pen should do much better for me than the odd "), _c('i', [_vm._v("£")]), _vm._v("1000 a year."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-512",
      "id": "num-footnote-1-512-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")]), _vm._v(" If it fails I will leave"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-513",
      "id": "num-footnote-2-513-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")])]), _vm._v(" on what they leave me. Another chance might be if it fails in the patronage which might after a year or two place me in Exchequer."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-514",
      "id": "num-footnote-3-514-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")])]), _vm._v(" But I do not count on this unless indeed the D. of B."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-515",
      "id": "num-footnote-4-515-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")])]), _vm._v(" when he comes of age should chuse to make play.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "block sidebar floatgalley-right",
    attrs: {
      "id": "rw-block-sidebar_110266-00005"
    }
  }, [_c('p', [_c('i', [_vm._v("£")]), _vm._v("24 Lad [y] Scott\n            ")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Got to my work again and wrote easier than the two last days. Gave Lady Scott her fortnight’s allowance "), _c('i', [_vm._v("£")]), _vm._v("24.0.0. The Laird of Harden made long visit. Spoke to Anne about a service for Dalgleish."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-516",
      "id": "num-footnote-5-516-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00106"
    }
  }, [_vm._v("Mr. Laidlaw came in from Abbotsford and dine [d] with us. We spent the evening in laying down plans for the farm"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-6-517",
      "id": "num-footnote-6-517-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145")])]), _vm._v(" and deciding whom we should keep and whom dismiss among the people. This we did on the true negroe-driving principle of self-interest – the only principle I know which "), _c('i', [_vm._v("never")]), _vm._v(" swerves from its objects. We chose all the active young and powerful men, turning old age and infirmity adrift. I cannot help this for [one] guinea cannot do the work of five but I will contrive to make [it] easier to the sufferers.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00037"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00107"
    }
  }, [_vm._v("9 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THURSDAY")]), _vm._v(" A stormy morning lowering and blustering like our fortunes. "), _c('i', [_vm._v("Mea virtute me involvo")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-7-518",
      "id": "num-footnote-7-518-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146")])]), _vm._v(" – But I must say to the Muse of fiction as the Earl of Pembroke said to the ejected Nun of Wilton ‘Go spin, you jade, go spin’ – Perhaps she has no "), _c('i', [_vm._v("tow")]), _vm._v(" on her "), _c('i', [_vm._v("rock")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-8-519",
      "id": "num-footnote-8-519-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00108"
    }
  }, [_vm._v(" When I was at Kilkenny last year we went to see a Nunnery but could not converse with the sisters because they were in strict retreat. I was delighted with the red-nosed padre who shewd us the place with a sort of proud unctuous humiliation and apparent dereliction of the world that had to me the air of a complete Tartuffe – a strong sanguine "), _c('a', {
    attrs: {
      "id": "pb-rw_98"
    }
  }, [_vm._v("square shoulderd son of the Church whom a protestant would be apt to warrant against any sufferings he was like to sustain by privation. My purpose however just now was to talk of the strict retreat which did not prevent the Nuns from walking in their little garden breviary in hand, peeping at us and allowing us to peep at them. Well – now we are in "), _c('i', [_vm._v("Strict Retreat")]), _vm._v(" and if we had been so last year instead of gallivanting to Ireland this affair might not have befallen if literary labour could have prevented it. But who could have suspected Constable’s timbers to have been rotten from the beginning?\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_98"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_110266-00109"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_98"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_96"
    }
  }, [_vm._v("Visited the Exhibition on my way home from the Court. The new rooms are most splendid, and several good pictures. The institution"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-520",
      "id": "num-footnote-1-520-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148")]), _vm._v(" has subsisted but five years and it is astonishing how much superior the worst of the present collection are to the tea-board looking things which first appeard. John Thomson of Duddingston"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-521",
      "id": "num-footnote-2-521-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149")])]), _vm._v(" has far the finest picture in the Exhibitn. of a large size. Subject "), _c('i', [_vm._v("Dunluce")]), _vm._v(", a ruinous ca [s] tle of the Antrim family near the Giant’s causeway with one of those terrible seas and skies which only Thomson can paint. Found Scroop there improving a picture of his own, an Italian scene in Calabria. He is I think greatly improved and one of the very best amateur painters I ever saw – Sir George Beaumont"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-522",
      "id": "num-footnote-3-522-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150")])]), _vm._v(" scarcely excepted. – Yet hang it I "), _c('i', [_vm._v("do")]), _vm._v(" except Sir George.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00110"
    }
  }, [_vm._v("I would not write to-day after I came home – I will not say "), _c('i', [_vm._v("could")]), _vm._v(" not for it is not true. But I was lazy: felt the desire "), _c('i', [_vm._v("far ’niente")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-523",
      "id": "num-footnote-4-523-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("151")])]), _vm._v(" which is the sign of one’s mind being at ease. I read "), _c('i', [_vm._v("The English in Italy")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-524",
      "id": "num-footnote-5-524-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("152")])]), _vm._v(" which is a clever book.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00111"
    }
  }, [_vm._v("Byron used to kick and frisk more contemptuously against the literary gravity and slang than any one I ever knew who had climbed so high – then it is true I never knew any one climb so high, and before you despise the eminence, carrying people along with you as convinced that you are not playing the fox and grapes, you must be at the top of the eminence. Moore told me two delightful stories of him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110266-00009"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_97"
    }
  }, [_vm._v("One was that while they stood at the window of Byron’s palazzo in Venice looking at a beautiful sun set Moore was naturally led to say something of its beauty when Byron answerd in a tone that I can easily conceive ‘Ah come d—n me, Tom, don’t be poetical.’ Another time standing with Moore on the balcony of the same palazzo a gondola passd with two English gentlemen who were easily distinguishd by their appearance. They cast a careless look at the balcony and went on. Byron crossd his arms and half stooping over the balcony said ‘Ah d—n ye if you had known what two fellows you were staring at you would have taken a longer look at us.’ This was the man – quaint capricious and playful with all his immense genius – He wrote from impulse never from effort and therefore I have always reckond Burns and Byron the most genuine poetical geniuses of my time and a half a century before me. We have however many men of high poetical talent but none I think of that ever gushing and perennial fountain of natural water.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_97"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_110266-00112"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_97"
    }
  }, [_vm._v("Mr. Laidlaw dined with us. Says Mr. G—n"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-525",
      "id": "num-footnote-1-525-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("153")]), _vm._v(" told him he would despair of my affairs were it any but S. W. S. No doubt – so should I and am wellnigh doing so at any rate – But "), _c('i', [_vm._v("fortuna juvante")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-526",
      "id": "num-footnote-2-526-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("154")])]), _vm._v(" much may be achieved. At worst the prospect is not very discouraging to one who wants little.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00113"
    }
  }, [_vm._v("Methinks I have been like Burns’s poor labourer")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00012"
    }
  }, [_c('p', [_vm._v("So constantly in Ruin’s sight")]), _vm._v(" "), _c('p', [_vm._v("The view o’t gives me little fright."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-527",
      "id": "num-footnote-3-527-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("155")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00114"
    }
  }, [_vm._v("10 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("FRIDAY")]), _vm._v(" Went through for a new day the task of buttoning which seems to me somehow to fill up more of my morning than usual, not certainly that such is really the case but that my mind attends to the process having so little left to hope or fear. The half-hour between waking and rising has all my life proved propitious to any task which was exercizing my invention. When I get over any knotty difficulty in a story or have had in former times to fill up a passage in a poem it was always when I first opend my eyes that the desired ideas throngd upon me. This is so much the case that I amin the habit of relying upon it and saying to myself when I am [at] a loss ‘Never mind, we shall have it at seven o’clock tomorrow morning.’ If I have forgot a circumstance or a\n          name or a copy of verses it is the same thing. There is a passage about this sort of matutinal inspiration in the "), _c('i', [_vm._v("Odyssey")]), _vm._v(" which would make a handsome figure here if I could read or write Greek."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-528",
      "id": "num-footnote-1-528-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("156")])]), _vm._v(" I will look into Pope for it who ten to one will not tell me the real translation.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00115"
    }
  }, [_vm._v("I think the first hour of the morning is also favourable to the bodily strength. Among other feats when I was a young man I was able at times to lift a smith’s anvil with one hand by what is called the "), _c('i', [_vm._v("horn")]), _vm._v(" or round projecting piece of iron on which things are beaten to turn them round. But I could only do this before breakfast and shortly after rising. It required my full strength undiminishd by the least exertion and those who choose to try will find the feat no easy one.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110266-00008"
    }
  }, [_vm._v("This morning I had some good ideas respecting "), _c('i', [_vm._v("Woodstock")]), _vm._v(" which will make the story better. The devil of a difficulty is that one puzzles the skean in order to excite curiosity and then cannot disentangle it for [the] satisfaction of the prying fiend they have raised.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00116"
    }
  }, [_vm._v("A letter from Sir James McIntosh"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-529",
      "id": "num-footnote-2-529-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("157")])]), _vm._v(" of condoleance prettily expressd and which may be sung to the old tune of Wellcome wellcome, brother Debtor."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-530",
      "id": "num-footnote-3-530-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("158")])]), _vm._v(" Another son of chivalry dismounted by mischance is sure to excite the compassion of one laid on the arena before him.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00117"
    }
  }, [_vm._v("Yesterday I had an anecdote from old Sir James Stewart Denham"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-531",
      "id": "num-footnote-4-531-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("159")])]), _vm._v(" which is worth writing down. His uncle Lord Elcho was as is well known engaged in the affair of 1745. He was dissatisfied with the conduct of matters from beginning to end. But after the left wing of the Highlanders was repulsed and broken at Culloden Elcho rode up to the Chevalier and told him all was lost and that nothing remaind except to charge at the head of two thousand men who were still unbroken and either turn the fate of the day or die sword in hand as became his pretensions. The Chevalier gave him some evasive answer and turning his horse’s head\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_99"
    }
  }, [_vm._v("rode off the field. Lord Elcho calld after him (I write the very words) ‘There you go for ad—ncowardlyb—g Italian’ and never would see him and never would see lost his property and remaind an exile inthe cause. Lord Elcho left two copies of his memoirs, one with Sir James Stewart’s family, one with Lord Wemyss."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-532",
      "id": "num-footnote-1-532-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("160")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00118"
    }
  }, [_vm._v("This is better evidence than the romance of Chevalier Johnstone."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-533",
      "id": "num-footnote-2-533-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("161")])]), _vm._v(" And I have little doubt it is true. Yet it is no proof of the prince’s cowardice though it shows him to have been no John of Gaunt."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-534",
      "id": "num-footnote-3-534-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("162")])]), _vm._v(" Princes are constantly surrounded with people who hold up their own "), _c('i', [_vm._v("life")]), _vm._v(" and "), _c('i', [_vm._v("safety")]), _vm._v(" to them as by far the most important stake in any contest and this is a doctrine in which conviction is easily received. Such an eminent person finds every bodie’s advice save here and there that of a desperate Elcho recommend obedience to the natural instinct of self preservation which very often men of inferior situations find it difficult to combat when all the world are crying to them to get on and be damnd instead of encouraging them to run away. At Preston-pans the Chevalier offerd to lead the van and he was with the Second line which during that brief affair followd the first very close. Johnstone’s own account, carefully re [a] d, brings him within a pistol shot of the first line. At the same time Charles Edward had not a head or heart for great things notwithstanding his daring adventure, and the Irish officers by whom he was guided were poor creatures. Lord George Murray"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-535",
      "id": "num-footnote-4-535-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("163")])]), _vm._v(" was the soul of the undertaking.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-000034"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110266-00009"
    }
  }, [_vm._v("11 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SATURDAY")]), _vm._v(" Court sate till half past one. I had but a trifle to do so wrote to Miss Maclean Clephane"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-536",
      "id": "num-footnote-5-536-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("164")])]), _vm._v(" – and Nephew Walter. Sent the last "), _c('i', [_vm._v("£")]), _vm._v("40 in addition to "), _c('i', [_vm._v("£")]), _vm._v("240 sent on the 6th, making his full equipment "), _c('i', [_vm._v("£")]), _vm._v("280."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-6-537",
      "id": "num-footnote-6-537-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("165")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110266-00010"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_100"
    }
  }, [_vm._v("A man calling himself Charles Gray of Carse wrote to me expressing sympathy for my misfortunes and offering me half the profits of what he calls the anti radical Laika which, if I understand him right, is a patent medicine"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-538",
      "id": "num-footnote-1-538-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("166")]), _vm._v(" to which I suppose he expects me to stand trumpeter. He endeavours to get over my objections to accepting his liberality (supposing me to entertain them) by assuring me his conduct is founded on a "), _c('i', [_vm._v("sage")]), _vm._v(" "), _c('i', [_vm._v("selfishness")]), _vm._v(". This is diverting enough – I suppose the Commissioners of police will next send me a letter of condoleance begging my acceptance of a broom a shovel and a scavenger’s great coat and assuring me that they had appointed me to all the emolument of a well frequented crossing – it would be doing more than they have done of late to the cleanliness of the streets which, witness my shoes, are in a piteous pickle. I thankd the Selfish Sage with due decorum for what purpose can anger serve? I remember once before a mad woman from about Alnwick, by [name] Latin or Laytoun,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-539",
      "id": "num-footnote-2-539-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("167")])]), _vm._v(" baited me with letters and plans – first for charity to herself or some protegee – I gave my guinea – then she wanted to have half the profit of a novel which I was to publish under my name and auspices – She sent me the manuscript and a "), _c('i', [_vm._v("moving")]), _vm._v(" tale it was for some of the scenes lay in the "), _c('i', [_vm._v("Cabinet a l’eau")]), _vm._v(". I declined the partnership. Lastly my fair correspondent insisted I was a lover of speculation and would be much profited by going shares in a patent medicine which she had invented for the benefit of little babies I believe. I declined to have anything to do with such a Herod-like affair and beggd to decline the honour of correspondence in future. I should have thought the thing a quiz but that the novel was real and substantial.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110266-00011"
    }
  }, [_vm._v("Anne goes to Ravelston"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-540",
      "id": "num-footnote-3-540-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("168")])]), _vm._v(" to-day to remain tomorrow.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110266-00012"
    }
  }, [_vm._v("Sir Alexr. Don calld and we had a good laugh together.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00038"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00120"
    }
  }, [_vm._v("12 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" Having ended the Second Vol of "), _c('i', [_vm._v("Woodstock")]), _vm._v(" last night I have to begin the Third this morning. Now I have not the slightest idea how the story is to be wound up to a catastrophe. I am just in the same case as I used to be when I lost myself in former days in some country to which I was a stranger – I always pushd for the pleasantest road and either found or made it the nearest. It is the\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_101"
    }
  }, [_vm._v("same in writing. I never could lay down a plan – or having laid it down I never could adhere to it; the action of composition always dilated some passages and abridged or omitted others and personages were renderd important or insignificant not according to their agency in the original conception of the plan but according to the success or otherwise with which I was able to bring them out. I only tried to make that which I was actually writing diverting and interesting, leaving the rest to fate. I have been often amused with the critics distinguishing some passages as particularly labourd when the pen passd over the whole as fast as it could move and the eye never again saw them excepting in proof. Verse I write twice and sometimes three times over. This may be calld in Spanish the "), _c('i', [_vm._v("Der donde diere")]), _vm._v(" mode of composition – in English "), _c('i', [_vm._v("Hab nab at a")]), _vm._v(" venture. It is a perilous stile I grant but I cannot help [it] – when I chain my mind to ideas which are purely imaginative – for argument is a different thing – it seems to me that the sun leaves the landscape, that I think away the whole vivacity and spirit of my original conception, and that the results are cold, tame and spiritless. It is the difference between a written oration and one bursting from the unpremed [it] ated exertions of the Speaker which have always something the air of enthusiasm and inspiration. I would not have young authors imitate my carelessness however – "), _c('i', [_vm._v("consilium non")]), _vm._v(" "), _c('i', [_vm._v("currum cape")]), _vm._v(" – "), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-541",
      "id": "num-footnote-1-541-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("169")]), _vm._v("\n          Read a few page of Will D’Avenant who was fond of having it supposed that Shakespeare intrigued with his mother. I think the pretension can only be treated as Phaeton’s was according to Fielding’s farce. ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00013"
    }
  }, [_c('p', [_vm._v("Besides by all the village boys I’m sham’d,")]), _vm._v(" "), _c('p', [_vm._v("You the Sun’s son, you rascal? – you be damnd.")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110266-00010"
    }
  }, [_vm._v("Egad I’ll put that into "), _c('i', [_vm._v("Woodstock")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-542",
      "id": "num-footnote-2-542-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("170")])]), _vm._v(" It might come well from the old admirer of Shakspeare –"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-543",
      "id": "num-footnote-3-543-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("171")])]), _vm._v(" then Fielding’s lines were not written – what then it is an anachronism for some sly rogue to detect. Besides it is easy to swear they were written and that fielding adopted them from tradition.\n         ")])])])])])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(156),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(159),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(162),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(165),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(168),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(171),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(174),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(177),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(180),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(183),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(186),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(189),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(192),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(195),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(198),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(201),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(204),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781847674951',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(208)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(210);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 210 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.4839530d7f8918177063.js